import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: string;
  Date: any;
  FilterNode: string;
};

/** Action */
export enum Action {
  Create = 'CREATE',
  Delete = 'DELETE',
  Exec = 'EXEC',
  Read = 'READ',
  Send = 'SEND',
  Update = 'UPDATE'
}

export type AddUserToOrg = {
  orgRole?: InputMaybe<Organization_Users_Role>;
  roles?: InputMaybe<Array<AssignedRoles>>;
  userEmail: Scalars['String'];
};

export enum AlertType {
  Proactive = 'proactive',
  Standard = 'standard',
  Subscription = 'subscription'
}

export type AnnouncementRecipient = {
  __typename?: 'AnnouncementRecipient';
  entryText: Scalars['String'];
  userEmail: Scalars['String'];
};

export type AsanaProject = {
  __typename?: 'AsanaProject';
  name: Scalars['String'];
  providerUniqueId: Scalars['String'];
};

export type AsanaWorkspace = {
  __typename?: 'AsanaWorkspace';
  name: Scalars['String'];
  providerUniqueId: Scalars['String'];
};

export type AssignedRoles = {
  domain: Domain;
  domainId: Scalars['Int'];
  role: Role;
};

export type BatchEntryInput = {
  /** The conversation parts of the feedback entry. The fullText field of the feedback entry holds the first conversation part, all other conversation parts should go here. */
  conversationParts?: InputMaybe<Array<ConversationPartInput>>;
  /** Custom fields for the feedback entry. This is a list of key values pairs that will be associated with the entry. The keys and values will both be shown on the UI as is. We use the key to denote Custom Field Groups i.e. 'Customer Tenure' and the values are the specific values within that group i.e. '0-90 days'. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** The source of the feedback entry. This is a human readable name. */
  dataSource: Scalars['String'];
  /** The link to the feedback entry in the source system. This is displayed on our UI and lets users backlink to the original ticket */
  dataSourcePermalink?: InputMaybe<Scalars['String']>;
  /** The date the feedback or ticket was submitted. In ISO 8601 format. */
  feedbackDate: Scalars['String'];
  /** The alias of the person who submitted the feedback or ticket, this can be used to join other meta data about the submitter. */
  feedbackSubmitterAlias: Scalars['String'];
  /** The full text of the feedback entry. If this is a conversation, this should be the first conversation part. */
  fullText: Scalars['String'];
  /** The source's unique id of the feedback entry */
  providerUniqueId: Scalars['String'];
  /** The type of submitter either 'customer' or 'agent'. Defaults to 'customer'. For conversations this should be set off of the first conversation part. */
  submitterType?: InputMaybe<Submitter_Type>;
  /** The title or subject of the feedback entry */
  title?: InputMaybe<Scalars['String']>;
};

export type Board = {
  __typename?: 'Board';
  creator: Users;
  description?: Maybe<Scalars['String']>;
  filterInput: SavedFilterInput;
  filterNode: Scalars['FilterNode'];
  id: Scalars['Int'];
  isPinnedByUser: Scalars['Boolean'];
  teamId: Scalars['Int'];
  title: Scalars['String'];
  widgets: Array<Widget>;
};

export type BreakdownInput = {
  type: Breakdown;
};

export enum CadenceType {
  Daily = 'daily',
  Weekly = 'weekly'
}

export type ChangelogInput = {
  date: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Chart = {
  __typename?: 'Chart';
  breakdown?: Maybe<Breakdown>;
  dateCreated?: Maybe<Scalars['Float']>;
  /** ID of the Group */
  id: Scalars['Int'];
  owner?: Maybe<Users>;
  seriesData?: Maybe<Array<SeriesData>>;
  tags?: Maybe<Array<Tag>>;
  /** Title of the group. This is a mutatable field. */
  title: Scalars['String'];
  type: Chart_Type;
  y_axis_data?: Maybe<Y_Axis_Data>;
};

export type Chart2D = {
  __typename?: 'Chart2D';
  config: ChartConfig;
  /** ID of the Chart */
  id: Scalars['Int'];
  legend: Array<Label>;
  owner?: Maybe<User>;
  series: Array<Array<Scalars['Float']>>;
  /** Title of the chart. This is a mutatable field. */
  title: Scalars['String'];
  tooltipLabels: Array<Scalars['String']>;
  xAxisLabels: Array<Scalars['String']>;
};

export type ChartConfig = {
  __typename?: 'ChartConfig';
  breakdown?: Maybe<Breakdown>;
  seriesConfig?: Maybe<Array<SeriesConfig>>;
  type: Chart_Type;
  y_axis_data?: Maybe<Y_Axis_Data>;
};

export type ChartDep = {
  __typename?: 'ChartDep';
  id: Scalars['Int'];
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
  title: Scalars['String'];
};

export type ClusterFilter = {
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type ClusterFilterInput = {
  clusters: Array<ClusterFilter>;
  filterCondition: FilterType;
};

export enum ClusterSort {
  Mentions = 'MENTIONS',
  Unwrap = 'UNWRAP'
}

export enum ClusterStatus {
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Monitored = 'MONITORED',
  New = 'NEW',
  Pending = 'PENDING',
  Unmonitored = 'UNMONITORED'
}

export enum ClusterUserRole {
  Collaborator = 'COLLABORATOR',
  Owner = 'OWNER'
}

export type ClusterUsersFilterInput = {
  clusterUsers: Array<ClusterUsersInput>;
  filterCondition: FilterType;
};

export type ClusterUsersInput = {
  role?: InputMaybe<ClusterUserRole>;
  user_id: Scalars['Int'];
};

export enum ComparisonType {
  Contains = 'CONTAINS',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotContains = 'NOT_CONTAINS',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export enum CompleteSearch {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export type ConversationPartInput = {
  dateSubmitted: Scalars['String'];
  feedbackSubmitterAlias: Scalars['String'];
  fullText: Scalars['String'];
  providerUniqueId: Scalars['String'];
  submitterType: Submitter_Type;
};

/** Object to fetch chart layouts cheaply */
export type CustomChartsLight = {
  __typename?: 'CustomChartsLight';
  chartId: Scalars['Int'];
  chartName: Scalars['String'];
  savedFilterInput: SavedFilterInput;
};

export type CustomFieldInput = {
  /** The key of the custom field. This is used to denote the Custom Field Group i.e. "Customer Tenure" */
  key: Scalars['String'];
  /** The value of the custom field. This is the specific value within the group i.e. "0-90 days" */
  value: Scalars['String'];
};

export type DataSeriesConfiguration = {
  customName?: InputMaybe<Scalars['String']>;
  filterNode: Scalars['FilterNode'];
  /** The segment group id. This only needs specified if the chart breakdown is specified to 'segment'. */
  segmentGroupId?: InputMaybe<Scalars['Int']>;
  teamIdOverride?: InputMaybe<Scalars['Int']>;
};

export type DataSeriesConfigurationOutput = {
  __typename?: 'DataSeriesConfigurationOutput';
  customName?: Maybe<Scalars['String']>;
  filterNode: Scalars['FilterNode'];
  segmentGroupId?: Maybe<Scalars['Int']>;
  team: Teams;
};

export type DeliveryStatus = {
  __typename?: 'DeliveryStatus';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum DigestSendFrequency {
  EveryTwoWeeks = 'every_two_weeks',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum DigestSeriesType {
  Realtime = 'realtime',
  Scheduled = 'scheduled'
}

export enum DigestStatus {
  Approved = 'approved',
  Draft = 'draft',
  PendingReview = 'pending_review',
  Sent = 'sent'
}

export type DiscoverableOrg = {
  __typename?: 'DiscoverableOrg';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type DomainInput = {
  id: Scalars['Int'];
  type: Domain;
};

export type EditChartInput = {
  breakdown?: InputMaybe<Breakdown>;
  series?: InputMaybe<Array<SeriesInput>>;
  /** why is this a filter? Shouldn't this be a tag to assign to the chart? */
  tags?: InputMaybe<Array<TagFilter>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Chart_Type>;
  y_axis_data?: InputMaybe<Y_Axis_Data>;
};

export type EditClusterInput = {
  acceptedStatus?: InputMaybe<ClusterStatus>;
  sentenceIdToAdd?: InputMaybe<Scalars['Int']>;
  sentenceIdToRemove?: InputMaybe<Scalars['Int']>;
  sentenceIdsToRemove?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditGroupInput = {
  sentenceIdToAdd?: InputMaybe<Scalars['BigInt']>;
  sentenceIdToRemove?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Group_Status>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditGroupResult = {
  __typename?: 'EditGroupResult';
  dependencies?: Maybe<GroupDependencies>;
  group?: Maybe<Group>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type EntriesCount = {
  __typename?: 'EntriesCount';
  amount: Scalars['Int'];
};

export type EntryBatchImport = {
  __typename?: 'EntryBatchImport';
  /** Returns the number of entries scheduled for import. */
  entriesScheduledForImport: Scalars['Int'];
  /** Status Message. */
  message: Scalars['String'];
};

export type EntryFilter = {
  id: Scalars['BigInt'];
};

export type EntryFilterInput = {
  entry: Array<EntryFilter>;
  filterCondition: FilterType;
};

export type EntryGroupedStatusFilterInput = {
  filterCondition: FilterType;
  /** If true, only entries on at least 1 group are returned. If false, only entries that dont belong to any group are returned */
  grouped: Array<Scalars['Boolean']>;
};

export type EntryReplyInput = {
  entryId: Scalars['BigInt'];
  text: Scalars['String'];
};

export enum EqualityType {
  Equal = 'EQUAL'
}

export type ExistingWidgetInput = {
  height: Scalars['Int'];
  id: Scalars['Int'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

/** Ticket data returned by External Systems (Jira, Asana, etc). */
export type ExternalTicketData = {
  __typename?: 'ExternalTicketData';
  assignee: Scalars['String'];
  closedDate?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  providerUniqueId: Scalars['String'];
  sourcePermalink: Scalars['String'];
  status: External_Ticket_Status;
};

export type ExternalTicketInput = {
  assignee?: InputMaybe<Scalars['String']>;
  closedDate?: InputMaybe<Scalars['Date']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  providerUniqueId: Scalars['String'];
  sourcePermalink: Scalars['String'];
  status: External_Ticket_Status;
};

export type ExternalTicketsStatusFilterInput = {
  filterCondition: FilterType;
  status: Array<GroupExternalTicketStatus>;
};

export type FeedbackEntryInput = {
  conversationParts?: InputMaybe<Array<ConversationPartInput>>;
  dataSource: Scalars['String'];
  dataSourcePermalink?: InputMaybe<Scalars['String']>;
  feedbackDate: Scalars['String'];
  feedbackSubmitterAlias: Scalars['String'];
  fullText: Scalars['String'];
  providerUniqueId: Scalars['String'];
  segments: Array<FeedbackSegmentInput>;
  stars?: InputMaybe<Scalars['Int']>;
  submitterType?: InputMaybe<Submitter_Type>;
  teamId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type FeedbackEntryText = {
  __typename?: 'FeedbackEntryText';
  conversationParts: Array<Conversation_Part>;
  /** The text to display on the frontend by default. This accounts for the default distillate display setting, having conversation parts and if theres's a valid distillate. */
  displayText: Scalars['String'];
  /** If the display text is using the distillate. */
  displayTextIsDistillate: Scalars['Boolean'];
  /** The summary distillate text */
  distillateText?: Maybe<Scalars['String']>;
  /** The full entry text */
  entryText?: Maybe<Scalars['String']>;
  /** The full conversation text. Including the entry text and submitter. */
  fullConversation: Scalars['String'];
  hasConversation: Scalars['Boolean'];
};

export type FeedbackReply = {
  __typename?: 'FeedbackReply';
  conversationPart?: Maybe<Conversation_Part>;
  errorMessage?: Maybe<Scalars['String']>;
  feedbackEntryId: Scalars['BigInt'];
  success: Scalars['Boolean'];
};

export type FeedbackSegmentFilterInput = {
  filterCondition: FilterType;
  groupId: Scalars['Int'];
  segments: Array<Scalars['String']>;
};

export type FeedbackSegmentInput = {
  feedbackSegmentConfigId: Scalars['Int'];
  feedbackSegmentGroupId: Scalars['Int'];
  value: Scalars['String'];
};

/** A filter field */
export type FilterField = {
  __typename?: 'FilterField';
  /** Additional metadata for the field such as the integrations that are associated with the field */
  additionalMetaData: Array<Scalars['String']>;
  /** The allowed operators for the field */
  allowedOperators: Array<Operator>;
  /** The display name of the field */
  displayName: Scalars['String'];
  /** The name of the field */
  fieldName: Scalars['String'];
  /** Whether the field has overlap with existing filters */
  hasOverLapWithExistingFilters: Scalars['Boolean'];
  /** Whether the field has values */
  hasValues: Scalars['Boolean'];
  /** The subtitle of the field */
  subTitle?: Maybe<Scalars['String']>;
};

/** A filter field display */
export type FilterFieldDisplay = {
  __typename?: 'FilterFieldDisplay';
  /** The display name of the field */
  displayName: Scalars['String'];
  /** The name of the field */
  fieldName: Scalars['String'];
  /** The values of the field */
  values: Array<FilterFieldValue>;
};

/** A filter field value */
export type FilterFieldValue = {
  __typename?: 'FilterFieldValue';
  /** The display name of the filter value */
  displayName: Scalars['String'];
  /** The filter value */
  filterValue: Scalars['String'];
};

/** Filter results of your GQL query by different qualities. */
export type FilterInput = {
  clusterFilters?: InputMaybe<Array<ClusterFilterInput>>;
  clusterUsersFilter?: InputMaybe<Array<ClusterUsersFilterInput>>;
  clusteredOnly?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Date']>;
  entryFilter?: InputMaybe<Array<EntryFilterInput>>;
  /** Filter based on entry grouped status (grouped/ungrouped) */
  entryGroupedStatusFilter?: InputMaybe<Array<EntryGroupedStatusFilterInput>>;
  filterSet?: InputMaybe<GenericNestedListFilterInput>;
  groupExternalTicketsFilter?: InputMaybe<Array<ExternalTicketsStatusFilterInput>>;
  groupFilter?: InputMaybe<Array<GroupFilterInput>>;
  groupTitleFilterQuery?: InputMaybe<Scalars['String']>;
  /** Filter based on min stars */
  maxStarsFilter?: InputMaybe<Array<MaxStarsFilterInput>>;
  /** Filter based on min stars */
  minStarsFilter?: InputMaybe<Array<MinStarsFilterInput>>;
  /** Filter based on owner ids */
  ownerFilter?: InputMaybe<Array<OwnerFilterInput>>;
  queryString?: InputMaybe<Array<Scalars['String']>>;
  segmentFilters?: InputMaybe<Array<FeedbackSegmentFilterInput>>;
  sentimentFilter?: InputMaybe<Array<SentimentFilterInput>>;
  sourceFitler?: InputMaybe<Array<SourceFilterInput>>;
  sourceUrlFilter?: InputMaybe<Array<SourceUrlFilterInput>>;
  startDate?: InputMaybe<Scalars['Date']>;
  /** Filter based on tag ids */
  tagFilters?: InputMaybe<Array<TagFilterInput>>;
  themeFilters?: InputMaybe<Array<ThemeFilterInput>>;
};

export enum FilterType {
  And = 'AND',
  Or = 'OR'
}

export type GeneratedGptReply = {
  __typename?: 'GeneratedGptReply';
  entryId: Scalars['BigInt'];
  generatedText: Scalars['String'];
  success: Scalars['Boolean'];
};

export type GenericFilterInput = {
  equality: EqualityType;
  filterType: GenericFilterType;
  value: Scalars['String'];
  valueType: ValueType;
};

export enum GenericFilterType {
  TrendingNew = 'TrendingNew'
}

export type GenericListFilter = {
  filterCondition: FilterType;
  filters: Array<GenericFilterInput>;
};

export type GenericNestedListFilterInput = {
  filterCondition: FilterType;
  filterables: Array<GenericListFilter>;
};

export type GptRepliesInput = {
  /** Context for the reply generation (eg: "We have fixed this issue in our latest update") */
  details: Scalars['String'];
  /** Entry ID. This is not relevant for the query itself, but helps identifying on the frontend. */
  entryId: Scalars['BigInt'];
  /** Review text from the entry we want to generate a reply for. */
  feedbackText: Scalars['String'];
};

export enum GptResponseType {
  BugFixed = 'bugFixed',
  WorkInProgress = 'workInProgress'
}

export type Group = {
  __typename?: 'Group';
  ancestors?: Maybe<Array<Group>>;
  /** Returns if the group can have children added to it. This is used to limit the frontend's ability to grow the tree. */
  canAddChildren: Scalars['Boolean'];
  /** Centroid text (or sentence) of the Group */
  centroidText: Scalars['String'];
  chart: Chart2D;
  children: Array<Group>;
  createdAt: Scalars['String'];
  creator: GroupCreator;
  /** Don't use this field. Use createdAt instead. */
  dateCreated?: Maybe<Scalars['Float']>;
  feedbackEntries?: Maybe<Array<Feedback_Entries>>;
  groupEntries?: Maybe<Array<GroupEntry>>;
  /** ID of the Group */
  id: Scalars['BigInt'];
  /** Title of a group in a weekly digest */
  insight?: Maybe<GroupInsight>;
  /** If this search group is using exact match only. If this is true the Frontend should skip the sentence chooser. */
  isExactMatch: Scalars['Boolean'];
  /** Checks if this group is considered 'new'. This means that the group was created in the last 14 days. */
  isNew?: Maybe<Scalars['Boolean']>;
  isPinnedByUser: Scalars['Boolean'];
  mentionsOverTime?: Maybe<SeriesData>;
  owner?: Maybe<Users>;
  parent?: Maybe<Group>;
  /** If there is a group processing. True for processing False for done processing. */
  processing: Scalars['Boolean'];
  /** If a group is processing this number indicates on a 0% - 100% scale how complete the search process is. If a search isn't processing this number is useless. Use `searchProcessing` field to determine if a search is underway. */
  progress: Scalars['Int'];
  sentencesMappings?: Maybe<Array<GroupSentenceMapping>>;
  /** Returns the both filtered and unfiltered denominators for all groups. */
  statistics: GroupStatistics;
  /** Status of the group. Default to show to customers is 'monitored' */
  status: Group_Status;
  summary?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  /** Title of the group. This is a mutatable field. */
  title: Scalars['String'];
  /** Returns the total number of decendents per the group's taxonomy. */
  totalDescendents: Scalars['Int'];
  /** Trending status of the group. This indicates is a group's entries count is increase, decreasing. If null this means the group isn't trending. */
  trending?: Maybe<Group_Trending>;
  type: Group_Type;
  /** Count of unique entries present in this Group */
  uniqueEntries: Scalars['Int'];
};


export type GroupChildrenArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GroupFeedbackEntriesArgs = {
  entriesSkip?: InputMaybe<Scalars['Int']>;
  entriesTake?: InputMaybe<Scalars['Int']>;
};


export type GroupGroupEntriesArgs = {
  entriesSkip?: InputMaybe<Scalars['Int']>;
  entriesTake?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
};


export type GroupMentionsOverTimeArgs = {
  chartBin?: InputMaybe<Chart_Bin_Type>;
};


export type GroupParentArgs = {
  FilterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type GroupSentencesMappingsArgs = {
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  sentencesTake?: InputMaybe<Scalars['Int']>;
};

export type GroupCreator = {
  __typename?: 'GroupCreator';
  /** If this group was created by an Unwrap user or not */
  isUnwrapGenerated: Scalars['Boolean'];
  user?: Maybe<Users>;
};

export type GroupDenominator = {
  __typename?: 'GroupDenominator';
  /** The number of unique entries that match the filter set */
  denominatorFiltered: Scalars['Int'];
  /** The number of unique entries excluding all filters but the date filter */
  denominatorUnfiltered: Scalars['Int'];
};

export type GroupDependencies = {
  __typename?: 'GroupDependencies';
  charts: Array<ChartDep>;
  dependencies: Array<GroupDependency>;
  pinners: Array<PinnedGroupDep>;
};

export type GroupDependency = {
  __typename?: 'GroupDependency';
  message: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type GroupEntry = {
  __typename?: 'GroupEntry';
  belongsToGroup: Scalars['Boolean'];
  date?: Maybe<Scalars['Date']>;
  defaultDistillateDisplay: Scalars['Boolean'];
  /** @deprecated Not used, no longer contains data. Get data from the entry object */
  distillateId?: Maybe<Scalars['BigInt']>;
  distillateText?: Maybe<Scalars['String']>;
  entryText?: Maybe<Scalars['String']>;
  groupMemberships?: Maybe<Array<GroupLight>>;
  /** Checks if there are conversation parts (before vending full conversation) */
  hasConversation: Scalars['Boolean'];
  /** Entry Id */
  id?: Maybe<Scalars['BigInt']>;
  mappedSentences: Array<Sentence>;
};

export enum GroupExternalTicketStatus {
  Closed = 'CLOSED',
  NoTickets = 'NO_TICKETS',
  Open = 'OPEN',
  Unassigned = 'UNASSIGNED'
}

export type GroupFilter = {
  /** If true, only return entries that belong to this group but not to any of its children */
  exclusive?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Group_Type>;
};

export type GroupFilterInput = {
  filterCondition: FilterType;
  group: Array<GroupFilter>;
};

export type GroupId = {
  __typename?: 'GroupId';
  id: Scalars['BigInt'];
};

export type GroupInsight = {
  __typename?: 'GroupInsight';
  /** Section for the group insight. */
  digestSection?: Maybe<Scalars['String']>;
  /** Expiration date for the group insight. */
  expirationDate?: Maybe<Scalars['Date']>;
  /** Group Id. */
  groupId: Scalars['BigInt'];
  /** Group Insight Id. */
  id: Scalars['Int'];
  /** Flag to include the group insight in the digest. */
  includeInDigest: Scalars['Boolean'];
  /** Flag to include the group insight in the report. */
  includeInReport: Scalars['Boolean'];
  /** Description for the group insight. */
  insightDescription?: Maybe<Scalars['String']>;
  /** Start date for the group insight. */
  insightStartDate?: Maybe<Scalars['Date']>;
  /** Title (header) for the insight. */
  insightTitle?: Maybe<Scalars['String']>;
  /** Flag to supress the group insight. */
  isSuppressed: Scalars['Boolean'];
  /** End date for the group insight. */
  reportEndDate?: Maybe<Scalars['Date']>;
  /** Start date for the group insight. */
  reportStartDate?: Maybe<Scalars['Date']>;
  /** Team Id. */
  teamId: Scalars['Int'];
  /** Time window for the group insight. */
  timeWindow: Insights_Time_Window;
};

export type GroupLight = {
  __typename?: 'GroupLight';
  ancestors?: Maybe<Array<GroupLight>>;
  /** ID of the Group */
  id: Scalars['BigInt'];
  /** Status of the group */
  status: Group_Status;
  summary?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  teamName?: Maybe<Scalars['String']>;
  /** Title of the group */
  title: Scalars['String'];
  totalDescendants?: Maybe<Scalars['Int']>;
  /** Type fo the group */
  type: Group_Type;
};

export type GroupSentenceMapping = {
  __typename?: 'GroupSentenceMapping';
  /** Flag indicating if the sentence belongs to the group or not. True - belongs False - does not belong. */
  belongs: Scalars['Boolean'];
  /**
   * ID of the Sentence Mapping
   * @deprecated don't use this. This is a bridge table. Ids are transient
   */
  id: Scalars['BigInt'];
  sentence: Sentence;
};

export type GroupStatistics = {
  __typename?: 'GroupStatistics';
  /** The denominator of the group */
  denominator: GroupDenominator;
  /** The mentions over time for the group */
  mentionsOverTime?: Maybe<SeriesData>;
};

export type GroupsCount = {
  __typename?: 'GroupsCount';
  amount: Scalars['Int'];
};

export type IChartSeries = {
  __typename?: 'IChartSeries';
  seriesData: Array<IChartableItem>;
  seriesId: Scalars['Int'];
  seriesTitle: Scalars['String'];
  totalValue: Scalars['Float'];
};

export type IChartableItem = {
  __typename?: 'IChartableItem';
  count: Scalars['Int'];
  date: Scalars['Date'];
};

export type IDescribeSourceFieldsKickoffResult = {
  __typename?: 'IDescribeSourceFieldsKickoffResult';
  describeSourceFieldsUuid: Scalars['String'];
};

export type IEntiresChart = {
  __typename?: 'IEntiresChart';
  entries: Array<IChartableItem>;
  totalEntries: Scalars['Int'];
};

export type IExecutionResult = {
  __typename?: 'IExecutionResult';
  executionUuid: Scalars['String'];
  responsePayload?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type IMultiSeriesChart = {
  __typename?: 'IMultiSeriesChart';
  seriesDenominator: Array<IChartableItem>;
  seriesSets: Array<IChartSeries>;
  totalDenominator: Scalars['Float'];
};

export type IScraperResult = {
  __typename?: 'IScraperResult';
  appName: Scalars['String'];
  response: Scalars['String'];
  success: Scalars['Boolean'];
};

export type IValidationKickoffResult = {
  __typename?: 'IValidationKickoffResult';
  validationUuid: Scalars['String'];
};

export type Insight = {
  __typename?: 'Insight';
  chartBin: Chart_Bin_Type;
  collection: InsightCollection;
  creationSource: Scalars['String'];
  digest: Digest;
  entries: Array<Feedback_Entries>;
  /** Whether or not to exclude this insight from the digest */
  excludeFromDigest: Scalars['Boolean'];
  expirationDate: Scalars['Date'];
  feedbackStatus: Digest_Group_Status;
  /** Filters that are saved explicitly on the insight. This includes the start date and end date from the insight. This is a different set of filters than what's on the chart */
  filterInput: SavedFilterInput;
  id: Scalars['Int'];
  insightStatus: Insight_Status;
  insightType: Insight_Type;
  /** The order of the insight in the digest */
  order: Scalars['Int'];
  sources: Scalars['String'];
  team: Teams;
  text: Scalars['String'];
  title: Scalars['String'];
};

export type InsightCollection = {
  __typename?: 'InsightCollection';
  id: Scalars['BigInt'];
  title?: Maybe<Scalars['String']>;
  type: Insight_Collection_Type;
};

export type IntegrationFilterInput = {
  comparison: ComparisonType;
  filterId?: InputMaybe<Scalars['Int']>;
  segmentGroupId?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type IntegrationType = {
  displayDescription: Scalars['String'];
  displayLogoUrl: Scalars['String'];
  displayName: Scalars['String'];
  frontendViewable: Scalars['Boolean'];
  requirements?: InputMaybe<Array<IntegrationTypeRequirement>>;
  scraperKey: Scalars['String'];
  sourceKey: Scalars['String'];
};

export type IntegrationTypeRequirement = {
  fieldRequired: Scalars['Boolean'];
  obfuscate: Scalars['Boolean'];
  requirementDisplayDescription: Scalars['String'];
  requirementDisplayName: Scalars['String'];
  requirementExample: Scalars['String'];
  requirementKey: Scalars['String'];
};

export type IntegrationTypeRequirementInput = {
  /** id field of integration_type_requirement */
  id: Scalars['Int'];
  /** Value for the required field */
  value: Scalars['String'];
  /** Optional id field for the value. If value already exists include the valueId field and the value will be updated. */
  valueId?: InputMaybe<Scalars['Int']>;
};

export type InternalUser = {
  __typename?: 'InternalUser';
  email: Scalars['String'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export enum InviteLinkStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type JiraProject = {
  __typename?: 'JiraProject';
  key: Scalars['String'];
  name: Scalars['String'];
  providerUniqueId: Scalars['String'];
};

export type Label = {
  __typename?: 'Label';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LinearTeam = {
  __typename?: 'LinearTeam';
  key: Scalars['String'];
  name: Scalars['String'];
  providerUniqueId: Scalars['String'];
};

export type MaxStarsFilterInput = {
  amounts: Array<Scalars['Int']>;
  filterCondition: FilterType;
};

export type MinStarsFilterInput = {
  amounts: Array<Scalars['Int']>;
  filterCondition: FilterType;
};

export type MutateExternalTicketsIntegration = {
  externalTicketsIntegrationId?: InputMaybe<Scalars['Int']>;
  integrationTypeId: Scalars['Int'];
  orgId: Scalars['Int'];
  requirements: Array<IntegrationTypeRequirementInput>;
};

export type MutateFeedbackIntegration = {
  feedbackIntegrationId?: InputMaybe<Scalars['Int']>;
  integrationName?: InputMaybe<Scalars['String']>;
  integrationTypeId: Scalars['Int'];
  requirements: Array<IntegrationTypeRequirementInput>;
  segmentGroups?: InputMaybe<Array<SegmentGroupInput>>;
  segments?: InputMaybe<Array<SegmentConfigInput>>;
  teamId: Scalars['Int'];
};

export type MutateStoreIntegration = {
  /** Values specific to the Google Maps integration */
  google?: InputMaybe<StoreInput>;
  /** Id of the feedback_segment_group that the feedback_segment_config(s) need pointed to. This should be the 'Store' group. */
  segmentGroupId: Scalars['Int'];
  /** Name of the store. This will create a feedback_segment_config for each integration created in this call with the value_override set to the value specified here. */
  storeName: Scalars['String'];
  /** Values specific to the Yelp integration */
  yelp?: InputMaybe<StoreInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Associates a domain with an organization. */
  addDomainToOrg: Org_Domains;
  addEmailToAlert: Alerts_Emails;
  addOrganizationUsers?: Maybe<Array<OrganizationUser>>;
  addPreviewPageLead: Preview_Page_Leads;
  addUserMapping: Users;
  addWidgetFeedback: Feedback_Entries;
  /** This is called when the search group fails to complete in the preview. This will fire an alarm */
  alertGroupFailed: Scalars['Boolean'];
  /** This finalizes the group. is meant to be called when a user approves or rejects the group. In reality all groups are rejected by default. This is really only called when someone wants to approve a group */
  approveGroup: Group;
  /** Assigns a given ChildGroup to a given ParentGroup. Returns the child group that gets assigned */
  assignChild: Group;
  /** resolver to bulk assign many children to a group. Returns all the children that were assigned. */
  assignChildren: Array<Group>;
  batchImport: EntryBatchImport;
  /** resolver to bulk assign many children to a group */
  bulkAssignChildren: Group;
  clearIntegrationValidationData?: Maybe<Scalars['Boolean']>;
  /** Clones a board and all its widgets (also cloned) */
  cloneBoard: Board;
  copyTeamEntries?: Maybe<Scalars['Boolean']>;
  createAlert: New_Alerts;
  /** Creates a new board */
  createBoard: Board;
  /** Manually create one changelog event. */
  createChangelog: Changelog;
  /** Creates a chart given configurations specified */
  createChart: Chart;
  /** Creates a chart given configurations specified */
  createChart2D: Chart2D;
  createDigest: Digest;
  createDigestSeries: Digest_Series;
  createDigestSeriesChannel: Digest_Series_Channel;
  /** Creates a group of feedback given a query string */
  createGroup: Group;
  /** Adds a row to group_insights */
  createGroupInsight: Group_Insights;
  /** Create an Insight */
  createInsight: Insight;
  createIntegrationType?: Maybe<Integration_Type>;
  createOauthStateSecret: User_Oauth_Secret_State;
  createOnDemandInsight: OnDemandInsight;
  createOrganization: Organization;
  /** Creates an AWS Secret and returns the title of the secret */
  createSecret?: Maybe<Scalars['String']>;
  createSegmentGroup: Feedback_Segment_Group;
  createSlackConnection?: Maybe<Org_Connections>;
  /** Use this to create new stores for teams that pull in both google and yelp reviews for specific locations. Note if either store id exists this will return an error complaining that the store exists, and will return the segment override value. */
  createStoreIntegration: Array<Feedback_Integration>;
  createTag: Tag;
  createTeam: Teams;
  createToken: User_Token;
  createUser: Users;
  /** Creates new widgets on a board, based on the provided input with existing underlying resources */
  createWidgets: Array<Widget>;
  deleteAlert?: Maybe<New_Alerts>;
  /** Deletes a board and all its widgets */
  deleteBoard: Scalars['Boolean'];
  /** Delete one changelog event. */
  deleteChangelog: Changelog;
  /** Deletes a chart by id */
  deleteChart?: Maybe<Chart>;
  deleteDigest: Digest;
  /** Remove a digest series channel from a digest series. This doesn't actually delete the channel it just sets the channel to inactive. */
  deleteDigestSeriesChannel: Digest_Series_Channel;
  /** Remove a team from a digest series. */
  deleteDigestSeriesTeam: Digest_Series;
  deleteEntry?: Maybe<Feedback_Entries>;
  /** Deletes a row from group_insights */
  deleteGroupInsight?: Maybe<Group_Insights>;
  deleteOrgConnection?: Maybe<Org_Connections>;
  deleteOrganization?: Maybe<Organization>;
  deleteTeam?: Maybe<Teams>;
  deleteToken: User_Token;
  /** Deletes a widget from a board. Both the widget and the underlying resource (chart, table, etc) are deleted. */
  deleteWidget: Scalars['Boolean'];
  /** Duplicates existing widgets on a board, based on the provided input with existing underlying resources */
  duplicateWidgets: Array<Widget>;
  editAlert?: Maybe<New_Alerts>;
  /** Edit one changelog event. */
  editChangelog: Changelog;
  /** Edits a chart belonging to a team */
  editChart: Chart;
  /** Edits a chart belonging to a team */
  editChart2D: Chart2D;
  editChecklistItem: Trial_Checklist_Items;
  editDigestSeriesTeam: Digest_Series;
  editFeedbackEntrySentiment?: Maybe<Feedback_Entries>;
  /** resolver to make edits to a group */
  editGroup: EditGroupResult;
  /** Deletes a row from group_insights */
  editGroupInsight?: Maybe<Group_Insights>;
  editOrganization?: Maybe<Organization>;
  editTeam?: Maybe<Teams>;
  entriesUpload: Array<Feedback_Entries>;
  externalTicketsIntegration: External_Tickets_Integration;
  feedbackIntegration: Feedback_Integration;
  generateDraftDigestEmail: DeliveryStatus;
  /** Generate a taxonomy schema based on instructions */
  generateTaxonomySchema: Scalars['String'];
  grantAccessRequest?: Maybe<OrganizationUser>;
  /** Handles keeping unwrap service in sync with google account sign on. */
  handleGoogleSignIn: Scalars['Boolean'];
  internalPermissions?: Maybe<Scalars['Boolean']>;
  /** Kicks off integrations for a team specified. This will by default update all segments for each entry. */
  kickOffTeamImport: Scalars['Boolean'];
  /** Trigger a process using the provided taxonomy schema */
  kickoffAutoTaxonomyProcess: Scalars['Boolean'];
  linkAsanaTicket: External_Ticket;
  linkJiraTicket: External_Ticket;
  linkLinearTicket: External_Ticket;
  /** Adds a row to the group_views table. */
  logGroupView: Group_Views;
  /** Adds or removes an entry to/from a group. Adding will add the distillate to the group. Removing will remove all sentences (including the distillate) from the group. */
  modifyEntryGroupMembership?: Maybe<Feedback_Entries>;
  moveTeam?: Maybe<Scalars['Boolean']>;
  nlpLaunch: Scalars['Boolean'];
  /** This will create an insight for the group and add it to the latest digest in a realtime digest series. */
  publishRealtimeTrend: Array<Digest>;
  rawIntercomUpload: Array<Raw_Intercom_Data>;
  /** resolver to remove a child from a parent. Returns the new Parent Group */
  removeChild: Group;
  /** Removes a domain from an organization. */
  removeDomainFromOrg: Scalars['Boolean'];
  removeEmailFromAlert: Alerts_Emails;
  /** Sets the group owner to the id supplied in args. Group owners have the group automatically added to their pins. */
  removeGroupOwner: Group;
  removeOrganizationUser?: Maybe<Array<OrganizationUser>>;
  /** Removes tag from a group. Does not delete tag. */
  removeTagFromGroup: Tag;
  replyToReviews: Array<FeedbackReply>;
  /** Allow an authenticated user to request access to an organization. The user must be signed in before requesting access. Returns name of the organization that the access request went to. */
  requestAccessToOrganization?: Maybe<Scalars['String']>;
  /** Saves a plot and returns the id of the saved plot */
  savePlot: Scalars['Int'];
  sendAnnouncementEmail: Announcement_Emails;
  /** @deprecated Don't use this anymore. Use "generateDraftDigestEmail" instead. */
  sendDigest: Digest;
  /** This will send the given digest to the configured slack channels on the DigestSeries. */
  sendDigestToSlack: DeliveryStatus;
  sendGroupComplete?: Maybe<Teams>;
  sendTestDigestEmail: DeliveryStatus;
  sendTestSlack: DeliveryStatus;
  setDefaultOrganizationTeam?: Maybe<Organization>;
  setDefaultRole?: Maybe<Organization>;
  setDigestStatus: Digest;
  setDigestSubject: Digest;
  /** Suggest Insights */
  suggestInsights: Array<Insight>;
  tagGroup: Tag;
  togglePinBoardForUser: Scalars['Boolean'];
  /** Allow the user in context to 'pin' the group. If this is called and the user already has this group pinned this will un-pin the group */
  togglePinGroup: Group;
  unlinkAsanaTicket?: Maybe<Scalars['Boolean']>;
  unlinkJiraTicket?: Maybe<Scalars['Boolean']>;
  unlinkLinearTicket?: Maybe<Scalars['Boolean']>;
  updateAutoPopulateSGList: Digest_Series;
  updateBoardDescription: Board;
  /** Updates the filter for a board. This is deprecated and will be removed in the future. */
  updateBoardFilter: Board;
  /** Updates the filter node for a board. This is the new way to update the filter for a board. */
  updateBoardFilterNode: Board;
  updateBoardLayout: Board;
  updateBoardTitle: Board;
  /** Update the user's status of the campaign (i.e. whether or not they've dismissed or acknowledged the campaign) */
  updateCampaignTreatment: Campaign;
  updateDigestSeriesSendFrequency: Digest_Series;
  /** Updates whether a domain can be discovered. */
  updateDomainDiscovery: Org_Domains;
  /** Sets the group owner to the id supplied in args. Group owners have the group automatically added to their pins. */
  updateGroupOwner: Group;
  /** Update Insight */
  updateInsight: Insight;
  updateIntegrationRequirementValue: Feedback_Integration;
  updateOrganizationUser?: Maybe<Array<OrganizationUser>>;
  updateTeamDefaults: TeamDefaults;
  /** Upload scraped changelog data from a given feedback integration. */
  uploadChangelogs?: Maybe<Array<Changelog>>;
  upsertReview: SubmitReviewPayload;
};


export type MutationAddDomainToOrgArgs = {
  allowDiscovery: Scalars['Boolean'];
  domain: Scalars['String'];
  orgId: Scalars['Int'];
};


export type MutationAddEmailToAlertArgs = {
  alertId: Scalars['Int'];
  newEmail: Scalars['String'];
  teamId: Scalars['Int'];
};


export type MutationAddOrganizationUsersArgs = {
  orgId: Scalars['Int'];
  usersToAdd?: InputMaybe<Array<AddUserToOrg>>;
};


export type MutationAddPreviewPageLeadArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddUserMappingArgs = {
  unwrapUserId: Scalars['Int'];
};


export type MutationAddWidgetFeedbackArgs = {
  email: Scalars['String'];
  feedback: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
};


export type MutationAlertGroupFailedArgs = {
  email?: InputMaybe<Scalars['String']>;
  queryString: Scalars['String'];
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
  wasRetried: Scalars['Boolean'];
};


export type MutationApproveGroupArgs = {
  belongingSentenceIds?: InputMaybe<Array<Scalars['BigInt']>>;
  differingSentenceIds?: InputMaybe<Array<Scalars['BigInt']>>;
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type MutationAssignChildArgs = {
  childGroupId: Scalars['BigInt'];
  filterInput?: InputMaybe<FilterInput>;
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationAssignChildrenArgs = {
  childGroupIds: Array<Scalars['BigInt']>;
  filterInput?: InputMaybe<FilterInput>;
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationBatchImportArgs = {
  entries: Array<BatchEntryInput>;
  teamId: Scalars['Int'];
};


export type MutationBulkAssignChildrenArgs = {
  childGroupIds: Array<Scalars['BigInt']>;
  filterInput?: InputMaybe<FilterInput>;
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationClearIntegrationValidationDataArgs = {
  integrationType: MutateFeedbackIntegration;
};


export type MutationCloneBoardArgs = {
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationCopyTeamEntriesArgs = {
  destinationTeamId: Scalars['Int'];
  originTeamId: Scalars['Int'];
};


export type MutationCreateAlertArgs = {
  alertName?: InputMaybe<Scalars['String']>;
  cadence?: InputMaybe<CadenceType>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  filterInput: FilterInput;
  period?: InputMaybe<Scalars['Int']>;
  slackChannelID?: InputMaybe<Scalars['String']>;
  slackChannelName?: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
  threshold?: InputMaybe<Scalars['Int']>;
  type?: AlertType;
};


export type MutationCreateBoardArgs = {
  description?: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
  title: Scalars['String'];
};


export type MutationCreateChangelogArgs = {
  date: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
  title: Scalars['String'];
};


export type MutationCreateChartArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  editChartInput: EditChartInput;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type MutationCreateChart2DArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  editChartInput: EditChartInput;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type MutationCreateDigestArgs = {
  digestSeriesId: Scalars['Int'];
};


export type MutationCreateDigestSeriesArgs = {
  digestSeriesType: DigestSeriesType;
  orgId: Scalars['Int'];
  sendFrequency: DigestSendFrequency;
  teamIds: Array<Scalars['Int']>;
  title: Scalars['String'];
};


export type MutationCreateDigestSeriesChannelArgs = {
  channelType: Channel_Type;
  sendGrid?: InputMaybe<SendGridDigestSeriesChannel>;
  seriesId: Scalars['Int'];
  slack?: InputMaybe<SlackDigestSeriesChannel>;
};


export type MutationCreateGroupArgs = {
  email?: InputMaybe<Scalars['String']>;
  excludeFromNewFilter?: InputMaybe<Scalars['Boolean']>;
  queryString: Scalars['String'];
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type MutationCreateGroupInsightArgs = {
  filterStartDate: Scalars['Date'];
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationCreateInsightArgs = {
  chartBin: Chart_Bin_Type;
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  digestId: Scalars['Int'];
  entryIds: Array<Scalars['BigInt']>;
  excludeFromDigest?: InputMaybe<Scalars['Boolean']>;
  expirationDate: Scalars['Date'];
  feedbackStatus: Digest_Group_Status;
  filterInput: FilterInput;
  order?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
  title: Scalars['String'];
};


export type MutationCreateIntegrationTypeArgs = {
  integration: IntegrationType;
};


export type MutationCreateOauthStateSecretArgs = {
  orgId: Scalars['Int'];
};


export type MutationCreateOnDemandInsightArgs = {
  draftDescription: Scalars['String'];
  draftTitle: Scalars['String'];
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String'];
};


export type MutationCreateSecretArgs = {
  secretName: Scalars['String'];
  secretValue: Scalars['String'];
};


export type MutationCreateSegmentGroupArgs = {
  displayName: Scalars['String'];
  teamId: Scalars['Int'];
  valueType: SegmentType;
};


export type MutationCreateSlackConnectionArgs = {
  code: Scalars['String'];
  orgId: Scalars['Int'];
  secretStateFromSlack: Scalars['String'];
};


export type MutationCreateStoreIntegrationArgs = {
  store: MutateStoreIntegration;
  teamId: Scalars['Int'];
};


export type MutationCreateTagArgs = {
  chartId?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
};


export type MutationCreateTeamArgs = {
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orgId: Scalars['Int'];
  usersRoles?: InputMaybe<Array<UserRolesInput>>;
};


export type MutationCreateUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  inviteLinkHash?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
};


export type MutationCreateWidgetsArgs = {
  boardId: Scalars['Int'];
  inputWidgets: Array<NewWidgetInput>;
  keepOriginalResources?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
};


export type MutationDeleteAlertArgs = {
  alertId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationDeleteBoardArgs = {
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationDeleteChangelogArgs = {
  changelogId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationDeleteChartArgs = {
  chartId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationDeleteDigestArgs = {
  digestId: Scalars['Int'];
};


export type MutationDeleteDigestSeriesChannelArgs = {
  channelId: Scalars['Int'];
  seriesId: Scalars['Int'];
};


export type MutationDeleteDigestSeriesTeamArgs = {
  seriesId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationDeleteEntryArgs = {
  entryId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationDeleteGroupInsightArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationDeleteOrgConnectionArgs = {
  connectionId: Scalars['Int'];
  orgId: Scalars['Int'];
};


export type MutationDeleteOrganizationArgs = {
  name?: InputMaybe<Scalars['String']>;
  orgId: Scalars['Int'];
};


export type MutationDeleteTeamArgs = {
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationDeleteTokenArgs = {
  tokenId: Scalars['Int'];
};


export type MutationDeleteWidgetArgs = {
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  widgetId: Scalars['Int'];
};


export type MutationDuplicateWidgetsArgs = {
  boardId: Scalars['Int'];
  inputWidgets: Array<NewWidgetInput>;
  teamId: Scalars['Int'];
};


export type MutationEditAlertArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  alertId: Scalars['Int'];
  alertName?: InputMaybe<Scalars['String']>;
  cadence?: InputMaybe<CadenceType>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  filterInput?: InputMaybe<FilterInput>;
  period?: InputMaybe<Scalars['Int']>;
  slackChannelID?: InputMaybe<Scalars['String']>;
  slackChannelName?: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
  threshold?: InputMaybe<Scalars['Int']>;
};


export type MutationEditChangelogArgs = {
  changelogId: Scalars['Int'];
  date?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationEditChartArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  chartId: Scalars['Int'];
  editChartInput: EditChartInput;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type MutationEditChart2DArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  chartId: Scalars['Int'];
  editChartInput: EditChartInput;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type MutationEditChecklistItemArgs = {
  id: Scalars['Int'];
  isCompleted?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type MutationEditDigestSeriesTeamArgs = {
  id: Scalars['Int'];
  teamIds: Array<Scalars['Int']>;
};


export type MutationEditFeedbackEntrySentimentArgs = {
  entryId: Scalars['BigInt'];
  sentiment: Scalars['Float'];
  teamId: Scalars['Int'];
};


export type MutationEditGroupArgs = {
  filterInput?: InputMaybe<FilterInput>;
  groupId: Scalars['BigInt'];
  input: EditGroupInput;
  teamId: Scalars['Int'];
};


export type MutationEditGroupInsightArgs = {
  description?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  groupId: Scalars['BigInt'];
  groupStatus?: InputMaybe<Digest_Group_Status>;
  includeInDigest?: InputMaybe<Scalars['Boolean']>;
  includeInReport?: InputMaybe<Scalars['Boolean']>;
  reportMonthDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  teamId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationEditOrganizationArgs = {
  name?: InputMaybe<Scalars['String']>;
  orgId: Scalars['Int'];
};


export type MutationEditTeamArgs = {
  name?: InputMaybe<Scalars['String']>;
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
  userRoles?: InputMaybe<Array<UserRolesInput>>;
};


export type MutationEntriesUploadArgs = {
  feedbackIntegrationId: Scalars['Int'];
  input: Array<FeedbackEntryInput>;
  kickOffNlp?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
  updateEntries?: InputMaybe<Scalars['Boolean']>;
};


export type MutationExternalTicketsIntegrationArgs = {
  input: MutateExternalTicketsIntegration;
  orgId: Scalars['Int'];
};


export type MutationFeedbackIntegrationArgs = {
  input: MutateFeedbackIntegration;
};


export type MutationGenerateDraftDigestEmailArgs = {
  digestId: Scalars['Int'];
};


export type MutationGenerateTaxonomySchemaArgs = {
  instructions: Scalars['String'];
  previousSchema?: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
};


export type MutationGrantAccessRequestArgs = {
  linkHash: Scalars['String'];
};


export type MutationHandleGoogleSignInArgs = {
  linkHash?: InputMaybe<Scalars['String']>;
};


export type MutationInternalPermissionsArgs = {
  orgId: Scalars['Int'];
  role: Role;
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationKickOffTeamImportArgs = {
  monthsToScrape?: InputMaybe<Scalars['Int']>;
  overrideLatestReviews?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
  updateEntryRows?: InputMaybe<Scalars['Boolean']>;
};


export type MutationKickoffAutoTaxonomyProcessArgs = {
  schema: Scalars['String'];
  teamId: Scalars['Int'];
};


export type MutationLinkAsanaTicketArgs = {
  externalTicketsIntegrationId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  input: ExternalTicketInput;
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationLinkJiraTicketArgs = {
  externalTicketsIntegrationId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  input: ExternalTicketInput;
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationLinkLinearTicketArgs = {
  externalTicketsIntegrationId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  input: ExternalTicketInput;
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationLogGroupViewArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationModifyEntryGroupMembershipArgs = {
  action: Group_Membership_Action;
  entryId: Scalars['BigInt'];
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationMoveTeamArgs = {
  destinationOrgId: Scalars['Int'];
  originOrgId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationNlpLaunchArgs = {
  categorizeOnly?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
};


export type MutationPublishRealtimeTrendArgs = {
  teamId: Scalars['Int'];
  trends: Array<TrendInput>;
};


export type MutationRawIntercomUploadArgs = {
  rawEntries: Array<RawIntercomEntryInput>;
  teamId: Scalars['Int'];
};


export type MutationRemoveChildArgs = {
  childGroupId: Scalars['BigInt'];
  filterInput?: InputMaybe<FilterInput>;
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationRemoveDomainFromOrgArgs = {
  orgDomainId: Scalars['Int'];
  orgId: Scalars['Int'];
};


export type MutationRemoveEmailFromAlertArgs = {
  alertEmailId: Scalars['Int'];
  alertId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationRemoveGroupOwnerArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationRemoveOrganizationUserArgs = {
  orgId: Scalars['Int'];
  userToDeleteEmail: Scalars['String'];
};


export type MutationRemoveTagFromGroupArgs = {
  groupId: Scalars['BigInt'];
  tagId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationReplyToReviewsArgs = {
  replyInput: Array<EntryReplyInput>;
  teamId: Scalars['Int'];
};


export type MutationRequestAccessToOrganizationArgs = {
  orgId?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['Int']>;
};


export type MutationSavePlotArgs = {
  boardId: Scalars['Int'];
  id: Scalars['Int'];
  plotConfigurationInput: PlotConfig;
  teamId: Scalars['Int'];
};


export type MutationSendAnnouncementEmailArgs = {
  body: Scalars['String'];
  groupId: Scalars['BigInt'];
  image?: InputMaybe<Scalars['String']>;
  orgId: Scalars['Int'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  teamId: Scalars['Int'];
};


export type MutationSendDigestArgs = {
  digestId: Scalars['Int'];
};


export type MutationSendDigestToSlackArgs = {
  digestId: Scalars['Int'];
};


export type MutationSendGroupCompleteArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationSendTestDigestEmailArgs = {
  digestId: Scalars['Int'];
  emailAddress: Scalars['String'];
};


export type MutationSendTestSlackArgs = {
  digestId: Scalars['Int'];
};


export type MutationSetDefaultOrganizationTeamArgs = {
  defaultTeamId?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['Int'];
};


export type MutationSetDefaultRoleArgs = {
  defaultRole: Role;
  orgId: Scalars['Int'];
};


export type MutationSetDigestStatusArgs = {
  digestId: Scalars['Int'];
  status: DigestStatus;
};


export type MutationSetDigestSubjectArgs = {
  digestId: Scalars['Int'];
  subject: Scalars['String'];
};


export type MutationSuggestInsightsArgs = {
  digestId: Scalars['Int'];
};


export type MutationTagGroupArgs = {
  groupId: Scalars['BigInt'];
  tagId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationTogglePinBoardForUserArgs = {
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationTogglePinGroupArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type MutationUnlinkAsanaTicketArgs = {
  externalTicketId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
};


export type MutationUnlinkJiraTicketArgs = {
  externalTicketId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
};


export type MutationUnlinkLinearTicketArgs = {
  externalTicketId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
};


export type MutationUpdateAutoPopulateSgListArgs = {
  autoPopulateSGList: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type MutationUpdateBoardDescriptionArgs = {
  boardId: Scalars['Int'];
  description: Scalars['String'];
  teamId: Scalars['Int'];
};


export type MutationUpdateBoardFilterArgs = {
  boardId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type MutationUpdateBoardFilterNodeArgs = {
  boardId: Scalars['Int'];
  filterNode: Scalars['FilterNode'];
  teamId: Scalars['Int'];
};


export type MutationUpdateBoardLayoutArgs = {
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  widgets: Array<ExistingWidgetInput>;
};


export type MutationUpdateBoardTitleArgs = {
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  title: Scalars['String'];
};


export type MutationUpdateCampaignTreatmentArgs = {
  campaignId: Scalars['Int'];
  status: Campaign_Status;
};


export type MutationUpdateDigestSeriesSendFrequencyArgs = {
  id: Scalars['Int'];
  sendFrequency: DigestSendFrequency;
};


export type MutationUpdateDomainDiscoveryArgs = {
  allowDiscovery: Scalars['Boolean'];
  orgDomainId: Scalars['Int'];
  orgId: Scalars['Int'];
};


export type MutationUpdateGroupOwnerArgs = {
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationUpdateInsightArgs = {
  chartBin: Chart_Bin_Type;
  entryIds: Array<Scalars['BigInt']>;
  excludeFromDigest?: InputMaybe<Scalars['Boolean']>;
  expirationDate: Scalars['Date'];
  feedbackStatus: Digest_Group_Status;
  filterInput: FilterInput;
  insightId: Scalars['Int'];
  insightStatus: Insight_Status;
  order: Scalars['Int'];
  text: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateIntegrationRequirementValueArgs = {
  feedbackIntegrationId: Scalars['Int'];
  requirementKey: Scalars['String'];
  teamId: Scalars['Int'];
  updatedValue: Scalars['String'];
};


export type MutationUpdateOrganizationUserArgs = {
  assignedRoles?: InputMaybe<Array<AssignedRoles>>;
  orgId: Scalars['Int'];
  role?: InputMaybe<Organization_Users_Role>;
  userToUpdateEmail: Scalars['String'];
};


export type MutationUpdateTeamDefaultsArgs = {
  customer_locked_out?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Date']>;
  exploreDefaultWindow?: InputMaybe<Date_Window>;
  lock_out_message?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type MutationUploadChangelogsArgs = {
  changelogs: Array<ChangelogInput>;
  feedbackIntegrationId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type MutationUpsertReviewArgs = {
  feature: Unwrap_Feature;
  feedback: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  rating: Scalars['Int'];
  teamId: Scalars['Int'];
};

export type NewWidgetInput = {
  widgetType: Board_Widget_Type;
  widgetTypeId: Scalars['Int'];
};

export type OnDemandInsight = {
  __typename?: 'OnDemandInsight';
  description: Scalars['String'];
  title: Scalars['String'];
};

export enum Operator {
  Equal = 'EQUAL',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export type OrgSlackChannels = {
  __typename?: 'OrgSlackChannels';
  channels: Array<SlackChannelInfo>;
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  /** If the user is confirmed or not. Reasons for not being confirmed are if the user was invited but has yet to sign up and accept. */
  confirmed: Scalars['Boolean'];
  /** User's email. */
  email: Scalars['String'];
  /** Organization that User belongs to. */
  organization: Organization;
  /** User's roles in the organization. Members have limited ability on the organization. */
  role: Organization_Users_Role;
  /** Teams that the user is a member of. */
  teams: Array<Teams>;
  /** Relationship to the Unwrap user representation. */
  user?: Maybe<Users>;
};

export enum OrganizationUsersRole {
  Admin = 'admin',
  Member = 'member'
}

export type OwnerFilterInput = {
  filterCondition: FilterType;
  owner: Array<OwnerInput>;
};

export type OwnerInput = {
  user_id: Scalars['Int'];
};

/** Permission */
export type Permission = {
  __typename?: 'Permission';
  actions: Array<Action>;
  resource: Resource;
};

export type PinnedGroupDep = {
  __typename?: 'PinnedGroupDep';
  pinner: Pinner;
};

export type Pinner = {
  __typename?: 'Pinner';
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type Plot = {
  __typename?: 'Plot';
  /** ID of the Chart */
  id: Scalars['Int'];
  plotConfiguration: PlotConfigurationOutput;
  rangeEnd: Scalars['Float'];
  rangeStart: Scalars['Float'];
  series: Array<PlotSeries>;
  /** Title of the chart. This is a mutatable field. */
  title: Scalars['String'];
  tooltipLabels: Array<Scalars['String']>;
  /** This is the unnormalized data series. This explicitly supports group charts. */
  unNormalizedSeries: Array<PlotSeries>;
  xAxisLabels: Array<Scalars['String']>;
};

/** Input for a chart configuration. This is used in creating / updating a chart, as well as previewing a chart configuration. */
export type PlotConfig = {
  binSelection: Chart_Bin_Type;
  breakdown?: InputMaybe<Breakdown>;
  chartType: Chart_Type;
  series: Array<DataSeriesConfiguration>;
  title: Scalars['String'];
  yAxisMetric: Y_Axis_Data;
};

export type PlotConfigurationOutput = {
  __typename?: 'PlotConfigurationOutput';
  breakdown?: Maybe<Breakdown>;
  chartBinType: Chart_Bin_Type;
  chartType: Chart_Type;
  seriesConfig: Array<DataSeriesConfigurationOutput>;
  title: Scalars['String'];
  yAxisMetric: Y_Axis_Data;
};

export type PlotSeries = {
  __typename?: 'PlotSeries';
  customName?: Maybe<Scalars['String']>;
  dataSeries: Array<Scalars['Float']>;
  seriesLabel: Label;
};

export type PotentialWidget = {
  __typename?: 'PotentialWidget';
  title: Scalars['String'];
  widgetType: Board_Widget_Type;
  widgetTypeId: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  /** Returns permissions for the current user and team */
  accessControlList: Array<Permission>;
  /** Returns all organizations that a user belongs to. */
  allOrganizations?: Maybe<Array<Organization>>;
  allTeams?: Maybe<Array<Teams>>;
  /** Returns amount of entries with filter */
  amountOfEntries: EntriesCount;
  /** Returns amount of groups */
  amountOfGroups: GroupsCount;
  /** Retrieve the user from the token provided. This is used for authentication. */
  authenticatedUser: User;
  checklistItems?: Maybe<Array<Trial_Checklist_Items>>;
  connections?: Maybe<Array<Connection_Type>>;
  /** Gets all users both confirmed and invited for an organization. */
  currentOrgUser?: Maybe<OrganizationUser>;
  describeSourceFields?: Maybe<IDescribeSourceFieldsKickoffResult>;
  /** Returns all of the digest series in descending order of date created */
  digestSeries: Array<Digest_Series>;
  digestSeriesChannels: Array<Digest_Series_Channel>;
  digestSeriesTeam: Array<Digest_Series_Team>;
  digests: Array<Digest>;
  /** This query returns organizations that match the user's domain and can be discovered. */
  discoverOrgs?: Maybe<Array<DiscoverableOrg>>;
  /** Returns the earliest feedback date for a team. */
  earliestFeedbackDate: Scalars['String'];
  emailExists: Scalars['Boolean'];
  /** Returns feedback Entries for a team. Entries are the full customer review with any related metadata. */
  entries?: Maybe<Array<Feedback_Entries>>;
  /** Specific queries for aggregated entries over time averaged by day */
  feedbackEntriesByTime: IEntiresChart;
  feedbackIntegration?: Maybe<Array<Feedback_Integration>>;
  /** Returns a full conversation for a given feedback entry. */
  fullConversation?: Maybe<Array<Conversation_Part>>;
  generateGptReplies?: Maybe<Array<GeneratedGptReply>>;
  /** Get a list of active digests for a given team Id. This returns digests in draft / ready for review state that have a mapping to the given teamId. */
  getActiveDigestsForTeam: Array<Digest>;
  /** Get the Insights for the team from the latest sent or approved digest that are not expired */
  getActiveInsightsForTeam: Array<Insight>;
  getAlert?: Maybe<New_Alerts>;
  getAlerts?: Maybe<Array<New_Alerts>>;
  /** Returns all groups in a team with very minimal meta data. This query needs to be fast. Be very careful adding meta data to GroupLight. */
  getAllGroups: Array<GroupLight>;
  /** Returns all groups in all teams in an org with very minimal meta data. */
  getAllGroupsFromOrg: Array<GroupLight>;
  /** Get all announcement emails for a given group. */
  getAnnouncementEmails: Array<Announcement_Emails>;
  /** Get all announcement recipients for a given group. */
  getAnnouncementRecipients?: Maybe<Array<AnnouncementRecipient>>;
  getAnnouncementTemplate: Scalars['String'];
  getAsanaProjects: Array<AsanaProject>;
  getAsanaTickets: Array<ExternalTicketData>;
  getAsanaWorkspaces: Array<AsanaWorkspace>;
  getBoard?: Maybe<Board>;
  getBoards: Array<Board>;
  /** Get the all information about the first unexpired campaign the user belongs to that they haven't seen yet. */
  getCampaign?: Maybe<Campaign>;
  /** Get all changelog data belonging to a specific team. */
  getChangelogs?: Maybe<Array<Changelog>>;
  getChannelId?: Maybe<Scalars['String']>;
  /** Returns all charts for a team */
  getChart: Chart;
  /** Returns a single time series chart */
  getChart2D: Chart2D;
  /** Returns an unsaved chart preview. */
  getChart2DPreview: Chart2D;
  /**
   * Returns all charts for a team
   * @deprecated Use 'getChart2D' instead, you should never be querying all charts at once.
   */
  getChart2Ds: Array<Chart2D>;
  /** Returns an unsaved chart preview. */
  getChartPreview: Chart;
  /**
   * Returns all charts for a team
   * @deprecated This is no longer used along with the Chart type contract. Use 'getChart2D' instead.
   */
  getCharts: Array<Chart>;
  /** Returns potential candidate children for a given group on a team. This has two modes: without a search string this will just return groups that overlap with the given group. With a search string this will return groups that match the search string, and ignore overlap. */
  getChildCandidates: Array<Group>;
  /** Returns all the children for a given group on a team */
  getChildren: Array<Group>;
  /** Returns all the child groups (with minimal data) for a given group on a team */
  getChildrenLight: Array<GroupLight>;
  /** resolver to return a set of children to the parent group. This doesn't automatically assign the child groups to the parent */
  getChildrenToAssign: Array<Group>;
  getDashboardAlerts: Array<Dashboard_Alerts>;
  getFilterFieldDisplay: FilterFieldDisplay;
  getFilterFieldValues: Array<FilterFieldValue>;
  getFilterFields: Array<FilterField>;
  /** Returns specified group */
  getGroup: Group;
  /** Returns the group specified by id with very minimal meta data. */
  getGroupById: GroupLight;
  /** Get all announcement recipients for a given group. */
  getGroupEmails?: Maybe<Array<AnnouncementRecipient>>;
  /** Returns group insights */
  getGroupInsights: Array<Group_Insights>;
  /** Returns all search groups for a team */
  getGroups: Array<Group>;
  /** Get an Insight by Id */
  getInsight: Insight;
  /** Get an Insight by a collection id and type */
  getInsightByCollection?: Maybe<Insight>;
  /** Get a plot preview for a given insight */
  getInsightPlotPreview: Plot;
  /** @deprecated This is deprecated use getInsightPrviewCharts */
  getInsightPreviewChartToDelete: SeriesData;
  getInsightPreviewCharts: Chart2D;
  /** Get a entries for an Insight by collection type and id. This currently just returns entries that match the specific collection and filters. The FE is responsible for merging these previews with anytthing that already exists on the insight */
  getInsightPreviewEntries: Array<Feedback_Entries>;
  /** Get data sources for a given team */
  getInsightSources: Scalars['String'];
  /** Get insights for a given digest */
  getInsights: Array<Insight>;
  getInviteLinkStatus: InviteLinkStatus;
  getJiraProjects: Array<JiraProject>;
  getJiraTickets: Array<ExternalTicketData>;
  getLinearTeams: Array<LinearTeam>;
  getLinearTickets: Array<ExternalTicketData>;
  getOrganization?: Maybe<Organization>;
  getOrganizationTeams?: Maybe<Array<Teams>>;
  /** Gets all users both confirmed and invited for an organization. */
  getOrganizationUsers?: Maybe<Array<OrganizationUser>>;
  /** Returns all organizations that a user belongs to. */
  getOrganizations?: Maybe<Array<Organization>>;
  /** Returns a single time series chart */
  getPlot: Plot;
  /** Returns an unsaved chart preview. */
  getPlotPreview: Plot;
  /** Returns all groups belonging to a specific preview page lead */
  getPreviewPageGroups: Array<Group>;
  getPreviewPageLead: Scalars['Boolean'];
  /** Returns specified group */
  getPublicGroup: Group;
  getTags?: Maybe<Array<Tag>>;
  /** Returns all the taxonomy for a team */
  getTaxonomy: Array<TaxonomyElement>;
  getTeamPotentialWidgets: Array<PotentialWidget>;
  getTokens: Array<User_Token>;
  /** Returns all the highest level parent groups for a team and the given filter set. */
  getTopLevelParents: Array<Group>;
  getUserAttributes: Users;
  /** Returns all the highest level parent groups for a team and the given filter set. If a filter statement is provided, it will only return groups that match the filter statement. */
  groupSearch: Array<TaxonomyTreeNode>;
  inMemTest: Scalars['String'];
  integrations?: Maybe<Array<Integration_Type>>;
  internalUsers: Array<InternalUser>;
  isOrganizationManagedByOkta?: Maybe<Scalars['Boolean']>;
  /** List all external tickets associated to a group */
  listExternalTickets: Array<External_Ticket>;
  /** Returns oldest feedback date (excluding empty and non-tokenized entries) */
  oldestFeedbackDate: Scalars['Date'];
  orgSlackChannels?: Maybe<OrgSlackChannels>;
  pollExecution?: Maybe<IExecutionResult>;
  /** Returns current team defaults for public teams. */
  publicTeamDefaults: TeamDefaults;
  publicTeamGroups?: Maybe<TeamGroups>;
  publicTeams?: Maybe<Teams>;
  /** Search for digest series by a given query */
  searchDigestSeries: Array<Digest_Series>;
  /** Search for digests by a given query */
  searchDigests: Array<Digest>;
  segments?: Maybe<Array<Feedback_Segment_Group>>;
  sentences?: Maybe<Array<Feedback_Sentences>>;
  similarSentences?: Maybe<Array<Feedback_Sentences>>;
  /** Gets distinct feedback entry sources given a team id. */
  sources: Array<Scalars['String']>;
  /** This is terribly named. This get's data from zapier, that's stored in a staging table. This is exclusively used by our data import system. Which only communicates over auth token */
  stagingData: Array<Data_Integration_Staging_Data>;
  teamCharts: TeamCharts;
  /** Returns current team defaults for all teams. */
  teamDefaultConfigs: Array<TeamDefaultConfigs>;
  /** Returns different team defaults values (oldest feedback date, default explore date windows, etc.) */
  teamDefaults: TeamDefaults;
  teamFlags?: Maybe<Team_Background_Job_Flags>;
  teamGroups?: Maybe<TeamGroups>;
  teams?: Maybe<Teams>;
  testExternalTicketsIntegration: Scalars['Boolean'];
  testIntegrationConnected?: Maybe<IScraperResult>;
  validateIntegrationConfig?: Maybe<IValidationKickoffResult>;
};


export type QueryAccessControlListArgs = {
  domains: Array<DomainInput>;
};


export type QueryAllTeamsArgs = {
  orgId: Scalars['Int'];
};


export type QueryAmountOfEntriesArgs = {
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  repliableOnly?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryAmountOfGroupsArgs = {
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  status?: InputMaybe<Group_Status>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Group_Type>;
};


export type QueryAuthenticatedUserArgs = {
  token: Scalars['String'];
};


export type QueryChecklistItemsArgs = {
  teamId: Scalars['Int'];
};


export type QueryCurrentOrgUserArgs = {
  orgId: Scalars['Int'];
};


export type QueryDescribeSourceFieldsArgs = {
  integrationType: MutateFeedbackIntegration;
};


export type QueryDigestSeriesArgs = {
  creatorId?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['Int']>;
  seriesId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDigestSeriesChannelsArgs = {
  seriesId: Scalars['Int'];
};


export type QueryDigestSeriesTeamArgs = {
  seriesId: Scalars['Int'];
};


export type QueryDigestsArgs = {
  creatorId?: InputMaybe<Scalars['Int']>;
  digestSeriesId?: InputMaybe<Scalars['Int']>;
  digestSeriesType?: InputMaybe<DigestSeriesType>;
  orgId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<DigestStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryEarliestFeedbackDateArgs = {
  teamId: Scalars['Int'];
};


export type QueryEmailExistsArgs = {
  email: Scalars['String'];
};


export type QueryEntriesArgs = {
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  modifiedSince?: InputMaybe<Scalars['Date']>;
  repliableOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByType>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryFeedbackEntriesByTimeArgs = {
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryFeedbackIntegrationArgs = {
  integrationId?: InputMaybe<Scalars['Int']>;
  integrationTypeId?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QueryFullConversationArgs = {
  entry_id: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type QueryGenerateGptRepliesArgs = {
  gptRepliesInput: Array<GptRepliesInput>;
  teamId: Scalars['Int'];
};


export type QueryGetActiveDigestsForTeamArgs = {
  teamId: Scalars['Int'];
};


export type QueryGetActiveInsightsForTeamArgs = {
  teamId: Scalars['Int'];
};


export type QueryGetAlertArgs = {
  alertId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type QueryGetAlertsArgs = {
  teamId: Scalars['Int'];
  type?: InputMaybe<AlertType>;
};


export type QueryGetAllGroupsArgs = {
  status?: InputMaybe<Group_Status>;
  teamId: Scalars['Int'];
  type?: InputMaybe<Group_Type>;
};


export type QueryGetAllGroupsFromOrgArgs = {
  orgId: Scalars['Int'];
  status?: InputMaybe<Group_Status>;
  type?: InputMaybe<Group_Type>;
};


export type QueryGetAnnouncementEmailsArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryGetAnnouncementRecipientsArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryGetAnnouncementTemplateArgs = {
  teamId: Scalars['Int'];
};


export type QueryGetAsanaProjectsArgs = {
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAsanaTicketsArgs = {
  orgId: Scalars['Int'];
  projectId: Scalars['String'];
  queryString: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAsanaWorkspacesArgs = {
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
};


export type QueryGetBoardArgs = {
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type QueryGetBoardsArgs = {
  teamId: Scalars['Int'];
  titleSubstring?: InputMaybe<Scalars['String']>;
};


export type QueryGetCampaignArgs = {
  pageName: Scalars['String'];
};


export type QueryGetChangelogsArgs = {
  teamId: Scalars['Int'];
};


export type QueryGetChannelIdArgs = {
  channelName: Scalars['String'];
  orgId: Scalars['Int'];
};


export type QueryGetChartArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  chartId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type QueryGetChart2DArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  chartId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type QueryGetChart2DPreviewArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  editChartInput: EditChartInput;
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type QueryGetChart2DsArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  filterInput?: InputMaybe<FilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QueryGetChartPreviewArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  editChartInput: EditChartInput;
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type QueryGetChartsArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  filterInput?: InputMaybe<FilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QueryGetChildCandidatesArgs = {
  groupTitleSearchString?: InputMaybe<Scalars['String']>;
  parentGroupId: Scalars['BigInt'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QueryGetChildrenArgs = {
  filterInput?: InputMaybe<FilterInput>;
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryGetChildrenLightArgs = {
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryGetChildrenToAssignArgs = {
  filterInput?: InputMaybe<FilterInput>;
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryGetDashboardAlertsArgs = {
  teamId: Scalars['Int'];
};


export type QueryGetFilterFieldDisplayArgs = {
  fieldName: Scalars['String'];
  filterValue: Scalars['String'];
  teamId: Scalars['Int'];
};


export type QueryGetFilterFieldValuesArgs = {
  fieldName: Scalars['String'];
  fieldStatementFilters: Scalars['FilterNode'];
  searchTerm?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type QueryGetFilterFieldsArgs = {
  fieldStatementFilters: Scalars['FilterNode'];
  teamId: Scalars['Int'];
};


export type QueryGetGroupArgs = {
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGetGroupByIdArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryGetGroupEmailsArgs = {
  filterInput?: InputMaybe<FilterInput>;
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryGetGroupInsightsArgs = {
  groupId?: InputMaybe<Scalars['BigInt']>;
  teamId: Scalars['Int'];
};


export type QueryGetGroupsArgs = {
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  getInsights?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeOrphans?: InputMaybe<Scalars['Boolean']>;
  pinnedByUser?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByType>;
  sortField?: InputMaybe<SortFieldType>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGetInsightArgs = {
  insightId: Scalars['Int'];
};


export type QueryGetInsightByCollectionArgs = {
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  digestId: Scalars['Int'];
};


export type QueryGetInsightPlotPreviewArgs = {
  chartBin?: InputMaybe<Chart_Bin_Type>;
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  filterNode: Scalars['FilterNode'];
  teamId: Scalars['Int'];
};


export type QueryGetInsightPreviewChartToDeleteArgs = {
  chartBin?: InputMaybe<Chart_Bin_Type>;
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type QueryGetInsightPreviewChartsArgs = {
  chartBin?: InputMaybe<Chart_Bin_Type>;
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type QueryGetInsightPreviewEntriesArgs = {
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
};


export type QueryGetInsightSourcesArgs = {
  teamId: Scalars['Int'];
};


export type QueryGetInsightsArgs = {
  digestId: Scalars['Int'];
  includeDenied?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetInviteLinkStatusArgs = {
  inviteLinkHash: Scalars['String'];
};


export type QueryGetJiraProjectsArgs = {
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
};


export type QueryGetJiraTicketsArgs = {
  orgId: Scalars['Int'];
  projectId: Scalars['String'];
  queryString: Scalars['String'];
};


export type QueryGetLinearTeamsArgs = {
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
};


export type QueryGetLinearTicketsArgs = {
  linearTeamId?: InputMaybe<Scalars['String']>;
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
};


export type QueryGetOrganizationArgs = {
  orgId: Scalars['Int'];
};


export type QueryGetOrganizationTeamsArgs = {
  orgId: Scalars['Int'];
};


export type QueryGetOrganizationUsersArgs = {
  orgId: Scalars['Int'];
};


export type QueryGetPlotArgs = {
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  chartId: Scalars['Int'];
  pageLevelFilterNode: Scalars['FilterNode'];
  teamId: Scalars['Int'];
};


export type QueryGetPlotPreviewArgs = {
  denominatorFilterOverride?: InputMaybe<Scalars['FilterNode']>;
  pageLevelFilterNode: Scalars['FilterNode'];
  plotConfigurationInput: PlotConfig;
  teamId: Scalars['Int'];
};


export type QueryGetPreviewPageGroupsArgs = {
  belongs?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  filterInput?: InputMaybe<FilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  teamUuid: Scalars['String'];
};


export type QueryGetPreviewPageLeadArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicGroupArgs = {
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  groupId: Scalars['BigInt'];
  teamUuid: Scalars['String'];
};


export type QueryGetTagsArgs = {
  teamId: Scalars['Int'];
};


export type QueryGetTaxonomyArgs = {
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type QueryGetTeamPotentialWidgetsArgs = {
  teamId: Scalars['Int'];
  titleSubstring?: InputMaybe<Scalars['String']>;
};


export type QueryGetTopLevelParentsArgs = {
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type QueryGroupSearchArgs = {
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  searchString: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QueryIntegrationsArgs = {
  feedbackIntegrationType?: InputMaybe<Feedback_Integration_Type>;
};


export type QueryIsOrganizationManagedByOktaArgs = {
  teamId: Scalars['Int'];
};


export type QueryListExternalTicketsArgs = {
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
};


export type QueryOldestFeedbackDateArgs = {
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryOrgSlackChannelsArgs = {
  orgId: Scalars['Int'];
};


export type QueryPollExecutionArgs = {
  executionUuid: Scalars['String'];
  orgId?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QueryPublicTeamDefaultsArgs = {
  filterInput?: InputMaybe<FilterInput>;
  teamUuid: Scalars['String'];
};


export type QueryPublicTeamGroupsArgs = {
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByType>;
  sortField?: InputMaybe<SortFieldType>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  teamUuid: Scalars['String'];
};


export type QueryPublicTeamsArgs = {
  uuid: Scalars['String'];
};


export type QuerySearchDigestSeriesArgs = {
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchDigestsArgs = {
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySegmentsArgs = {
  aiGenerated?: InputMaybe<Scalars['Boolean']>;
  segmentType?: InputMaybe<SegmentType>;
  teamId: Scalars['Int'];
};


export type QuerySentencesArgs = {
  discardCrapSentences?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  groupId?: InputMaybe<Scalars['BigInt']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortByClusterId?: InputMaybe<Scalars['BigInt']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  textSearch?: InputMaybe<Scalars['String']>;
  unclusteredSentences?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySimilarSentencesArgs = {
  filterInput?: InputMaybe<FilterInput>;
  groupId?: InputMaybe<Scalars['BigInt']>;
  queryString: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QuerySourcesArgs = {
  teamId: Scalars['Int'];
};


export type QueryStagingDataArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};


export type QueryTeamChartsArgs = {
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
};


export type QueryTeamDefaultsArgs = {
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryTeamFlagsArgs = {
  teamId: Scalars['Int'];
};


export type QueryTeamGroupsArgs = {
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByType>;
  sortField?: InputMaybe<SortFieldType>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
};


export type QueryTeamsArgs = {
  id: Scalars['Int'];
  uuid?: InputMaybe<Scalars['String']>;
};


export type QueryTestExternalTicketsIntegrationArgs = {
  integrationType: MutateFeedbackIntegration;
  orgId: Scalars['Int'];
};


export type QueryTestIntegrationConnectedArgs = {
  integrationType: MutateFeedbackIntegration;
};


export type QueryValidateIntegrationConfigArgs = {
  integration: MutateFeedbackIntegration;
};

export type RawIntercomEntryInput = {
  date: Scalars['String'];
  entry: Scalars['String'];
  providerUniqueId: Scalars['String'];
  unparsedResponse: Scalars['String'];
};

/** Resource */
export enum Resource {
  AccessRequests = 'ACCESS_REQUESTS',
  Alerts = 'ALERTS',
  Boards = 'BOARDS',
  Campaigns = 'CAMPAIGNS',
  Changelogs = 'CHANGELOGS',
  Charts = 'CHARTS',
  ChecklistItems = 'CHECKLIST_ITEMS',
  Digests = 'DIGESTS',
  Domains = 'DOMAINS',
  Emails = 'EMAILS',
  Entries = 'ENTRIES',
  Filters = 'FILTERS',
  Groups = 'GROUPS',
  GroupsTags = 'GROUPS_TAGS',
  Imports = 'IMPORTS',
  Insights = 'INSIGHTS',
  Integrations = 'INTEGRATIONS',
  IntegrationTypes = 'INTEGRATION_TYPES',
  Invites = 'INVITES',
  Logs = 'LOGS',
  Nlp = 'NLP',
  Organizations = 'ORGANIZATIONS',
  OrganizationsDomains = 'ORGANIZATIONS_DOMAINS',
  OrganizationsMembers = 'ORGANIZATIONS_MEMBERS',
  PinnedGroups = 'PINNED_GROUPS',
  Replies = 'REPLIES',
  Reviews = 'REVIEWS',
  Secrets = 'SECRETS',
  Segments = 'SEGMENTS',
  Sentences = 'SENTENCES',
  Slack = 'SLACK',
  SlackAlert = 'SLACK_ALERT',
  SlackConnection = 'SLACK_CONNECTION',
  Sources = 'SOURCES',
  Tags = 'TAGS',
  Taxonomy = 'TAXONOMY',
  Teams = 'TEAMS',
  TeamConfigs = 'TEAM_CONFIGS',
  Tickets = 'TICKETS',
  TicketIntegrations = 'TICKET_INTEGRATIONS',
  Tokens = 'TOKENS',
  Users = 'USERS',
  Widgets = 'WIDGETS'
}

export type SavedFeedbackSegmentFilter = {
  __typename?: 'SavedFeedbackSegmentFilter';
  feedbackSegments?: Maybe<Array<Scalars['String']>>;
  filterCondition?: Maybe<FilterType>;
  segmentGroupId?: Maybe<Scalars['Int']>;
};

export type SavedFilterInput = {
  __typename?: 'SavedFilterInput';
  endDate?: Maybe<Scalars['Date']>;
  groupFilter?: Maybe<Array<SavedGroupFilter>>;
  maxStarFilter?: Maybe<Array<SavedMaxStarFilter>>;
  minStarFilter?: Maybe<Array<SavedMaxStarFilter>>;
  segment?: Maybe<Array<SavedFeedbackSegmentFilter>>;
  sentimentFilter?: Maybe<Array<SavedSentimentFilter>>;
  sourceFilter?: Maybe<Array<SavedSourceFilter>>;
  startDate?: Maybe<Scalars['Date']>;
  teamName?: Maybe<Scalars['String']>;
};

export type SavedGroupFilter = {
  __typename?: 'SavedGroupFilter';
  filterCondition?: Maybe<FilterType>;
  groups?: Maybe<Array<GroupId>>;
};

export type SavedMaxStarFilter = {
  __typename?: 'SavedMaxStarFilter';
  amounts?: Maybe<Array<Scalars['Int']>>;
  filterCondition?: Maybe<FilterType>;
};

export type SavedMinStarFilter = {
  __typename?: 'SavedMinStarFilter';
  amounts?: Maybe<Array<Scalars['Int']>>;
  filterCondition?: Maybe<FilterType>;
};

export type SavedSentimentFilter = {
  __typename?: 'SavedSentimentFilter';
  filterCondition?: Maybe<FilterType>;
  sentiments?: Maybe<Array<SentimentType>>;
};

export type SavedSourceFilter = {
  __typename?: 'SavedSourceFilter';
  filterCondition?: Maybe<FilterType>;
  sources: Array<Scalars['String']>;
};

export type SegmentConfigInput = {
  fieldPath: Scalars['String'];
  segmentConfigId?: InputMaybe<Scalars['Int']>;
  segmentGroupId: Scalars['Int'];
  valueOverride?: InputMaybe<Scalars['String']>;
};

export type SegmentGroupInput = {
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<IntegrationFilterInput>>;
  name: Scalars['String'];
  segmentConfigs?: InputMaybe<Array<SegmentConfigInput>>;
  segmentGroupId?: InputMaybe<Scalars['Int']>;
};

export enum SegmentType {
  Number = 'NUMBER',
  String = 'STRING'
}

export type SendGridDigestSeriesChannel = {
  listId: Scalars['String'];
};

export type Sentence = {
  __typename?: 'Sentence';
  entry?: Maybe<Feedback_Entries>;
  groupId?: Maybe<Scalars['BigInt']>;
  /** ID of the sentence */
  id: Scalars['BigInt'];
  isTitle: Scalars['Boolean'];
  orderInEntry: Scalars['Int'];
  /** Sample of text from the entry that occurs just before the sentence. This text is empty if the sentence is a title */
  preceedingText: Scalars['String'];
  /** Sample of text from the entry that occurs just after the sentence. This text is empty if the sentence is a title */
  proceedingText: Scalars['String'];
  /** Text of the sentence */
  text: Scalars['String'];
};

export type SentimentFilterInput = {
  filterCondition: FilterType;
  sentiments: Array<SentimentType>;
};

export enum SentimentType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SeriesConfig = {
  __typename?: 'SeriesConfig';
  filterInput: SavedFilterInput;
  segmentGroupId?: Maybe<Scalars['Int']>;
  team: Teams;
};

export type SeriesData = {
  __typename?: 'SeriesData';
  aggregateData: Array<Array<Scalars['Int']>>;
  breakdown?: Maybe<Breakdown>;
  breakdownLabels?: Maybe<Array<Label>>;
  chartLabels: Array<Scalars['String']>;
  filterInput?: Maybe<SavedFilterInput>;
  normalizedData: Array<Array<Scalars['Float']>>;
  segmentGroupId?: Maybe<Scalars['Int']>;
  team: Teams;
  tooltipLabels: Array<Scalars['String']>;
  totalDenominatorEntries?: Maybe<Array<Scalars['Int']>>;
  totalDenominatorEntriesFull?: Maybe<Array<Scalars['Int']>>;
  y_axis_data?: Maybe<Y_Axis_Data>;
};

export type SeriesInput = {
  customName?: InputMaybe<Scalars['String']>;
  /** FilterInput for the data series to show on the chart */
  filterInput?: InputMaybe<FilterInput>;
  /** The segment group id. This only needs specified if the chart breakdown is specified to 'segment'. */
  segmentGroupId?: InputMaybe<Scalars['Int']>;
  /** Overrides the default teamId on the chart. */
  teamIdOverride?: InputMaybe<Scalars['Int']>;
};

export type SlackChannelInfo = {
  __typename?: 'SlackChannelInfo';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SlackDigestSeriesChannel = {
  channelName: Scalars['String'];
};

export enum SortByType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortFieldType {
  Date = 'DATE',
  Mentions = 'MENTIONS'
}

export type SourceFilterInput = {
  filterCondition: FilterType;
  sources: Array<Scalars['String']>;
};

export type SourceUrlFilterInput = {
  filterCondition: FilterType;
  urls: Array<Scalars['String']>;
};

export type StoreInput = {
  /** This is the id of the store that we need to fetch from google or yelp. This will be written to the integration_type_requirement_value. */
  storeId: Scalars['String'];
};

export type SubmitReviewPayload = {
  __typename?: 'SubmitReviewPayload';
  id: Scalars['Int'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type TagFilter = {
  id: Scalars['Int'];
};

export type TagFilterInput = {
  filterCondition: FilterType;
  tags: Array<TagFilter>;
};

export type TaxonomyElement = {
  __typename?: 'TaxonomyElement';
  childrenIds: Array<Scalars['BigInt']>;
  groupId: Scalars['BigInt'];
  node: Group;
};

export type TaxonomyTreeNode = {
  __typename?: 'TaxonomyTreeNode';
  children: Array<TaxonomyTreeNode>;
  groupId: Scalars['BigInt'];
  node: Group;
};

/** All charts on a team */
export type TeamCharts = {
  __typename?: 'TeamCharts';
  amountOfCharts: Scalars['Int'];
  charts: Array<CustomChartsLight>;
};


/** All charts on a team */
export type TeamChartsChartsArgs = {
  chartsSkip?: InputMaybe<Scalars['Int']>;
  chartsTake?: InputMaybe<Scalars['Int']>;
};

export type TeamDefaultConfigs = {
  __typename?: 'TeamDefaultConfigs';
  customer_locked_out: Scalars['Boolean'];
  endDate?: Maybe<Scalars['String']>;
  exploreDefaultWindow?: Maybe<Date_Window>;
  lock_out_message?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
};

export type TeamDefaults = {
  __typename?: 'TeamDefaults';
  customer_locked_out: Scalars['Boolean'];
  endDate?: Maybe<Scalars['Date']>;
  exploreDefaultWindow?: Maybe<Date_Window>;
  lock_out_message?: Maybe<Scalars['String']>;
  oldestFeedbackDate: Scalars['Date'];
  startDate?: Maybe<Scalars['Date']>;
};

/** Team groups */
export type TeamGroups = {
  __typename?: 'TeamGroups';
  amountOfGroups: GroupsCount;
  /** This replaces call to getGroups */
  groups: Array<Group>;
  /** Returns flattened taxonomy structure */
  taxonomyFlat: Array<TaxonomyElement>;
  /** Returns flattened taxonomy tree structure */
  taxonomyGroups: Array<TaxonomyElement>;
  /** Returns recursive taxonomy tree structure */
  taxonomyTrees: Array<TaxonomyTreeNode>;
};


/** Team groups */
export type TeamGroupsGroupsArgs = {
  onlyIncludeOrphans?: InputMaybe<Scalars['Boolean']>;
};

export type ThemeFilter = {
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type ThemeFilterInput = {
  filterCondition: FilterType;
  themes: Array<ThemeFilter>;
};

export type TrendInput = {
  detectionMethod: Scalars['String'];
  detectionNotes: Scalars['String'];
  groupId: Scalars['BigInt'];
  insightDescription: Scalars['String'];
  insightEntries: Scalars['String'];
  insightTitle: Scalars['String'];
  insightTrend: Digest_Group_Status;
  trendPeriod: Trend_Period;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  teams: Array<Scalars['Int']>;
};

export type UserRolesInput = {
  roles: Array<Role>;
  userId: Scalars['Int'];
};

export enum ValueType {
  Boolean = 'BOOLEAN',
  Int = 'INT',
  String = 'STRING'
}

export type Widget = {
  __typename?: 'Widget';
  boardId: Scalars['Int'];
  height: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['String'];
  widgetType: Board_Widget_Type;
  widgetTypeId: Scalars['Int'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type YAxisInput = {
  type: Y_Axis_Data;
};

export type Alerts_Emails = {
  __typename?: 'alerts_emails';
  alert_id: Scalars['Int'];
  id: Scalars['Int'];
  team_id: Scalars['Int'];
  to_email?: Maybe<Scalars['String']>;
};

export type Alerts_Notifications = {
  __typename?: 'alerts_notifications';
  alert_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  sent: Scalars['Int'];
  sent_date?: Maybe<Scalars['Date']>;
  team_id: Scalars['Int'];
};

export type Alerts_Slack = {
  __typename?: 'alerts_slack';
  alert_id: Scalars['Int'];
  id: Scalars['Int'];
  organization_connections_id: Scalars['Int'];
  slack_channel_ID: Scalars['String'];
  slack_channel_name?: Maybe<Scalars['String']>;
  team_id: Scalars['Int'];
};

export type Announcement_Emails = {
  __typename?: 'announcement_emails';
  body: Scalars['String'];
  date: Scalars['Date'];
  groupId?: Maybe<Scalars['BigInt']>;
  id: Scalars['Int'];
  recipients: Array<AnnouncementRecipient>;
  subject: Scalars['String'];
  teamId: Scalars['Int'];
  teams: Teams;
  user: Users;
  userId: Scalars['Int'];
};

export enum Board_Widget_Type {
  ChartWidget = 'chart_widget'
}

export enum Breakdown {
  Group = 'group',
  LeafGroup = 'leaf_group',
  Segment = 'segment',
  Sentiment = 'sentiment',
  Source = 'source'
}

export type Campaign = {
  __typename?: 'campaign';
  campaignPages: Array<Campaign_Items>;
  campaignUsers: Array<Campaign_Users>;
  expiration: Scalars['Date'];
  id: Scalars['Int'];
  page: Scalars['String'];
  uiType: Ui_Type;
};

export type Campaign_Items = {
  __typename?: 'campaign_items';
  description: Scalars['String'];
  order: Scalars['Int'];
  targetElement?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum Campaign_Status {
  Acknowledged = 'acknowledged',
  Dismissed = 'dismissed',
  Unseen = 'unseen'
}

export type Campaign_Users = {
  __typename?: 'campaign_users';
  status: Campaign_Status;
  user_id: Scalars['Int'];
};

export type Changelog = {
  __typename?: 'changelog';
  date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  feedbackIntegrationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  integration?: Maybe<Feedback_Integration>;
  teamId: Scalars['Int'];
  teams: Teams;
  title: Scalars['String'];
  userId?: Maybe<Scalars['Int']>;
};

export enum Channel_Type {
  Sendgrid = 'sendgrid',
  Slack = 'slack'
}

export enum Chart_Bin_Type {
  Daily = 'daily',
  Dynamic = 'dynamic',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Weekly = 'weekly'
}

export enum Chart_Type {
  HorizontalBar = 'horizontal_bar',
  Line = 'line',
  Pie = 'pie',
  StackedArea = 'stacked_area',
  StackedBar = 'stacked_bar',
  VerticalBar = 'vertical_bar'
}

export type Connection_Type = {
  __typename?: 'connection_type';
  authUrl: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  logoUrl: Scalars['String'];
  orgConnection: Array<Org_Connections>;
  title: Scalars['String'];
};


export type Connection_TypeOrgConnectionArgs = {
  orgId: Scalars['Int'];
};

/** A conversation part is a part of a conversation that is associated with a feedback entry. */
export type Conversation_Part = {
  __typename?: 'conversation_part';
  /** Date timestamp of the conversation part (UTC) */
  date?: Maybe<Scalars['Float']>;
  /** Full text of the conversation part. */
  fullText?: Maybe<Scalars['String']>;
  /** Unique id of the provider - for replies, its a concatenation: entryid-unwrapreply or entryid-existingreply */
  providerUniqueId?: Maybe<Scalars['String']>;
  /** Submitter alias on the conversation part */
  submitter?: Maybe<Scalars['String']>;
  submitterType: Submitter_Type;
  userId?: Maybe<Scalars['Int']>;
};

export type Dashboard_Alerts = {
  __typename?: 'dashboard_alerts';
  id: Scalars['Int'];
  message: Scalars['String'];
};

export type Data_Integration_Staging_Data = {
  __typename?: 'data_integration_staging_data';
  dataSource?: Maybe<Scalars['String']>;
  feedbackDate: Scalars['Float'];
  feedbackText: Scalars['String'];
  id: Scalars['Int'];
  segmentJson?: Maybe<Scalars['String']>;
  sourcePermalink: Scalars['String'];
  submitter: Scalars['String'];
  teamId: Scalars['Int'];
};

export enum Date_Window {
  All = 'all',
  Last_1y = 'last_1y',
  Last_7d = 'last_7d',
  Last_30d = 'last_30d',
  Last_90d = 'last_90d'
}

/** A Digest object is a colletion of insights that we send to a customer */
export type Digest = {
  __typename?: 'digest';
  /** User who approved the digest */
  approver?: Maybe<Users>;
  creator: Users;
  /** Date the digest was created */
  dateCreated: Scalars['Date'];
  digestSeries: Digest_Series;
  /** The id of the digest */
  id: Scalars['Int'];
  insights: Array<Insight>;
  status: DigestStatus;
  /** The subject of the digest */
  subject?: Maybe<Scalars['String']>;
};

export enum Digest_Group_Status {
  GoingWell = 'going_well',
  NeedsImprovement = 'needs_improvement'
}

/** A Digest object is a collection of insights that we send to a customer */
export type Digest_Series = {
  __typename?: 'digest_series';
  /** Whether or not to autopopulate Sendgrid list with org members */
  autoPopulateSGList: Scalars['Boolean'];
  creator: Users;
  /** Date the digest was created */
  dateCreated?: Maybe<Scalars['Date']>;
  digestSeriesType: DigestSeriesType;
  /** The channels associated with this digest series */
  digest_series_channel: Array<Digest_Series_Channel>;
  digests: Array<Digest>;
  /** The id of the digest */
  id: Scalars['Int'];
  organization: Organization;
  /** Frequency at which to send digests (weekly, every_two_weeks, monthly) */
  sendFrequency: DigestSendFrequency;
  teams: Array<Teams>;
  title: Scalars['String'];
};

export type Digest_Series_Channel = {
  __typename?: 'digest_series_channel';
  active: Scalars['Boolean'];
  digestSeriesId: Scalars['Int'];
  id: Scalars['Int'];
  subChannelName: Scalars['String'];
  subChannelType: Channel_Type;
};

export type Digest_Series_Team = {
  __typename?: 'digest_series_team';
  digest_series: Digest_Series;
  digest_series_id: Scalars['Int'];
  id: Scalars['ID'];
  team_id: Scalars['Int'];
};

export enum Domain {
  Org = 'org',
  Team = 'team'
}

export type External_Ticket = {
  __typename?: 'external_ticket';
  assignee?: Maybe<Scalars['String']>;
  closedDate?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  integration: External_Tickets_Integration;
  name: Scalars['String'];
  providerUniqueId: Scalars['String'];
  sourcePermalink: Scalars['String'];
  status: External_Ticket_Status;
};

export enum External_Ticket_Status {
  Closed = 'closed',
  Open = 'open'
}

export type External_Tickets_Group_Mapping = {
  __typename?: 'external_tickets_group_mapping';
  external_ticket_id: Scalars['ID'];
  group_id: Scalars['ID'];
  team_id: Scalars['ID'];
};

export type External_Tickets_Integration = {
  __typename?: 'external_tickets_integration';
  id: Scalars['Int'];
  requirementValue: Array<Integration_Type_Requirement_Value>;
  type: Integration_Type;
};

/** An Entry is a customer's feedback / review with any related metadata. */
export type Feedback_Entries = {
  __typename?: 'feedback_entries';
  allGroupTitles?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Use FeedbackEntryText.conversationParts instead. This field is deprecated. */
  conversationParts: Array<Conversation_Part>;
  /** Date timestamp of feedback submission (UTC) */
  date?: Maybe<Scalars['Float']>;
  /** @deprecated Use FeedbackEntryText.displayText instead to get the display text. You now no longer need to check this value. */
  defaultDistillateDisplay: Scalars['Boolean'];
  /** @deprecated Use FeedbackEntryText.distillateText instead. This field is deprecated. */
  distillateText?: Maybe<Scalars['String']>;
  feedbackEntryText: FeedbackEntryText;
  /** @deprecated Use FeedbackEntryText.fullConversation instead. This field is deprecated. */
  fullConversation?: Maybe<Scalars['String']>;
  groupMemberships?: Maybe<Array<GroupLight>>;
  /**
   * Checks if there are conversation parts (before vending full conversation)
   * @deprecated Use FeedbackEntryText.hasConversation instead. This field is deprecated.
   */
  hasConversation: Scalars['Boolean'];
  id: Scalars['BigInt'];
  /** Unique ID from the data source provider */
  providerUniqueId?: Maybe<Scalars['String']>;
  /** Segments associated with the customer's feedback */
  segments: Array<Feedback_Segment>;
  sentences: Array<Feedback_Sentences>;
  /** NLP estimated sentiment from the full review text. */
  sentiment?: Maybe<Scalars['Float']>;
  /** Data source for the feedback (i.e. yelp, google play, etc.) */
  source?: Maybe<Scalars['String']>;
  /** Link to original source of feedback. */
  source_permalink?: Maybe<Scalars['String']>;
  /** Stars left by the customer on the feedback. */
  stars?: Maybe<Scalars['Int']>;
  /** Customer's username or email that was associated with the review */
  submitter?: Maybe<Scalars['String']>;
  /** Type of submitter (i.e customer, agent) */
  submitterType?: Maybe<Scalars['String']>;
  /** Full text of the customer's feedback */
  text?: Maybe<Scalars['String']>;
  /** Title of the customer's feedback */
  title?: Maybe<Scalars['String']>;
};

export type Feedback_Integration = {
  __typename?: 'feedback_integration';
  defaultDistillateDisplay: Scalars['Boolean'];
  filters: Array<Feedback_Integration_Filters>;
  id: Scalars['Int'];
  integrationName: Scalars['String'];
  requirementValue: Array<Integration_Type_Requirement_Value>;
  segmentConfig: Array<Feedback_Segment_Config>;
  type: Integration_Type;
};


export type Feedback_IntegrationSegmentConfigArgs = {
  ai_generated?: InputMaybe<Scalars['Boolean']>;
};

export type Feedback_Integration_Filters = {
  __typename?: 'feedback_integration_filters';
  comparison: ComparisonType;
  feedbackIntegration: Feedback_Integration;
  id: Scalars['Int'];
  segmentGroup: Feedback_Segment_Group;
  value: Scalars['String'];
};

export enum Feedback_Integration_Type {
  DataImport = 'data_import',
  ExternalTickets = 'external_tickets',
  MetaData = 'meta_data'
}

export type Feedback_Segment = {
  __typename?: 'feedback_segment';
  config: Feedback_Segment_Config;
  entry: Feedback_Entries;
  group: Feedback_Segment_Group;
  groupName: Scalars['String'];
  id: Scalars['BigInt'];
  value: Scalars['String'];
};

export type Feedback_Segment_Config = {
  __typename?: 'feedback_segment_config';
  feedbackIntegration: Feedback_Integration;
  id: Scalars['Int'];
  override?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  segmentGroup: Feedback_Segment_Group;
};

export type Feedback_Segment_Group = {
  __typename?: 'feedback_segment_group';
  aiGenerated: Scalars['Boolean'];
  displayName: Scalars['String'];
  distinctValues: Array<Scalars['String']>;
  /** @deprecated Don't call this it's going to be REALLY SLOW. */
  feedbackSegment: Array<Feedback_Segment>;
  feedbackSegmentConfig: Array<Feedback_Segment_Config>;
  id: Scalars['Int'];
};

export type Feedback_Sentences = {
  __typename?: 'feedback_sentences';
  /** Relationship to the entry that the sentence appears in. */
  entry: Feedback_Entries;
  /** Id of the sentence. */
  id: Scalars['BigInt'];
  is_distillate: Scalars['Boolean'];
  /** The title of the entry is also stored as a 'Sentence'. This flag is used to signal that this sentence is the title of the entry. */
  is_title?: Maybe<Scalars['Int']>;
  /** Sentiment score of the sentence from (-1) negative to (+1) positive. */
  sentiment?: Maybe<Scalars['Float']>;
  /** Text of the sentence */
  text?: Maybe<Scalars['String']>;
};

export enum Filter_Condition {
  And = 'and',
  Or = 'or'
}

export type Group_Insights = {
  __typename?: 'group_insights';
  /** Section for the group insight. */
  digestSection?: Maybe<Digest_Group_Status>;
  /** Expiration date for the group insight. */
  expirationDate?: Maybe<Scalars['Date']>;
  /** Group Id. */
  groupId: Scalars['BigInt'];
  /** Group Insight Id. */
  id: Scalars['Int'];
  /** Flag to include the group insight in the digest. */
  includeInDigest: Scalars['Boolean'];
  /** Flag to include the group insight in the report. */
  includeInReport: Scalars['Boolean'];
  /** Description for the group insight. */
  insightDescription?: Maybe<Scalars['String']>;
  /** Start date for the group insight. */
  insightStartDate?: Maybe<Scalars['Date']>;
  /** Title (header) for the insight. */
  insightTitle?: Maybe<Scalars['String']>;
  /** Flag to supress the group insight. */
  isSuppressed: Scalars['Boolean'];
  /** End date for the group insight. */
  reportEndDate?: Maybe<Scalars['Date']>;
  /** Start date for the group insight. */
  reportStartDate?: Maybe<Scalars['Date']>;
  /** Team Id. */
  teamId: Scalars['Int'];
  /** Time window for the group insight. */
  timeWindow: Insights_Time_Window;
};

export enum Group_Membership_Action {
  Add = 'add',
  Remove = 'remove'
}

export enum Group_Status {
  Archived = 'archived',
  Completed = 'completed',
  Monitored = 'monitored',
  Pending = 'pending',
  Unmonitored = 'unmonitored'
}

export enum Group_Trending {
  Decreasing = 'decreasing',
  Increasing = 'increasing'
}

export enum Group_Type {
  Cluster = 'cluster',
  ClusterSearch = 'cluster_search',
  Search = 'search'
}

export type Group_Views = {
  __typename?: 'group_views';
  /** The exact time the group was visited at */
  dateVisited?: Maybe<Scalars['Date']>;
  /** Group id. */
  groupId: Scalars['BigInt'];
  /** Group_View id */
  id: Scalars['Int'];
  /** User id. */
  teamId: Scalars['Int'];
};

export enum Insight_Collection_Type {
  Chart = 'chart',
  Group = 'group'
}

export enum Insight_Status {
  Approved = 'approved',
  Denied = 'denied',
  Draft = 'draft'
}

export enum Insight_Type {
  ManualCreation = 'manual_creation',
  PreviousInsight = 'previous_insight',
  RealtimeAlert = 'realtime_alert',
  SuggestedRecent = 'suggested_recent',
  SuggestedTrending = 'suggested_trending',
  SuggestedViews = 'suggested_views'
}

export enum Insights_Time_Window {
  LastMonth = 'last_month',
  LastTwoWeeks = 'last_two_weeks',
  LastWeek = 'last_week'
}

export enum Integration_Category {
  Import = 'import',
  Reply = 'reply'
}

export type Integration_Type = {
  __typename?: 'integration_type';
  authRedirect?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  feedbackIntegrationType: Feedback_Integration_Type;
  id: Scalars['Int'];
  itemName?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  orgExternalTicketsIntegration: Array<External_Tickets_Integration>;
  requirements: Array<Integration_Type_Requirement>;
  scraperKey: Scalars['String'];
  sourceKey?: Maybe<Scalars['String']>;
  teamIntegration: Array<Feedback_Integration>;
  title: Scalars['String'];
};


export type Integration_TypeOrgExternalTicketsIntegrationArgs = {
  orgId: Scalars['Int'];
};


export type Integration_TypeTeamIntegrationArgs = {
  teamId: Scalars['Int'];
};

export type Integration_Type_Requirement = {
  __typename?: 'integration_type_requirement';
  category?: Maybe<Integration_Category>;
  description: Scalars['String'];
  example: Scalars['String'];
  frontendReplacementKey?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  key: Scalars['String'];
  obfuscate: Scalars['Boolean'];
  regex?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  requiredForAuthRedirect: Scalars['Boolean'];
  title: Scalars['String'];
  value: Array<Integration_Type_Requirement_Value>;
};


export type Integration_Type_RequirementValueArgs = {
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
};

export type Integration_Type_Requirement_Value = {
  __typename?: 'integration_type_requirement_value';
  id: Scalars['Int'];
  requirement: Integration_Type_Requirement;
  value: Scalars['String'];
};

export type New_Alerts = {
  __typename?: 'new_alerts';
  active: Scalars['Int'];
  cadence?: Maybe<CadenceType>;
  created_at?: Maybe<Scalars['Date']>;
  creator_id: Scalars['Int'];
  emails: Array<Alerts_Emails>;
  filterInput: SavedFilterInput;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  notifications: Array<Alerts_Notifications>;
  period?: Maybe<Scalars['Int']>;
  slack: Array<Alerts_Slack>;
  team_id: Scalars['Int'];
  threshold?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type Org_Connections = {
  __typename?: 'org_connections';
  connected_name: Scalars['String'];
  id: Scalars['Int'];
  type: Connection_Type;
};

export type Org_Domains = {
  __typename?: 'org_domains';
  /** Flag to determine if the domain is discoverable and should be shown to orphan users. 1 - yes, 0 - no. */
  allowDiscovery?: Maybe<Scalars['Boolean']>;
  /** Domain (unwrap.ai). */
  domain: Scalars['String'];
  /** Id of the domain. */
  id: Scalars['Int'];
};

export type Organization = {
  __typename?: 'organization';
  /** Returns the list of connections (eg. Slack). */
  connections: Array<Org_Connections>;
  /** fetch the currently authenticated user on the organization. */
  currentUser: OrganizationUser;
  /** The default role for new members of the organization. */
  defaultRole: Role;
  /** The foreign key value for the default team. */
  defaultTeamId?: Maybe<Scalars['Int']>;
  /** Id of the organization. */
  id: Scalars['Int'];
  /** Flag to determine if the organization is customer facing. 1 - yes, 0 - no. */
  isCustomerFacing: Scalars['Int'];
  /** Whether the organization is managed by an identity pool. If this is true the `orgUser` field will not represent the membership of the org. */
  isManagedByIdentityPool: Scalars['Boolean'];
  /** Name of the organization. */
  name: Scalars['String'];
  /** Returns the list of domains associated with the organization. */
  orgDomains: Array<Org_Domains>;
  /** fetch all users belonging to this organization. Beware this is a pretty expensive query when fetching all organizations. */
  orgUser: Array<OrganizationUser>;
  /** All teams belonging to the organization. */
  teams: Array<Teams>;
};

export type Organization_Users = {
  __typename?: 'organization_users';
  orgId: Scalars['Int'];
  organization?: Maybe<Organization>;
  role: Organization_Users_Role;
  userId: Scalars['Int'];
  users: Users;
};

export enum Organization_Users_Role {
  Admin = 'admin',
  Member = 'member'
}

export type Preview_Page_Leads = {
  __typename?: 'preview_page_leads';
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type Raw_Intercom_Data = {
  __typename?: 'raw_intercom_data';
  entry?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  teamId: Scalars['Int'];
  unparsedResponse?: Maybe<Scalars['String']>;
};

export enum Role {
  Admin = 'admin',
  Contributor = 'contributor',
  Member = 'member',
  Replier = 'replier',
  SuperAdmin = 'superAdmin',
  Viewer = 'viewer'
}

export type Role_Attachments = {
  __typename?: 'role_attachments';
  domain: Scalars['String'];
  domainId: Scalars['Int'];
  /** Role attachment Id. */
  id: Scalars['Int'];
  orgId?: Maybe<Scalars['Int']>;
  role: Scalars['String'];
  userId?: Maybe<Scalars['Int']>;
};

export enum Submitter_Type {
  Agent = 'agent',
  Customer = 'customer'
}

export type Tag = {
  __typename?: 'tag';
  /** the user who created the tag */
  creator: Users;
  /** Tag Id. */
  id: Scalars['Int'];
  /** Name of the tag */
  name: Scalars['String'];
  /** team the tag belongs to. */
  team: Teams;
};

export type Team_Background_Job_Flags = {
  __typename?: 'team_background_job_flags';
  categorizing_last_run: Scalars['Float'];
  clustering_last_run: Scalars['Float'];
  currently_categorizing_themes?: Maybe<Scalars['Int']>;
  currently_clustering?: Maybe<Scalars['Int']>;
  currently_tokenizing?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  tokenizing_last_run: Scalars['Float'];
};

/** Teams (or Views) are collections of imported data and selectable on the Unwrap Dashboard. */
export type Teams = {
  __typename?: 'teams';
  /** @deprecated No longer used */
  categorizerVersion?: Maybe<Scalars['Int']>;
  /** Change logs related to the Team. */
  changelogs: Array<Changelog>;
  /** Date the Team was created */
  creationDate: Scalars['Date'];
  /** @deprecated No longer used. */
  demoMode?: Maybe<Scalars['Int']>;
  /** Team's unique id. */
  id: Scalars['Int'];
  /** @deprecated No longer used */
  isPredicting?: Maybe<Scalars['Int']>;
  /** @deprecated No longer used */
  labels?: Maybe<Scalars['String']>;
  /** Logo for the Team (optional) */
  logoUrl?: Maybe<Scalars['String']>;
  /** Name of the Team (or View) */
  name: Scalars['String'];
  /** Id of the organization that the team belongs to. */
  orgId?: Maybe<Scalars['Int']>;
  /** Organization that the Team belongs to. */
  organization: Organization;
  /** Roles that are linked to the Team. */
  roles: Array<Role_Attachments>;
};

export type Theme_Aliases = {
  __typename?: 'theme_aliases';
  aliasName?: Maybe<Scalars['String']>;
  categorizeMethod?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export enum Trend_Period {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type Trial_Checklist_Items = {
  __typename?: 'trial_checklist_items';
  action_item_link?: Maybe<Scalars['String']>;
  checklist_item_text: Scalars['String'];
  id: Scalars['Int'];
  is_completed: Scalars['Int'];
  order: Scalars['Int'];
};

export enum Ui_Type {
  Modal = 'modal',
  Tooltip = 'tooltip'
}

export enum Unwrap_Feature {
  Assistant = 'assistant'
}

export type User_Oauth_Secret_State = {
  __typename?: 'user_oauth_secret_state';
  creation_date: Scalars['Date'];
  expiration_date: Scalars['Date'];
  id: Scalars['Int'];
  org_id: Scalars['Int'];
  secret_state: Scalars['String'];
  used: Scalars['Boolean'];
  user_id: Scalars['Int'];
};

export type User_Token = {
  __typename?: 'user_token';
  id: Scalars['Int'];
  tokenPreview: Scalars['String'];
};

export type Users = {
  __typename?: 'users';
  /** Date this user was created. */
  dateCreated: Scalars['Date'];
  /** User's email */
  email: Scalars['String'];
  /** User's first name */
  firstName?: Maybe<Scalars['String']>;
  /** User Id. */
  id: Scalars['Int'];
  /** User's last name. */
  lastName?: Maybe<Scalars['String']>;
  /**
   * Organizations that this user belongs to.
   * @deprecated This field is deprecated, it uses the old organization_users logic. Use orgs instead.
   */
  organizations: Array<Organization_Users>;
  orgs: Array<Organization>;
  /** Roles that this user has, filtered by organization context. */
  roles: Array<Role_Attachments>;
};


export type UsersRolesArgs = {
  orgId?: InputMaybe<Scalars['Int']>;
};

export enum Y_Axis_Data {
  AbsoluteVolume = 'absolute_volume',
  Favorability = 'favorability',
  RelativeShare = 'relative_share'
}

export type AllTeamsQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type AllTeamsQuery = { __typename?: 'Query', allTeams?: Array<{ __typename?: 'teams', id: number, name: string }> | null };

export type AlertDataFragment = { __typename?: 'new_alerts', id: number, name?: string | null, type: string, team_id: number, active: number, period?: number | null, cadence?: CadenceType | null, threshold?: number | null, created_at?: any | null, creator_id: number, emails: Array<{ __typename?: 'alerts_emails', alert_id: number, id: number, team_id: number, to_email?: string | null }>, notifications: Array<{ __typename?: 'alerts_notifications', id: number, sent: number, sent_date?: any | null, team_id: number, alert_id?: number | null }>, slack: Array<{ __typename?: 'alerts_slack', alert_id: number, id: number, organization_connections_id: number, slack_channel_ID: string, slack_channel_name?: string | null, team_id: number }>, filterInput: { __typename?: 'SavedFilterInput', groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } };

export type AnnouncementFragment = { __typename?: 'announcement_emails', id: number, date: any, subject: string, body: string, recipients: Array<{ __typename?: 'AnnouncementRecipient', userEmail: string, entryText: string }> };

export type BoardFragment = { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, filterNode: string, widgets: Array<{ __typename?: 'Widget', height: number, width: number, id: number, x: number, y: number, widgetType: Board_Widget_Type, widgetTypeId: number, boardId: number, title: string }>, creator: { __typename?: 'users', firstName?: string | null } };

export type BoardLightFragment = { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, creator: { __typename?: 'users', firstName?: string | null, lastName?: string | null, email: string } };

export type CampaignFragment = { __typename?: 'campaign', expiration: any, id: number, page: string, uiType: Ui_Type, campaignPages: Array<{ __typename?: 'campaign_items', title?: string | null, targetElement?: string | null, order: number, description: string }>, campaignUsers: Array<{ __typename?: 'campaign_users', user_id: number, status: Campaign_Status }> };

export type ChangelogFragment = { __typename?: 'changelog', id: number, userId?: number | null, feedbackIntegrationId?: number | null, title: string, teamId: number, description?: string | null, date?: any | null, integration?: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } | null };

export type Chart2DFragment = { __typename?: 'Chart2D', id: number, title: string, xAxisLabels: Array<string>, tooltipLabels: Array<string>, series: Array<Array<number>>, owner?: { __typename?: 'User', firstName: string, lastName: string, email: string } | null, legend: Array<{ __typename?: 'Label', id: string, name: string }>, config: { __typename?: 'ChartConfig', y_axis_data?: Y_Axis_Data | null, breakdown?: Breakdown | null, type: Chart_Type, seriesConfig?: Array<{ __typename?: 'SeriesConfig', segmentGroupId?: number | null, team: { __typename?: 'teams', id: number, name: string }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } }> | null } };

export type ChartFragment = { __typename?: 'Chart', breakdown?: Breakdown | null, type: Chart_Type, dateCreated?: number | null, id: number, title: string, y_axis_data?: Y_Axis_Data | null, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, seriesData?: Array<{ __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null }> | null };

export type ConversationFragment = { __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null };

export type DataSeriesConfigurationFragment = { __typename?: 'DataSeriesConfigurationOutput', segmentGroupId?: number | null, filterNode: string, customName?: string | null, team: { __typename?: 'teams', id: number, name: string } };

export type DigestDataFragment = { __typename?: 'digest', id: number, dateCreated: any, status: DigestStatus, subject?: string | null, digestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } };

export type DigestSeriesDataFragment = { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> };

export type EntryFragment = { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null };

export type ExternalTicketFragment = { __typename?: 'external_ticket', assignee?: string | null, dueDate?: any | null, id: number, name: string, providerUniqueId: string, sourcePermalink: string, closedDate?: any | null, status: External_Ticket_Status, integration: { __typename?: 'external_tickets_integration', type: { __typename?: 'integration_type', title: string, logoUrl: string, scraperKey: string } } };

export type FilterFragment = { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null };

export type FullPlotFragment = { __typename?: 'Plot', id: number, title: string, xAxisLabels: Array<string>, tooltipLabels: Array<string>, rangeStart: number, rangeEnd: number, series: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number>, customName?: string | null, seriesLabel: { __typename?: 'Label', id: string, name: string } }>, unNormalizedSeries: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number> }>, plotConfiguration: { __typename?: 'PlotConfigurationOutput', yAxisMetric: Y_Axis_Data, breakdown?: Breakdown | null, chartType: Chart_Type, title: string, chartBinType: Chart_Bin_Type, seriesConfig: Array<{ __typename?: 'DataSeriesConfigurationOutput', segmentGroupId?: number | null, filterNode: string, customName?: string | null, team: { __typename?: 'teams', id: number, name: string } }> } };

export type GroupEntryFragment = { __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null };

export type GroupDataFragment = { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null };

export type GroupInsightFragment = { __typename?: 'GroupInsight', digestSection?: string | null, expirationDate?: any | null, groupId: string, id: number, includeInDigest: boolean, insightDescription?: string | null, insightStartDate?: any | null, isSuppressed: boolean, teamId: number, timeWindow: Insights_Time_Window, includeInReport: boolean, reportStartDate?: any | null, insightTitle?: string | null };

export type GroupInsightsDataFragment = { __typename?: 'group_insights', digestSection?: Digest_Group_Status | null, expirationDate?: any | null, groupId: string, id: number, includeInDigest: boolean, insightTitle?: string | null, insightDescription?: string | null, insightStartDate?: any | null, isSuppressed: boolean, teamId: number, timeWindow: Insights_Time_Window, includeInReport: boolean, reportStartDate?: any | null };

export type GroupLightFragment = { __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number };

export type GroupMembershipFragment = { __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null };

export type GroupPlotFragment = { __typename?: 'Plot', xAxisLabels: Array<string>, tooltipLabels: Array<string>, rangeStart: number, rangeEnd: number, series: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number> }>, unNormalizedSeries: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number> }> };

export type GroupSentenceDataFragment = { __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null };

export type GroupTaxonomyFragment = { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null };

export type InsightLightFragment = { __typename?: 'Insight', id: number, insightStatus: Insight_Status, insightType: Insight_Type, text: string, chartBin: Chart_Bin_Type, creationSource: string, title: string, feedbackStatus: Digest_Group_Status, expirationDate: any, order: number, excludeFromDigest: boolean, sources: string, team: { __typename?: 'teams', id: number, orgId?: number | null }, collection: { __typename?: 'InsightCollection', id: string, type: Insight_Collection_Type, title?: string | null }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null }, entries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> };

export type InsightNoSourcesFragment = { __typename?: 'Insight', id: number, insightStatus: Insight_Status, insightType: Insight_Type, text: string, chartBin: Chart_Bin_Type, creationSource: string, title: string, feedbackStatus: Digest_Group_Status, expirationDate: any, order: number, excludeFromDigest: boolean, team: { __typename?: 'teams', id: number, orgId?: number | null }, collection: { __typename?: 'InsightCollection', id: string, type: Insight_Collection_Type, title?: string | null }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null }, entries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> };

export type OrgDomainFragment = { __typename?: 'org_domains', id: number, domain: string, allowDiscovery?: boolean | null };

export type OrgUserTeamsFragment = { __typename?: 'OrganizationUser', teams: Array<{ __typename?: 'teams', id: number, name: string }> };

export type OrganizationFragment = { __typename?: 'organization', id: number, name: string, isManagedByIdentityPool: boolean, defaultRole: Role, defaultTeamId?: number | null, orgUser: Array<{ __typename?: 'OrganizationUser', confirmed: boolean, email: string, role: Organization_Users_Role, user?: { __typename?: 'users', id: number, email: string, firstName?: string | null, lastName?: string | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null }>, teams: Array<{ __typename?: 'teams', creationDate: any, id: number, name: string, logoUrl?: string | null, orgId?: number | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> }>, orgDomains: Array<{ __typename?: 'org_domains', id: number, domain: string, allowDiscovery?: boolean | null }> };

export type OrganizationUserFragment = { __typename?: 'OrganizationUser', confirmed: boolean, email: string, role: Organization_Users_Role, user?: { __typename?: 'users', id: number, email: string, firstName?: string | null, lastName?: string | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null };

export type OrganizationsLightFragment = { __typename?: 'organization', id: number, name: string, isCustomerFacing: number, isManagedByIdentityPool: boolean, defaultTeamId?: number | null, currentUser: { __typename?: 'OrganizationUser', role: Organization_Users_Role }, teams: Array<{ __typename?: 'teams', id: number, name: string, logoUrl?: string | null }>, connections: Array<{ __typename?: 'org_connections', connected_name: string, id: number, type: { __typename?: 'connection_type', description: string, id: number, title: string } }> };

export type PartialEntryFragment = { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, source?: string | null, submitter?: string | null, providerUniqueId?: string | null, source_permalink?: string | null, distillateText?: string | null, hasConversation: boolean, sentiment?: number | null, allGroupTitles?: Array<string> | null, segments: Array<{ __typename?: 'feedback_segment', value: string, groupName: string }> };

export type PlotConfigurationFragment = { __typename?: 'PlotConfigurationOutput', yAxisMetric: Y_Axis_Data, breakdown?: Breakdown | null, chartType: Chart_Type, title: string, chartBinType: Chart_Bin_Type, seriesConfig: Array<{ __typename?: 'DataSeriesConfigurationOutput', segmentGroupId?: number | null, filterNode: string, customName?: string | null, team: { __typename?: 'teams', id: number, name: string } }> };

export type PlotFragment = { __typename?: 'Plot', id: number, title: string, xAxisLabels: Array<string>, tooltipLabels: Array<string>, series: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number>, customName?: string | null, seriesLabel: { __typename?: 'Label', id: string, name: string } }>, plotConfiguration: { __typename?: 'PlotConfigurationOutput', yAxisMetric: Y_Axis_Data, breakdown?: Breakdown | null, chartType: Chart_Type, title: string, chartBinType: Chart_Bin_Type, seriesConfig: Array<{ __typename?: 'DataSeriesConfigurationOutput', segmentGroupId?: number | null, filterNode: string, customName?: string | null, team: { __typename?: 'teams', id: number, name: string } }> } };

export type PotentialWidgetFragment = { __typename?: 'PotentialWidget', title: string, widgetType: Board_Widget_Type, widgetTypeId: number };

export type SentenceEntryFragment = { __typename?: 'feedback_sentences', id: string, text?: string | null, is_title?: number | null, is_distillate: boolean, entry: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } };

export type SeriesDataFragment = { __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null };

export type TeamDataFragment = { __typename?: 'teams', creationDate: any, id: number, name: string, logoUrl?: string | null, orgId?: number | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> };

export type UserDataFragment = { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string };

export type WidgetFragment = { __typename?: 'Widget', height: number, width: number, id: number, x: number, y: number, widgetType: Board_Widget_Type, widgetTypeId: number, boardId: number, title: string };

export type AddDomainToOrgMutationVariables = Exact<{
  allowDiscovery: Scalars['Boolean'];
  domain: Scalars['String'];
  orgId: Scalars['Int'];
}>;


export type AddDomainToOrgMutation = { __typename?: 'Mutation', addDomainToOrg: { __typename?: 'org_domains', allowDiscovery?: boolean | null, domain: string, id: number } };

export type AddOrganizationUsersMutationVariables = Exact<{
  orgId: Scalars['Int'];
  usersToAdd: Array<AddUserToOrg> | AddUserToOrg;
}>;


export type AddOrganizationUsersMutation = { __typename?: 'Mutation', addOrganizationUsers?: Array<{ __typename?: 'OrganizationUser', confirmed: boolean, email: string, role: Organization_Users_Role, user?: { __typename?: 'users', id: number, email: string, firstName?: string | null, lastName?: string | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null }> | null };

export type AddWidgetFeedbackMutationVariables = Exact<{
  email: Scalars['String'];
  feedback: Scalars['String'];
  teamId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type AddWidgetFeedbackMutation = { __typename?: 'Mutation', addWidgetFeedback: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } };

export type AlertGroupFailedMutationVariables = Exact<{
  queryString: Scalars['String'];
  teamId: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  wasRetried: Scalars['Boolean'];
}>;


export type AlertGroupFailedMutation = { __typename?: 'Mutation', alertGroupFailed: boolean };

export type ApproveGroupMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  belongingSentenceIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  differingSentenceIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type ApproveGroupMutation = { __typename?: 'Mutation', approveGroup: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null } };

export type AssignChildMutationVariables = Exact<{
  teamId: Scalars['Int'];
  parentGroupId: Scalars['BigInt'];
  childGroupId: Scalars['BigInt'];
}>;


export type AssignChildMutation = { __typename?: 'Mutation', assignChild: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null } };

export type AssignChildrenMutationVariables = Exact<{
  teamId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  childGroupIds: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;


export type AssignChildrenMutation = { __typename?: 'Mutation', assignChildren: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }> };

export type CloneBoardMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type CloneBoardMutation = { __typename?: 'Mutation', cloneBoard: { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, creator: { __typename?: 'users', firstName?: string | null, lastName?: string | null, email: string } } };

export type CopyTeamEntriesMutationVariables = Exact<{
  destinationTeamId: Scalars['Int'];
  originTeamId: Scalars['Int'];
}>;


export type CopyTeamEntriesMutation = { __typename?: 'Mutation', copyTeamEntries?: boolean | null };

export type CreateAlertMutationVariables = Exact<{
  filterInput: FilterInput;
  teamId: Scalars['Int'];
  type: AlertType;
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  period?: InputMaybe<Scalars['Int']>;
  alertName?: InputMaybe<Scalars['String']>;
  cadence?: InputMaybe<CadenceType>;
  slackChannelId?: InputMaybe<Scalars['String']>;
  slackChannelName?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Int']>;
}>;


export type CreateAlertMutation = { __typename?: 'Mutation', createAlert: { __typename?: 'new_alerts', id: number, name?: string | null, type: string, team_id: number, active: number, period?: number | null, cadence?: CadenceType | null, threshold?: number | null, created_at?: any | null, creator_id: number, emails: Array<{ __typename?: 'alerts_emails', alert_id: number, id: number, team_id: number, to_email?: string | null }>, notifications: Array<{ __typename?: 'alerts_notifications', id: number, sent: number, sent_date?: any | null, team_id: number, alert_id?: number | null }>, slack: Array<{ __typename?: 'alerts_slack', alert_id: number, id: number, organization_connections_id: number, slack_channel_ID: string, slack_channel_name?: string | null, team_id: number }>, filterInput: { __typename?: 'SavedFilterInput', groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } } };

export type CreateBoardMutationVariables = Exact<{
  teamId: Scalars['Int'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type CreateBoardMutation = { __typename?: 'Mutation', createBoard: { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, creator: { __typename?: 'users', firstName?: string | null, lastName?: string | null, email: string } } };

export type CreateChangelogDataMutationVariables = Exact<{
  date: Scalars['Float'];
  teamId: Scalars['Int'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type CreateChangelogDataMutation = { __typename?: 'Mutation', createChangelog: { __typename?: 'changelog', id: number, userId?: number | null, feedbackIntegrationId?: number | null, title: string, teamId: number, description?: string | null, date?: any | null, integration?: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } | null } };

export type CreateCustomChartMutationVariables = Exact<{
  editChartInput: EditChartInput;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
  chartBinType?: InputMaybe<Chart_Bin_Type>;
}>;


export type CreateCustomChartMutation = { __typename?: 'Mutation', createChart: { __typename?: 'Chart', id: number } };

export type CreateDigestMutationVariables = Exact<{
  digestSeriesId: Scalars['Int'];
}>;


export type CreateDigestMutation = { __typename?: 'Mutation', createDigest: { __typename?: 'digest', id: number, dateCreated: any, status: DigestStatus, subject?: string | null, digestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } } };

export type CreateDigestSeriesMutationVariables = Exact<{
  orgId: Scalars['Int'];
  teamIds: Array<Scalars['Int']> | Scalars['Int'];
  title: Scalars['String'];
  digestSeriesType: DigestSeriesType;
  sendFrequency: DigestSendFrequency;
}>;


export type CreateDigestSeriesMutation = { __typename?: 'Mutation', createDigestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> } };

export type CreateDigestSeriesChannelMutationVariables = Exact<{
  channelType: Channel_Type;
  seriesId: Scalars['Int'];
  sendGrid?: InputMaybe<SendGridDigestSeriesChannel>;
  slack?: InputMaybe<SlackDigestSeriesChannel>;
}>;


export type CreateDigestSeriesChannelMutation = { __typename?: 'Mutation', createDigestSeriesChannel: { __typename?: 'digest_series_channel', id: number, subChannelName: string } };

export type CreateFeedbackSegmentGroupMutationVariables = Exact<{
  displayName: Scalars['String'];
  teamId: Scalars['Int'];
  valueType: SegmentType;
}>;


export type CreateFeedbackSegmentGroupMutation = { __typename?: 'Mutation', createSegmentGroup: { __typename?: 'feedback_segment_group', displayName: string, id: number } };

export type CreateGroupMutationVariables = Exact<{
  queryString: Scalars['String'];
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  excludeFromNewFilter?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string } };

export type CreateGroupIncludeDataMutationVariables = Exact<{
  queryString: Scalars['String'];
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
  excludeFromNewFilter?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateGroupIncludeDataMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null } };

export type CreateGroupInsightMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterStartDate: Scalars['Date'];
}>;


export type CreateGroupInsightMutation = { __typename?: 'Mutation', createGroupInsight: { __typename?: 'group_insights', digestSection?: Digest_Group_Status | null, expirationDate?: any | null, groupId: string, id: number, includeInDigest: boolean, insightTitle?: string | null, insightDescription?: string | null, insightStartDate?: any | null, isSuppressed: boolean, teamId: number, timeWindow: Insights_Time_Window, includeInReport: boolean, reportStartDate?: any | null } };

export type CreateInsightMutationVariables = Exact<{
  chartBin: Chart_Bin_Type;
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  digestId: Scalars['Int'];
  entryIds: Array<Scalars['BigInt']> | Scalars['BigInt'];
  expirationDate: Scalars['Date'];
  feedbackStatus: Digest_Group_Status;
  filterInput: FilterInput;
  text: Scalars['String'];
  title: Scalars['String'];
  excludeFromDigest?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateInsightMutation = { __typename?: 'Mutation', createInsight: { __typename?: 'Insight', id: number, insightStatus: Insight_Status, insightType: Insight_Type, text: string, chartBin: Chart_Bin_Type, creationSource: string, title: string, feedbackStatus: Digest_Group_Status, expirationDate: any, order: number, excludeFromDigest: boolean, sources: string, team: { __typename?: 'teams', id: number, orgId?: number | null }, collection: { __typename?: 'InsightCollection', id: string, type: Insight_Collection_Type, title?: string | null }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null }, entries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> } };

export type CreateOauthStateSecretMutationVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type CreateOauthStateSecretMutation = { __typename?: 'Mutation', createOauthStateSecret: { __typename?: 'user_oauth_secret_state', creation_date: any, expiration_date: any, id: number, org_id: number, secret_state: string, used: boolean, user_id: number } };

export type CreateOrganizationMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'organization', id: number, name: string, isCustomerFacing: number, isManagedByIdentityPool: boolean, defaultTeamId?: number | null, currentUser: { __typename?: 'OrganizationUser', role: Organization_Users_Role }, teams: Array<{ __typename?: 'teams', id: number, name: string, logoUrl?: string | null }>, connections: Array<{ __typename?: 'org_connections', connected_name: string, id: number, type: { __typename?: 'connection_type', description: string, id: number, title: string } }> } };

export type CreatePreviewPageLeadMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
}>;


export type CreatePreviewPageLeadMutation = { __typename?: 'Mutation', addPreviewPageLead: { __typename?: 'preview_page_leads', email?: string | null, id: number, name?: string | null } };

export type CreateSecretMutationVariables = Exact<{
  secretName: Scalars['String'];
  secretValue: Scalars['String'];
}>;


export type CreateSecretMutation = { __typename?: 'Mutation', createSecret?: string | null };

export type CreateSlackConnectionMutationVariables = Exact<{
  code: Scalars['String'];
  orgId: Scalars['Int'];
  secretStateFromSlack: Scalars['String'];
}>;


export type CreateSlackConnectionMutation = { __typename?: 'Mutation', createSlackConnection?: { __typename?: 'org_connections', connected_name: string, id: number } | null };

export type CreateTagMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['BigInt']>;
  chartId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'tag', id: number, name: string } };

export type CreateTeamMutationVariables = Exact<{
  name: Scalars['String'];
  orgId: Scalars['Int'];
  usersRoles?: InputMaybe<Array<UserRolesInput> | UserRolesInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'teams', creationDate: any, id: number, name: string, logoUrl?: string | null, orgId?: number | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } };

export type DeleteAlertMutationVariables = Exact<{
  alertId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type DeleteAlertMutation = { __typename?: 'Mutation', deleteAlert?: { __typename?: 'new_alerts', id: number } | null };

export type DeleteBoardMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type DeleteBoardMutation = { __typename?: 'Mutation', deleteBoard: boolean };

export type DeleteChangelogDataMutationVariables = Exact<{
  changelogId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type DeleteChangelogDataMutation = { __typename?: 'Mutation', deleteChangelog: { __typename?: 'changelog', id: number } };

export type DeleteChildMutationVariables = Exact<{
  childGroupId: Scalars['BigInt'];
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type DeleteChildMutation = { __typename?: 'Mutation', removeChild: { __typename?: 'Group', id: string } };

export type DeleteChartMutationVariables = Exact<{
  chartId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type DeleteChartMutation = { __typename?: 'Mutation', deleteChart?: { __typename?: 'Chart', breakdown?: Breakdown | null, type: Chart_Type, dateCreated?: number | null, id: number, title: string, y_axis_data?: Y_Axis_Data | null, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, seriesData?: Array<{ __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null }> | null } | null };

export type DeleteDigestMutationVariables = Exact<{
  digestId: Scalars['Int'];
}>;


export type DeleteDigestMutation = { __typename?: 'Mutation', deleteDigest: { __typename?: 'digest', id: number } };

export type DeleteDigestSeriesChannelMutationVariables = Exact<{
  channelId: Scalars['Int'];
  seriesId: Scalars['Int'];
}>;


export type DeleteDigestSeriesChannelMutation = { __typename?: 'Mutation', deleteDigestSeriesChannel: { __typename?: 'digest_series_channel', id: number } };

export type DeleteDigestSeriesTeamMutationVariables = Exact<{
  seriesId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type DeleteDigestSeriesTeamMutation = { __typename?: 'Mutation', deleteDigestSeriesTeam: { __typename?: 'digest_series', id: number } };

export type DeleteGroupInsightMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type DeleteGroupInsightMutation = { __typename?: 'Mutation', deleteGroupInsight?: { __typename?: 'group_insights', digestSection?: Digest_Group_Status | null, expirationDate?: any | null, groupId: string, id: number, includeInDigest: boolean, insightTitle?: string | null, insightDescription?: string | null, insightStartDate?: any | null, isSuppressed: boolean, teamId: number, timeWindow: Insights_Time_Window, includeInReport: boolean, reportStartDate?: any | null } | null };

export type DeleteOrgConnectionMutationVariables = Exact<{
  connectionId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type DeleteOrgConnectionMutation = { __typename?: 'Mutation', deleteOrgConnection?: { __typename?: 'org_connections', connected_name: string, id: number } | null };

export type DeleteOrganizationMutationVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: { __typename?: 'organization', id: number, name: string } | null };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam?: { __typename?: 'teams', creationDate: any, id: number, name: string, logoUrl?: string | null, orgId?: number | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null };

export type DeleteWidgetMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  widgetId: Scalars['Int'];
}>;


export type DeleteWidgetMutation = { __typename?: 'Mutation', deleteWidget: boolean };

export type DuplicateWidgetsMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  inputWidgets: Array<NewWidgetInput> | NewWidgetInput;
}>;


export type DuplicateWidgetsMutation = { __typename?: 'Mutation', duplicateWidgets: Array<{ __typename?: 'Widget', height: number, width: number, id: number, x: number, y: number, widgetType: Board_Widget_Type, widgetTypeId: number, boardId: number, title: string }> };

export type EditAlertMutationVariables = Exact<{
  alertId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  teamId: Scalars['Int'];
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  cadence?: InputMaybe<CadenceType>;
  alertName?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<Scalars['Int']>;
  slackChannelId?: InputMaybe<Scalars['String']>;
  slackChannelName?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Int']>;
}>;


export type EditAlertMutation = { __typename?: 'Mutation', editAlert?: { __typename?: 'new_alerts', id: number, name?: string | null, type: string, team_id: number, active: number, period?: number | null, cadence?: CadenceType | null, threshold?: number | null, created_at?: any | null, creator_id: number, emails: Array<{ __typename?: 'alerts_emails', alert_id: number, id: number, team_id: number, to_email?: string | null }>, notifications: Array<{ __typename?: 'alerts_notifications', id: number, sent: number, sent_date?: any | null, team_id: number, alert_id?: number | null }>, slack: Array<{ __typename?: 'alerts_slack', alert_id: number, id: number, organization_connections_id: number, slack_channel_ID: string, slack_channel_name?: string | null, team_id: number }>, filterInput: { __typename?: 'SavedFilterInput', groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } } | null };

export type EditChangelogDataMutationVariables = Exact<{
  changelogId: Scalars['Int'];
  teamId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  date: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type EditChangelogDataMutation = { __typename?: 'Mutation', editChangelog: { __typename?: 'changelog', id: number, userId?: number | null, feedbackIntegrationId?: number | null, title: string, teamId: number, description?: string | null, date?: any | null, integration?: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } | null } };

export type EditChartMutationVariables = Exact<{
  chartId: Scalars['Int'];
  editChartInput: EditChartInput;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
  chartBinType?: InputMaybe<Chart_Bin_Type>;
}>;


export type EditChartMutation = { __typename?: 'Mutation', editChart: { __typename?: 'Chart', breakdown?: Breakdown | null, type: Chart_Type, dateCreated?: number | null, id: number, title: string, y_axis_data?: Y_Axis_Data | null, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, seriesData?: Array<{ __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null }> | null } };

export type EditFeedbackEntrySentimentMutationVariables = Exact<{
  entryId: Scalars['BigInt'];
  sentiment: Scalars['Float'];
  teamId: Scalars['Int'];
}>;


export type EditFeedbackEntrySentimentMutation = { __typename?: 'Mutation', editFeedbackEntrySentiment?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null };

export type EditGroupMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  input: EditGroupInput;
  teamId: Scalars['Int'];
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  filterInput: FilterInput;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditGroupMutation = { __typename?: 'Mutation', editGroup: { __typename?: 'EditGroupResult', message?: string | null, success: boolean, dependencies?: { __typename?: 'GroupDependencies', charts: Array<{ __typename?: 'ChartDep', id: number, title: string, teamId: number, orgId: number }>, dependencies: Array<{ __typename?: 'GroupDependency', message: string, type: string, title: string }>, pinners: Array<{ __typename?: 'PinnedGroupDep', pinner: { __typename?: 'Pinner', fullName: string, email: string } }> } | null, group?: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null } | null } };

export type EditGroupInsightMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  includeInDigest?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  groupStatus?: InputMaybe<Digest_Group_Status>;
  startDate?: InputMaybe<Scalars['Date']>;
  includeInReport?: InputMaybe<Scalars['Boolean']>;
  reportMonthDate?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
}>;


export type EditGroupInsightMutation = { __typename?: 'Mutation', editGroupInsight?: { __typename?: 'group_insights', digestSection?: Digest_Group_Status | null, expirationDate?: any | null, groupId: string, id: number, includeInDigest: boolean, insightTitle?: string | null, insightDescription?: string | null, insightStartDate?: any | null, isSuppressed: boolean, teamId: number, timeWindow: Insights_Time_Window, includeInReport: boolean, reportStartDate?: any | null } | null };

export type EditOrganizationMutationVariables = Exact<{
  orgId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type EditOrganizationMutation = { __typename?: 'Mutation', editOrganization?: { __typename?: 'organization', id: number, name: string, isCustomerFacing: number, isManagedByIdentityPool: boolean, defaultTeamId?: number | null, currentUser: { __typename?: 'OrganizationUser', role: Organization_Users_Role }, teams: Array<{ __typename?: 'teams', id: number, name: string, logoUrl?: string | null }>, connections: Array<{ __typename?: 'org_connections', connected_name: string, id: number, type: { __typename?: 'connection_type', description: string, id: number, title: string } }> } | null };

export type EditTeamMutationVariables = Exact<{
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
  userRoles?: InputMaybe<Array<UserRolesInput> | UserRolesInput>;
  name: Scalars['String'];
}>;


export type EditTeamMutation = { __typename?: 'Mutation', editTeam?: { __typename?: 'teams', creationDate: any, id: number, name: string, logoUrl?: string | null, orgId?: number | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null };

export type ExternalTicketsIntegrationMutationVariables = Exact<{
  input: MutateExternalTicketsIntegration;
  orgId: Scalars['Int'];
}>;


export type ExternalTicketsIntegrationMutation = { __typename?: 'Mutation', externalTicketsIntegration: { __typename?: 'external_tickets_integration', id: number } };

export type FeedbackEntriesUploadMutationVariables = Exact<{
  input: Array<FeedbackEntryInput> | FeedbackEntryInput;
  teamId: Scalars['Int'];
  feedbackIntegrationId: Scalars['Int'];
}>;


export type FeedbackEntriesUploadMutation = { __typename?: 'Mutation', entriesUpload: Array<{ __typename?: 'feedback_entries', id: string }> };

export type FeedbackIntegrationMutationVariables = Exact<{
  input: MutateFeedbackIntegration;
}>;


export type FeedbackIntegrationMutation = { __typename?: 'Mutation', feedbackIntegration: { __typename?: 'feedback_integration', id: number, requirementValue: Array<{ __typename?: 'integration_type_requirement_value', id: number, value: string }>, segmentConfig: Array<{ __typename?: 'feedback_segment_config', id: number, path: string }> } };

export type GenerateDraftDigestEmailMutationVariables = Exact<{
  digestId: Scalars['Int'];
}>;


export type GenerateDraftDigestEmailMutation = { __typename?: 'Mutation', generateDraftDigestEmail: { __typename?: 'DeliveryStatus', success: boolean, message: string } };

export type GenerateTaxonomySchemaMutationVariables = Exact<{
  instructions: Scalars['String'];
  teamId: Scalars['Int'];
  previousSchema?: InputMaybe<Scalars['String']>;
}>;


export type GenerateTaxonomySchemaMutation = { __typename?: 'Mutation', generateTaxonomySchema: string };

export type GetGroupInsightsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetGroupInsightsQuery = { __typename?: 'Query', getGroupInsights: Array<{ __typename?: 'group_insights', digestSection?: Digest_Group_Status | null, expirationDate?: any | null, groupId: string, id: number, includeInDigest: boolean, insightTitle?: string | null, insightDescription?: string | null, insightStartDate?: any | null, isSuppressed: boolean, teamId: number, timeWindow: Insights_Time_Window, includeInReport: boolean, reportStartDate?: any | null }> };

export type GrantAccessMutationVariables = Exact<{
  linkHash: Scalars['String'];
}>;


export type GrantAccessMutation = { __typename?: 'Mutation', grantAccessRequest?: { __typename?: 'OrganizationUser', confirmed: boolean, email: string, user?: { __typename?: 'users', firstName?: string | null, lastName?: string | null } | null } | null };

export type HandleGoogleSignInMutationVariables = Exact<{
  linkHash?: InputMaybe<Scalars['String']>;
}>;


export type HandleGoogleSignInMutation = { __typename?: 'Mutation', handleGoogleSignIn: boolean };

export type KickoffAutoTaxonomyProcessMutationVariables = Exact<{
  schema: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type KickoffAutoTaxonomyProcessMutation = { __typename?: 'Mutation', kickoffAutoTaxonomyProcess: boolean };

export type LaunchNlpMutationVariables = Exact<{
  teamId: Scalars['Int'];
  categorizeOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type LaunchNlpMutation = { __typename?: 'Mutation', nlpLaunch: boolean };

export type LinkAsanaTicketMutationVariables = Exact<{
  externalTicketsIntegrationId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  input: ExternalTicketInput;
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type LinkAsanaTicketMutation = { __typename?: 'Mutation', linkAsanaTicket: { __typename?: 'external_ticket', assignee?: string | null, dueDate?: any | null, closedDate?: any | null, id: number, name: string, providerUniqueId: string, sourcePermalink: string, status: External_Ticket_Status } };

export type LinkJiraTicketMutationVariables = Exact<{
  externalTicketsIntegrationId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  input: ExternalTicketInput;
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type LinkJiraTicketMutation = { __typename?: 'Mutation', linkJiraTicket: { __typename?: 'external_ticket', assignee?: string | null, dueDate?: any | null, closedDate?: any | null, id: number, name: string, providerUniqueId: string, sourcePermalink: string, status: External_Ticket_Status } };

export type LinkLinearTicketMutationVariables = Exact<{
  externalTicketsIntegrationId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  input: ExternalTicketInput;
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type LinkLinearTicketMutation = { __typename?: 'Mutation', linkLinearTicket: { __typename?: 'external_ticket', assignee?: string | null, dueDate?: any | null, closedDate?: any | null, id: number, name: string, providerUniqueId: string, sourcePermalink: string, status: External_Ticket_Status } };

export type LogGroupViewMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type LogGroupViewMutation = { __typename?: 'Mutation', logGroupView: { __typename?: 'group_views', teamId: number, id: number, groupId: string, dateVisited?: any | null } };

export type ModifyEntryGroupMembershipMutationVariables = Exact<{
  action: Group_Membership_Action;
  entryId: Scalars['BigInt'];
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type ModifyEntryGroupMembershipMutation = { __typename?: 'Mutation', modifyEntryGroupMembership?: { __typename?: 'feedback_entries', id: string, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null };

export type MoveTeamMutationVariables = Exact<{
  destinationOrgId: Scalars['Int'];
  originOrgId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type MoveTeamMutation = { __typename?: 'Mutation', moveTeam?: boolean | null };

export type CreateOnDemandInsightMutationVariables = Exact<{
  draftTitle: Scalars['String'];
  draftDescription: Scalars['String'];
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type CreateOnDemandInsightMutation = { __typename?: 'Mutation', createOnDemandInsight: { __typename?: 'OnDemandInsight', title: string, description: string } };

export type PublishDigestToSlackMutationVariables = Exact<{
  digestId: Scalars['Int'];
}>;


export type PublishDigestToSlackMutation = { __typename?: 'Mutation', sendDigestToSlack: { __typename?: 'DeliveryStatus', success: boolean, message: string } };

export type RemoveChildMutationVariables = Exact<{
  childGroupId: Scalars['BigInt'];
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
}>;


export type RemoveChildMutation = { __typename?: 'Mutation', removeChild: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null } };

export type RemoveDomainFromOrgMutationVariables = Exact<{
  orgDomainId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type RemoveDomainFromOrgMutation = { __typename?: 'Mutation', removeDomainFromOrg: boolean };

export type RemoveGroupOwnerMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type RemoveGroupOwnerMutation = { __typename?: 'Mutation', removeGroupOwner: { __typename?: 'Group', id: string } };

export type RemoveOrganizationUserMutationVariables = Exact<{
  orgId: Scalars['Int'];
  userToDeleteEmail: Scalars['String'];
}>;


export type RemoveOrganizationUserMutation = { __typename?: 'Mutation', removeOrganizationUser?: Array<{ __typename?: 'OrganizationUser', confirmed: boolean, email: string, role: Organization_Users_Role, user?: { __typename?: 'users', id: number, email: string, firstName?: string | null, lastName?: string | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null }> | null };

export type RemoveTagFromGroupMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  tagId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type RemoveTagFromGroupMutation = { __typename?: 'Mutation', removeTagFromGroup: { __typename?: 'tag', id: number, name: string } };

export type ReplyToReviewsMutationVariables = Exact<{
  replyInput: Array<EntryReplyInput> | EntryReplyInput;
  teamId: Scalars['Int'];
}>;


export type ReplyToReviewsMutation = { __typename?: 'Mutation', replyToReviews: Array<{ __typename?: 'FeedbackReply', errorMessage?: string | null, feedbackEntryId: string, success: boolean, conversationPart?: { __typename?: 'conversation_part', date?: number | null, fullText?: string | null, submitter?: string | null, submitterType: Submitter_Type, userId?: number | null } | null }> };

export type RequestAccessMutationVariables = Exact<{
  teamId?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['Int']>;
}>;


export type RequestAccessMutation = { __typename?: 'Mutation', requestAccessToOrganization?: string | null };

export type SavePlotMutationVariables = Exact<{
  id: Scalars['Int'];
  plotConfigurationInput: PlotConfig;
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type SavePlotMutation = { __typename?: 'Mutation', savePlot: number };

export type SendAnnouncementEmailMutationVariables = Exact<{
  body: Scalars['String'];
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
  recipients: Array<Scalars['String']> | Scalars['String'];
  subject: Scalars['String'];
  teamId: Scalars['Int'];
  image?: InputMaybe<Scalars['String']>;
}>;


export type SendAnnouncementEmailMutation = { __typename?: 'Mutation', sendAnnouncementEmail: { __typename?: 'announcement_emails', id: number, date: any, subject: string, body: string, recipients: Array<{ __typename?: 'AnnouncementRecipient', userEmail: string, entryText: string }> } };

export type SendDigestMutationVariables = Exact<{
  digestId: Scalars['Int'];
}>;


export type SendDigestMutation = { __typename?: 'Mutation', sendDigest: { __typename?: 'digest', id: number, dateCreated: any, status: DigestStatus, subject?: string | null, digestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } } };

export type SendTestDigestEmailMutationVariables = Exact<{
  digestId: Scalars['Int'];
  emailAddress: Scalars['String'];
}>;


export type SendTestDigestEmailMutation = { __typename?: 'Mutation', sendTestDigestEmail: { __typename?: 'DeliveryStatus', success: boolean, message: string } };

export type SendTestSlackDigestMutationVariables = Exact<{
  digestId: Scalars['Int'];
}>;


export type SendTestSlackDigestMutation = { __typename?: 'Mutation', sendTestSlack: { __typename?: 'DeliveryStatus', success: boolean, message: string } };

export type SetDefaultOrganizationTeamMutationVariables = Exact<{
  orgId: Scalars['Int'];
  defaultTeamId?: InputMaybe<Scalars['Int']>;
}>;


export type SetDefaultOrganizationTeamMutation = { __typename?: 'Mutation', setDefaultOrganizationTeam?: { __typename?: 'organization', id: number, name: string, isCustomerFacing: number, isManagedByIdentityPool: boolean, defaultTeamId?: number | null, currentUser: { __typename?: 'OrganizationUser', role: Organization_Users_Role }, teams: Array<{ __typename?: 'teams', id: number, name: string, logoUrl?: string | null }>, connections: Array<{ __typename?: 'org_connections', connected_name: string, id: number, type: { __typename?: 'connection_type', description: string, id: number, title: string } }> } | null };

export type SetDefaultRoleMutationVariables = Exact<{
  defaultRole: Role;
  orgId: Scalars['Int'];
}>;


export type SetDefaultRoleMutation = { __typename?: 'Mutation', setDefaultRole?: { __typename?: 'organization', id: number } | null };

export type SetDigestStatusMutationVariables = Exact<{
  digestId: Scalars['Int'];
  status: DigestStatus;
}>;


export type SetDigestStatusMutation = { __typename?: 'Mutation', setDigestStatus: { __typename?: 'digest', id: number, dateCreated: any, status: DigestStatus, subject?: string | null, digestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } } };

export type SetDigestSubjectMutationVariables = Exact<{
  digestId: Scalars['Int'];
  subject: Scalars['String'];
}>;


export type SetDigestSubjectMutation = { __typename?: 'Mutation', setDigestSubject: { __typename?: 'digest', id: number } };

export type UpsertReviewMutationVariables = Exact<{
  feature: Unwrap_Feature;
  feedback: Scalars['String'];
  rating: Scalars['Int'];
  teamId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
}>;


export type UpsertReviewMutation = { __typename?: 'Mutation', upsertReview: { __typename?: 'SubmitReviewPayload', id: number, message: string, success: boolean } };

export type SuggestInsightsMutationVariables = Exact<{
  digestId: Scalars['Int'];
}>;


export type SuggestInsightsMutation = { __typename?: 'Mutation', suggestInsights: Array<{ __typename?: 'Insight', id: number }> };

export type TagGroupMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  tagId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type TagGroupMutation = { __typename?: 'Mutation', tagGroup: { __typename?: 'tag', id: number, name: string } };

export type TogglePinBoardMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type TogglePinBoardMutation = { __typename?: 'Mutation', togglePinBoardForUser: boolean };

export type TogglePinGroupMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type TogglePinGroupMutation = { __typename?: 'Mutation', togglePinGroup: { __typename?: 'Group', id: string, isPinnedByUser: boolean } };

export type UnlinkAsanaTicketMutationVariables = Exact<{
  externalTicketId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
}>;


export type UnlinkAsanaTicketMutation = { __typename?: 'Mutation', unlinkAsanaTicket?: boolean | null };

export type UnlinkJiraTicketMutationVariables = Exact<{
  externalTicketId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
}>;


export type UnlinkJiraTicketMutation = { __typename?: 'Mutation', unlinkJiraTicket?: boolean | null };

export type UnlinkLinearTicketMutationVariables = Exact<{
  externalTicketId: Scalars['Int'];
  groupId: Scalars['BigInt'];
  orgId: Scalars['Int'];
}>;


export type UnlinkLinearTicketMutation = { __typename?: 'Mutation', unlinkLinearTicket?: boolean | null };

export type UpdateBoardDescriptionMutationVariables = Exact<{
  boardId: Scalars['Int'];
  description: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type UpdateBoardDescriptionMutation = { __typename?: 'Mutation', updateBoardDescription: { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, creator: { __typename?: 'users', firstName?: string | null, lastName?: string | null, email: string } } };

export type UpdateBoardFilterMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
}>;


export type UpdateBoardFilterMutation = { __typename?: 'Mutation', updateBoardFilter: { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, filterNode: string, widgets: Array<{ __typename?: 'Widget', height: number, width: number, id: number, x: number, y: number, widgetType: Board_Widget_Type, widgetTypeId: number, boardId: number, title: string }>, creator: { __typename?: 'users', firstName?: string | null } } };

export type UpdateBoardFilterNodeMutationVariables = Exact<{
  boardId: Scalars['Int'];
  filterNode: Scalars['FilterNode'];
  teamId: Scalars['Int'];
}>;


export type UpdateBoardFilterNodeMutation = { __typename?: 'Mutation', updateBoardFilterNode: { __typename?: 'Board', id: number } };

export type UpdateBoardLayoutMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  widgets: Array<ExistingWidgetInput> | ExistingWidgetInput;
}>;


export type UpdateBoardLayoutMutation = { __typename?: 'Mutation', updateBoardLayout: { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, filterNode: string, widgets: Array<{ __typename?: 'Widget', height: number, width: number, id: number, x: number, y: number, widgetType: Board_Widget_Type, widgetTypeId: number, boardId: number, title: string }>, creator: { __typename?: 'users', firstName?: string | null } } };

export type UpdateBoardTitleMutationVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
  title: Scalars['String'];
}>;


export type UpdateBoardTitleMutation = { __typename?: 'Mutation', updateBoardTitle: { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, creator: { __typename?: 'users', firstName?: string | null, lastName?: string | null, email: string } } };

export type UpdateCampaignTreatmentMutationVariables = Exact<{
  campaignId: Scalars['Int'];
  status: Campaign_Status;
}>;


export type UpdateCampaignTreatmentMutation = { __typename?: 'Mutation', updateCampaignTreatment: { __typename?: 'campaign', expiration: any, id: number, page: string, uiType: Ui_Type, campaignPages: Array<{ __typename?: 'campaign_items', title?: string | null, targetElement?: string | null, order: number, description: string }>, campaignUsers: Array<{ __typename?: 'campaign_users', user_id: number, status: Campaign_Status }> } };

export type UpdateDigestSeriesSendFrequencyMutationVariables = Exact<{
  digestSeriesId: Scalars['Int'];
  sendFrequency: DigestSendFrequency;
}>;


export type UpdateDigestSeriesSendFrequencyMutation = { __typename?: 'Mutation', updateDigestSeriesSendFrequency: { __typename?: 'digest_series', id: number } };

export type UpdateDomainDiscoveryMutationVariables = Exact<{
  allowDiscovery: Scalars['Boolean'];
  orgDomainId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type UpdateDomainDiscoveryMutation = { __typename?: 'Mutation', updateDomainDiscovery: { __typename?: 'org_domains', allowDiscovery?: boolean | null, domain: string, id: number } };

export type UpdateGroupOwnerMutationVariables = Exact<{
  groupId: Scalars['BigInt'];
  userId: Scalars['Int'];
  teamId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type UpdateGroupOwnerMutation = { __typename?: 'Mutation', updateGroupOwner: { __typename?: 'Group', id: string } };

export type UpdateInsightMutationVariables = Exact<{
  entryIds: Array<Scalars['BigInt']> | Scalars['BigInt'];
  expirationDate: Scalars['Date'];
  feedbackStatus: Digest_Group_Status;
  filterInput: FilterInput;
  insightId: Scalars['Int'];
  insightStatus: Insight_Status;
  text: Scalars['String'];
  title: Scalars['String'];
  chartBin: Chart_Bin_Type;
  order: Scalars['Int'];
  excludeFromDigest?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateInsightMutation = { __typename?: 'Mutation', updateInsight: { __typename?: 'Insight', id: number, insightStatus: Insight_Status, insightType: Insight_Type, text: string, chartBin: Chart_Bin_Type, creationSource: string, title: string, feedbackStatus: Digest_Group_Status, expirationDate: any, order: number, excludeFromDigest: boolean, sources: string, team: { __typename?: 'teams', id: number, orgId?: number | null }, collection: { __typename?: 'InsightCollection', id: string, type: Insight_Collection_Type, title?: string | null }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null }, entries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> } };

export type UpdateOrganizationUserMutationVariables = Exact<{
  orgId: Scalars['Int'];
  userToUpdateEmail: Scalars['String'];
  assignedRoles?: InputMaybe<Array<AssignedRoles> | AssignedRoles>;
}>;


export type UpdateOrganizationUserMutation = { __typename?: 'Mutation', updateOrganizationUser?: Array<{ __typename?: 'OrganizationUser', confirmed: boolean, email: string, role: Organization_Users_Role, user?: { __typename?: 'users', id: number, email: string, firstName?: string | null, lastName?: string | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null }> | null };

export type UpdateTeamDefaultsMutationVariables = Exact<{
  teamId: Scalars['Int'];
  exploreDefaultWindow?: InputMaybe<Date_Window>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  customer_locked_out?: InputMaybe<Scalars['Boolean']>;
  lock_out_message?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTeamDefaultsMutation = { __typename?: 'Mutation', updateTeamDefaults: { __typename?: 'TeamDefaults', exploreDefaultWindow?: Date_Window | null, oldestFeedbackDate: any, startDate?: any | null, endDate?: any | null, customer_locked_out: boolean, lock_out_message?: string | null } };

export type UpdateAutoPopulateSgListMutationVariables = Exact<{
  autoPopulateSgList: Scalars['Boolean'];
  updateAutoPopulateSgListId: Scalars['Int'];
}>;


export type UpdateAutoPopulateSgListMutation = { __typename?: 'Mutation', updateAutoPopulateSGList: { __typename?: 'digest_series', id: number } };

export type AddEmailToAlertMutationVariables = Exact<{
  alertId: Scalars['Int'];
  newEmail: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type AddEmailToAlertMutation = { __typename?: 'Mutation', addEmailToAlert: { __typename?: 'alerts_emails', alert_id: number, id: number, team_id: number, to_email?: string | null } };

export type AmountOfEntriesQueryVariables = Exact<{
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
  repliableOnly?: InputMaybe<Scalars['Boolean']>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  filterInput?: InputMaybe<FilterInput>;
}>;


export type AmountOfEntriesQuery = { __typename?: 'Query', amountOfEntries: { __typename?: 'EntriesCount', amount: number } };

export type AmountOfGroupsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  status?: InputMaybe<Group_Status>;
  type?: InputMaybe<Group_Type>;
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
}>;


export type AmountOfGroupsQuery = { __typename?: 'Query', amountOfGroups: { __typename?: 'GroupsCount', amount: number } };

export type GetAnnouncementEmailsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  groupId: Scalars['BigInt'];
}>;


export type GetAnnouncementEmailsQuery = { __typename?: 'Query', getAnnouncementEmails: Array<{ __typename?: 'announcement_emails', id: number, date: any, subject: string, body: string, recipients: Array<{ __typename?: 'AnnouncementRecipient', userEmail: string, entryText: string }> }> };

export type ConnectionsQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type ConnectionsQuery = { __typename?: 'Query', connections?: Array<{ __typename?: 'connection_type', id: number, title: string, description: string, logoUrl: string, authUrl: string, orgConnection: Array<{ __typename?: 'org_connections', id: number, connected_name: string }> }> | null };

export type DataForFiltersQueryVariables = Exact<{
  teamId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type DataForFiltersQuery = { __typename?: 'Query', sources: Array<string>, segments?: Array<{ __typename?: 'feedback_segment_group', id: number, displayName: string, distinctValues: Array<string> }> | null, getAllGroups: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type }>, getTags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, getOrganizationUsers?: Array<{ __typename?: 'OrganizationUser', email: string, confirmed: boolean, user?: { __typename?: 'users', id: number } | null }> | null };

export type DiscoverOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscoverOrgsQuery = { __typename?: 'Query', discoverOrgs?: Array<{ __typename?: 'DiscoverableOrg', id: number, name: string }> | null };

export type EmailExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type EmailExistsQuery = { __typename?: 'Query', emailExists: boolean };

export type FeedbackEntriesQueryVariables = Exact<{
  teamId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filterInput?: InputMaybe<FilterInput>;
  repliableOnly?: InputMaybe<Scalars['Boolean']>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
}>;


export type FeedbackEntriesQuery = { __typename?: 'Query', entries?: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null };

export type FeedbackEntriesByTimeQueryVariables = Exact<{
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  teamUuid?: InputMaybe<Scalars['String']>;
}>;


export type FeedbackEntriesByTimeQuery = { __typename?: 'Query', feedbackEntriesByTime: { __typename?: 'IEntiresChart', totalEntries: number, entries: Array<{ __typename?: 'IChartableItem', count: number, date: any }> } };

export type GetFeedbackIntegrationsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  integrationTypeId?: InputMaybe<Scalars['Int']>;
  integrationId?: InputMaybe<Scalars['Int']>;
}>;


export type GetFeedbackIntegrationsQuery = { __typename?: 'Query', feedbackIntegration?: Array<{ __typename?: 'feedback_integration', id: number, integrationName: string, defaultDistillateDisplay: boolean, filters: Array<{ __typename?: 'feedback_integration_filters', comparison: ComparisonType, id: number, value: string, segmentGroup: { __typename?: 'feedback_segment_group', id: number, displayName: string } }>, requirementValue: Array<{ __typename?: 'integration_type_requirement_value', value: string, valueId: number, requirement: { __typename?: 'integration_type_requirement', id: number, key: string } }>, segmentConfig: Array<{ __typename?: 'feedback_segment_config', id: number, override?: string | null, path: string, segmentGroup: { __typename?: 'feedback_segment_group', id: number, displayName: string } }>, type: { __typename?: 'integration_type', logoUrl: string, title: string, feedbackIntegrationType: Feedback_Integration_Type, id: number, authRedirect?: string | null, description: string, itemName?: string | null, scraperKey: string, sourceKey?: string | null }, requirements: { __typename?: 'integration_type', requirements: Array<{ __typename?: 'integration_type_requirement', id: number, key: string, obfuscate: boolean, title: string, description: string, example: string, frontendReplacementKey?: string | null, regex?: string | null, required: boolean, requiredForAuthRedirect: boolean, category?: Integration_Category | null }> } }> | null };

export type FeedbackIntegrationFragment = { __typename?: 'feedback_integration', id: number, integrationName: string, defaultDistillateDisplay: boolean, filters: Array<{ __typename?: 'feedback_integration_filters', comparison: ComparisonType, id: number, value: string, segmentGroup: { __typename?: 'feedback_segment_group', id: number, displayName: string } }>, requirementValue: Array<{ __typename?: 'integration_type_requirement_value', value: string, valueId: number, requirement: { __typename?: 'integration_type_requirement', id: number, key: string } }>, segmentConfig: Array<{ __typename?: 'feedback_segment_config', id: number, override?: string | null, path: string, segmentGroup: { __typename?: 'feedback_segment_group', id: number, displayName: string } }>, type: { __typename?: 'integration_type', logoUrl: string, title: string, feedbackIntegrationType: Feedback_Integration_Type, id: number, authRedirect?: string | null, description: string, itemName?: string | null, scraperKey: string, sourceKey?: string | null }, requirements: { __typename?: 'integration_type', requirements: Array<{ __typename?: 'integration_type_requirement', id: number, key: string, obfuscate: boolean, title: string, description: string, example: string, frontendReplacementKey?: string | null, regex?: string | null, required: boolean, requiredForAuthRedirect: boolean, category?: Integration_Category | null }> } };

export type FeedbackSentencesQueryVariables = Exact<{
  teamId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortByClusterId?: InputMaybe<Scalars['BigInt']>;
  unclusteredSentences?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
}>;


export type FeedbackSentencesQuery = { __typename?: 'Query', sentences?: Array<{ __typename?: 'feedback_sentences', id: string, text?: string | null, is_title?: number | null, is_distillate: boolean, entry: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } }> | null };

export type GenerateGptRepliesQueryVariables = Exact<{
  gptRepliesInput: Array<GptRepliesInput> | GptRepliesInput;
  teamId: Scalars['Int'];
}>;


export type GenerateGptRepliesQuery = { __typename?: 'Query', generateGptReplies?: Array<{ __typename?: 'GeneratedGptReply', entryId: string, generatedText: string, success: boolean }> | null };

export type AccessControlListQueryVariables = Exact<{
  domains: Array<DomainInput> | DomainInput;
}>;


export type AccessControlListQuery = { __typename?: 'Query', accessControlList: Array<{ __typename?: 'Permission', actions: Array<Action>, resource: Resource }> };

export type GetActiveInsightsForTeamQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetActiveInsightsForTeamQuery = { __typename?: 'Query', getActiveInsightsForTeam: Array<{ __typename?: 'Insight', id: number, insightStatus: Insight_Status, insightType: Insight_Type, text: string, chartBin: Chart_Bin_Type, creationSource: string, title: string, feedbackStatus: Digest_Group_Status, expirationDate: any, order: number, excludeFromDigest: boolean, team: { __typename?: 'teams', id: number, orgId?: number | null }, collection: { __typename?: 'InsightCollection', id: string, type: Insight_Collection_Type, title?: string | null }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null }, entries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> }> };

export type GetAlertQueryVariables = Exact<{
  alertId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type GetAlertQuery = { __typename?: 'Query', getAlert?: { __typename?: 'new_alerts', id: number, name?: string | null, type: string, team_id: number, active: number, period?: number | null, cadence?: CadenceType | null, threshold?: number | null, created_at?: any | null, creator_id: number, emails: Array<{ __typename?: 'alerts_emails', alert_id: number, id: number, team_id: number, to_email?: string | null }>, notifications: Array<{ __typename?: 'alerts_notifications', id: number, sent: number, sent_date?: any | null, team_id: number, alert_id?: number | null }>, slack: Array<{ __typename?: 'alerts_slack', alert_id: number, id: number, organization_connections_id: number, slack_channel_ID: string, slack_channel_name?: string | null, team_id: number }>, filterInput: { __typename?: 'SavedFilterInput', groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } } | null };

export type GetAlertsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  type?: InputMaybe<AlertType>;
}>;


export type GetAlertsQuery = { __typename?: 'Query', getAlerts?: Array<{ __typename?: 'new_alerts', id: number, name?: string | null, type: string, team_id: number, active: number, period?: number | null, cadence?: CadenceType | null, threshold?: number | null, created_at?: any | null, creator_id: number, emails: Array<{ __typename?: 'alerts_emails', alert_id: number, id: number, team_id: number, to_email?: string | null }>, notifications: Array<{ __typename?: 'alerts_notifications', id: number, sent: number, sent_date?: any | null, team_id: number, alert_id?: number | null }>, slack: Array<{ __typename?: 'alerts_slack', alert_id: number, id: number, organization_connections_id: number, slack_channel_ID: string, slack_channel_name?: string | null, team_id: number }>, filterInput: { __typename?: 'SavedFilterInput', groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } }> | null };

export type GetAllOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganizationsQuery = { __typename?: 'Query', allOrganizations?: Array<{ __typename?: 'organization', id: number, name: string }> | null };

export type GetAnnouncementTemplateQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetAnnouncementTemplateQuery = { __typename?: 'Query', getAnnouncementTemplate: string };

export type GetAsanaProjectsQueryVariables = Exact<{
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type GetAsanaProjectsQuery = { __typename?: 'Query', getAsanaProjects: Array<{ __typename?: 'AsanaProject', name: string, providerUniqueId: string }> };

export type GetAsanaTicketsQueryVariables = Exact<{
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
  workspaceId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetAsanaTicketsQuery = { __typename?: 'Query', getAsanaTickets: Array<{ __typename?: 'ExternalTicketData', assignee: string, dueDate?: any | null, name: string, providerUniqueId: string, sourcePermalink: string, closedDate?: any | null, status: External_Ticket_Status }> };

export type GetAsanaWorkspacesQueryVariables = Exact<{
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
}>;


export type GetAsanaWorkspacesQuery = { __typename?: 'Query', getAsanaWorkspaces: Array<{ __typename?: 'AsanaWorkspace', name: string, providerUniqueId: string }> };

export type GetBoardQueryVariables = Exact<{
  boardId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type GetBoardQuery = { __typename?: 'Query', getBoard?: { __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, filterNode: string, widgets: Array<{ __typename?: 'Widget', height: number, width: number, id: number, x: number, y: number, widgetType: Board_Widget_Type, widgetTypeId: number, boardId: number, title: string }>, creator: { __typename?: 'users', firstName?: string | null } } | null };

export type GetBoardsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  titleSubstring?: InputMaybe<Scalars['String']>;
}>;


export type GetBoardsQuery = { __typename?: 'Query', getBoards: Array<{ __typename?: 'Board', id: number, title: string, description?: string | null, isPinnedByUser: boolean, creator: { __typename?: 'users', firstName?: string | null, lastName?: string | null, email: string } }> };

export type GetCampaignQueryVariables = Exact<{
  pageName: Scalars['String'];
}>;


export type GetCampaignQuery = { __typename?: 'Query', getCampaign?: { __typename?: 'campaign', expiration: any, id: number, page: string, uiType: Ui_Type, campaignPages: Array<{ __typename?: 'campaign_items', title?: string | null, targetElement?: string | null, order: number, description: string }>, campaignUsers: Array<{ __typename?: 'campaign_users', user_id: number, status: Campaign_Status }> } | null };

export type GetChangelogDataQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetChangelogDataQuery = { __typename?: 'Query', getChangelogs?: Array<{ __typename?: 'changelog', id: number, userId?: number | null, feedbackIntegrationId?: number | null, title: string, teamId: number, description?: string | null, date?: any | null, integration?: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } | null }> | null };

export type GetChart2DPreviewQueryVariables = Exact<{
  editChartInput: EditChartInput;
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  chartBinType?: InputMaybe<Chart_Bin_Type>;
}>;


export type GetChart2DPreviewQuery = { __typename?: 'Query', getChart2DPreview: { __typename?: 'Chart2D', id: number, title: string, xAxisLabels: Array<string>, tooltipLabels: Array<string>, series: Array<Array<number>>, owner?: { __typename?: 'User', firstName: string, lastName: string, email: string } | null, legend: Array<{ __typename?: 'Label', id: string, name: string }>, config: { __typename?: 'ChartConfig', y_axis_data?: Y_Axis_Data | null, breakdown?: Breakdown | null, type: Chart_Type, seriesConfig?: Array<{ __typename?: 'SeriesConfig', segmentGroupId?: number | null, team: { __typename?: 'teams', id: number, name: string }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } }> | null } } };

export type GetChartPreviewQueryVariables = Exact<{
  editChartInput: EditChartInput;
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  chartBinType?: InputMaybe<Chart_Bin_Type>;
}>;


export type GetChartPreviewQuery = { __typename?: 'Query', getChartPreview: { __typename?: 'Chart', breakdown?: Breakdown | null, type: Chart_Type, dateCreated?: number | null, id: number, title: string, y_axis_data?: Y_Axis_Data | null, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, seriesData?: Array<{ __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null }> | null } };

export type GetChildCandidatesQueryVariables = Exact<{
  teamId: Scalars['Int'];
  parentGroupId: Scalars['BigInt'];
  groupTitleSearchString?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetChildCandidatesQuery = { __typename?: 'Query', getChildCandidates: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }> };

export type GetChildrenQueryVariables = Exact<{
  teamId: Scalars['Int'];
  filterInput: FilterInput;
  parentGroupId: Scalars['BigInt'];
}>;


export type GetChildrenQuery = { __typename?: 'Query', getChildren: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }> };

export type GetChildrenLightQueryVariables = Exact<{
  parentGroupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type GetChildrenLightQuery = { __typename?: 'Query', getChildrenLight: Array<{ __typename?: 'GroupLight', id: string, title: string, teamId: number, type: Group_Type, status: Group_Status }> };

export type GetChildrenToAssignQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
}>;


export type GetChildrenToAssignQuery = { __typename?: 'Query', getChildrenToAssign: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }> };

export type GetGroupEmailsQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
}>;


export type GetGroupEmailsQuery = { __typename?: 'Query', getGroupEmails?: Array<{ __typename?: 'AnnouncementRecipient', entryText: string, userEmail: string }> | null };

export type GetCustomChartQueryVariables = Exact<{
  chartId: Scalars['Int'];
  teamId: Scalars['Int'];
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  filterInput?: InputMaybe<FilterInput>;
}>;


export type GetCustomChartQuery = { __typename?: 'Query', getChart: { __typename?: 'Chart', breakdown?: Breakdown | null, type: Chart_Type, dateCreated?: number | null, id: number, title: string, y_axis_data?: Y_Axis_Data | null, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, seriesData?: Array<{ __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null }> | null } };

export type GetCustomChart2DQueryVariables = Exact<{
  chartId: Scalars['Int'];
  teamId: Scalars['Int'];
  chartBinType?: InputMaybe<Chart_Bin_Type>;
  filterInput?: InputMaybe<FilterInput>;
}>;


export type GetCustomChart2DQuery = { __typename?: 'Query', getChart2D: { __typename?: 'Chart2D', id: number, title: string, xAxisLabels: Array<string>, tooltipLabels: Array<string>, series: Array<Array<number>>, owner?: { __typename?: 'User', firstName: string, lastName: string, email: string } | null, legend: Array<{ __typename?: 'Label', id: string, name: string }>, config: { __typename?: 'ChartConfig', y_axis_data?: Y_Axis_Data | null, breakdown?: Breakdown | null, type: Chart_Type, seriesConfig?: Array<{ __typename?: 'SeriesConfig', segmentGroupId?: number | null, team: { __typename?: 'teams', id: number, name: string }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } }> | null } } };

export type GetCustomChartsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filterInput?: InputMaybe<FilterInput>;
  chartBinType?: InputMaybe<Chart_Bin_Type>;
}>;


export type GetCustomChartsQuery = { __typename?: 'Query', getCharts: Array<{ __typename?: 'Chart', breakdown?: Breakdown | null, type: Chart_Type, dateCreated?: number | null, id: number, title: string, y_axis_data?: Y_Axis_Data | null, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, seriesData?: Array<{ __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null }> | null }> };

export type GetDashboardAlertsQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetDashboardAlertsQuery = { __typename?: 'Query', getDashboardAlerts: Array<{ __typename?: 'dashboard_alerts', id: number, message: string }> };

export type GetDigestSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDigestSeriesQuery = { __typename?: 'Query', digestSeries: Array<{ __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }> };

export type GetDigestSeriesChannelsQueryVariables = Exact<{
  seriesId: Scalars['Int'];
}>;


export type GetDigestSeriesChannelsQuery = { __typename?: 'Query', digestSeriesChannels: Array<{ __typename?: 'digest_series_channel', id: number, subChannelName: string, subChannelType: Channel_Type }> };

export type GetDigestSeriesTeamQueryVariables = Exact<{
  seriesId: Scalars['Int'];
}>;


export type GetDigestSeriesTeamQuery = { __typename?: 'Query', digestSeriesTeam: Array<{ __typename?: 'digest_series_team', id: string, team_id: number }> };

export type GetDigestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDigestsQuery = { __typename?: 'Query', digests: Array<{ __typename?: 'digest', id: number, dateCreated: any, status: DigestStatus, subject?: string | null, digestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } }> };

export type GetDigestsForActiveTeamQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetDigestsForActiveTeamQuery = { __typename?: 'Query', getActiveDigestsForTeam: Array<{ __typename?: 'digest', id: number, dateCreated: any, status: DigestStatus, subject?: string | null, digestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } }> };

export type GetEarliestFeedbackDateQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetEarliestFeedbackDateQuery = { __typename?: 'Query', earliestFeedbackDate: string };

export type GetFilterFieldDisplayQueryVariables = Exact<{
  fieldName: Scalars['String'];
  filterValue: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type GetFilterFieldDisplayQuery = { __typename?: 'Query', getFilterFieldDisplay: { __typename?: 'FilterFieldDisplay', displayName: string, values: Array<{ __typename?: 'FilterFieldValue', displayName: string, filterValue: string }> } };

export type GetFilterFieldValuesQueryVariables = Exact<{
  fieldName: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
  teamId: Scalars['Int'];
  fieldStatementFilters: Scalars['FilterNode'];
}>;


export type GetFilterFieldValuesQuery = { __typename?: 'Query', getFilterFieldValues: Array<{ __typename?: 'FilterFieldValue', displayName: string, filterValue: string }> };

export type GetFilterFieldsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  fieldStatementFilters: Scalars['FilterNode'];
}>;


export type GetFilterFieldsQuery = { __typename?: 'Query', getFilterFields: Array<{ __typename?: 'FilterField', allowedOperators: Array<Operator>, displayName: string, fieldName: string, hasValues: boolean, hasOverLapWithExistingFilters: boolean, additionalMetaData: Array<string> }> };

export type GetGroupQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  belongs?: InputMaybe<Scalars['Boolean']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGroupQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null } };

export type GetGroupForExportQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterInput: FilterInput;
  belongs?: InputMaybe<Scalars['Boolean']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
}>;


export type GetGroupForExportQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', id: string, title: string, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null, children: Array<{ __typename?: 'Group', id: string, title: string, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null, children: Array<{ __typename?: 'Group', id: string, title: string, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null, children: Array<{ __typename?: 'Group', id: string, title: string, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null }> }> }> } };

export type GetGroupByIdQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
}>;


export type GetGroupByIdQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', id: string, title: string, summary?: string | null, isPinnedByUser: boolean, uniqueEntries: number, createdAt: string, tags?: Array<{ __typename?: 'tag', id: number, name: string }> | null, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null } } };

export type GetGroupPlotQueryVariables = Exact<{
  pageLevelFilterNode: Scalars['FilterNode'];
  plotConfigurationInput: PlotConfig;
  teamId: Scalars['Int'];
  denominatorFilterOverride?: InputMaybe<Scalars['FilterNode']>;
}>;


export type GetGroupPlotQuery = { __typename?: 'Query', getPlotPreview: { __typename?: 'Plot', xAxisLabels: Array<string>, tooltipLabels: Array<string>, rangeStart: number, rangeEnd: number, series: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number> }>, unNormalizedSeries: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number> }> } };

export type GetGroupSentencesQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  belongs?: InputMaybe<Scalars['Boolean']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGroupSentencesQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null } };

export type GetGroupStatusQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
}>;


export type GetGroupStatusQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', processing: boolean, progress: number } };

export type GetGroupsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput: FilterInput;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SortFieldType>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', getGroups: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null }> };

export type GetGroupsLightQueryVariables = Exact<{
  teamId: Scalars['Int'];
  status?: InputMaybe<Group_Status>;
  type?: InputMaybe<Group_Type>;
}>;


export type GetGroupsLightQuery = { __typename?: 'Query', getAllGroups: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> };

export type GetGroupsLightTaxonomyQueryVariables = Exact<{
  teamId: Scalars['Int'];
  status?: InputMaybe<Group_Status>;
  type?: InputMaybe<Group_Type>;
}>;


export type GetGroupsLightTaxonomyQuery = { __typename?: 'Query', getAllGroups: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, totalDescendants?: number | null }> };

export type GetInsightByCollectionQueryVariables = Exact<{
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  digestId: Scalars['Int'];
}>;


export type GetInsightByCollectionQuery = { __typename?: 'Query', getInsightByCollection?: { __typename?: 'Insight', id: number, insightStatus: Insight_Status, insightType: Insight_Type, text: string, chartBin: Chart_Bin_Type, creationSource: string, title: string, feedbackStatus: Digest_Group_Status, expirationDate: any, order: number, excludeFromDigest: boolean, sources: string, team: { __typename?: 'teams', id: number, orgId?: number | null }, collection: { __typename?: 'InsightCollection', id: string, type: Insight_Collection_Type, title?: string | null }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null }, entries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> } | null };

export type GetInsightGroupsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput: FilterInput;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SortFieldType>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetInsightGroupsQuery = { __typename?: 'Query', getGroups: Array<{ __typename?: 'Group', isNew?: boolean | null, id: string, title: string, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, insight?: { __typename?: 'GroupInsight', digestSection?: string | null, expirationDate?: any | null, groupId: string, id: number, includeInDigest: boolean, insightDescription?: string | null, insightStartDate?: any | null, isSuppressed: boolean, teamId: number, timeWindow: Insights_Time_Window, includeInReport: boolean, reportStartDate?: any | null, insightTitle?: string | null } | null, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null }> };

export type GetInsightPreviewChartToDeleteQueryVariables = Exact<{
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
  chartBin?: InputMaybe<Chart_Bin_Type>;
}>;


export type GetInsightPreviewChartToDeleteQuery = { __typename?: 'Query', getInsightPreviewChartToDelete: { __typename?: 'SeriesData', aggregateData: Array<Array<number>>, breakdown?: Breakdown | null, chartLabels: Array<string>, normalizedData: Array<Array<number>>, tooltipLabels: Array<string>, y_axis_data?: Y_Axis_Data | null, segmentGroupId?: number | null, breakdownLabels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, team: { __typename?: 'teams', id: number, name: string }, filterInput?: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null } | null } };

export type GetInsightPreviewEntriesQueryVariables = Exact<{
  collectionId: Scalars['BigInt'];
  collectionType: Insight_Collection_Type;
  filterInput: FilterInput;
  teamId: Scalars['Int'];
}>;


export type GetInsightPreviewEntriesQuery = { __typename?: 'Query', getInsightPreviewEntries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> };

export type GetInsightSourcesQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetInsightSourcesQuery = { __typename?: 'Query', getInsightSources: string };

export type GetInsightsQueryVariables = Exact<{
  digestId: Scalars['Int'];
  includeDenied?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetInsightsQuery = { __typename?: 'Query', getInsights: Array<{ __typename?: 'Insight', id: number, insightStatus: Insight_Status, insightType: Insight_Type, text: string, chartBin: Chart_Bin_Type, creationSource: string, title: string, feedbackStatus: Digest_Group_Status, expirationDate: any, order: number, excludeFromDigest: boolean, sources: string, team: { __typename?: 'teams', id: number, orgId?: number | null }, collection: { __typename?: 'InsightCollection', id: string, type: Insight_Collection_Type, title?: string | null }, filterInput: { __typename?: 'SavedFilterInput', teamName?: string | null, startDate?: any | null, endDate?: any | null, groupFilter?: Array<{ __typename?: 'SavedGroupFilter', filterCondition?: FilterType | null, groups?: Array<{ __typename?: 'GroupId', id: string }> | null }> | null, segment?: Array<{ __typename?: 'SavedFeedbackSegmentFilter', feedbackSegments?: Array<string> | null, filterCondition?: FilterType | null, segmentGroupId?: number | null }> | null, sentimentFilter?: Array<{ __typename?: 'SavedSentimentFilter', filterCondition?: FilterType | null, sentiments?: Array<SentimentType> | null }> | null, sourceFilter?: Array<{ __typename?: 'SavedSourceFilter', filterCondition?: FilterType | null, sources: Array<string> }> | null, minStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null, maxStarFilter?: Array<{ __typename?: 'SavedMaxStarFilter', amounts?: Array<number> | null, filterCondition?: FilterType | null }> | null }, entries: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> }> };

export type GetIntegrationDataSourceFieldsQueryVariables = Exact<{
  input: MutateFeedbackIntegration;
}>;


export type GetIntegrationDataSourceFieldsQuery = { __typename?: 'Query', describeSourceFields?: { __typename?: 'IDescribeSourceFieldsKickoffResult', describeSourceFieldsUuid: string } | null };

export type GetInviteLinkStatusQueryVariables = Exact<{
  inviteLinkHash: Scalars['String'];
}>;


export type GetInviteLinkStatusQuery = { __typename?: 'Query', getInviteLinkStatus: InviteLinkStatus };

export type GetJiraProjectsQueryVariables = Exact<{
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
}>;


export type GetJiraProjectsQuery = { __typename?: 'Query', getJiraProjects: Array<{ __typename?: 'JiraProject', providerUniqueId: string, name: string, key: string }> };

export type GetJiraTicketsQueryVariables = Exact<{
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetJiraTicketsQuery = { __typename?: 'Query', getJiraTickets: Array<{ __typename?: 'ExternalTicketData', assignee: string, dueDate?: any | null, name: string, providerUniqueId: string, sourcePermalink: string, closedDate?: any | null, status: External_Ticket_Status }> };

export type GetLinearTeamsQueryVariables = Exact<{
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
}>;


export type GetLinearTeamsQuery = { __typename?: 'Query', getLinearTeams: Array<{ __typename?: 'LinearTeam', key: string, name: string, providerUniqueId: string }> };

export type GetLinearTicketsQueryVariables = Exact<{
  orgId: Scalars['Int'];
  queryString: Scalars['String'];
  linearTeamId?: InputMaybe<Scalars['String']>;
}>;


export type GetLinearTicketsQuery = { __typename?: 'Query', getLinearTickets: Array<{ __typename?: 'ExternalTicketData', assignee: string, closedDate?: any | null, dueDate?: any | null, name: string, providerUniqueId: string, sourcePermalink: string, status: External_Ticket_Status }> };

export type GetOrganizationQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', getOrganization?: { __typename?: 'organization', id: number, name: string, isManagedByIdentityPool: boolean, defaultRole: Role, defaultTeamId?: number | null, orgUser: Array<{ __typename?: 'OrganizationUser', confirmed: boolean, email: string, role: Organization_Users_Role, user?: { __typename?: 'users', id: number, email: string, firstName?: string | null, lastName?: string | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null }>, teams: Array<{ __typename?: 'teams', creationDate: any, id: number, name: string, logoUrl?: string | null, orgId?: number | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> }>, orgDomains: Array<{ __typename?: 'org_domains', id: number, domain: string, allowDiscovery?: boolean | null }> } | null };

export type GetOrganizationUserTeamsQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type GetOrganizationUserTeamsQuery = { __typename?: 'Query', currentOrgUser?: { __typename?: 'OrganizationUser', teams: Array<{ __typename?: 'teams', id: number, name: string }> } | null };

export type GetOrganizationUsersQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type GetOrganizationUsersQuery = { __typename?: 'Query', getOrganizationUsers?: Array<{ __typename?: 'OrganizationUser', confirmed: boolean, email: string, role: Organization_Users_Role, user?: { __typename?: 'users', id: number, email: string, firstName?: string | null, lastName?: string | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null }> | null };

export type GetOrganizationsLightQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsLightQuery = { __typename?: 'Query', getOrganizations?: Array<{ __typename?: 'organization', id: number, name: string, isCustomerFacing: number, isManagedByIdentityPool: boolean, defaultTeamId?: number | null, currentUser: { __typename?: 'OrganizationUser', role: Organization_Users_Role }, teams: Array<{ __typename?: 'teams', id: number, name: string, logoUrl?: string | null }>, connections: Array<{ __typename?: 'org_connections', connected_name: string, id: number, type: { __typename?: 'connection_type', description: string, id: number, title: string } }> }> | null };

export type GetOrphansQueryVariables = Exact<{
  teamId: Scalars['Int'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput: FilterInput;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SortFieldType>;
}>;


export type GetOrphansQuery = { __typename?: 'Query', getGroups: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }> };

export type GetPartialEntriesQueryVariables = Exact<{
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByType>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetPartialEntriesQuery = { __typename?: 'Query', entries?: Array<{ __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, source?: string | null, submitter?: string | null, providerUniqueId?: string | null, source_permalink?: string | null, distillateText?: string | null, hasConversation: boolean, sentiment?: number | null, allGroupTitles?: Array<string> | null, segments: Array<{ __typename?: 'feedback_segment', value: string, groupName: string }> }> | null };

export type GetPinnedGroupsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput: FilterInput;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SortFieldType>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPinnedGroupsQuery = { __typename?: 'Query', getGroups: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null }> };

export type GetPlotQueryVariables = Exact<{
  chartId: Scalars['Int'];
  pageLevelFilterNode: Scalars['FilterNode'];
  teamId: Scalars['Int'];
  chartBinType?: InputMaybe<Chart_Bin_Type>;
}>;


export type GetPlotQuery = { __typename?: 'Query', getPlot: { __typename?: 'Plot', id: number, title: string, xAxisLabels: Array<string>, tooltipLabels: Array<string>, series: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number>, customName?: string | null, seriesLabel: { __typename?: 'Label', id: string, name: string } }>, plotConfiguration: { __typename?: 'PlotConfigurationOutput', yAxisMetric: Y_Axis_Data, breakdown?: Breakdown | null, chartType: Chart_Type, title: string, chartBinType: Chart_Bin_Type, seriesConfig: Array<{ __typename?: 'DataSeriesConfigurationOutput', segmentGroupId?: number | null, filterNode: string, customName?: string | null, team: { __typename?: 'teams', id: number, name: string } }> } } };

export type GetPlotPreviewQueryVariables = Exact<{
  pageLevelFilterNode: Scalars['FilterNode'];
  plotConfigurationInput: PlotConfig;
  teamId: Scalars['Int'];
}>;


export type GetPlotPreviewQuery = { __typename?: 'Query', getPlotPreview: { __typename?: 'Plot', id: number, title: string, xAxisLabels: Array<string>, tooltipLabels: Array<string>, series: Array<{ __typename?: 'PlotSeries', dataSeries: Array<number>, customName?: string | null, seriesLabel: { __typename?: 'Label', id: string, name: string } }>, plotConfiguration: { __typename?: 'PlotConfigurationOutput', yAxisMetric: Y_Axis_Data, breakdown?: Breakdown | null, chartType: Chart_Type, title: string, chartBinType: Chart_Bin_Type, seriesConfig: Array<{ __typename?: 'DataSeriesConfigurationOutput', segmentGroupId?: number | null, filterNode: string, customName?: string | null, team: { __typename?: 'teams', id: number, name: string } }> } } };

export type GetPreviewPageGroupsQueryVariables = Exact<{
  email: Scalars['String'];
  teamId: Scalars['Int'];
  teamUuid: Scalars['String'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filterInput: FilterInput;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPreviewPageGroupsQuery = { __typename?: 'Query', getPreviewPageGroups: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null }> };

export type GetPublicGroupQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  filterInput: FilterInput;
  belongs?: InputMaybe<Scalars['Boolean']>;
  teamUuid: Scalars['String'];
  sentencesTake?: InputMaybe<Scalars['Int']>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPublicGroupQuery = { __typename?: 'Query', getPublicGroup: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null } };

export type GetSlackChannelIdQueryVariables = Exact<{
  channelName: Scalars['String'];
  orgId: Scalars['Int'];
}>;


export type GetSlackChannelIdQuery = { __typename?: 'Query', getChannelId?: string | null };

export type GetTagsQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetTagsQuery = { __typename?: 'Query', getTags?: Array<{ __typename?: 'tag', id: number, name: string }> | null };

export type TaxonomyQueryVariables = Exact<{
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
}>;


export type TaxonomyQuery = { __typename?: 'Query', getTaxonomy: Array<{ __typename?: 'TaxonomyElement', groupId: string, childrenIds: Array<string>, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null } }> };

export type GetTaxonomyGroupQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
  filterInput: FilterInput;
  belongs?: InputMaybe<Scalars['Boolean']>;
  teamUuid?: InputMaybe<Scalars['String']>;
}>;


export type GetTaxonomyGroupQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, parent?: { __typename?: 'Group', id: string } | null, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null } };

export type TeamDefaultConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamDefaultConfigsQuery = { __typename?: 'Query', teamDefaultConfigs: Array<{ __typename?: 'TeamDefaultConfigs', endDate?: string | null, startDate?: string | null, exploreDefaultWindow?: Date_Window | null, teamId: number }> };

export type GetTeamPotentialWidgetsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  titleSubstring?: InputMaybe<Scalars['String']>;
}>;


export type GetTeamPotentialWidgetsQuery = { __typename?: 'Query', getTeamPotentialWidgets: Array<{ __typename?: 'PotentialWidget', title: string, widgetType: Board_Widget_Type, widgetTypeId: number }> };

export type GetUserAttrOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAttrOrgsQuery = { __typename?: 'Query', getUserAttributes: { __typename?: 'users', id: number, lastName?: string | null, firstName?: string | null, email: string, dateCreated: any, orgs: Array<{ __typename?: 'organization', id: number, name: string }> } };

export type GetUserAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAttributesQuery = { __typename?: 'Query', getUserAttributes: { __typename?: 'users', id: number, lastName?: string | null, firstName?: string | null, email: string, dateCreated: any } };

export type GroupSearchQueryVariables = Exact<{
  searchString: Scalars['String'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
}>;


export type GroupSearchQuery = { __typename?: 'Query', groupSearch: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null } }> };

export type IntegrationConnectedQueryVariables = Exact<{
  input: MutateFeedbackIntegration;
}>;


export type IntegrationConnectedQuery = { __typename?: 'Query', testIntegrationConnected?: { __typename?: 'IScraperResult', success: boolean, appName: string, response: string } | null };

export type IntegrationsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  orgId: Scalars['Int'];
  feedbackIntegrationType?: InputMaybe<Feedback_Integration_Type>;
}>;


export type IntegrationsQuery = { __typename?: 'Query', integrations?: Array<{ __typename?: 'integration_type', description: string, id: number, logoUrl: string, title: string, authRedirect?: string | null, scraperKey: string, feedbackIntegrationType: Feedback_Integration_Type, teamIntegration: Array<{ __typename?: 'feedback_integration', id: number, integrationName: string }>, orgExternalTicketsIntegration: Array<{ __typename?: 'external_tickets_integration', id: number }>, requirements: Array<{ __typename?: 'integration_type_requirement', id: number, description: string, example: string, required: boolean, requiredForAuthRedirect: boolean, frontendReplacementKey?: string | null, obfuscate: boolean, regex?: string | null, title: string, key: string, category?: Integration_Category | null, value: Array<{ __typename?: 'integration_type_requirement_value', id: number, value: string }> }> }> | null };

export type IntegrationTypeFragment = { __typename?: 'integration_type', description: string, id: number, logoUrl: string, title: string, authRedirect?: string | null, scraperKey: string, feedbackIntegrationType: Feedback_Integration_Type, teamIntegration: Array<{ __typename?: 'feedback_integration', id: number, integrationName: string }>, orgExternalTicketsIntegration: Array<{ __typename?: 'external_tickets_integration', id: number }>, requirements: Array<{ __typename?: 'integration_type_requirement', id: number, description: string, example: string, required: boolean, requiredForAuthRedirect: boolean, frontendReplacementKey?: string | null, obfuscate: boolean, regex?: string | null, title: string, key: string, category?: Integration_Category | null, value: Array<{ __typename?: 'integration_type_requirement_value', id: number, value: string }> }> };

export type IntegrationsLightQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsLightQuery = { __typename?: 'Query', integrations?: Array<{ __typename?: 'integration_type', id: number, itemName?: string | null, logoUrl: string, sourceKey?: string | null, title: string }> | null };

export type InternalPermissionsMutationVariables = Exact<{
  orgId: Scalars['Int'];
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
  role: Role;
}>;


export type InternalPermissionsMutation = { __typename?: 'Mutation', internalPermissions?: boolean | null };

export type InternalUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalUsersQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'InternalUser', id: number, email: string, name?: string | null }> };

export type ListExternalTicketsQueryVariables = Exact<{
  groupId: Scalars['BigInt'];
  teamId: Scalars['Int'];
}>;


export type ListExternalTicketsQuery = { __typename?: 'Query', listExternalTickets: Array<{ __typename?: 'external_ticket', assignee?: string | null, dueDate?: any | null, id: number, name: string, providerUniqueId: string, sourcePermalink: string, closedDate?: any | null, status: External_Ticket_Status, integration: { __typename?: 'external_tickets_integration', type: { __typename?: 'integration_type', title: string, logoUrl: string, scraperKey: string } } }> };

export type OldestFeedbackDateQueryVariables = Exact<{
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
}>;


export type OldestFeedbackDateQuery = { __typename?: 'Query', oldestFeedbackDate: any };

export type OldestFeedbackEntryQueryVariables = Exact<{
  teamId: Scalars['Int'];
  sortBy?: InputMaybe<SortByType>;
  teamUuid?: InputMaybe<Scalars['String']>;
}>;


export type OldestFeedbackEntryQuery = { __typename?: 'Query', entries?: Array<{ __typename?: 'feedback_entries', date?: number | null }> | null };

export type OrgManagedByOktaQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type OrgManagedByOktaQuery = { __typename?: 'Query', isOrganizationManagedByOkta?: boolean | null };

export type PollExecutionQueryVariables = Exact<{
  executionUuid: Scalars['String'];
  teamId: Scalars['Int'];
  orgId?: InputMaybe<Scalars['Int']>;
}>;


export type PollExecutionQuery = { __typename?: 'Query', pollExecution?: { __typename?: 'IExecutionResult', status: string, executionUuid: string, responsePayload?: string | null } | null };

export type PublicTeamDefaultsQueryVariables = Exact<{
  teamUuid: Scalars['String'];
}>;


export type PublicTeamDefaultsQuery = { __typename?: 'Query', publicTeamDefaults: { __typename?: 'TeamDefaults', endDate?: any | null, exploreDefaultWindow?: Date_Window | null, oldestFeedbackDate: any, startDate?: any | null, customer_locked_out: boolean, lock_out_message?: string | null } };

export type PublicTeamGroupsListQueryVariables = Exact<{
  teamUuid: Scalars['String'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput: FilterInput;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<SortFieldType>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type PublicTeamGroupsListQuery = { __typename?: 'Query', publicTeamGroups?: { __typename?: 'TeamGroups', amountOfGroups: { __typename?: 'GroupsCount', amount: number }, groups: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null }> } | null };

export type PublicTeamsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type PublicTeamsQuery = { __typename?: 'Query', publicTeams?: { __typename?: 'teams', id: number, name: string } | null };

export type RemoveEmailFromAlertMutationVariables = Exact<{
  alertId: Scalars['Int'];
  teamId: Scalars['Int'];
  alertEmailId: Scalars['Int'];
}>;


export type RemoveEmailFromAlertMutation = { __typename?: 'Mutation', removeEmailFromAlert: { __typename?: 'alerts_emails', alert_id: number, id: number, team_id: number, to_email?: string | null } };

export type SearchDigestSeriesQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchDigestSeriesQuery = { __typename?: 'Query', searchDigestSeries: Array<{ __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }> };

export type SearchDigestsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchDigestsQuery = { __typename?: 'Query', searchDigests: Array<{ __typename?: 'digest', id: number, dateCreated: any, status: DigestStatus, subject?: string | null, digestSeries: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> }, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } }> };

export type SegmentGroupQueryVariables = Exact<{
  teamId: Scalars['Int'];
  aiGenerated?: InputMaybe<Scalars['Boolean']>;
}>;


export type SegmentGroupQuery = { __typename?: 'Query', segments?: Array<{ __typename?: 'feedback_segment_group', displayName: string, id: number, aiGenerated: boolean }> | null };

export type SimilarSentencesQueryVariables = Exact<{
  queryString: Scalars['String'];
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
  groupId?: InputMaybe<Scalars['BigInt']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type SimilarSentencesQuery = { __typename?: 'Query', similarSentences?: Array<{ __typename?: 'feedback_sentences', id: string, text?: string | null, is_title?: number | null, is_distillate: boolean, entry: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } }> | null };

export type SourcesQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type SourcesQuery = { __typename?: 'Query', sources: Array<string> };

export type TeamsQueryVariables = Exact<{
  teamsId: Scalars['Int'];
  uuid?: InputMaybe<Scalars['String']>;
}>;


export type TeamsQuery = { __typename?: 'Query', teams?: { __typename?: 'teams', creationDate: any, id: number, name: string, logoUrl?: string | null, orgId?: number | null, roles: Array<{ __typename?: 'role_attachments', domain: string, domainId: number, id: number, orgId?: number | null, role: string, userId?: number | null }> } | null };

export type TeamChartsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  filterInput?: InputMaybe<FilterInput>;
}>;


export type TeamChartsQuery = { __typename?: 'Query', teamCharts: { __typename?: 'TeamCharts', amountOfCharts: number, charts: Array<{ __typename?: 'CustomChartsLight', chartId: number, chartName: string, savedFilterInput: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } }> } };

export type TeamDefaultsQueryVariables = Exact<{
  teamId: Scalars['Int'];
  teamUuid?: InputMaybe<Scalars['String']>;
}>;


export type TeamDefaultsQuery = { __typename?: 'Query', teamDefaults: { __typename?: 'TeamDefaults', endDate?: any | null, exploreDefaultWindow?: Date_Window | null, oldestFeedbackDate: any, startDate?: any | null, customer_locked_out: boolean, lock_out_message?: string | null } };

export type TeamFlagsQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type TeamFlagsQuery = { __typename?: 'Query', teamFlags?: { __typename?: 'team_background_job_flags', categorizing_last_run: number, clustering_last_run: number, currently_categorizing_themes?: number | null, currently_clustering?: number | null, currently_tokenizing?: number | null, id: number, tokenizing_last_run: number } | null };

export type TeamGroupsListQueryVariables = Exact<{
  teamId: Scalars['Int'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
  sentencesTake?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SortFieldType>;
  sentencesSkip?: InputMaybe<Scalars['Int']>;
  includeDescendantsOnMappings?: InputMaybe<Scalars['Boolean']>;
}>;


export type TeamGroupsListQuery = { __typename?: 'Query', teamGroups?: { __typename?: 'TeamGroups', amountOfGroups: { __typename?: 'GroupsCount', amount: number }, groups: Array<{ __typename?: 'Group', id: string, title: string, isNew?: boolean | null, isExactMatch: boolean, isPinnedByUser: boolean, centroidText: string, uniqueEntries: number, type: Group_Type, status: Group_Status, progress: number, processing: boolean, dateCreated?: number | null, totalDescendents: number, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, owner?: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string } | null, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorFiltered: number, denominatorUnfiltered: number } }, mentionsOverTime?: { __typename?: 'SeriesData', y_axis_data?: Y_Axis_Data | null, tooltipLabels: Array<string>, segmentGroupId?: number | null, normalizedData: Array<Array<number>>, chartLabels: Array<string>, breakdown?: Breakdown | null, aggregateData: Array<Array<number>>, breakdownLabels?: Array<{ __typename?: 'Label', name: string, id: string }> | null, filterInput?: { __typename?: 'SavedFilterInput', startDate?: any | null, endDate?: any | null } | null } | null, groupEntries?: Array<{ __typename?: 'GroupEntry', belongsToGroup: boolean, defaultDistillateDisplay: boolean, mappedSentences: Array<{ __typename?: 'Sentence', id: string, text: string, isTitle: boolean, orderInEntry: number, preceedingText: string, proceedingText: string, groupId?: string | null, entry?: { __typename?: 'feedback_entries', id: string, date?: number | null, text?: string | null, title?: string | null, stars?: number | null, source?: string | null, submitter?: string | null, submitterType?: string | null, sentiment?: number | null, source_permalink?: string | null, hasConversation: boolean, distillateText?: string | null, defaultDistillateDisplay: boolean, segments: Array<{ __typename?: 'feedback_segment', groupName: string, value: string, group: { __typename?: 'feedback_segment_group', aiGenerated: boolean }, config: { __typename?: 'feedback_segment_config', feedbackIntegration: { __typename?: 'feedback_integration', type: { __typename?: 'integration_type', title: string } } } }>, feedbackEntryText: { __typename?: 'FeedbackEntryText', conversationParts: Array<{ __typename?: 'conversation_part', submitterType: Submitter_Type, submitter?: string | null, fullText?: string | null, date?: number | null, userId?: number | null, providerUniqueId?: string | null }> }, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null } | null }>, groupMemberships?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number, ancestors?: Array<{ __typename?: 'GroupLight', id: string, title: string, status: Group_Status, type: Group_Type, teamId: number }> | null }> | null }> | null }> } | null };

export type TeamGroupsTaxonomyFlatQueryVariables = Exact<{
  teamId: Scalars['Int'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SortFieldType>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
}>;


export type TeamGroupsTaxonomyFlatQuery = { __typename?: 'Query', teamGroups?: { __typename?: 'TeamGroups', amountOfGroups: { __typename?: 'GroupsCount', amount: number }, taxonomyFlat: Array<{ __typename?: 'TaxonomyElement', groupId: string, node: { __typename: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null } }> } | null };

export type TeamGroupsTaxonomyTreeQueryVariables = Exact<{
  teamId: Scalars['Int'];
  belongs?: InputMaybe<Scalars['Boolean']>;
  filterInput?: InputMaybe<FilterInput>;
  status?: InputMaybe<Group_Status>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  teamUuid?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SortFieldType>;
  filterStatement?: InputMaybe<Scalars['FilterNode']>;
}>;


export type TeamGroupsTaxonomyTreeQuery = { __typename?: 'Query', teamGroups?: { __typename?: 'TeamGroups', amountOfGroups: { __typename?: 'GroupsCount', amount: number }, taxonomyTrees: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }, children: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }, children: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }, children: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }, children: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }, children: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null }, children: Array<{ __typename?: 'TaxonomyTreeNode', groupId: string, node: { __typename?: 'Group', id: string, title: string, isNew?: boolean | null, processing: boolean, progress: number, trending?: Group_Trending | null, isPinnedByUser: boolean, uniqueEntries: number, dateCreated?: number | null, totalDescendents: number, canAddChildren: boolean, creator: { __typename?: 'GroupCreator', isUnwrapGenerated: boolean, user?: { __typename?: 'users', email: string } | null }, tags?: Array<{ __typename?: 'tag', name: string, id: number }> | null, statistics: { __typename?: 'GroupStatistics', denominator: { __typename?: 'GroupDenominator', denominatorUnfiltered: number, denominatorFiltered: number } }, ancestors?: Array<{ __typename?: 'Group', id: string, title: string }> | null } }> }> }> }> }> }> }> } | null };

export type TestExternalTicketsIntegrationQueryVariables = Exact<{
  integrationType: MutateFeedbackIntegration;
  orgId: Scalars['Int'];
}>;


export type TestExternalTicketsIntegrationQuery = { __typename?: 'Query', testExternalTicketsIntegration: boolean };

export type EditDigestSeriesTeamMutationVariables = Exact<{
  editDigestSeriesTeamId: Scalars['Int'];
  teamIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type EditDigestSeriesTeamMutation = { __typename?: 'Mutation', editDigestSeriesTeam: { __typename?: 'digest_series', id: number, title: string, dateCreated?: any | null, digestSeriesType: DigestSeriesType, autoPopulateSGList: boolean, sendFrequency: DigestSendFrequency, creator: { __typename?: 'users', id: number, firstName?: string | null, lastName?: string | null, email: string }, teams: Array<{ __typename?: 'teams', id: number, name: string }>, organization: { __typename?: 'organization', id: number, name: string }, digest_series_channel: Array<{ __typename?: 'digest_series_channel', id: number, subChannelType: Channel_Type, subChannelName: string, active: boolean }> } };

export type ValidateIntegrationConfigQueryVariables = Exact<{
  input: MutateFeedbackIntegration;
}>;


export type ValidateIntegrationConfigQuery = { __typename?: 'Query', validateIntegrationConfig?: { __typename?: 'IValidationKickoffResult', validationUuid: string } | null };

export type GetPreviewPageLeadQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type GetPreviewPageLeadQuery = { __typename?: 'Query', getPreviewPageLead: boolean };

export const AlertDataFragmentDoc = gql`
    fragment AlertData on new_alerts {
  id
  name
  type
  team_id
  active
  period
  cadence
  threshold
  created_at
  creator_id
  emails {
    alert_id
    id
    team_id
    to_email
  }
  notifications {
    id
    sent
    sent_date
    team_id
    alert_id
  }
  slack {
    alert_id
    id
    organization_connections_id
    slack_channel_ID
    slack_channel_name
    team_id
  }
  filterInput {
    groupFilter {
      filterCondition
      groups {
        id
      }
    }
    segment {
      feedbackSegments
      filterCondition
      segmentGroupId
    }
    sentimentFilter {
      filterCondition
      sentiments
    }
    sourceFilter {
      filterCondition
      sources
    }
    minStarFilter {
      amounts
      filterCondition
    }
    maxStarFilter {
      amounts
      filterCondition
    }
  }
}
    `;
export const AnnouncementFragmentDoc = gql`
    fragment Announcement on announcement_emails {
  id
  date
  subject
  body
  recipients {
    userEmail
    entryText
  }
}
    `;
export const WidgetFragmentDoc = gql`
    fragment Widget on Widget {
  height
  width
  id
  x
  y
  widgetType
  widgetTypeId
  boardId
  title
}
    `;
export const BoardFragmentDoc = gql`
    fragment Board on Board {
  id
  title
  description
  isPinnedByUser
  filterNode
  widgets {
    ...Widget
  }
  creator {
    firstName
  }
}
    ${WidgetFragmentDoc}`;
export const BoardLightFragmentDoc = gql`
    fragment BoardLight on Board {
  id
  title
  description
  isPinnedByUser
  creator {
    firstName
    lastName
    email
  }
}
    `;
export const CampaignFragmentDoc = gql`
    fragment Campaign on campaign {
  campaignPages {
    title
    targetElement
    order
    description
  }
  expiration
  campaignUsers {
    user_id
    status
  }
  id
  page
  uiType
}
    `;
export const ChangelogFragmentDoc = gql`
    fragment Changelog on changelog {
  id
  userId
  feedbackIntegrationId
  title
  teamId
  description
  date
  integration {
    type {
      title
    }
  }
}
    `;
export const FilterFragmentDoc = gql`
    fragment Filter on SavedFilterInput {
  teamName
  groupFilter {
    filterCondition
    groups {
      id
    }
  }
  startDate
  endDate
  segment {
    feedbackSegments
    filterCondition
    segmentGroupId
  }
  sentimentFilter {
    filterCondition
    sentiments
  }
  sourceFilter {
    filterCondition
    sources
  }
  minStarFilter {
    amounts
    filterCondition
  }
  maxStarFilter {
    amounts
    filterCondition
  }
}
    `;
export const Chart2DFragmentDoc = gql`
    fragment Chart2D on Chart2D {
  id
  title
  xAxisLabels
  tooltipLabels
  series
  owner {
    firstName
    lastName
    email
  }
  legend {
    id
    name
  }
  config {
    y_axis_data
    breakdown
    type
    seriesConfig {
      team {
        id
        name
      }
      segmentGroupId
      filterInput {
        ...Filter
      }
    }
  }
}
    ${FilterFragmentDoc}`;
export const SeriesDataFragmentDoc = gql`
    fragment SeriesData on SeriesData {
  aggregateData
  breakdown
  chartLabels
  normalizedData
  tooltipLabels
  y_axis_data
  breakdown
  breakdownLabels {
    id
    name
  }
  team {
    id
    name
  }
  segmentGroupId
  filterInput {
    ...Filter
  }
}
    ${FilterFragmentDoc}`;
export const ChartFragmentDoc = gql`
    fragment Chart on Chart {
  breakdown
  type
  dateCreated
  id
  owner {
    id
    firstName
    lastName
  }
  tags {
    id
    name
  }
  seriesData {
    ...SeriesData
  }
  title
  y_axis_data
}
    ${SeriesDataFragmentDoc}`;
export const UserDataFragmentDoc = gql`
    fragment UserData on users {
  id
  firstName
  lastName
  email
}
    `;
export const DigestSeriesDataFragmentDoc = gql`
    fragment DigestSeriesData on digest_series {
  id
  creator {
    ...UserData
  }
  title
  dateCreated
  teams {
    id
    name
  }
  organization {
    id
    name
  }
  digestSeriesType
  autoPopulateSGList
  digest_series_channel {
    id
    subChannelType
    subChannelName
    active
  }
  sendFrequency
}
    ${UserDataFragmentDoc}`;
export const DigestDataFragmentDoc = gql`
    fragment DigestData on digest {
  id
  digestSeries {
    ...DigestSeriesData
  }
  creator {
    ...UserData
  }
  dateCreated
  status
  subject
}
    ${DigestSeriesDataFragmentDoc}
${UserDataFragmentDoc}`;
export const ExternalTicketFragmentDoc = gql`
    fragment ExternalTicket on external_ticket {
  assignee
  dueDate
  id
  name
  providerUniqueId
  sourcePermalink
  closedDate
  status
  integration {
    type {
      title
      logoUrl
      scraperKey
    }
  }
}
    `;
export const DataSeriesConfigurationFragmentDoc = gql`
    fragment DataSeriesConfiguration on DataSeriesConfigurationOutput {
  team {
    id
    name
  }
  segmentGroupId
  filterNode
  customName
}
    `;
export const PlotConfigurationFragmentDoc = gql`
    fragment PlotConfiguration on PlotConfigurationOutput {
  yAxisMetric
  breakdown
  chartType
  title
  chartBinType
  seriesConfig {
    ...DataSeriesConfiguration
  }
}
    ${DataSeriesConfigurationFragmentDoc}`;
export const FullPlotFragmentDoc = gql`
    fragment FullPlot on Plot {
  id
  title
  xAxisLabels
  tooltipLabels
  series {
    seriesLabel {
      id
      name
    }
    dataSeries
    customName
  }
  unNormalizedSeries {
    dataSeries
  }
  plotConfiguration {
    ...PlotConfiguration
  }
  rangeStart
  rangeEnd
}
    ${PlotConfigurationFragmentDoc}`;
export const ConversationFragmentDoc = gql`
    fragment Conversation on conversation_part {
  submitterType
  submitter
  fullText
  date
  userId
  providerUniqueId
}
    `;
export const GroupLightFragmentDoc = gql`
    fragment GroupLight on GroupLight {
  id
  title
  status
  type
  teamId
}
    `;
export const GroupMembershipFragmentDoc = gql`
    fragment GroupMembership on GroupLight {
  ...GroupLight
  ancestors {
    ...GroupLight
  }
}
    ${GroupLightFragmentDoc}`;
export const EntryFragmentDoc = gql`
    fragment Entry on feedback_entries {
  id
  date
  text
  title
  stars
  source
  submitter
  submitterType
  sentiment
  source_permalink
  hasConversation
  distillateText
  segments {
    groupName
    value
    group {
      aiGenerated
    }
    config {
      feedbackIntegration {
        type {
          title
        }
      }
    }
  }
  feedbackEntryText {
    conversationParts {
      ...Conversation
    }
  }
  groupMemberships {
    ...GroupMembership
  }
  defaultDistillateDisplay
}
    ${ConversationFragmentDoc}
${GroupMembershipFragmentDoc}`;
export const GroupSentenceDataFragmentDoc = gql`
    fragment GroupSentenceData on Sentence {
  id
  text
  isTitle
  orderInEntry
  preceedingText
  proceedingText
  entry {
    ...Entry
  }
  groupId
}
    ${EntryFragmentDoc}`;
export const GroupEntryFragmentDoc = gql`
    fragment GroupEntry on GroupEntry {
  mappedSentences {
    ...GroupSentenceData
  }
  belongsToGroup
  groupMemberships {
    ...GroupMembership
  }
  defaultDistillateDisplay
}
    ${GroupSentenceDataFragmentDoc}
${GroupMembershipFragmentDoc}`;
export const GroupDataFragmentDoc = gql`
    fragment GroupData on Group {
  id
  title
  isNew
  isExactMatch
  isPinnedByUser
  centroidText
  uniqueEntries
  type
  status
  progress
  processing
  dateCreated
  totalDescendents
  creator {
    isUnwrapGenerated
    user {
      email
    }
  }
  owner {
    id
    firstName
    lastName
    email
  }
  tags {
    name
    id
  }
  statistics {
    denominator {
      denominatorFiltered
      denominatorUnfiltered
    }
  }
  mentionsOverTime {
    y_axis_data
    tooltipLabels
    segmentGroupId
    normalizedData
    chartLabels
    breakdownLabels {
      name
      id
    }
    breakdown
    aggregateData
    filterInput {
      startDate
      endDate
    }
  }
  groupEntries(
    entriesTake: $sentencesTake
    entriesSkip: $sentencesSkip
    includeDescendantsOnMappings: $includeDescendantsOnMappings
  ) {
    ...GroupEntry
  }
}
    ${GroupEntryFragmentDoc}`;
export const GroupInsightFragmentDoc = gql`
    fragment GroupInsight on GroupInsight {
  digestSection
  expirationDate
  groupId
  id
  includeInDigest
  insightDescription
  insightStartDate
  isSuppressed
  teamId
  timeWindow
  includeInReport
  reportStartDate
  insightTitle
}
    `;
export const GroupInsightsDataFragmentDoc = gql`
    fragment GroupInsightsData on group_insights {
  digestSection
  expirationDate
  groupId
  id
  includeInDigest
  insightTitle
  insightDescription
  insightStartDate
  isSuppressed
  teamId
  timeWindow
  includeInReport
  reportStartDate
  insightTitle
}
    `;
export const GroupPlotFragmentDoc = gql`
    fragment GroupPlot on Plot {
  xAxisLabels
  tooltipLabels
  series {
    dataSeries
  }
  unNormalizedSeries {
    dataSeries
  }
  rangeStart
  rangeEnd
}
    `;
export const GroupTaxonomyFragmentDoc = gql`
    fragment GroupTaxonomy on Group {
  id
  title
  isNew
  processing
  progress
  trending
  isPinnedByUser
  uniqueEntries
  dateCreated
  totalDescendents
  creator {
    isUnwrapGenerated
    user {
      email
    }
  }
  tags {
    name
    id
  }
  statistics {
    denominator {
      denominatorUnfiltered
      denominatorFiltered
    }
  }
  ancestors {
    id
    title
  }
  canAddChildren
}
    `;
export const InsightLightFragmentDoc = gql`
    fragment InsightLight on Insight {
  id
  insightStatus
  insightType
  text
  chartBin
  team {
    id
    orgId
  }
  creationSource
  title
  feedbackStatus
  collection {
    id
    type
    title
  }
  filterInput {
    ...Filter
  }
  expirationDate
  entries {
    ...Entry
  }
  order
  excludeFromDigest
  sources
}
    ${FilterFragmentDoc}
${EntryFragmentDoc}`;
export const InsightNoSourcesFragmentDoc = gql`
    fragment InsightNoSources on Insight {
  id
  insightStatus
  insightType
  text
  chartBin
  team {
    id
    orgId
  }
  creationSource
  title
  feedbackStatus
  collection {
    id
    type
    title
  }
  filterInput {
    ...Filter
  }
  expirationDate
  entries {
    ...Entry
  }
  order
  excludeFromDigest
}
    ${FilterFragmentDoc}
${EntryFragmentDoc}`;
export const OrgUserTeamsFragmentDoc = gql`
    fragment OrgUserTeams on OrganizationUser {
  teams {
    id
    name
  }
}
    `;
export const OrganizationUserFragmentDoc = gql`
    fragment OrganizationUser on OrganizationUser {
  confirmed
  email
  role
  user {
    id
    email
    firstName
    lastName
    roles(orgId: $orgId) {
      domain
      domainId
      id
      orgId
      role
      userId
    }
  }
}
    `;
export const TeamDataFragmentDoc = gql`
    fragment TeamData on teams {
  creationDate
  id
  name
  logoUrl
  orgId
  roles {
    domain
    domainId
    id
    orgId
    role
    userId
  }
}
    `;
export const OrgDomainFragmentDoc = gql`
    fragment OrgDomain on org_domains {
  id
  domain
  allowDiscovery
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on organization {
  id
  name
  isManagedByIdentityPool
  orgUser {
    ...OrganizationUser
  }
  teams {
    ...TeamData
  }
  orgDomains {
    ...OrgDomain
  }
  defaultRole
  defaultTeamId
}
    ${OrganizationUserFragmentDoc}
${TeamDataFragmentDoc}
${OrgDomainFragmentDoc}`;
export const OrganizationsLightFragmentDoc = gql`
    fragment OrganizationsLight on organization {
  id
  name
  currentUser {
    role
  }
  isCustomerFacing
  isManagedByIdentityPool
  teams {
    id
    name
    logoUrl
  }
  connections {
    connected_name
    id
    type {
      description
      id
      title
    }
  }
  defaultTeamId
}
    `;
export const PartialEntryFragmentDoc = gql`
    fragment PartialEntry on feedback_entries {
  id
  date
  text
  title
  source
  submitter
  providerUniqueId
  source_permalink
  distillateText
  hasConversation
  segments {
    value
    groupName
  }
  sentiment
  allGroupTitles
}
    `;
export const PlotFragmentDoc = gql`
    fragment Plot on Plot {
  id
  title
  xAxisLabels
  tooltipLabels
  series {
    seriesLabel {
      id
      name
    }
    dataSeries
    customName
  }
  plotConfiguration {
    ...PlotConfiguration
  }
}
    ${PlotConfigurationFragmentDoc}`;
export const PotentialWidgetFragmentDoc = gql`
    fragment PotentialWidget on PotentialWidget {
  title
  widgetType
  widgetTypeId
}
    `;
export const SentenceEntryFragmentDoc = gql`
    fragment SentenceEntry on feedback_sentences {
  id
  text
  is_title
  is_distillate
  entry {
    ...Entry
  }
}
    ${EntryFragmentDoc}`;
export const FeedbackIntegrationFragmentDoc = gql`
    fragment FeedbackIntegration on feedback_integration {
  filters {
    comparison
    id
    segmentGroup {
      id
      displayName
    }
    value
  }
  id
  integrationName
  requirementValue {
    valueId: id
    value
    requirement {
      id
      key
    }
  }
  segmentConfig(ai_generated: false) {
    id
    override
    path
    segmentGroup {
      id
      displayName
    }
  }
  defaultDistillateDisplay
  type {
    logoUrl
    title
    feedbackIntegrationType
    id
    authRedirect
    description
    itemName
    scraperKey
    sourceKey
  }
  requirements: type {
    requirements {
      id
      key
      obfuscate
      title
      description
      example
      frontendReplacementKey
      regex
      required
      requiredForAuthRedirect
      category
    }
  }
}
    `;
export const IntegrationTypeFragmentDoc = gql`
    fragment IntegrationType on integration_type {
  description
  id
  logoUrl
  title
  authRedirect
  scraperKey
  teamIntegration(teamId: $teamId) {
    id
    integrationName
  }
  orgExternalTicketsIntegration(orgId: $orgId) {
    id
  }
  requirements {
    id
    description
    example
    required
    requiredForAuthRedirect
    frontendReplacementKey
    obfuscate
    regex
    title
    key
    value(teamId: $teamId, orgId: $orgId) {
      id
      value
    }
    category
  }
  feedbackIntegrationType
}
    `;
export const AllTeamsDocument = gql`
    query AllTeams($orgId: Int!) {
  allTeams(orgId: $orgId) {
    id
    name
  }
}
    `;

/**
 * __useAllTeamsQuery__
 *
 * To run a query within a React component, call `useAllTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeamsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAllTeamsQuery(baseOptions: Apollo.QueryHookOptions<AllTeamsQuery, AllTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTeamsQuery, AllTeamsQueryVariables>(AllTeamsDocument, options);
      }
export function useAllTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTeamsQuery, AllTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTeamsQuery, AllTeamsQueryVariables>(AllTeamsDocument, options);
        }
export type AllTeamsQueryHookResult = ReturnType<typeof useAllTeamsQuery>;
export type AllTeamsLazyQueryHookResult = ReturnType<typeof useAllTeamsLazyQuery>;
export type AllTeamsQueryResult = Apollo.QueryResult<AllTeamsQuery, AllTeamsQueryVariables>;
export const AddDomainToOrgDocument = gql`
    mutation AddDomainToOrg($allowDiscovery: Boolean!, $domain: String!, $orgId: Int!) {
  addDomainToOrg(allowDiscovery: $allowDiscovery, domain: $domain, orgId: $orgId) {
    allowDiscovery
    domain
    id
  }
}
    `;
export type AddDomainToOrgMutationFn = Apollo.MutationFunction<AddDomainToOrgMutation, AddDomainToOrgMutationVariables>;

/**
 * __useAddDomainToOrgMutation__
 *
 * To run a mutation, you first call `useAddDomainToOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDomainToOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDomainToOrgMutation, { data, loading, error }] = useAddDomainToOrgMutation({
 *   variables: {
 *      allowDiscovery: // value for 'allowDiscovery'
 *      domain: // value for 'domain'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAddDomainToOrgMutation(baseOptions?: Apollo.MutationHookOptions<AddDomainToOrgMutation, AddDomainToOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDomainToOrgMutation, AddDomainToOrgMutationVariables>(AddDomainToOrgDocument, options);
      }
export type AddDomainToOrgMutationHookResult = ReturnType<typeof useAddDomainToOrgMutation>;
export type AddDomainToOrgMutationResult = Apollo.MutationResult<AddDomainToOrgMutation>;
export type AddDomainToOrgMutationOptions = Apollo.BaseMutationOptions<AddDomainToOrgMutation, AddDomainToOrgMutationVariables>;
export const AddOrganizationUsersDocument = gql`
    mutation AddOrganizationUsers($orgId: Int!, $usersToAdd: [AddUserToOrg!]!) {
  addOrganizationUsers(orgId: $orgId, usersToAdd: $usersToAdd) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export type AddOrganizationUsersMutationFn = Apollo.MutationFunction<AddOrganizationUsersMutation, AddOrganizationUsersMutationVariables>;

/**
 * __useAddOrganizationUsersMutation__
 *
 * To run a mutation, you first call `useAddOrganizationUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationUsersMutation, { data, loading, error }] = useAddOrganizationUsersMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      usersToAdd: // value for 'usersToAdd'
 *   },
 * });
 */
export function useAddOrganizationUsersMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationUsersMutation, AddOrganizationUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationUsersMutation, AddOrganizationUsersMutationVariables>(AddOrganizationUsersDocument, options);
      }
export type AddOrganizationUsersMutationHookResult = ReturnType<typeof useAddOrganizationUsersMutation>;
export type AddOrganizationUsersMutationResult = Apollo.MutationResult<AddOrganizationUsersMutation>;
export type AddOrganizationUsersMutationOptions = Apollo.BaseMutationOptions<AddOrganizationUsersMutation, AddOrganizationUsersMutationVariables>;
export const AddWidgetFeedbackDocument = gql`
    mutation AddWidgetFeedback($email: String!, $feedback: String!, $teamId: Int!, $name: String) {
  addWidgetFeedback(
    email: $email
    feedback: $feedback
    teamId: $teamId
    name: $name
  ) {
    ...Entry
  }
}
    ${EntryFragmentDoc}`;
export type AddWidgetFeedbackMutationFn = Apollo.MutationFunction<AddWidgetFeedbackMutation, AddWidgetFeedbackMutationVariables>;

/**
 * __useAddWidgetFeedbackMutation__
 *
 * To run a mutation, you first call `useAddWidgetFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWidgetFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWidgetFeedbackMutation, { data, loading, error }] = useAddWidgetFeedbackMutation({
 *   variables: {
 *      email: // value for 'email'
 *      feedback: // value for 'feedback'
 *      teamId: // value for 'teamId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddWidgetFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddWidgetFeedbackMutation, AddWidgetFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWidgetFeedbackMutation, AddWidgetFeedbackMutationVariables>(AddWidgetFeedbackDocument, options);
      }
export type AddWidgetFeedbackMutationHookResult = ReturnType<typeof useAddWidgetFeedbackMutation>;
export type AddWidgetFeedbackMutationResult = Apollo.MutationResult<AddWidgetFeedbackMutation>;
export type AddWidgetFeedbackMutationOptions = Apollo.BaseMutationOptions<AddWidgetFeedbackMutation, AddWidgetFeedbackMutationVariables>;
export const AlertGroupFailedDocument = gql`
    mutation AlertGroupFailed($queryString: String!, $teamId: Int!, $email: String, $teamUuid: String, $wasRetried: Boolean!) {
  alertGroupFailed(
    queryString: $queryString
    teamId: $teamId
    email: $email
    teamUuid: $teamUuid
    wasRetried: $wasRetried
  )
}
    `;
export type AlertGroupFailedMutationFn = Apollo.MutationFunction<AlertGroupFailedMutation, AlertGroupFailedMutationVariables>;

/**
 * __useAlertGroupFailedMutation__
 *
 * To run a mutation, you first call `useAlertGroupFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlertGroupFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alertGroupFailedMutation, { data, loading, error }] = useAlertGroupFailedMutation({
 *   variables: {
 *      queryString: // value for 'queryString'
 *      teamId: // value for 'teamId'
 *      email: // value for 'email'
 *      teamUuid: // value for 'teamUuid'
 *      wasRetried: // value for 'wasRetried'
 *   },
 * });
 */
export function useAlertGroupFailedMutation(baseOptions?: Apollo.MutationHookOptions<AlertGroupFailedMutation, AlertGroupFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlertGroupFailedMutation, AlertGroupFailedMutationVariables>(AlertGroupFailedDocument, options);
      }
export type AlertGroupFailedMutationHookResult = ReturnType<typeof useAlertGroupFailedMutation>;
export type AlertGroupFailedMutationResult = Apollo.MutationResult<AlertGroupFailedMutation>;
export type AlertGroupFailedMutationOptions = Apollo.BaseMutationOptions<AlertGroupFailedMutation, AlertGroupFailedMutationVariables>;
export const ApproveGroupDocument = gql`
    mutation ApproveGroup($groupId: BigInt!, $teamId: Int!, $belongingSentenceIds: [BigInt!], $differingSentenceIds: [BigInt!], $teamUuid: String, $sentencesTake: Int, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  approveGroup(
    groupId: $groupId
    teamId: $teamId
    belongingSentenceIds: $belongingSentenceIds
    differingSentenceIds: $differingSentenceIds
    teamUuid: $teamUuid
  ) {
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;
export type ApproveGroupMutationFn = Apollo.MutationFunction<ApproveGroupMutation, ApproveGroupMutationVariables>;

/**
 * __useApproveGroupMutation__
 *
 * To run a mutation, you first call `useApproveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveGroupMutation, { data, loading, error }] = useApproveGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      belongingSentenceIds: // value for 'belongingSentenceIds'
 *      differingSentenceIds: // value for 'differingSentenceIds'
 *      teamUuid: // value for 'teamUuid'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useApproveGroupMutation(baseOptions?: Apollo.MutationHookOptions<ApproveGroupMutation, ApproveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveGroupMutation, ApproveGroupMutationVariables>(ApproveGroupDocument, options);
      }
export type ApproveGroupMutationHookResult = ReturnType<typeof useApproveGroupMutation>;
export type ApproveGroupMutationResult = Apollo.MutationResult<ApproveGroupMutation>;
export type ApproveGroupMutationOptions = Apollo.BaseMutationOptions<ApproveGroupMutation, ApproveGroupMutationVariables>;
export const AssignChildDocument = gql`
    mutation AssignChild($teamId: Int!, $parentGroupId: BigInt!, $childGroupId: BigInt!) {
  assignChild(
    teamId: $teamId
    parentGroupId: $parentGroupId
    childGroupId: $childGroupId
  ) {
    ...GroupTaxonomy
  }
}
    ${GroupTaxonomyFragmentDoc}`;
export type AssignChildMutationFn = Apollo.MutationFunction<AssignChildMutation, AssignChildMutationVariables>;

/**
 * __useAssignChildMutation__
 *
 * To run a mutation, you first call `useAssignChildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignChildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignChildMutation, { data, loading, error }] = useAssignChildMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      parentGroupId: // value for 'parentGroupId'
 *      childGroupId: // value for 'childGroupId'
 *   },
 * });
 */
export function useAssignChildMutation(baseOptions?: Apollo.MutationHookOptions<AssignChildMutation, AssignChildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignChildMutation, AssignChildMutationVariables>(AssignChildDocument, options);
      }
export type AssignChildMutationHookResult = ReturnType<typeof useAssignChildMutation>;
export type AssignChildMutationResult = Apollo.MutationResult<AssignChildMutation>;
export type AssignChildMutationOptions = Apollo.BaseMutationOptions<AssignChildMutation, AssignChildMutationVariables>;
export const AssignChildrenDocument = gql`
    mutation AssignChildren($teamId: Int!, $groupId: BigInt!, $childGroupIds: [BigInt!]!) {
  assignChildren(
    teamId: $teamId
    parentGroupId: $groupId
    childGroupIds: $childGroupIds
  ) {
    ...GroupTaxonomy
  }
}
    ${GroupTaxonomyFragmentDoc}`;
export type AssignChildrenMutationFn = Apollo.MutationFunction<AssignChildrenMutation, AssignChildrenMutationVariables>;

/**
 * __useAssignChildrenMutation__
 *
 * To run a mutation, you first call `useAssignChildrenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignChildrenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignChildrenMutation, { data, loading, error }] = useAssignChildrenMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      groupId: // value for 'groupId'
 *      childGroupIds: // value for 'childGroupIds'
 *   },
 * });
 */
export function useAssignChildrenMutation(baseOptions?: Apollo.MutationHookOptions<AssignChildrenMutation, AssignChildrenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignChildrenMutation, AssignChildrenMutationVariables>(AssignChildrenDocument, options);
      }
export type AssignChildrenMutationHookResult = ReturnType<typeof useAssignChildrenMutation>;
export type AssignChildrenMutationResult = Apollo.MutationResult<AssignChildrenMutation>;
export type AssignChildrenMutationOptions = Apollo.BaseMutationOptions<AssignChildrenMutation, AssignChildrenMutationVariables>;
export const CloneBoardDocument = gql`
    mutation CloneBoard($boardId: Int!, $teamId: Int!) {
  cloneBoard(boardId: $boardId, teamId: $teamId) {
    ...BoardLight
  }
}
    ${BoardLightFragmentDoc}`;
export type CloneBoardMutationFn = Apollo.MutationFunction<CloneBoardMutation, CloneBoardMutationVariables>;

/**
 * __useCloneBoardMutation__
 *
 * To run a mutation, you first call `useCloneBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneBoardMutation, { data, loading, error }] = useCloneBoardMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useCloneBoardMutation(baseOptions?: Apollo.MutationHookOptions<CloneBoardMutation, CloneBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneBoardMutation, CloneBoardMutationVariables>(CloneBoardDocument, options);
      }
export type CloneBoardMutationHookResult = ReturnType<typeof useCloneBoardMutation>;
export type CloneBoardMutationResult = Apollo.MutationResult<CloneBoardMutation>;
export type CloneBoardMutationOptions = Apollo.BaseMutationOptions<CloneBoardMutation, CloneBoardMutationVariables>;
export const CopyTeamEntriesDocument = gql`
    mutation CopyTeamEntries($destinationTeamId: Int!, $originTeamId: Int!) {
  copyTeamEntries(
    destinationTeamId: $destinationTeamId
    originTeamId: $originTeamId
  )
}
    `;
export type CopyTeamEntriesMutationFn = Apollo.MutationFunction<CopyTeamEntriesMutation, CopyTeamEntriesMutationVariables>;

/**
 * __useCopyTeamEntriesMutation__
 *
 * To run a mutation, you first call `useCopyTeamEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyTeamEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyTeamEntriesMutation, { data, loading, error }] = useCopyTeamEntriesMutation({
 *   variables: {
 *      destinationTeamId: // value for 'destinationTeamId'
 *      originTeamId: // value for 'originTeamId'
 *   },
 * });
 */
export function useCopyTeamEntriesMutation(baseOptions?: Apollo.MutationHookOptions<CopyTeamEntriesMutation, CopyTeamEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyTeamEntriesMutation, CopyTeamEntriesMutationVariables>(CopyTeamEntriesDocument, options);
      }
export type CopyTeamEntriesMutationHookResult = ReturnType<typeof useCopyTeamEntriesMutation>;
export type CopyTeamEntriesMutationResult = Apollo.MutationResult<CopyTeamEntriesMutation>;
export type CopyTeamEntriesMutationOptions = Apollo.BaseMutationOptions<CopyTeamEntriesMutation, CopyTeamEntriesMutationVariables>;
export const CreateAlertDocument = gql`
    mutation CreateAlert($filterInput: FilterInput!, $teamId: Int!, $type: AlertType!, $emails: [String!], $period: Int, $alertName: String, $cadence: CadenceType, $slackChannelId: String, $slackChannelName: String, $threshold: Int) {
  createAlert(
    filterInput: $filterInput
    teamId: $teamId
    type: $type
    emails: $emails
    period: $period
    alertName: $alertName
    cadence: $cadence
    slackChannelID: $slackChannelId
    slackChannelName: $slackChannelName
    threshold: $threshold
  ) {
    ...AlertData
  }
}
    ${AlertDataFragmentDoc}`;
export type CreateAlertMutationFn = Apollo.MutationFunction<CreateAlertMutation, CreateAlertMutationVariables>;

/**
 * __useCreateAlertMutation__
 *
 * To run a mutation, you first call `useCreateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertMutation, { data, loading, error }] = useCreateAlertMutation({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      teamId: // value for 'teamId'
 *      type: // value for 'type'
 *      emails: // value for 'emails'
 *      period: // value for 'period'
 *      alertName: // value for 'alertName'
 *      cadence: // value for 'cadence'
 *      slackChannelId: // value for 'slackChannelId'
 *      slackChannelName: // value for 'slackChannelName'
 *      threshold: // value for 'threshold'
 *   },
 * });
 */
export function useCreateAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlertMutation, CreateAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlertMutation, CreateAlertMutationVariables>(CreateAlertDocument, options);
      }
export type CreateAlertMutationHookResult = ReturnType<typeof useCreateAlertMutation>;
export type CreateAlertMutationResult = Apollo.MutationResult<CreateAlertMutation>;
export type CreateAlertMutationOptions = Apollo.BaseMutationOptions<CreateAlertMutation, CreateAlertMutationVariables>;
export const CreateBoardDocument = gql`
    mutation CreateBoard($teamId: Int!, $title: String!, $description: String) {
  createBoard(teamId: $teamId, title: $title, description: $description) {
    ...BoardLight
  }
}
    ${BoardLightFragmentDoc}`;
export type CreateBoardMutationFn = Apollo.MutationFunction<CreateBoardMutation, CreateBoardMutationVariables>;

/**
 * __useCreateBoardMutation__
 *
 * To run a mutation, you first call `useCreateBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoardMutation, { data, loading, error }] = useCreateBoardMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateBoardMutation(baseOptions?: Apollo.MutationHookOptions<CreateBoardMutation, CreateBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBoardMutation, CreateBoardMutationVariables>(CreateBoardDocument, options);
      }
export type CreateBoardMutationHookResult = ReturnType<typeof useCreateBoardMutation>;
export type CreateBoardMutationResult = Apollo.MutationResult<CreateBoardMutation>;
export type CreateBoardMutationOptions = Apollo.BaseMutationOptions<CreateBoardMutation, CreateBoardMutationVariables>;
export const CreateChangelogDataDocument = gql`
    mutation CreateChangelogData($date: Float!, $teamId: Int!, $title: String!, $description: String) {
  createChangelog(
    date: $date
    teamId: $teamId
    title: $title
    description: $description
  ) {
    ...Changelog
  }
}
    ${ChangelogFragmentDoc}`;
export type CreateChangelogDataMutationFn = Apollo.MutationFunction<CreateChangelogDataMutation, CreateChangelogDataMutationVariables>;

/**
 * __useCreateChangelogDataMutation__
 *
 * To run a mutation, you first call `useCreateChangelogDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChangelogDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChangelogDataMutation, { data, loading, error }] = useCreateChangelogDataMutation({
 *   variables: {
 *      date: // value for 'date'
 *      teamId: // value for 'teamId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateChangelogDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateChangelogDataMutation, CreateChangelogDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChangelogDataMutation, CreateChangelogDataMutationVariables>(CreateChangelogDataDocument, options);
      }
export type CreateChangelogDataMutationHookResult = ReturnType<typeof useCreateChangelogDataMutation>;
export type CreateChangelogDataMutationResult = Apollo.MutationResult<CreateChangelogDataMutation>;
export type CreateChangelogDataMutationOptions = Apollo.BaseMutationOptions<CreateChangelogDataMutation, CreateChangelogDataMutationVariables>;
export const CreateCustomChartDocument = gql`
    mutation CreateCustomChart($editChartInput: EditChartInput!, $filterInput: FilterInput!, $teamId: Int!, $chartBinType: chart_bin_type) {
  createChart(
    editChartInput: $editChartInput
    filterInput: $filterInput
    teamId: $teamId
    chartBinType: $chartBinType
  ) {
    id
  }
}
    `;
export type CreateCustomChartMutationFn = Apollo.MutationFunction<CreateCustomChartMutation, CreateCustomChartMutationVariables>;

/**
 * __useCreateCustomChartMutation__
 *
 * To run a mutation, you first call `useCreateCustomChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomChartMutation, { data, loading, error }] = useCreateCustomChartMutation({
 *   variables: {
 *      editChartInput: // value for 'editChartInput'
 *      filterInput: // value for 'filterInput'
 *      teamId: // value for 'teamId'
 *      chartBinType: // value for 'chartBinType'
 *   },
 * });
 */
export function useCreateCustomChartMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomChartMutation, CreateCustomChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomChartMutation, CreateCustomChartMutationVariables>(CreateCustomChartDocument, options);
      }
export type CreateCustomChartMutationHookResult = ReturnType<typeof useCreateCustomChartMutation>;
export type CreateCustomChartMutationResult = Apollo.MutationResult<CreateCustomChartMutation>;
export type CreateCustomChartMutationOptions = Apollo.BaseMutationOptions<CreateCustomChartMutation, CreateCustomChartMutationVariables>;
export const CreateDigestDocument = gql`
    mutation CreateDigest($digestSeriesId: Int!) {
  createDigest(digestSeriesId: $digestSeriesId) {
    ...DigestData
  }
}
    ${DigestDataFragmentDoc}`;
export type CreateDigestMutationFn = Apollo.MutationFunction<CreateDigestMutation, CreateDigestMutationVariables>;

/**
 * __useCreateDigestMutation__
 *
 * To run a mutation, you first call `useCreateDigestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigestMutation, { data, loading, error }] = useCreateDigestMutation({
 *   variables: {
 *      digestSeriesId: // value for 'digestSeriesId'
 *   },
 * });
 */
export function useCreateDigestMutation(baseOptions?: Apollo.MutationHookOptions<CreateDigestMutation, CreateDigestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDigestMutation, CreateDigestMutationVariables>(CreateDigestDocument, options);
      }
export type CreateDigestMutationHookResult = ReturnType<typeof useCreateDigestMutation>;
export type CreateDigestMutationResult = Apollo.MutationResult<CreateDigestMutation>;
export type CreateDigestMutationOptions = Apollo.BaseMutationOptions<CreateDigestMutation, CreateDigestMutationVariables>;
export const CreateDigestSeriesDocument = gql`
    mutation CreateDigestSeries($orgId: Int!, $teamIds: [Int!]!, $title: String!, $digestSeriesType: DigestSeriesType!, $sendFrequency: DigestSendFrequency!) {
  createDigestSeries(
    orgId: $orgId
    teamIds: $teamIds
    title: $title
    digestSeriesType: $digestSeriesType
    sendFrequency: $sendFrequency
  ) {
    ...DigestSeriesData
  }
}
    ${DigestSeriesDataFragmentDoc}`;
export type CreateDigestSeriesMutationFn = Apollo.MutationFunction<CreateDigestSeriesMutation, CreateDigestSeriesMutationVariables>;

/**
 * __useCreateDigestSeriesMutation__
 *
 * To run a mutation, you first call `useCreateDigestSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigestSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigestSeriesMutation, { data, loading, error }] = useCreateDigestSeriesMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      teamIds: // value for 'teamIds'
 *      title: // value for 'title'
 *      digestSeriesType: // value for 'digestSeriesType'
 *      sendFrequency: // value for 'sendFrequency'
 *   },
 * });
 */
export function useCreateDigestSeriesMutation(baseOptions?: Apollo.MutationHookOptions<CreateDigestSeriesMutation, CreateDigestSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDigestSeriesMutation, CreateDigestSeriesMutationVariables>(CreateDigestSeriesDocument, options);
      }
export type CreateDigestSeriesMutationHookResult = ReturnType<typeof useCreateDigestSeriesMutation>;
export type CreateDigestSeriesMutationResult = Apollo.MutationResult<CreateDigestSeriesMutation>;
export type CreateDigestSeriesMutationOptions = Apollo.BaseMutationOptions<CreateDigestSeriesMutation, CreateDigestSeriesMutationVariables>;
export const CreateDigestSeriesChannelDocument = gql`
    mutation CreateDigestSeriesChannel($channelType: channel_type!, $seriesId: Int!, $sendGrid: SendGridDigestSeriesChannel, $slack: SlackDigestSeriesChannel) {
  createDigestSeriesChannel(
    channelType: $channelType
    seriesId: $seriesId
    sendGrid: $sendGrid
    slack: $slack
  ) {
    id
    subChannelName
  }
}
    `;
export type CreateDigestSeriesChannelMutationFn = Apollo.MutationFunction<CreateDigestSeriesChannelMutation, CreateDigestSeriesChannelMutationVariables>;

/**
 * __useCreateDigestSeriesChannelMutation__
 *
 * To run a mutation, you first call `useCreateDigestSeriesChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigestSeriesChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigestSeriesChannelMutation, { data, loading, error }] = useCreateDigestSeriesChannelMutation({
 *   variables: {
 *      channelType: // value for 'channelType'
 *      seriesId: // value for 'seriesId'
 *      sendGrid: // value for 'sendGrid'
 *      slack: // value for 'slack'
 *   },
 * });
 */
export function useCreateDigestSeriesChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateDigestSeriesChannelMutation, CreateDigestSeriesChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDigestSeriesChannelMutation, CreateDigestSeriesChannelMutationVariables>(CreateDigestSeriesChannelDocument, options);
      }
export type CreateDigestSeriesChannelMutationHookResult = ReturnType<typeof useCreateDigestSeriesChannelMutation>;
export type CreateDigestSeriesChannelMutationResult = Apollo.MutationResult<CreateDigestSeriesChannelMutation>;
export type CreateDigestSeriesChannelMutationOptions = Apollo.BaseMutationOptions<CreateDigestSeriesChannelMutation, CreateDigestSeriesChannelMutationVariables>;
export const CreateFeedbackSegmentGroupDocument = gql`
    mutation CreateFeedbackSegmentGroup($displayName: String!, $teamId: Int!, $valueType: SegmentType!) {
  createSegmentGroup(
    displayName: $displayName
    teamId: $teamId
    valueType: $valueType
  ) {
    displayName
    id
  }
}
    `;
export type CreateFeedbackSegmentGroupMutationFn = Apollo.MutationFunction<CreateFeedbackSegmentGroupMutation, CreateFeedbackSegmentGroupMutationVariables>;

/**
 * __useCreateFeedbackSegmentGroupMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackSegmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackSegmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackSegmentGroupMutation, { data, loading, error }] = useCreateFeedbackSegmentGroupMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      teamId: // value for 'teamId'
 *      valueType: // value for 'valueType'
 *   },
 * });
 */
export function useCreateFeedbackSegmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackSegmentGroupMutation, CreateFeedbackSegmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackSegmentGroupMutation, CreateFeedbackSegmentGroupMutationVariables>(CreateFeedbackSegmentGroupDocument, options);
      }
export type CreateFeedbackSegmentGroupMutationHookResult = ReturnType<typeof useCreateFeedbackSegmentGroupMutation>;
export type CreateFeedbackSegmentGroupMutationResult = Apollo.MutationResult<CreateFeedbackSegmentGroupMutation>;
export type CreateFeedbackSegmentGroupMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackSegmentGroupMutation, CreateFeedbackSegmentGroupMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($queryString: String!, $teamId: Int!, $teamUuid: String, $email: String, $excludeFromNewFilter: Boolean) {
  createGroup(
    queryString: $queryString
    teamId: $teamId
    teamUuid: $teamUuid
    email: $email
    excludeFromNewFilter: $excludeFromNewFilter
  ) {
    id
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      queryString: // value for 'queryString'
 *      teamId: // value for 'teamId'
 *      teamUuid: // value for 'teamUuid'
 *      email: // value for 'email'
 *      excludeFromNewFilter: // value for 'excludeFromNewFilter'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateGroupIncludeDataDocument = gql`
    mutation CreateGroupIncludeData($queryString: String!, $teamId: Int!, $teamUuid: String, $email: String, $sentencesTake: Int, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean, $excludeFromNewFilter: Boolean) {
  createGroup(
    queryString: $queryString
    teamId: $teamId
    teamUuid: $teamUuid
    email: $email
    excludeFromNewFilter: $excludeFromNewFilter
  ) {
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;
export type CreateGroupIncludeDataMutationFn = Apollo.MutationFunction<CreateGroupIncludeDataMutation, CreateGroupIncludeDataMutationVariables>;

/**
 * __useCreateGroupIncludeDataMutation__
 *
 * To run a mutation, you first call `useCreateGroupIncludeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupIncludeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupIncludeDataMutation, { data, loading, error }] = useCreateGroupIncludeDataMutation({
 *   variables: {
 *      queryString: // value for 'queryString'
 *      teamId: // value for 'teamId'
 *      teamUuid: // value for 'teamUuid'
 *      email: // value for 'email'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *      excludeFromNewFilter: // value for 'excludeFromNewFilter'
 *   },
 * });
 */
export function useCreateGroupIncludeDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupIncludeDataMutation, CreateGroupIncludeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupIncludeDataMutation, CreateGroupIncludeDataMutationVariables>(CreateGroupIncludeDataDocument, options);
      }
export type CreateGroupIncludeDataMutationHookResult = ReturnType<typeof useCreateGroupIncludeDataMutation>;
export type CreateGroupIncludeDataMutationResult = Apollo.MutationResult<CreateGroupIncludeDataMutation>;
export type CreateGroupIncludeDataMutationOptions = Apollo.BaseMutationOptions<CreateGroupIncludeDataMutation, CreateGroupIncludeDataMutationVariables>;
export const CreateGroupInsightDocument = gql`
    mutation CreateGroupInsight($groupId: BigInt!, $teamId: Int!, $filterStartDate: Date!) {
  createGroupInsight(
    groupId: $groupId
    teamId: $teamId
    filterStartDate: $filterStartDate
  ) {
    ...GroupInsightsData
  }
}
    ${GroupInsightsDataFragmentDoc}`;
export type CreateGroupInsightMutationFn = Apollo.MutationFunction<CreateGroupInsightMutation, CreateGroupInsightMutationVariables>;

/**
 * __useCreateGroupInsightMutation__
 *
 * To run a mutation, you first call `useCreateGroupInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupInsightMutation, { data, loading, error }] = useCreateGroupInsightMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterStartDate: // value for 'filterStartDate'
 *   },
 * });
 */
export function useCreateGroupInsightMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupInsightMutation, CreateGroupInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupInsightMutation, CreateGroupInsightMutationVariables>(CreateGroupInsightDocument, options);
      }
export type CreateGroupInsightMutationHookResult = ReturnType<typeof useCreateGroupInsightMutation>;
export type CreateGroupInsightMutationResult = Apollo.MutationResult<CreateGroupInsightMutation>;
export type CreateGroupInsightMutationOptions = Apollo.BaseMutationOptions<CreateGroupInsightMutation, CreateGroupInsightMutationVariables>;
export const CreateInsightDocument = gql`
    mutation CreateInsight($chartBin: chart_bin_type!, $collectionId: BigInt!, $collectionType: insight_collection_type!, $digestId: Int!, $entryIds: [BigInt!]!, $expirationDate: Date!, $feedbackStatus: digest_group_status!, $filterInput: FilterInput!, $text: String!, $title: String!, $excludeFromDigest: Boolean) {
  createInsight(
    chartBin: $chartBin
    collectionId: $collectionId
    collectionType: $collectionType
    digestId: $digestId
    entryIds: $entryIds
    expirationDate: $expirationDate
    feedbackStatus: $feedbackStatus
    filterInput: $filterInput
    text: $text
    title: $title
    excludeFromDigest: $excludeFromDigest
  ) {
    ...InsightLight
  }
}
    ${InsightLightFragmentDoc}`;
export type CreateInsightMutationFn = Apollo.MutationFunction<CreateInsightMutation, CreateInsightMutationVariables>;

/**
 * __useCreateInsightMutation__
 *
 * To run a mutation, you first call `useCreateInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightMutation, { data, loading, error }] = useCreateInsightMutation({
 *   variables: {
 *      chartBin: // value for 'chartBin'
 *      collectionId: // value for 'collectionId'
 *      collectionType: // value for 'collectionType'
 *      digestId: // value for 'digestId'
 *      entryIds: // value for 'entryIds'
 *      expirationDate: // value for 'expirationDate'
 *      feedbackStatus: // value for 'feedbackStatus'
 *      filterInput: // value for 'filterInput'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      excludeFromDigest: // value for 'excludeFromDigest'
 *   },
 * });
 */
export function useCreateInsightMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsightMutation, CreateInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsightMutation, CreateInsightMutationVariables>(CreateInsightDocument, options);
      }
export type CreateInsightMutationHookResult = ReturnType<typeof useCreateInsightMutation>;
export type CreateInsightMutationResult = Apollo.MutationResult<CreateInsightMutation>;
export type CreateInsightMutationOptions = Apollo.BaseMutationOptions<CreateInsightMutation, CreateInsightMutationVariables>;
export const CreateOauthStateSecretDocument = gql`
    mutation CreateOauthStateSecret($orgId: Int!) {
  createOauthStateSecret(orgId: $orgId) {
    creation_date
    expiration_date
    id
    org_id
    secret_state
    used
    user_id
  }
}
    `;
export type CreateOauthStateSecretMutationFn = Apollo.MutationFunction<CreateOauthStateSecretMutation, CreateOauthStateSecretMutationVariables>;

/**
 * __useCreateOauthStateSecretMutation__
 *
 * To run a mutation, you first call `useCreateOauthStateSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOauthStateSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOauthStateSecretMutation, { data, loading, error }] = useCreateOauthStateSecretMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useCreateOauthStateSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateOauthStateSecretMutation, CreateOauthStateSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOauthStateSecretMutation, CreateOauthStateSecretMutationVariables>(CreateOauthStateSecretDocument, options);
      }
export type CreateOauthStateSecretMutationHookResult = ReturnType<typeof useCreateOauthStateSecretMutation>;
export type CreateOauthStateSecretMutationResult = Apollo.MutationResult<CreateOauthStateSecretMutation>;
export type CreateOauthStateSecretMutationOptions = Apollo.BaseMutationOptions<CreateOauthStateSecretMutation, CreateOauthStateSecretMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($name: String!) {
  createOrganization(name: $name) {
    ...OrganizationsLight
  }
}
    ${OrganizationsLightFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreatePreviewPageLeadDocument = gql`
    mutation CreatePreviewPageLead($email: String!, $name: String!) {
  addPreviewPageLead(email: $email, name: $name) {
    email
    id
    name
  }
}
    `;
export type CreatePreviewPageLeadMutationFn = Apollo.MutationFunction<CreatePreviewPageLeadMutation, CreatePreviewPageLeadMutationVariables>;

/**
 * __useCreatePreviewPageLeadMutation__
 *
 * To run a mutation, you first call `useCreatePreviewPageLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewPageLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewPageLeadMutation, { data, loading, error }] = useCreatePreviewPageLeadMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreatePreviewPageLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreviewPageLeadMutation, CreatePreviewPageLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreviewPageLeadMutation, CreatePreviewPageLeadMutationVariables>(CreatePreviewPageLeadDocument, options);
      }
export type CreatePreviewPageLeadMutationHookResult = ReturnType<typeof useCreatePreviewPageLeadMutation>;
export type CreatePreviewPageLeadMutationResult = Apollo.MutationResult<CreatePreviewPageLeadMutation>;
export type CreatePreviewPageLeadMutationOptions = Apollo.BaseMutationOptions<CreatePreviewPageLeadMutation, CreatePreviewPageLeadMutationVariables>;
export const CreateSecretDocument = gql`
    mutation CreateSecret($secretName: String!, $secretValue: String!) {
  createSecret(secretName: $secretName, secretValue: $secretValue)
}
    `;
export type CreateSecretMutationFn = Apollo.MutationFunction<CreateSecretMutation, CreateSecretMutationVariables>;

/**
 * __useCreateSecretMutation__
 *
 * To run a mutation, you first call `useCreateSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSecretMutation, { data, loading, error }] = useCreateSecretMutation({
 *   variables: {
 *      secretName: // value for 'secretName'
 *      secretValue: // value for 'secretValue'
 *   },
 * });
 */
export function useCreateSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateSecretMutation, CreateSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSecretMutation, CreateSecretMutationVariables>(CreateSecretDocument, options);
      }
export type CreateSecretMutationHookResult = ReturnType<typeof useCreateSecretMutation>;
export type CreateSecretMutationResult = Apollo.MutationResult<CreateSecretMutation>;
export type CreateSecretMutationOptions = Apollo.BaseMutationOptions<CreateSecretMutation, CreateSecretMutationVariables>;
export const CreateSlackConnectionDocument = gql`
    mutation CreateSlackConnection($code: String!, $orgId: Int!, $secretStateFromSlack: String!) {
  createSlackConnection(
    code: $code
    orgId: $orgId
    secretStateFromSlack: $secretStateFromSlack
  ) {
    connected_name
    id
  }
}
    `;
export type CreateSlackConnectionMutationFn = Apollo.MutationFunction<CreateSlackConnectionMutation, CreateSlackConnectionMutationVariables>;

/**
 * __useCreateSlackConnectionMutation__
 *
 * To run a mutation, you first call `useCreateSlackConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackConnectionMutation, { data, loading, error }] = useCreateSlackConnectionMutation({
 *   variables: {
 *      code: // value for 'code'
 *      orgId: // value for 'orgId'
 *      secretStateFromSlack: // value for 'secretStateFromSlack'
 *   },
 * });
 */
export function useCreateSlackConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSlackConnectionMutation, CreateSlackConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSlackConnectionMutation, CreateSlackConnectionMutationVariables>(CreateSlackConnectionDocument, options);
      }
export type CreateSlackConnectionMutationHookResult = ReturnType<typeof useCreateSlackConnectionMutation>;
export type CreateSlackConnectionMutationResult = Apollo.MutationResult<CreateSlackConnectionMutation>;
export type CreateSlackConnectionMutationOptions = Apollo.BaseMutationOptions<CreateSlackConnectionMutation, CreateSlackConnectionMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($groupId: BigInt, $chartId: Int, $name: String!, $teamId: Int!) {
  createTag(groupId: $groupId, name: $name, teamId: $teamId, chartId: $chartId) {
    id
    name
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      chartId: // value for 'chartId'
 *      name: // value for 'name'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($name: String!, $orgId: Int!, $usersRoles: [UserRolesInput!], $logoUrl: String) {
  createTeam(
    name: $name
    orgId: $orgId
    usersRoles: $usersRoles
    logoUrl: $logoUrl
  ) {
    ...TeamData
  }
}
    ${TeamDataFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      name: // value for 'name'
 *      orgId: // value for 'orgId'
 *      usersRoles: // value for 'usersRoles'
 *      logoUrl: // value for 'logoUrl'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteAlertDocument = gql`
    mutation DeleteAlert($alertId: Int!, $teamId: Int!) {
  deleteAlert(alertId: $alertId, teamId: $teamId) {
    id
  }
}
    `;
export type DeleteAlertMutationFn = Apollo.MutationFunction<DeleteAlertMutation, DeleteAlertMutationVariables>;

/**
 * __useDeleteAlertMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutation, { data, loading, error }] = useDeleteAlertMutation({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteAlertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertMutation, DeleteAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertMutation, DeleteAlertMutationVariables>(DeleteAlertDocument, options);
      }
export type DeleteAlertMutationHookResult = ReturnType<typeof useDeleteAlertMutation>;
export type DeleteAlertMutationResult = Apollo.MutationResult<DeleteAlertMutation>;
export type DeleteAlertMutationOptions = Apollo.BaseMutationOptions<DeleteAlertMutation, DeleteAlertMutationVariables>;
export const DeleteBoardDocument = gql`
    mutation DeleteBoard($boardId: Int!, $teamId: Int!) {
  deleteBoard(boardId: $boardId, teamId: $teamId)
}
    `;
export type DeleteBoardMutationFn = Apollo.MutationFunction<DeleteBoardMutation, DeleteBoardMutationVariables>;

/**
 * __useDeleteBoardMutation__
 *
 * To run a mutation, you first call `useDeleteBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoardMutation, { data, loading, error }] = useDeleteBoardMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteBoardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBoardMutation, DeleteBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBoardMutation, DeleteBoardMutationVariables>(DeleteBoardDocument, options);
      }
export type DeleteBoardMutationHookResult = ReturnType<typeof useDeleteBoardMutation>;
export type DeleteBoardMutationResult = Apollo.MutationResult<DeleteBoardMutation>;
export type DeleteBoardMutationOptions = Apollo.BaseMutationOptions<DeleteBoardMutation, DeleteBoardMutationVariables>;
export const DeleteChangelogDataDocument = gql`
    mutation DeleteChangelogData($changelogId: Int!, $teamId: Int!) {
  deleteChangelog(changelogId: $changelogId, teamId: $teamId) {
    id
  }
}
    `;
export type DeleteChangelogDataMutationFn = Apollo.MutationFunction<DeleteChangelogDataMutation, DeleteChangelogDataMutationVariables>;

/**
 * __useDeleteChangelogDataMutation__
 *
 * To run a mutation, you first call `useDeleteChangelogDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChangelogDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChangelogDataMutation, { data, loading, error }] = useDeleteChangelogDataMutation({
 *   variables: {
 *      changelogId: // value for 'changelogId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteChangelogDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChangelogDataMutation, DeleteChangelogDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChangelogDataMutation, DeleteChangelogDataMutationVariables>(DeleteChangelogDataDocument, options);
      }
export type DeleteChangelogDataMutationHookResult = ReturnType<typeof useDeleteChangelogDataMutation>;
export type DeleteChangelogDataMutationResult = Apollo.MutationResult<DeleteChangelogDataMutation>;
export type DeleteChangelogDataMutationOptions = Apollo.BaseMutationOptions<DeleteChangelogDataMutation, DeleteChangelogDataMutationVariables>;
export const DeleteChildDocument = gql`
    mutation DeleteChild($childGroupId: BigInt!, $parentGroupId: BigInt!, $teamId: Int!) {
  removeChild(
    childGroupId: $childGroupId
    parentGroupId: $parentGroupId
    teamId: $teamId
  ) {
    id
  }
}
    `;
export type DeleteChildMutationFn = Apollo.MutationFunction<DeleteChildMutation, DeleteChildMutationVariables>;

/**
 * __useDeleteChildMutation__
 *
 * To run a mutation, you first call `useDeleteChildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChildMutation, { data, loading, error }] = useDeleteChildMutation({
 *   variables: {
 *      childGroupId: // value for 'childGroupId'
 *      parentGroupId: // value for 'parentGroupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteChildMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChildMutation, DeleteChildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChildMutation, DeleteChildMutationVariables>(DeleteChildDocument, options);
      }
export type DeleteChildMutationHookResult = ReturnType<typeof useDeleteChildMutation>;
export type DeleteChildMutationResult = Apollo.MutationResult<DeleteChildMutation>;
export type DeleteChildMutationOptions = Apollo.BaseMutationOptions<DeleteChildMutation, DeleteChildMutationVariables>;
export const DeleteChartDocument = gql`
    mutation DeleteChart($chartId: Int!, $teamId: Int!) {
  deleteChart(chartId: $chartId, teamId: $teamId) {
    ...Chart
  }
}
    ${ChartFragmentDoc}`;
export type DeleteChartMutationFn = Apollo.MutationFunction<DeleteChartMutation, DeleteChartMutationVariables>;

/**
 * __useDeleteChartMutation__
 *
 * To run a mutation, you first call `useDeleteChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChartMutation, { data, loading, error }] = useDeleteChartMutation({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteChartMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChartMutation, DeleteChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChartMutation, DeleteChartMutationVariables>(DeleteChartDocument, options);
      }
export type DeleteChartMutationHookResult = ReturnType<typeof useDeleteChartMutation>;
export type DeleteChartMutationResult = Apollo.MutationResult<DeleteChartMutation>;
export type DeleteChartMutationOptions = Apollo.BaseMutationOptions<DeleteChartMutation, DeleteChartMutationVariables>;
export const DeleteDigestDocument = gql`
    mutation DeleteDigest($digestId: Int!) {
  deleteDigest(digestId: $digestId) {
    id
  }
}
    `;
export type DeleteDigestMutationFn = Apollo.MutationFunction<DeleteDigestMutation, DeleteDigestMutationVariables>;

/**
 * __useDeleteDigestMutation__
 *
 * To run a mutation, you first call `useDeleteDigestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDigestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDigestMutation, { data, loading, error }] = useDeleteDigestMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *   },
 * });
 */
export function useDeleteDigestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDigestMutation, DeleteDigestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDigestMutation, DeleteDigestMutationVariables>(DeleteDigestDocument, options);
      }
export type DeleteDigestMutationHookResult = ReturnType<typeof useDeleteDigestMutation>;
export type DeleteDigestMutationResult = Apollo.MutationResult<DeleteDigestMutation>;
export type DeleteDigestMutationOptions = Apollo.BaseMutationOptions<DeleteDigestMutation, DeleteDigestMutationVariables>;
export const DeleteDigestSeriesChannelDocument = gql`
    mutation DeleteDigestSeriesChannel($channelId: Int!, $seriesId: Int!) {
  deleteDigestSeriesChannel(channelId: $channelId, seriesId: $seriesId) {
    id
  }
}
    `;
export type DeleteDigestSeriesChannelMutationFn = Apollo.MutationFunction<DeleteDigestSeriesChannelMutation, DeleteDigestSeriesChannelMutationVariables>;

/**
 * __useDeleteDigestSeriesChannelMutation__
 *
 * To run a mutation, you first call `useDeleteDigestSeriesChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDigestSeriesChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDigestSeriesChannelMutation, { data, loading, error }] = useDeleteDigestSeriesChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useDeleteDigestSeriesChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDigestSeriesChannelMutation, DeleteDigestSeriesChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDigestSeriesChannelMutation, DeleteDigestSeriesChannelMutationVariables>(DeleteDigestSeriesChannelDocument, options);
      }
export type DeleteDigestSeriesChannelMutationHookResult = ReturnType<typeof useDeleteDigestSeriesChannelMutation>;
export type DeleteDigestSeriesChannelMutationResult = Apollo.MutationResult<DeleteDigestSeriesChannelMutation>;
export type DeleteDigestSeriesChannelMutationOptions = Apollo.BaseMutationOptions<DeleteDigestSeriesChannelMutation, DeleteDigestSeriesChannelMutationVariables>;
export const DeleteDigestSeriesTeamDocument = gql`
    mutation DeleteDigestSeriesTeam($seriesId: Int!, $teamId: Int!) {
  deleteDigestSeriesTeam(seriesId: $seriesId, teamId: $teamId) {
    id
  }
}
    `;
export type DeleteDigestSeriesTeamMutationFn = Apollo.MutationFunction<DeleteDigestSeriesTeamMutation, DeleteDigestSeriesTeamMutationVariables>;

/**
 * __useDeleteDigestSeriesTeamMutation__
 *
 * To run a mutation, you first call `useDeleteDigestSeriesTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDigestSeriesTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDigestSeriesTeamMutation, { data, loading, error }] = useDeleteDigestSeriesTeamMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteDigestSeriesTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDigestSeriesTeamMutation, DeleteDigestSeriesTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDigestSeriesTeamMutation, DeleteDigestSeriesTeamMutationVariables>(DeleteDigestSeriesTeamDocument, options);
      }
export type DeleteDigestSeriesTeamMutationHookResult = ReturnType<typeof useDeleteDigestSeriesTeamMutation>;
export type DeleteDigestSeriesTeamMutationResult = Apollo.MutationResult<DeleteDigestSeriesTeamMutation>;
export type DeleteDigestSeriesTeamMutationOptions = Apollo.BaseMutationOptions<DeleteDigestSeriesTeamMutation, DeleteDigestSeriesTeamMutationVariables>;
export const DeleteGroupInsightDocument = gql`
    mutation DeleteGroupInsight($groupId: BigInt!, $teamId: Int!) {
  deleteGroupInsight(groupId: $groupId, teamId: $teamId) {
    ...GroupInsightsData
  }
}
    ${GroupInsightsDataFragmentDoc}`;
export type DeleteGroupInsightMutationFn = Apollo.MutationFunction<DeleteGroupInsightMutation, DeleteGroupInsightMutationVariables>;

/**
 * __useDeleteGroupInsightMutation__
 *
 * To run a mutation, you first call `useDeleteGroupInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupInsightMutation, { data, loading, error }] = useDeleteGroupInsightMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteGroupInsightMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupInsightMutation, DeleteGroupInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupInsightMutation, DeleteGroupInsightMutationVariables>(DeleteGroupInsightDocument, options);
      }
export type DeleteGroupInsightMutationHookResult = ReturnType<typeof useDeleteGroupInsightMutation>;
export type DeleteGroupInsightMutationResult = Apollo.MutationResult<DeleteGroupInsightMutation>;
export type DeleteGroupInsightMutationOptions = Apollo.BaseMutationOptions<DeleteGroupInsightMutation, DeleteGroupInsightMutationVariables>;
export const DeleteOrgConnectionDocument = gql`
    mutation DeleteOrgConnection($connectionId: Int!, $orgId: Int!) {
  deleteOrgConnection(connectionId: $connectionId, orgId: $orgId) {
    connected_name
    id
  }
}
    `;
export type DeleteOrgConnectionMutationFn = Apollo.MutationFunction<DeleteOrgConnectionMutation, DeleteOrgConnectionMutationVariables>;

/**
 * __useDeleteOrgConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteOrgConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgConnectionMutation, { data, loading, error }] = useDeleteOrgConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDeleteOrgConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrgConnectionMutation, DeleteOrgConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrgConnectionMutation, DeleteOrgConnectionMutationVariables>(DeleteOrgConnectionDocument, options);
      }
export type DeleteOrgConnectionMutationHookResult = ReturnType<typeof useDeleteOrgConnectionMutation>;
export type DeleteOrgConnectionMutationResult = Apollo.MutationResult<DeleteOrgConnectionMutation>;
export type DeleteOrgConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteOrgConnectionMutation, DeleteOrgConnectionMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($orgId: Int!) {
  deleteOrganization(orgId: $orgId) {
    id
    name
  }
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($teamId: Int!, $orgId: Int!) {
  deleteTeam(teamId: $teamId, orgId: $orgId) {
    ...TeamData
  }
}
    ${TeamDataFragmentDoc}`;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const DeleteWidgetDocument = gql`
    mutation DeleteWidget($boardId: Int!, $teamId: Int!, $widgetId: Int!) {
  deleteWidget(boardId: $boardId, teamId: $teamId, widgetId: $widgetId)
}
    `;
export type DeleteWidgetMutationFn = Apollo.MutationFunction<DeleteWidgetMutation, DeleteWidgetMutationVariables>;

/**
 * __useDeleteWidgetMutation__
 *
 * To run a mutation, you first call `useDeleteWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWidgetMutation, { data, loading, error }] = useDeleteWidgetMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useDeleteWidgetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWidgetMutation, DeleteWidgetMutationVariables>(DeleteWidgetDocument, options);
      }
export type DeleteWidgetMutationHookResult = ReturnType<typeof useDeleteWidgetMutation>;
export type DeleteWidgetMutationResult = Apollo.MutationResult<DeleteWidgetMutation>;
export type DeleteWidgetMutationOptions = Apollo.BaseMutationOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>;
export const DuplicateWidgetsDocument = gql`
    mutation DuplicateWidgets($boardId: Int!, $teamId: Int!, $inputWidgets: [NewWidgetInput!]!) {
  duplicateWidgets(
    boardId: $boardId
    teamId: $teamId
    inputWidgets: $inputWidgets
  ) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type DuplicateWidgetsMutationFn = Apollo.MutationFunction<DuplicateWidgetsMutation, DuplicateWidgetsMutationVariables>;

/**
 * __useDuplicateWidgetsMutation__
 *
 * To run a mutation, you first call `useDuplicateWidgetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateWidgetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateWidgetsMutation, { data, loading, error }] = useDuplicateWidgetsMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *      inputWidgets: // value for 'inputWidgets'
 *   },
 * });
 */
export function useDuplicateWidgetsMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateWidgetsMutation, DuplicateWidgetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateWidgetsMutation, DuplicateWidgetsMutationVariables>(DuplicateWidgetsDocument, options);
      }
export type DuplicateWidgetsMutationHookResult = ReturnType<typeof useDuplicateWidgetsMutation>;
export type DuplicateWidgetsMutationResult = Apollo.MutationResult<DuplicateWidgetsMutation>;
export type DuplicateWidgetsMutationOptions = Apollo.BaseMutationOptions<DuplicateWidgetsMutation, DuplicateWidgetsMutationVariables>;
export const EditAlertDocument = gql`
    mutation EditAlert($alertId: Int!, $filterInput: FilterInput, $teamId: Int!, $emails: [String!], $cadence: CadenceType, $alertName: String, $active: Boolean, $period: Int, $slackChannelId: String, $slackChannelName: String, $threshold: Int) {
  editAlert(
    alertId: $alertId
    filterInput: $filterInput
    teamId: $teamId
    emails: $emails
    cadence: $cadence
    alertName: $alertName
    active: $active
    period: $period
    slackChannelID: $slackChannelId
    slackChannelName: $slackChannelName
    threshold: $threshold
  ) {
    ...AlertData
  }
}
    ${AlertDataFragmentDoc}`;
export type EditAlertMutationFn = Apollo.MutationFunction<EditAlertMutation, EditAlertMutationVariables>;

/**
 * __useEditAlertMutation__
 *
 * To run a mutation, you first call `useEditAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAlertMutation, { data, loading, error }] = useEditAlertMutation({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      filterInput: // value for 'filterInput'
 *      teamId: // value for 'teamId'
 *      emails: // value for 'emails'
 *      cadence: // value for 'cadence'
 *      alertName: // value for 'alertName'
 *      active: // value for 'active'
 *      period: // value for 'period'
 *      slackChannelId: // value for 'slackChannelId'
 *      slackChannelName: // value for 'slackChannelName'
 *      threshold: // value for 'threshold'
 *   },
 * });
 */
export function useEditAlertMutation(baseOptions?: Apollo.MutationHookOptions<EditAlertMutation, EditAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAlertMutation, EditAlertMutationVariables>(EditAlertDocument, options);
      }
export type EditAlertMutationHookResult = ReturnType<typeof useEditAlertMutation>;
export type EditAlertMutationResult = Apollo.MutationResult<EditAlertMutation>;
export type EditAlertMutationOptions = Apollo.BaseMutationOptions<EditAlertMutation, EditAlertMutationVariables>;
export const EditChangelogDataDocument = gql`
    mutation EditChangelogData($changelogId: Int!, $teamId: Int!, $title: String, $date: Float!, $description: String) {
  editChangelog(
    changelogId: $changelogId
    teamId: $teamId
    title: $title
    description: $description
    date: $date
  ) {
    ...Changelog
  }
}
    ${ChangelogFragmentDoc}`;
export type EditChangelogDataMutationFn = Apollo.MutationFunction<EditChangelogDataMutation, EditChangelogDataMutationVariables>;

/**
 * __useEditChangelogDataMutation__
 *
 * To run a mutation, you first call `useEditChangelogDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditChangelogDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editChangelogDataMutation, { data, loading, error }] = useEditChangelogDataMutation({
 *   variables: {
 *      changelogId: // value for 'changelogId'
 *      teamId: // value for 'teamId'
 *      title: // value for 'title'
 *      date: // value for 'date'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditChangelogDataMutation(baseOptions?: Apollo.MutationHookOptions<EditChangelogDataMutation, EditChangelogDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditChangelogDataMutation, EditChangelogDataMutationVariables>(EditChangelogDataDocument, options);
      }
export type EditChangelogDataMutationHookResult = ReturnType<typeof useEditChangelogDataMutation>;
export type EditChangelogDataMutationResult = Apollo.MutationResult<EditChangelogDataMutation>;
export type EditChangelogDataMutationOptions = Apollo.BaseMutationOptions<EditChangelogDataMutation, EditChangelogDataMutationVariables>;
export const EditChartDocument = gql`
    mutation EditChart($chartId: Int!, $editChartInput: EditChartInput!, $filterInput: FilterInput!, $teamId: Int!, $chartBinType: chart_bin_type) {
  editChart(
    chartId: $chartId
    editChartInput: $editChartInput
    filterInput: $filterInput
    teamId: $teamId
    chartBinType: $chartBinType
  ) {
    ...Chart
  }
}
    ${ChartFragmentDoc}`;
export type EditChartMutationFn = Apollo.MutationFunction<EditChartMutation, EditChartMutationVariables>;

/**
 * __useEditChartMutation__
 *
 * To run a mutation, you first call `useEditChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editChartMutation, { data, loading, error }] = useEditChartMutation({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      editChartInput: // value for 'editChartInput'
 *      filterInput: // value for 'filterInput'
 *      teamId: // value for 'teamId'
 *      chartBinType: // value for 'chartBinType'
 *   },
 * });
 */
export function useEditChartMutation(baseOptions?: Apollo.MutationHookOptions<EditChartMutation, EditChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditChartMutation, EditChartMutationVariables>(EditChartDocument, options);
      }
export type EditChartMutationHookResult = ReturnType<typeof useEditChartMutation>;
export type EditChartMutationResult = Apollo.MutationResult<EditChartMutation>;
export type EditChartMutationOptions = Apollo.BaseMutationOptions<EditChartMutation, EditChartMutationVariables>;
export const EditFeedbackEntrySentimentDocument = gql`
    mutation EditFeedbackEntrySentiment($entryId: BigInt!, $sentiment: Float!, $teamId: Int!) {
  editFeedbackEntrySentiment(
    entryId: $entryId
    sentiment: $sentiment
    teamId: $teamId
  ) {
    ...Entry
  }
}
    ${EntryFragmentDoc}`;
export type EditFeedbackEntrySentimentMutationFn = Apollo.MutationFunction<EditFeedbackEntrySentimentMutation, EditFeedbackEntrySentimentMutationVariables>;

/**
 * __useEditFeedbackEntrySentimentMutation__
 *
 * To run a mutation, you first call `useEditFeedbackEntrySentimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFeedbackEntrySentimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFeedbackEntrySentimentMutation, { data, loading, error }] = useEditFeedbackEntrySentimentMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *      sentiment: // value for 'sentiment'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useEditFeedbackEntrySentimentMutation(baseOptions?: Apollo.MutationHookOptions<EditFeedbackEntrySentimentMutation, EditFeedbackEntrySentimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFeedbackEntrySentimentMutation, EditFeedbackEntrySentimentMutationVariables>(EditFeedbackEntrySentimentDocument, options);
      }
export type EditFeedbackEntrySentimentMutationHookResult = ReturnType<typeof useEditFeedbackEntrySentimentMutation>;
export type EditFeedbackEntrySentimentMutationResult = Apollo.MutationResult<EditFeedbackEntrySentimentMutation>;
export type EditFeedbackEntrySentimentMutationOptions = Apollo.BaseMutationOptions<EditFeedbackEntrySentimentMutation, EditFeedbackEntrySentimentMutationVariables>;
export const EditGroupDocument = gql`
    mutation EditGroup($groupId: BigInt!, $input: EditGroupInput!, $teamId: Int!, $sentencesTake: Int, $sentencesSkip: Int, $filterInput: FilterInput!, $includeDescendantsOnMappings: Boolean) {
  editGroup(
    groupId: $groupId
    input: $input
    teamId: $teamId
    filterInput: $filterInput
  ) {
    dependencies {
      charts {
        id
        title
        teamId
        orgId
      }
      dependencies {
        message
        type
        title
      }
      pinners {
        pinner {
          fullName
          email
        }
      }
    }
    group {
      ...GroupData
    }
    message
    success
  }
}
    ${GroupDataFragmentDoc}`;
export type EditGroupMutationFn = Apollo.MutationFunction<EditGroupMutation, EditGroupMutationVariables>;

/**
 * __useEditGroupMutation__
 *
 * To run a mutation, you first call `useEditGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGroupMutation, { data, loading, error }] = useEditGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      input: // value for 'input'
 *      teamId: // value for 'teamId'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      filterInput: // value for 'filterInput'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useEditGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditGroupMutation, EditGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGroupMutation, EditGroupMutationVariables>(EditGroupDocument, options);
      }
export type EditGroupMutationHookResult = ReturnType<typeof useEditGroupMutation>;
export type EditGroupMutationResult = Apollo.MutationResult<EditGroupMutation>;
export type EditGroupMutationOptions = Apollo.BaseMutationOptions<EditGroupMutation, EditGroupMutationVariables>;
export const EditGroupInsightDocument = gql`
    mutation EditGroupInsight($groupId: BigInt!, $teamId: Int!, $description: String, $includeInDigest: Boolean, $expirationDate: Date, $groupStatus: digest_group_status, $startDate: Date, $includeInReport: Boolean, $reportMonthDate: Date, $title: String) {
  editGroupInsight(
    groupId: $groupId
    teamId: $teamId
    description: $description
    includeInDigest: $includeInDigest
    expirationDate: $expirationDate
    groupStatus: $groupStatus
    startDate: $startDate
    includeInReport: $includeInReport
    reportMonthDate: $reportMonthDate
    title: $title
  ) {
    ...GroupInsightsData
  }
}
    ${GroupInsightsDataFragmentDoc}`;
export type EditGroupInsightMutationFn = Apollo.MutationFunction<EditGroupInsightMutation, EditGroupInsightMutationVariables>;

/**
 * __useEditGroupInsightMutation__
 *
 * To run a mutation, you first call `useEditGroupInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGroupInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGroupInsightMutation, { data, loading, error }] = useEditGroupInsightMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      description: // value for 'description'
 *      includeInDigest: // value for 'includeInDigest'
 *      expirationDate: // value for 'expirationDate'
 *      groupStatus: // value for 'groupStatus'
 *      startDate: // value for 'startDate'
 *      includeInReport: // value for 'includeInReport'
 *      reportMonthDate: // value for 'reportMonthDate'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useEditGroupInsightMutation(baseOptions?: Apollo.MutationHookOptions<EditGroupInsightMutation, EditGroupInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGroupInsightMutation, EditGroupInsightMutationVariables>(EditGroupInsightDocument, options);
      }
export type EditGroupInsightMutationHookResult = ReturnType<typeof useEditGroupInsightMutation>;
export type EditGroupInsightMutationResult = Apollo.MutationResult<EditGroupInsightMutation>;
export type EditGroupInsightMutationOptions = Apollo.BaseMutationOptions<EditGroupInsightMutation, EditGroupInsightMutationVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($orgId: Int!, $name: String) {
  editOrganization(orgId: $orgId, name: $name) {
    ...OrganizationsLight
  }
}
    ${OrganizationsLightFragmentDoc}`;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const EditTeamDocument = gql`
    mutation EditTeam($orgId: Int!, $teamId: Int!, $userRoles: [UserRolesInput!], $name: String!) {
  editTeam(orgId: $orgId, teamId: $teamId, userRoles: $userRoles, name: $name) {
    ...TeamData
  }
}
    ${TeamDataFragmentDoc}`;
export type EditTeamMutationFn = Apollo.MutationFunction<EditTeamMutation, EditTeamMutationVariables>;

/**
 * __useEditTeamMutation__
 *
 * To run a mutation, you first call `useEditTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTeamMutation, { data, loading, error }] = useEditTeamMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      teamId: // value for 'teamId'
 *      userRoles: // value for 'userRoles'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditTeamMutation(baseOptions?: Apollo.MutationHookOptions<EditTeamMutation, EditTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTeamMutation, EditTeamMutationVariables>(EditTeamDocument, options);
      }
export type EditTeamMutationHookResult = ReturnType<typeof useEditTeamMutation>;
export type EditTeamMutationResult = Apollo.MutationResult<EditTeamMutation>;
export type EditTeamMutationOptions = Apollo.BaseMutationOptions<EditTeamMutation, EditTeamMutationVariables>;
export const ExternalTicketsIntegrationDocument = gql`
    mutation ExternalTicketsIntegration($input: MutateExternalTicketsIntegration!, $orgId: Int!) {
  externalTicketsIntegration(input: $input, orgId: $orgId) {
    id
  }
}
    `;
export type ExternalTicketsIntegrationMutationFn = Apollo.MutationFunction<ExternalTicketsIntegrationMutation, ExternalTicketsIntegrationMutationVariables>;

/**
 * __useExternalTicketsIntegrationMutation__
 *
 * To run a mutation, you first call `useExternalTicketsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalTicketsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalTicketsIntegrationMutation, { data, loading, error }] = useExternalTicketsIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useExternalTicketsIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ExternalTicketsIntegrationMutation, ExternalTicketsIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExternalTicketsIntegrationMutation, ExternalTicketsIntegrationMutationVariables>(ExternalTicketsIntegrationDocument, options);
      }
export type ExternalTicketsIntegrationMutationHookResult = ReturnType<typeof useExternalTicketsIntegrationMutation>;
export type ExternalTicketsIntegrationMutationResult = Apollo.MutationResult<ExternalTicketsIntegrationMutation>;
export type ExternalTicketsIntegrationMutationOptions = Apollo.BaseMutationOptions<ExternalTicketsIntegrationMutation, ExternalTicketsIntegrationMutationVariables>;
export const FeedbackEntriesUploadDocument = gql`
    mutation FeedbackEntriesUpload($input: [FeedbackEntryInput!]!, $teamId: Int!, $feedbackIntegrationId: Int!) {
  entriesUpload(
    input: $input
    teamId: $teamId
    feedbackIntegrationId: $feedbackIntegrationId
  ) {
    id
  }
}
    `;
export type FeedbackEntriesUploadMutationFn = Apollo.MutationFunction<FeedbackEntriesUploadMutation, FeedbackEntriesUploadMutationVariables>;

/**
 * __useFeedbackEntriesUploadMutation__
 *
 * To run a mutation, you first call `useFeedbackEntriesUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedbackEntriesUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedbackEntriesUploadMutation, { data, loading, error }] = useFeedbackEntriesUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      teamId: // value for 'teamId'
 *      feedbackIntegrationId: // value for 'feedbackIntegrationId'
 *   },
 * });
 */
export function useFeedbackEntriesUploadMutation(baseOptions?: Apollo.MutationHookOptions<FeedbackEntriesUploadMutation, FeedbackEntriesUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedbackEntriesUploadMutation, FeedbackEntriesUploadMutationVariables>(FeedbackEntriesUploadDocument, options);
      }
export type FeedbackEntriesUploadMutationHookResult = ReturnType<typeof useFeedbackEntriesUploadMutation>;
export type FeedbackEntriesUploadMutationResult = Apollo.MutationResult<FeedbackEntriesUploadMutation>;
export type FeedbackEntriesUploadMutationOptions = Apollo.BaseMutationOptions<FeedbackEntriesUploadMutation, FeedbackEntriesUploadMutationVariables>;
export const FeedbackIntegrationDocument = gql`
    mutation FeedbackIntegration($input: MutateFeedbackIntegration!) {
  feedbackIntegration(input: $input) {
    id
    requirementValue {
      id
      value
    }
    segmentConfig {
      id
      path
    }
  }
}
    `;
export type FeedbackIntegrationMutationFn = Apollo.MutationFunction<FeedbackIntegrationMutation, FeedbackIntegrationMutationVariables>;

/**
 * __useFeedbackIntegrationMutation__
 *
 * To run a mutation, you first call `useFeedbackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedbackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedbackIntegrationMutation, { data, loading, error }] = useFeedbackIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeedbackIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<FeedbackIntegrationMutation, FeedbackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedbackIntegrationMutation, FeedbackIntegrationMutationVariables>(FeedbackIntegrationDocument, options);
      }
export type FeedbackIntegrationMutationHookResult = ReturnType<typeof useFeedbackIntegrationMutation>;
export type FeedbackIntegrationMutationResult = Apollo.MutationResult<FeedbackIntegrationMutation>;
export type FeedbackIntegrationMutationOptions = Apollo.BaseMutationOptions<FeedbackIntegrationMutation, FeedbackIntegrationMutationVariables>;
export const GenerateDraftDigestEmailDocument = gql`
    mutation GenerateDraftDigestEmail($digestId: Int!) {
  generateDraftDigestEmail(digestId: $digestId) {
    success
    message
  }
}
    `;
export type GenerateDraftDigestEmailMutationFn = Apollo.MutationFunction<GenerateDraftDigestEmailMutation, GenerateDraftDigestEmailMutationVariables>;

/**
 * __useGenerateDraftDigestEmailMutation__
 *
 * To run a mutation, you first call `useGenerateDraftDigestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDraftDigestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDraftDigestEmailMutation, { data, loading, error }] = useGenerateDraftDigestEmailMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *   },
 * });
 */
export function useGenerateDraftDigestEmailMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDraftDigestEmailMutation, GenerateDraftDigestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDraftDigestEmailMutation, GenerateDraftDigestEmailMutationVariables>(GenerateDraftDigestEmailDocument, options);
      }
export type GenerateDraftDigestEmailMutationHookResult = ReturnType<typeof useGenerateDraftDigestEmailMutation>;
export type GenerateDraftDigestEmailMutationResult = Apollo.MutationResult<GenerateDraftDigestEmailMutation>;
export type GenerateDraftDigestEmailMutationOptions = Apollo.BaseMutationOptions<GenerateDraftDigestEmailMutation, GenerateDraftDigestEmailMutationVariables>;
export const GenerateTaxonomySchemaDocument = gql`
    mutation GenerateTaxonomySchema($instructions: String!, $teamId: Int!, $previousSchema: String) {
  generateTaxonomySchema(
    instructions: $instructions
    teamId: $teamId
    previousSchema: $previousSchema
  )
}
    `;
export type GenerateTaxonomySchemaMutationFn = Apollo.MutationFunction<GenerateTaxonomySchemaMutation, GenerateTaxonomySchemaMutationVariables>;

/**
 * __useGenerateTaxonomySchemaMutation__
 *
 * To run a mutation, you first call `useGenerateTaxonomySchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaxonomySchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaxonomySchemaMutation, { data, loading, error }] = useGenerateTaxonomySchemaMutation({
 *   variables: {
 *      instructions: // value for 'instructions'
 *      teamId: // value for 'teamId'
 *      previousSchema: // value for 'previousSchema'
 *   },
 * });
 */
export function useGenerateTaxonomySchemaMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTaxonomySchemaMutation, GenerateTaxonomySchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTaxonomySchemaMutation, GenerateTaxonomySchemaMutationVariables>(GenerateTaxonomySchemaDocument, options);
      }
export type GenerateTaxonomySchemaMutationHookResult = ReturnType<typeof useGenerateTaxonomySchemaMutation>;
export type GenerateTaxonomySchemaMutationResult = Apollo.MutationResult<GenerateTaxonomySchemaMutation>;
export type GenerateTaxonomySchemaMutationOptions = Apollo.BaseMutationOptions<GenerateTaxonomySchemaMutation, GenerateTaxonomySchemaMutationVariables>;
export const GetGroupInsightsDocument = gql`
    query GetGroupInsights($teamId: Int!, $groupId: BigInt) {
  getGroupInsights(teamId: $teamId, groupId: $groupId) {
    ...GroupInsightsData
  }
}
    ${GroupInsightsDataFragmentDoc}`;

/**
 * __useGetGroupInsightsQuery__
 *
 * To run a query within a React component, call `useGetGroupInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupInsightsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupInsightsQuery, GetGroupInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupInsightsQuery, GetGroupInsightsQueryVariables>(GetGroupInsightsDocument, options);
      }
export function useGetGroupInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupInsightsQuery, GetGroupInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupInsightsQuery, GetGroupInsightsQueryVariables>(GetGroupInsightsDocument, options);
        }
export type GetGroupInsightsQueryHookResult = ReturnType<typeof useGetGroupInsightsQuery>;
export type GetGroupInsightsLazyQueryHookResult = ReturnType<typeof useGetGroupInsightsLazyQuery>;
export type GetGroupInsightsQueryResult = Apollo.QueryResult<GetGroupInsightsQuery, GetGroupInsightsQueryVariables>;
export const GrantAccessDocument = gql`
    mutation GrantAccess($linkHash: String!) {
  grantAccessRequest(linkHash: $linkHash) {
    confirmed
    email
    user {
      firstName
      lastName
    }
  }
}
    `;
export type GrantAccessMutationFn = Apollo.MutationFunction<GrantAccessMutation, GrantAccessMutationVariables>;

/**
 * __useGrantAccessMutation__
 *
 * To run a mutation, you first call `useGrantAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantAccessMutation, { data, loading, error }] = useGrantAccessMutation({
 *   variables: {
 *      linkHash: // value for 'linkHash'
 *   },
 * });
 */
export function useGrantAccessMutation(baseOptions?: Apollo.MutationHookOptions<GrantAccessMutation, GrantAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantAccessMutation, GrantAccessMutationVariables>(GrantAccessDocument, options);
      }
export type GrantAccessMutationHookResult = ReturnType<typeof useGrantAccessMutation>;
export type GrantAccessMutationResult = Apollo.MutationResult<GrantAccessMutation>;
export type GrantAccessMutationOptions = Apollo.BaseMutationOptions<GrantAccessMutation, GrantAccessMutationVariables>;
export const HandleGoogleSignInDocument = gql`
    mutation HandleGoogleSignIn($linkHash: String) {
  handleGoogleSignIn(linkHash: $linkHash)
}
    `;
export type HandleGoogleSignInMutationFn = Apollo.MutationFunction<HandleGoogleSignInMutation, HandleGoogleSignInMutationVariables>;

/**
 * __useHandleGoogleSignInMutation__
 *
 * To run a mutation, you first call `useHandleGoogleSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleGoogleSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleGoogleSignInMutation, { data, loading, error }] = useHandleGoogleSignInMutation({
 *   variables: {
 *      linkHash: // value for 'linkHash'
 *   },
 * });
 */
export function useHandleGoogleSignInMutation(baseOptions?: Apollo.MutationHookOptions<HandleGoogleSignInMutation, HandleGoogleSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleGoogleSignInMutation, HandleGoogleSignInMutationVariables>(HandleGoogleSignInDocument, options);
      }
export type HandleGoogleSignInMutationHookResult = ReturnType<typeof useHandleGoogleSignInMutation>;
export type HandleGoogleSignInMutationResult = Apollo.MutationResult<HandleGoogleSignInMutation>;
export type HandleGoogleSignInMutationOptions = Apollo.BaseMutationOptions<HandleGoogleSignInMutation, HandleGoogleSignInMutationVariables>;
export const KickoffAutoTaxonomyProcessDocument = gql`
    mutation KickoffAutoTaxonomyProcess($schema: String!, $teamId: Int!) {
  kickoffAutoTaxonomyProcess(schema: $schema, teamId: $teamId)
}
    `;
export type KickoffAutoTaxonomyProcessMutationFn = Apollo.MutationFunction<KickoffAutoTaxonomyProcessMutation, KickoffAutoTaxonomyProcessMutationVariables>;

/**
 * __useKickoffAutoTaxonomyProcessMutation__
 *
 * To run a mutation, you first call `useKickoffAutoTaxonomyProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKickoffAutoTaxonomyProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kickoffAutoTaxonomyProcessMutation, { data, loading, error }] = useKickoffAutoTaxonomyProcessMutation({
 *   variables: {
 *      schema: // value for 'schema'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useKickoffAutoTaxonomyProcessMutation(baseOptions?: Apollo.MutationHookOptions<KickoffAutoTaxonomyProcessMutation, KickoffAutoTaxonomyProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KickoffAutoTaxonomyProcessMutation, KickoffAutoTaxonomyProcessMutationVariables>(KickoffAutoTaxonomyProcessDocument, options);
      }
export type KickoffAutoTaxonomyProcessMutationHookResult = ReturnType<typeof useKickoffAutoTaxonomyProcessMutation>;
export type KickoffAutoTaxonomyProcessMutationResult = Apollo.MutationResult<KickoffAutoTaxonomyProcessMutation>;
export type KickoffAutoTaxonomyProcessMutationOptions = Apollo.BaseMutationOptions<KickoffAutoTaxonomyProcessMutation, KickoffAutoTaxonomyProcessMutationVariables>;
export const LaunchNlpDocument = gql`
    mutation LaunchNLP($teamId: Int!, $categorizeOnly: Boolean) {
  nlpLaunch(teamId: $teamId, categorizeOnly: $categorizeOnly)
}
    `;
export type LaunchNlpMutationFn = Apollo.MutationFunction<LaunchNlpMutation, LaunchNlpMutationVariables>;

/**
 * __useLaunchNlpMutation__
 *
 * To run a mutation, you first call `useLaunchNlpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchNlpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchNlpMutation, { data, loading, error }] = useLaunchNlpMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      categorizeOnly: // value for 'categorizeOnly'
 *   },
 * });
 */
export function useLaunchNlpMutation(baseOptions?: Apollo.MutationHookOptions<LaunchNlpMutation, LaunchNlpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LaunchNlpMutation, LaunchNlpMutationVariables>(LaunchNlpDocument, options);
      }
export type LaunchNlpMutationHookResult = ReturnType<typeof useLaunchNlpMutation>;
export type LaunchNlpMutationResult = Apollo.MutationResult<LaunchNlpMutation>;
export type LaunchNlpMutationOptions = Apollo.BaseMutationOptions<LaunchNlpMutation, LaunchNlpMutationVariables>;
export const LinkAsanaTicketDocument = gql`
    mutation LinkAsanaTicket($externalTicketsIntegrationId: Int!, $groupId: BigInt!, $input: ExternalTicketInput!, $orgId: Int!, $teamId: Int!) {
  linkAsanaTicket(
    externalTicketsIntegrationId: $externalTicketsIntegrationId
    groupId: $groupId
    input: $input
    orgId: $orgId
    teamId: $teamId
  ) {
    assignee
    dueDate
    closedDate
    id
    name
    providerUniqueId
    sourcePermalink
    status
  }
}
    `;
export type LinkAsanaTicketMutationFn = Apollo.MutationFunction<LinkAsanaTicketMutation, LinkAsanaTicketMutationVariables>;

/**
 * __useLinkAsanaTicketMutation__
 *
 * To run a mutation, you first call `useLinkAsanaTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAsanaTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAsanaTicketMutation, { data, loading, error }] = useLinkAsanaTicketMutation({
 *   variables: {
 *      externalTicketsIntegrationId: // value for 'externalTicketsIntegrationId'
 *      groupId: // value for 'groupId'
 *      input: // value for 'input'
 *      orgId: // value for 'orgId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useLinkAsanaTicketMutation(baseOptions?: Apollo.MutationHookOptions<LinkAsanaTicketMutation, LinkAsanaTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAsanaTicketMutation, LinkAsanaTicketMutationVariables>(LinkAsanaTicketDocument, options);
      }
export type LinkAsanaTicketMutationHookResult = ReturnType<typeof useLinkAsanaTicketMutation>;
export type LinkAsanaTicketMutationResult = Apollo.MutationResult<LinkAsanaTicketMutation>;
export type LinkAsanaTicketMutationOptions = Apollo.BaseMutationOptions<LinkAsanaTicketMutation, LinkAsanaTicketMutationVariables>;
export const LinkJiraTicketDocument = gql`
    mutation LinkJiraTicket($externalTicketsIntegrationId: Int!, $groupId: BigInt!, $input: ExternalTicketInput!, $orgId: Int!, $teamId: Int!) {
  linkJiraTicket(
    externalTicketsIntegrationId: $externalTicketsIntegrationId
    groupId: $groupId
    input: $input
    orgId: $orgId
    teamId: $teamId
  ) {
    assignee
    dueDate
    closedDate
    id
    name
    providerUniqueId
    sourcePermalink
    status
  }
}
    `;
export type LinkJiraTicketMutationFn = Apollo.MutationFunction<LinkJiraTicketMutation, LinkJiraTicketMutationVariables>;

/**
 * __useLinkJiraTicketMutation__
 *
 * To run a mutation, you first call `useLinkJiraTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkJiraTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkJiraTicketMutation, { data, loading, error }] = useLinkJiraTicketMutation({
 *   variables: {
 *      externalTicketsIntegrationId: // value for 'externalTicketsIntegrationId'
 *      groupId: // value for 'groupId'
 *      input: // value for 'input'
 *      orgId: // value for 'orgId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useLinkJiraTicketMutation(baseOptions?: Apollo.MutationHookOptions<LinkJiraTicketMutation, LinkJiraTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkJiraTicketMutation, LinkJiraTicketMutationVariables>(LinkJiraTicketDocument, options);
      }
export type LinkJiraTicketMutationHookResult = ReturnType<typeof useLinkJiraTicketMutation>;
export type LinkJiraTicketMutationResult = Apollo.MutationResult<LinkJiraTicketMutation>;
export type LinkJiraTicketMutationOptions = Apollo.BaseMutationOptions<LinkJiraTicketMutation, LinkJiraTicketMutationVariables>;
export const LinkLinearTicketDocument = gql`
    mutation LinkLinearTicket($externalTicketsIntegrationId: Int!, $groupId: BigInt!, $input: ExternalTicketInput!, $orgId: Int!, $teamId: Int!) {
  linkLinearTicket(
    externalTicketsIntegrationId: $externalTicketsIntegrationId
    groupId: $groupId
    input: $input
    orgId: $orgId
    teamId: $teamId
  ) {
    assignee
    dueDate
    closedDate
    id
    name
    providerUniqueId
    sourcePermalink
    status
  }
}
    `;
export type LinkLinearTicketMutationFn = Apollo.MutationFunction<LinkLinearTicketMutation, LinkLinearTicketMutationVariables>;

/**
 * __useLinkLinearTicketMutation__
 *
 * To run a mutation, you first call `useLinkLinearTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkLinearTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkLinearTicketMutation, { data, loading, error }] = useLinkLinearTicketMutation({
 *   variables: {
 *      externalTicketsIntegrationId: // value for 'externalTicketsIntegrationId'
 *      groupId: // value for 'groupId'
 *      input: // value for 'input'
 *      orgId: // value for 'orgId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useLinkLinearTicketMutation(baseOptions?: Apollo.MutationHookOptions<LinkLinearTicketMutation, LinkLinearTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkLinearTicketMutation, LinkLinearTicketMutationVariables>(LinkLinearTicketDocument, options);
      }
export type LinkLinearTicketMutationHookResult = ReturnType<typeof useLinkLinearTicketMutation>;
export type LinkLinearTicketMutationResult = Apollo.MutationResult<LinkLinearTicketMutation>;
export type LinkLinearTicketMutationOptions = Apollo.BaseMutationOptions<LinkLinearTicketMutation, LinkLinearTicketMutationVariables>;
export const LogGroupViewDocument = gql`
    mutation LogGroupView($groupId: BigInt!, $teamId: Int!) {
  logGroupView(groupId: $groupId, teamId: $teamId) {
    teamId
    id
    groupId
    dateVisited
  }
}
    `;
export type LogGroupViewMutationFn = Apollo.MutationFunction<LogGroupViewMutation, LogGroupViewMutationVariables>;

/**
 * __useLogGroupViewMutation__
 *
 * To run a mutation, you first call `useLogGroupViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogGroupViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logGroupViewMutation, { data, loading, error }] = useLogGroupViewMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useLogGroupViewMutation(baseOptions?: Apollo.MutationHookOptions<LogGroupViewMutation, LogGroupViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogGroupViewMutation, LogGroupViewMutationVariables>(LogGroupViewDocument, options);
      }
export type LogGroupViewMutationHookResult = ReturnType<typeof useLogGroupViewMutation>;
export type LogGroupViewMutationResult = Apollo.MutationResult<LogGroupViewMutation>;
export type LogGroupViewMutationOptions = Apollo.BaseMutationOptions<LogGroupViewMutation, LogGroupViewMutationVariables>;
export const ModifyEntryGroupMembershipDocument = gql`
    mutation ModifyEntryGroupMembership($action: group_membership_action!, $entryId: BigInt!, $groupId: BigInt!, $teamId: Int!) {
  modifyEntryGroupMembership(
    action: $action
    entryId: $entryId
    groupId: $groupId
    teamId: $teamId
  ) {
    id
    groupMemberships {
      ...GroupMembership
    }
  }
}
    ${GroupMembershipFragmentDoc}`;
export type ModifyEntryGroupMembershipMutationFn = Apollo.MutationFunction<ModifyEntryGroupMembershipMutation, ModifyEntryGroupMembershipMutationVariables>;

/**
 * __useModifyEntryGroupMembershipMutation__
 *
 * To run a mutation, you first call `useModifyEntryGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyEntryGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyEntryGroupMembershipMutation, { data, loading, error }] = useModifyEntryGroupMembershipMutation({
 *   variables: {
 *      action: // value for 'action'
 *      entryId: // value for 'entryId'
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useModifyEntryGroupMembershipMutation(baseOptions?: Apollo.MutationHookOptions<ModifyEntryGroupMembershipMutation, ModifyEntryGroupMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyEntryGroupMembershipMutation, ModifyEntryGroupMembershipMutationVariables>(ModifyEntryGroupMembershipDocument, options);
      }
export type ModifyEntryGroupMembershipMutationHookResult = ReturnType<typeof useModifyEntryGroupMembershipMutation>;
export type ModifyEntryGroupMembershipMutationResult = Apollo.MutationResult<ModifyEntryGroupMembershipMutation>;
export type ModifyEntryGroupMembershipMutationOptions = Apollo.BaseMutationOptions<ModifyEntryGroupMembershipMutation, ModifyEntryGroupMembershipMutationVariables>;
export const MoveTeamDocument = gql`
    mutation MoveTeam($destinationOrgId: Int!, $originOrgId: Int!, $teamId: Int!) {
  moveTeam(
    destinationOrgId: $destinationOrgId
    originOrgId: $originOrgId
    teamId: $teamId
  )
}
    `;
export type MoveTeamMutationFn = Apollo.MutationFunction<MoveTeamMutation, MoveTeamMutationVariables>;

/**
 * __useMoveTeamMutation__
 *
 * To run a mutation, you first call `useMoveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTeamMutation, { data, loading, error }] = useMoveTeamMutation({
 *   variables: {
 *      destinationOrgId: // value for 'destinationOrgId'
 *      originOrgId: // value for 'originOrgId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useMoveTeamMutation(baseOptions?: Apollo.MutationHookOptions<MoveTeamMutation, MoveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveTeamMutation, MoveTeamMutationVariables>(MoveTeamDocument, options);
      }
export type MoveTeamMutationHookResult = ReturnType<typeof useMoveTeamMutation>;
export type MoveTeamMutationResult = Apollo.MutationResult<MoveTeamMutation>;
export type MoveTeamMutationOptions = Apollo.BaseMutationOptions<MoveTeamMutation, MoveTeamMutationVariables>;
export const CreateOnDemandInsightDocument = gql`
    mutation CreateOnDemandInsight($draftTitle: String!, $draftDescription: String!, $groupId: BigInt!, $teamId: Int!) {
  createOnDemandInsight(
    draftTitle: $draftTitle
    draftDescription: $draftDescription
    groupId: $groupId
    teamId: $teamId
  ) {
    title
    description
  }
}
    `;
export type CreateOnDemandInsightMutationFn = Apollo.MutationFunction<CreateOnDemandInsightMutation, CreateOnDemandInsightMutationVariables>;

/**
 * __useCreateOnDemandInsightMutation__
 *
 * To run a mutation, you first call `useCreateOnDemandInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnDemandInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnDemandInsightMutation, { data, loading, error }] = useCreateOnDemandInsightMutation({
 *   variables: {
 *      draftTitle: // value for 'draftTitle'
 *      draftDescription: // value for 'draftDescription'
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useCreateOnDemandInsightMutation(baseOptions?: Apollo.MutationHookOptions<CreateOnDemandInsightMutation, CreateOnDemandInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOnDemandInsightMutation, CreateOnDemandInsightMutationVariables>(CreateOnDemandInsightDocument, options);
      }
export type CreateOnDemandInsightMutationHookResult = ReturnType<typeof useCreateOnDemandInsightMutation>;
export type CreateOnDemandInsightMutationResult = Apollo.MutationResult<CreateOnDemandInsightMutation>;
export type CreateOnDemandInsightMutationOptions = Apollo.BaseMutationOptions<CreateOnDemandInsightMutation, CreateOnDemandInsightMutationVariables>;
export const PublishDigestToSlackDocument = gql`
    mutation PublishDigestToSlack($digestId: Int!) {
  sendDigestToSlack(digestId: $digestId) {
    success
    message
  }
}
    `;
export type PublishDigestToSlackMutationFn = Apollo.MutationFunction<PublishDigestToSlackMutation, PublishDigestToSlackMutationVariables>;

/**
 * __usePublishDigestToSlackMutation__
 *
 * To run a mutation, you first call `usePublishDigestToSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDigestToSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDigestToSlackMutation, { data, loading, error }] = usePublishDigestToSlackMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *   },
 * });
 */
export function usePublishDigestToSlackMutation(baseOptions?: Apollo.MutationHookOptions<PublishDigestToSlackMutation, PublishDigestToSlackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDigestToSlackMutation, PublishDigestToSlackMutationVariables>(PublishDigestToSlackDocument, options);
      }
export type PublishDigestToSlackMutationHookResult = ReturnType<typeof usePublishDigestToSlackMutation>;
export type PublishDigestToSlackMutationResult = Apollo.MutationResult<PublishDigestToSlackMutation>;
export type PublishDigestToSlackMutationOptions = Apollo.BaseMutationOptions<PublishDigestToSlackMutation, PublishDigestToSlackMutationVariables>;
export const RemoveChildDocument = gql`
    mutation RemoveChild($childGroupId: BigInt!, $parentGroupId: BigInt!, $teamId: Int!, $filterInput: FilterInput) {
  removeChild(
    childGroupId: $childGroupId
    parentGroupId: $parentGroupId
    teamId: $teamId
    filterInput: $filterInput
  ) {
    ...GroupTaxonomy
  }
}
    ${GroupTaxonomyFragmentDoc}`;
export type RemoveChildMutationFn = Apollo.MutationFunction<RemoveChildMutation, RemoveChildMutationVariables>;

/**
 * __useRemoveChildMutation__
 *
 * To run a mutation, you first call `useRemoveChildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChildMutation, { data, loading, error }] = useRemoveChildMutation({
 *   variables: {
 *      childGroupId: // value for 'childGroupId'
 *      parentGroupId: // value for 'parentGroupId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useRemoveChildMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChildMutation, RemoveChildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChildMutation, RemoveChildMutationVariables>(RemoveChildDocument, options);
      }
export type RemoveChildMutationHookResult = ReturnType<typeof useRemoveChildMutation>;
export type RemoveChildMutationResult = Apollo.MutationResult<RemoveChildMutation>;
export type RemoveChildMutationOptions = Apollo.BaseMutationOptions<RemoveChildMutation, RemoveChildMutationVariables>;
export const RemoveDomainFromOrgDocument = gql`
    mutation RemoveDomainFromOrg($orgDomainId: Int!, $orgId: Int!) {
  removeDomainFromOrg(orgDomainId: $orgDomainId, orgId: $orgId)
}
    `;
export type RemoveDomainFromOrgMutationFn = Apollo.MutationFunction<RemoveDomainFromOrgMutation, RemoveDomainFromOrgMutationVariables>;

/**
 * __useRemoveDomainFromOrgMutation__
 *
 * To run a mutation, you first call `useRemoveDomainFromOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDomainFromOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDomainFromOrgMutation, { data, loading, error }] = useRemoveDomainFromOrgMutation({
 *   variables: {
 *      orgDomainId: // value for 'orgDomainId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useRemoveDomainFromOrgMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDomainFromOrgMutation, RemoveDomainFromOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDomainFromOrgMutation, RemoveDomainFromOrgMutationVariables>(RemoveDomainFromOrgDocument, options);
      }
export type RemoveDomainFromOrgMutationHookResult = ReturnType<typeof useRemoveDomainFromOrgMutation>;
export type RemoveDomainFromOrgMutationResult = Apollo.MutationResult<RemoveDomainFromOrgMutation>;
export type RemoveDomainFromOrgMutationOptions = Apollo.BaseMutationOptions<RemoveDomainFromOrgMutation, RemoveDomainFromOrgMutationVariables>;
export const RemoveGroupOwnerDocument = gql`
    mutation RemoveGroupOwner($groupId: BigInt!, $teamId: Int!) {
  removeGroupOwner(groupId: $groupId, teamId: $teamId) {
    id
  }
}
    `;
export type RemoveGroupOwnerMutationFn = Apollo.MutationFunction<RemoveGroupOwnerMutation, RemoveGroupOwnerMutationVariables>;

/**
 * __useRemoveGroupOwnerMutation__
 *
 * To run a mutation, you first call `useRemoveGroupOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupOwnerMutation, { data, loading, error }] = useRemoveGroupOwnerMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useRemoveGroupOwnerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupOwnerMutation, RemoveGroupOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupOwnerMutation, RemoveGroupOwnerMutationVariables>(RemoveGroupOwnerDocument, options);
      }
export type RemoveGroupOwnerMutationHookResult = ReturnType<typeof useRemoveGroupOwnerMutation>;
export type RemoveGroupOwnerMutationResult = Apollo.MutationResult<RemoveGroupOwnerMutation>;
export type RemoveGroupOwnerMutationOptions = Apollo.BaseMutationOptions<RemoveGroupOwnerMutation, RemoveGroupOwnerMutationVariables>;
export const RemoveOrganizationUserDocument = gql`
    mutation RemoveOrganizationUser($orgId: Int!, $userToDeleteEmail: String!) {
  removeOrganizationUser(orgId: $orgId, userToDeleteEmail: $userToDeleteEmail) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export type RemoveOrganizationUserMutationFn = Apollo.MutationFunction<RemoveOrganizationUserMutation, RemoveOrganizationUserMutationVariables>;

/**
 * __useRemoveOrganizationUserMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationUserMutation, { data, loading, error }] = useRemoveOrganizationUserMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      userToDeleteEmail: // value for 'userToDeleteEmail'
 *   },
 * });
 */
export function useRemoveOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganizationUserMutation, RemoveOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganizationUserMutation, RemoveOrganizationUserMutationVariables>(RemoveOrganizationUserDocument, options);
      }
export type RemoveOrganizationUserMutationHookResult = ReturnType<typeof useRemoveOrganizationUserMutation>;
export type RemoveOrganizationUserMutationResult = Apollo.MutationResult<RemoveOrganizationUserMutation>;
export type RemoveOrganizationUserMutationOptions = Apollo.BaseMutationOptions<RemoveOrganizationUserMutation, RemoveOrganizationUserMutationVariables>;
export const RemoveTagFromGroupDocument = gql`
    mutation RemoveTagFromGroup($groupId: BigInt!, $tagId: Int!, $teamId: Int!) {
  removeTagFromGroup(groupId: $groupId, tagId: $tagId, teamId: $teamId) {
    id
    name
  }
}
    `;
export type RemoveTagFromGroupMutationFn = Apollo.MutationFunction<RemoveTagFromGroupMutation, RemoveTagFromGroupMutationVariables>;

/**
 * __useRemoveTagFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromGroupMutation, { data, loading, error }] = useRemoveTagFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      tagId: // value for 'tagId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useRemoveTagFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagFromGroupMutation, RemoveTagFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagFromGroupMutation, RemoveTagFromGroupMutationVariables>(RemoveTagFromGroupDocument, options);
      }
export type RemoveTagFromGroupMutationHookResult = ReturnType<typeof useRemoveTagFromGroupMutation>;
export type RemoveTagFromGroupMutationResult = Apollo.MutationResult<RemoveTagFromGroupMutation>;
export type RemoveTagFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromGroupMutation, RemoveTagFromGroupMutationVariables>;
export const ReplyToReviewsDocument = gql`
    mutation ReplyToReviews($replyInput: [EntryReplyInput!]!, $teamId: Int!) {
  replyToReviews(replyInput: $replyInput, teamId: $teamId) {
    conversationPart {
      date
      fullText
      submitter
      submitterType
      userId
    }
    errorMessage
    feedbackEntryId
    success
  }
}
    `;
export type ReplyToReviewsMutationFn = Apollo.MutationFunction<ReplyToReviewsMutation, ReplyToReviewsMutationVariables>;

/**
 * __useReplyToReviewsMutation__
 *
 * To run a mutation, you first call `useReplyToReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToReviewsMutation, { data, loading, error }] = useReplyToReviewsMutation({
 *   variables: {
 *      replyInput: // value for 'replyInput'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useReplyToReviewsMutation(baseOptions?: Apollo.MutationHookOptions<ReplyToReviewsMutation, ReplyToReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyToReviewsMutation, ReplyToReviewsMutationVariables>(ReplyToReviewsDocument, options);
      }
export type ReplyToReviewsMutationHookResult = ReturnType<typeof useReplyToReviewsMutation>;
export type ReplyToReviewsMutationResult = Apollo.MutationResult<ReplyToReviewsMutation>;
export type ReplyToReviewsMutationOptions = Apollo.BaseMutationOptions<ReplyToReviewsMutation, ReplyToReviewsMutationVariables>;
export const RequestAccessDocument = gql`
    mutation RequestAccess($teamId: Int, $orgId: Int) {
  requestAccessToOrganization(teamId: $teamId, orgId: $orgId)
}
    `;
export type RequestAccessMutationFn = Apollo.MutationFunction<RequestAccessMutation, RequestAccessMutationVariables>;

/**
 * __useRequestAccessMutation__
 *
 * To run a mutation, you first call `useRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccessMutation, { data, loading, error }] = useRequestAccessMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useRequestAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccessMutation, RequestAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccessMutation, RequestAccessMutationVariables>(RequestAccessDocument, options);
      }
export type RequestAccessMutationHookResult = ReturnType<typeof useRequestAccessMutation>;
export type RequestAccessMutationResult = Apollo.MutationResult<RequestAccessMutation>;
export type RequestAccessMutationOptions = Apollo.BaseMutationOptions<RequestAccessMutation, RequestAccessMutationVariables>;
export const SavePlotDocument = gql`
    mutation SavePlot($id: Int!, $plotConfigurationInput: PlotConfig!, $boardId: Int!, $teamId: Int!) {
  savePlot(
    id: $id
    plotConfigurationInput: $plotConfigurationInput
    boardId: $boardId
    teamId: $teamId
  )
}
    `;
export type SavePlotMutationFn = Apollo.MutationFunction<SavePlotMutation, SavePlotMutationVariables>;

/**
 * __useSavePlotMutation__
 *
 * To run a mutation, you first call `useSavePlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlotMutation, { data, loading, error }] = useSavePlotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      plotConfigurationInput: // value for 'plotConfigurationInput'
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useSavePlotMutation(baseOptions?: Apollo.MutationHookOptions<SavePlotMutation, SavePlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlotMutation, SavePlotMutationVariables>(SavePlotDocument, options);
      }
export type SavePlotMutationHookResult = ReturnType<typeof useSavePlotMutation>;
export type SavePlotMutationResult = Apollo.MutationResult<SavePlotMutation>;
export type SavePlotMutationOptions = Apollo.BaseMutationOptions<SavePlotMutation, SavePlotMutationVariables>;
export const SendAnnouncementEmailDocument = gql`
    mutation SendAnnouncementEmail($body: String!, $groupId: BigInt!, $orgId: Int!, $recipients: [String!]!, $subject: String!, $teamId: Int!, $image: String) {
  sendAnnouncementEmail(
    body: $body
    groupId: $groupId
    orgId: $orgId
    recipients: $recipients
    subject: $subject
    teamId: $teamId
    image: $image
  ) {
    ...Announcement
  }
}
    ${AnnouncementFragmentDoc}`;
export type SendAnnouncementEmailMutationFn = Apollo.MutationFunction<SendAnnouncementEmailMutation, SendAnnouncementEmailMutationVariables>;

/**
 * __useSendAnnouncementEmailMutation__
 *
 * To run a mutation, you first call `useSendAnnouncementEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAnnouncementEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAnnouncementEmailMutation, { data, loading, error }] = useSendAnnouncementEmailMutation({
 *   variables: {
 *      body: // value for 'body'
 *      groupId: // value for 'groupId'
 *      orgId: // value for 'orgId'
 *      recipients: // value for 'recipients'
 *      subject: // value for 'subject'
 *      teamId: // value for 'teamId'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useSendAnnouncementEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendAnnouncementEmailMutation, SendAnnouncementEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAnnouncementEmailMutation, SendAnnouncementEmailMutationVariables>(SendAnnouncementEmailDocument, options);
      }
export type SendAnnouncementEmailMutationHookResult = ReturnType<typeof useSendAnnouncementEmailMutation>;
export type SendAnnouncementEmailMutationResult = Apollo.MutationResult<SendAnnouncementEmailMutation>;
export type SendAnnouncementEmailMutationOptions = Apollo.BaseMutationOptions<SendAnnouncementEmailMutation, SendAnnouncementEmailMutationVariables>;
export const SendDigestDocument = gql`
    mutation SendDigest($digestId: Int!) {
  sendDigest(digestId: $digestId) {
    ...DigestData
  }
}
    ${DigestDataFragmentDoc}`;
export type SendDigestMutationFn = Apollo.MutationFunction<SendDigestMutation, SendDigestMutationVariables>;

/**
 * __useSendDigestMutation__
 *
 * To run a mutation, you first call `useSendDigestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDigestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDigestMutation, { data, loading, error }] = useSendDigestMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *   },
 * });
 */
export function useSendDigestMutation(baseOptions?: Apollo.MutationHookOptions<SendDigestMutation, SendDigestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDigestMutation, SendDigestMutationVariables>(SendDigestDocument, options);
      }
export type SendDigestMutationHookResult = ReturnType<typeof useSendDigestMutation>;
export type SendDigestMutationResult = Apollo.MutationResult<SendDigestMutation>;
export type SendDigestMutationOptions = Apollo.BaseMutationOptions<SendDigestMutation, SendDigestMutationVariables>;
export const SendTestDigestEmailDocument = gql`
    mutation SendTestDigestEmail($digestId: Int!, $emailAddress: String!) {
  sendTestDigestEmail(digestId: $digestId, emailAddress: $emailAddress) {
    success
    message
  }
}
    `;
export type SendTestDigestEmailMutationFn = Apollo.MutationFunction<SendTestDigestEmailMutation, SendTestDigestEmailMutationVariables>;

/**
 * __useSendTestDigestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestDigestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestDigestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestDigestEmailMutation, { data, loading, error }] = useSendTestDigestEmailMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useSendTestDigestEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestDigestEmailMutation, SendTestDigestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestDigestEmailMutation, SendTestDigestEmailMutationVariables>(SendTestDigestEmailDocument, options);
      }
export type SendTestDigestEmailMutationHookResult = ReturnType<typeof useSendTestDigestEmailMutation>;
export type SendTestDigestEmailMutationResult = Apollo.MutationResult<SendTestDigestEmailMutation>;
export type SendTestDigestEmailMutationOptions = Apollo.BaseMutationOptions<SendTestDigestEmailMutation, SendTestDigestEmailMutationVariables>;
export const SendTestSlackDigestDocument = gql`
    mutation SendTestSlackDigest($digestId: Int!) {
  sendTestSlack(digestId: $digestId) {
    success
    message
  }
}
    `;
export type SendTestSlackDigestMutationFn = Apollo.MutationFunction<SendTestSlackDigestMutation, SendTestSlackDigestMutationVariables>;

/**
 * __useSendTestSlackDigestMutation__
 *
 * To run a mutation, you first call `useSendTestSlackDigestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestSlackDigestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestSlackDigestMutation, { data, loading, error }] = useSendTestSlackDigestMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *   },
 * });
 */
export function useSendTestSlackDigestMutation(baseOptions?: Apollo.MutationHookOptions<SendTestSlackDigestMutation, SendTestSlackDigestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestSlackDigestMutation, SendTestSlackDigestMutationVariables>(SendTestSlackDigestDocument, options);
      }
export type SendTestSlackDigestMutationHookResult = ReturnType<typeof useSendTestSlackDigestMutation>;
export type SendTestSlackDigestMutationResult = Apollo.MutationResult<SendTestSlackDigestMutation>;
export type SendTestSlackDigestMutationOptions = Apollo.BaseMutationOptions<SendTestSlackDigestMutation, SendTestSlackDigestMutationVariables>;
export const SetDefaultOrganizationTeamDocument = gql`
    mutation SetDefaultOrganizationTeam($orgId: Int!, $defaultTeamId: Int) {
  setDefaultOrganizationTeam(orgId: $orgId, defaultTeamId: $defaultTeamId) {
    ...OrganizationsLight
  }
}
    ${OrganizationsLightFragmentDoc}`;
export type SetDefaultOrganizationTeamMutationFn = Apollo.MutationFunction<SetDefaultOrganizationTeamMutation, SetDefaultOrganizationTeamMutationVariables>;

/**
 * __useSetDefaultOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useSetDefaultOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultOrganizationTeamMutation, { data, loading, error }] = useSetDefaultOrganizationTeamMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      defaultTeamId: // value for 'defaultTeamId'
 *   },
 * });
 */
export function useSetDefaultOrganizationTeamMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultOrganizationTeamMutation, SetDefaultOrganizationTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultOrganizationTeamMutation, SetDefaultOrganizationTeamMutationVariables>(SetDefaultOrganizationTeamDocument, options);
      }
export type SetDefaultOrganizationTeamMutationHookResult = ReturnType<typeof useSetDefaultOrganizationTeamMutation>;
export type SetDefaultOrganizationTeamMutationResult = Apollo.MutationResult<SetDefaultOrganizationTeamMutation>;
export type SetDefaultOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<SetDefaultOrganizationTeamMutation, SetDefaultOrganizationTeamMutationVariables>;
export const SetDefaultRoleDocument = gql`
    mutation SetDefaultRole($defaultRole: role!, $orgId: Int!) {
  setDefaultRole(defaultRole: $defaultRole, orgId: $orgId) {
    id
  }
}
    `;
export type SetDefaultRoleMutationFn = Apollo.MutationFunction<SetDefaultRoleMutation, SetDefaultRoleMutationVariables>;

/**
 * __useSetDefaultRoleMutation__
 *
 * To run a mutation, you first call `useSetDefaultRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultRoleMutation, { data, loading, error }] = useSetDefaultRoleMutation({
 *   variables: {
 *      defaultRole: // value for 'defaultRole'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useSetDefaultRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultRoleMutation, SetDefaultRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultRoleMutation, SetDefaultRoleMutationVariables>(SetDefaultRoleDocument, options);
      }
export type SetDefaultRoleMutationHookResult = ReturnType<typeof useSetDefaultRoleMutation>;
export type SetDefaultRoleMutationResult = Apollo.MutationResult<SetDefaultRoleMutation>;
export type SetDefaultRoleMutationOptions = Apollo.BaseMutationOptions<SetDefaultRoleMutation, SetDefaultRoleMutationVariables>;
export const SetDigestStatusDocument = gql`
    mutation SetDigestStatus($digestId: Int!, $status: DigestStatus!) {
  setDigestStatus(digestId: $digestId, status: $status) {
    ...DigestData
  }
}
    ${DigestDataFragmentDoc}`;
export type SetDigestStatusMutationFn = Apollo.MutationFunction<SetDigestStatusMutation, SetDigestStatusMutationVariables>;

/**
 * __useSetDigestStatusMutation__
 *
 * To run a mutation, you first call `useSetDigestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDigestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDigestStatusMutation, { data, loading, error }] = useSetDigestStatusMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetDigestStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetDigestStatusMutation, SetDigestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDigestStatusMutation, SetDigestStatusMutationVariables>(SetDigestStatusDocument, options);
      }
export type SetDigestStatusMutationHookResult = ReturnType<typeof useSetDigestStatusMutation>;
export type SetDigestStatusMutationResult = Apollo.MutationResult<SetDigestStatusMutation>;
export type SetDigestStatusMutationOptions = Apollo.BaseMutationOptions<SetDigestStatusMutation, SetDigestStatusMutationVariables>;
export const SetDigestSubjectDocument = gql`
    mutation SetDigestSubject($digestId: Int!, $subject: String!) {
  setDigestSubject(digestId: $digestId, subject: $subject) {
    id
  }
}
    `;
export type SetDigestSubjectMutationFn = Apollo.MutationFunction<SetDigestSubjectMutation, SetDigestSubjectMutationVariables>;

/**
 * __useSetDigestSubjectMutation__
 *
 * To run a mutation, you first call `useSetDigestSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDigestSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDigestSubjectMutation, { data, loading, error }] = useSetDigestSubjectMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSetDigestSubjectMutation(baseOptions?: Apollo.MutationHookOptions<SetDigestSubjectMutation, SetDigestSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDigestSubjectMutation, SetDigestSubjectMutationVariables>(SetDigestSubjectDocument, options);
      }
export type SetDigestSubjectMutationHookResult = ReturnType<typeof useSetDigestSubjectMutation>;
export type SetDigestSubjectMutationResult = Apollo.MutationResult<SetDigestSubjectMutation>;
export type SetDigestSubjectMutationOptions = Apollo.BaseMutationOptions<SetDigestSubjectMutation, SetDigestSubjectMutationVariables>;
export const UpsertReviewDocument = gql`
    mutation UpsertReview($feature: unwrap_feature!, $feedback: String!, $rating: Int!, $teamId: Int!, $id: Int) {
  upsertReview(
    feature: $feature
    feedback: $feedback
    rating: $rating
    teamId: $teamId
    id: $id
  ) {
    id
    message
    success
  }
}
    `;
export type UpsertReviewMutationFn = Apollo.MutationFunction<UpsertReviewMutation, UpsertReviewMutationVariables>;

/**
 * __useUpsertReviewMutation__
 *
 * To run a mutation, you first call `useUpsertReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertReviewMutation, { data, loading, error }] = useUpsertReviewMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *      feedback: // value for 'feedback'
 *      rating: // value for 'rating'
 *      teamId: // value for 'teamId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpsertReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpsertReviewMutation, UpsertReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertReviewMutation, UpsertReviewMutationVariables>(UpsertReviewDocument, options);
      }
export type UpsertReviewMutationHookResult = ReturnType<typeof useUpsertReviewMutation>;
export type UpsertReviewMutationResult = Apollo.MutationResult<UpsertReviewMutation>;
export type UpsertReviewMutationOptions = Apollo.BaseMutationOptions<UpsertReviewMutation, UpsertReviewMutationVariables>;
export const SuggestInsightsDocument = gql`
    mutation SuggestInsights($digestId: Int!) {
  suggestInsights(digestId: $digestId) {
    id
  }
}
    `;
export type SuggestInsightsMutationFn = Apollo.MutationFunction<SuggestInsightsMutation, SuggestInsightsMutationVariables>;

/**
 * __useSuggestInsightsMutation__
 *
 * To run a mutation, you first call `useSuggestInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestInsightsMutation, { data, loading, error }] = useSuggestInsightsMutation({
 *   variables: {
 *      digestId: // value for 'digestId'
 *   },
 * });
 */
export function useSuggestInsightsMutation(baseOptions?: Apollo.MutationHookOptions<SuggestInsightsMutation, SuggestInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestInsightsMutation, SuggestInsightsMutationVariables>(SuggestInsightsDocument, options);
      }
export type SuggestInsightsMutationHookResult = ReturnType<typeof useSuggestInsightsMutation>;
export type SuggestInsightsMutationResult = Apollo.MutationResult<SuggestInsightsMutation>;
export type SuggestInsightsMutationOptions = Apollo.BaseMutationOptions<SuggestInsightsMutation, SuggestInsightsMutationVariables>;
export const TagGroupDocument = gql`
    mutation TagGroup($groupId: BigInt!, $tagId: Int!, $teamId: Int!) {
  tagGroup(groupId: $groupId, tagId: $tagId, teamId: $teamId) {
    id
    name
  }
}
    `;
export type TagGroupMutationFn = Apollo.MutationFunction<TagGroupMutation, TagGroupMutationVariables>;

/**
 * __useTagGroupMutation__
 *
 * To run a mutation, you first call `useTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagGroupMutation, { data, loading, error }] = useTagGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      tagId: // value for 'tagId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<TagGroupMutation, TagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagGroupMutation, TagGroupMutationVariables>(TagGroupDocument, options);
      }
export type TagGroupMutationHookResult = ReturnType<typeof useTagGroupMutation>;
export type TagGroupMutationResult = Apollo.MutationResult<TagGroupMutation>;
export type TagGroupMutationOptions = Apollo.BaseMutationOptions<TagGroupMutation, TagGroupMutationVariables>;
export const TogglePinBoardDocument = gql`
    mutation TogglePinBoard($boardId: Int!, $teamId: Int!) {
  togglePinBoardForUser(boardId: $boardId, teamId: $teamId)
}
    `;
export type TogglePinBoardMutationFn = Apollo.MutationFunction<TogglePinBoardMutation, TogglePinBoardMutationVariables>;

/**
 * __useTogglePinBoardMutation__
 *
 * To run a mutation, you first call `useTogglePinBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinBoardMutation, { data, loading, error }] = useTogglePinBoardMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTogglePinBoardMutation(baseOptions?: Apollo.MutationHookOptions<TogglePinBoardMutation, TogglePinBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePinBoardMutation, TogglePinBoardMutationVariables>(TogglePinBoardDocument, options);
      }
export type TogglePinBoardMutationHookResult = ReturnType<typeof useTogglePinBoardMutation>;
export type TogglePinBoardMutationResult = Apollo.MutationResult<TogglePinBoardMutation>;
export type TogglePinBoardMutationOptions = Apollo.BaseMutationOptions<TogglePinBoardMutation, TogglePinBoardMutationVariables>;
export const TogglePinGroupDocument = gql`
    mutation TogglePinGroup($groupId: BigInt!, $teamId: Int!) {
  togglePinGroup(groupId: $groupId, teamId: $teamId) {
    id
    isPinnedByUser
  }
}
    `;
export type TogglePinGroupMutationFn = Apollo.MutationFunction<TogglePinGroupMutation, TogglePinGroupMutationVariables>;

/**
 * __useTogglePinGroupMutation__
 *
 * To run a mutation, you first call `useTogglePinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinGroupMutation, { data, loading, error }] = useTogglePinGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTogglePinGroupMutation(baseOptions?: Apollo.MutationHookOptions<TogglePinGroupMutation, TogglePinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePinGroupMutation, TogglePinGroupMutationVariables>(TogglePinGroupDocument, options);
      }
export type TogglePinGroupMutationHookResult = ReturnType<typeof useTogglePinGroupMutation>;
export type TogglePinGroupMutationResult = Apollo.MutationResult<TogglePinGroupMutation>;
export type TogglePinGroupMutationOptions = Apollo.BaseMutationOptions<TogglePinGroupMutation, TogglePinGroupMutationVariables>;
export const UnlinkAsanaTicketDocument = gql`
    mutation UnlinkAsanaTicket($externalTicketId: Int!, $groupId: BigInt!, $orgId: Int!) {
  unlinkAsanaTicket(
    externalTicketId: $externalTicketId
    groupId: $groupId
    orgId: $orgId
  )
}
    `;
export type UnlinkAsanaTicketMutationFn = Apollo.MutationFunction<UnlinkAsanaTicketMutation, UnlinkAsanaTicketMutationVariables>;

/**
 * __useUnlinkAsanaTicketMutation__
 *
 * To run a mutation, you first call `useUnlinkAsanaTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAsanaTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAsanaTicketMutation, { data, loading, error }] = useUnlinkAsanaTicketMutation({
 *   variables: {
 *      externalTicketId: // value for 'externalTicketId'
 *      groupId: // value for 'groupId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUnlinkAsanaTicketMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkAsanaTicketMutation, UnlinkAsanaTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkAsanaTicketMutation, UnlinkAsanaTicketMutationVariables>(UnlinkAsanaTicketDocument, options);
      }
export type UnlinkAsanaTicketMutationHookResult = ReturnType<typeof useUnlinkAsanaTicketMutation>;
export type UnlinkAsanaTicketMutationResult = Apollo.MutationResult<UnlinkAsanaTicketMutation>;
export type UnlinkAsanaTicketMutationOptions = Apollo.BaseMutationOptions<UnlinkAsanaTicketMutation, UnlinkAsanaTicketMutationVariables>;
export const UnlinkJiraTicketDocument = gql`
    mutation UnlinkJiraTicket($externalTicketId: Int!, $groupId: BigInt!, $orgId: Int!) {
  unlinkJiraTicket(
    externalTicketId: $externalTicketId
    groupId: $groupId
    orgId: $orgId
  )
}
    `;
export type UnlinkJiraTicketMutationFn = Apollo.MutationFunction<UnlinkJiraTicketMutation, UnlinkJiraTicketMutationVariables>;

/**
 * __useUnlinkJiraTicketMutation__
 *
 * To run a mutation, you first call `useUnlinkJiraTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkJiraTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkJiraTicketMutation, { data, loading, error }] = useUnlinkJiraTicketMutation({
 *   variables: {
 *      externalTicketId: // value for 'externalTicketId'
 *      groupId: // value for 'groupId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUnlinkJiraTicketMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkJiraTicketMutation, UnlinkJiraTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkJiraTicketMutation, UnlinkJiraTicketMutationVariables>(UnlinkJiraTicketDocument, options);
      }
export type UnlinkJiraTicketMutationHookResult = ReturnType<typeof useUnlinkJiraTicketMutation>;
export type UnlinkJiraTicketMutationResult = Apollo.MutationResult<UnlinkJiraTicketMutation>;
export type UnlinkJiraTicketMutationOptions = Apollo.BaseMutationOptions<UnlinkJiraTicketMutation, UnlinkJiraTicketMutationVariables>;
export const UnlinkLinearTicketDocument = gql`
    mutation UnlinkLinearTicket($externalTicketId: Int!, $groupId: BigInt!, $orgId: Int!) {
  unlinkLinearTicket(
    externalTicketId: $externalTicketId
    groupId: $groupId
    orgId: $orgId
  )
}
    `;
export type UnlinkLinearTicketMutationFn = Apollo.MutationFunction<UnlinkLinearTicketMutation, UnlinkLinearTicketMutationVariables>;

/**
 * __useUnlinkLinearTicketMutation__
 *
 * To run a mutation, you first call `useUnlinkLinearTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkLinearTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkLinearTicketMutation, { data, loading, error }] = useUnlinkLinearTicketMutation({
 *   variables: {
 *      externalTicketId: // value for 'externalTicketId'
 *      groupId: // value for 'groupId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUnlinkLinearTicketMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkLinearTicketMutation, UnlinkLinearTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkLinearTicketMutation, UnlinkLinearTicketMutationVariables>(UnlinkLinearTicketDocument, options);
      }
export type UnlinkLinearTicketMutationHookResult = ReturnType<typeof useUnlinkLinearTicketMutation>;
export type UnlinkLinearTicketMutationResult = Apollo.MutationResult<UnlinkLinearTicketMutation>;
export type UnlinkLinearTicketMutationOptions = Apollo.BaseMutationOptions<UnlinkLinearTicketMutation, UnlinkLinearTicketMutationVariables>;
export const UpdateBoardDescriptionDocument = gql`
    mutation UpdateBoardDescription($boardId: Int!, $description: String!, $teamId: Int!) {
  updateBoardDescription(
    boardId: $boardId
    description: $description
    teamId: $teamId
  ) {
    ...BoardLight
  }
}
    ${BoardLightFragmentDoc}`;
export type UpdateBoardDescriptionMutationFn = Apollo.MutationFunction<UpdateBoardDescriptionMutation, UpdateBoardDescriptionMutationVariables>;

/**
 * __useUpdateBoardDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateBoardDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardDescriptionMutation, { data, loading, error }] = useUpdateBoardDescriptionMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      description: // value for 'description'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useUpdateBoardDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBoardDescriptionMutation, UpdateBoardDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBoardDescriptionMutation, UpdateBoardDescriptionMutationVariables>(UpdateBoardDescriptionDocument, options);
      }
export type UpdateBoardDescriptionMutationHookResult = ReturnType<typeof useUpdateBoardDescriptionMutation>;
export type UpdateBoardDescriptionMutationResult = Apollo.MutationResult<UpdateBoardDescriptionMutation>;
export type UpdateBoardDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateBoardDescriptionMutation, UpdateBoardDescriptionMutationVariables>;
export const UpdateBoardFilterDocument = gql`
    mutation UpdateBoardFilter($boardId: Int!, $teamId: Int!, $filterInput: FilterInput) {
  updateBoardFilter(boardId: $boardId, teamId: $teamId, filterInput: $filterInput) {
    ...Board
  }
}
    ${BoardFragmentDoc}`;
export type UpdateBoardFilterMutationFn = Apollo.MutationFunction<UpdateBoardFilterMutation, UpdateBoardFilterMutationVariables>;

/**
 * __useUpdateBoardFilterMutation__
 *
 * To run a mutation, you first call `useUpdateBoardFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardFilterMutation, { data, loading, error }] = useUpdateBoardFilterMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useUpdateBoardFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBoardFilterMutation, UpdateBoardFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBoardFilterMutation, UpdateBoardFilterMutationVariables>(UpdateBoardFilterDocument, options);
      }
export type UpdateBoardFilterMutationHookResult = ReturnType<typeof useUpdateBoardFilterMutation>;
export type UpdateBoardFilterMutationResult = Apollo.MutationResult<UpdateBoardFilterMutation>;
export type UpdateBoardFilterMutationOptions = Apollo.BaseMutationOptions<UpdateBoardFilterMutation, UpdateBoardFilterMutationVariables>;
export const UpdateBoardFilterNodeDocument = gql`
    mutation UpdateBoardFilterNode($boardId: Int!, $filterNode: FilterNode!, $teamId: Int!) {
  updateBoardFilterNode(
    boardId: $boardId
    filterNode: $filterNode
    teamId: $teamId
  ) {
    id
  }
}
    `;
export type UpdateBoardFilterNodeMutationFn = Apollo.MutationFunction<UpdateBoardFilterNodeMutation, UpdateBoardFilterNodeMutationVariables>;

/**
 * __useUpdateBoardFilterNodeMutation__
 *
 * To run a mutation, you first call `useUpdateBoardFilterNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardFilterNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardFilterNodeMutation, { data, loading, error }] = useUpdateBoardFilterNodeMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      filterNode: // value for 'filterNode'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useUpdateBoardFilterNodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBoardFilterNodeMutation, UpdateBoardFilterNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBoardFilterNodeMutation, UpdateBoardFilterNodeMutationVariables>(UpdateBoardFilterNodeDocument, options);
      }
export type UpdateBoardFilterNodeMutationHookResult = ReturnType<typeof useUpdateBoardFilterNodeMutation>;
export type UpdateBoardFilterNodeMutationResult = Apollo.MutationResult<UpdateBoardFilterNodeMutation>;
export type UpdateBoardFilterNodeMutationOptions = Apollo.BaseMutationOptions<UpdateBoardFilterNodeMutation, UpdateBoardFilterNodeMutationVariables>;
export const UpdateBoardLayoutDocument = gql`
    mutation UpdateBoardLayout($boardId: Int!, $teamId: Int!, $widgets: [ExistingWidgetInput!]!) {
  updateBoardLayout(boardId: $boardId, teamId: $teamId, widgets: $widgets) {
    ...Board
  }
}
    ${BoardFragmentDoc}`;
export type UpdateBoardLayoutMutationFn = Apollo.MutationFunction<UpdateBoardLayoutMutation, UpdateBoardLayoutMutationVariables>;

/**
 * __useUpdateBoardLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateBoardLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardLayoutMutation, { data, loading, error }] = useUpdateBoardLayoutMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *      widgets: // value for 'widgets'
 *   },
 * });
 */
export function useUpdateBoardLayoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBoardLayoutMutation, UpdateBoardLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBoardLayoutMutation, UpdateBoardLayoutMutationVariables>(UpdateBoardLayoutDocument, options);
      }
export type UpdateBoardLayoutMutationHookResult = ReturnType<typeof useUpdateBoardLayoutMutation>;
export type UpdateBoardLayoutMutationResult = Apollo.MutationResult<UpdateBoardLayoutMutation>;
export type UpdateBoardLayoutMutationOptions = Apollo.BaseMutationOptions<UpdateBoardLayoutMutation, UpdateBoardLayoutMutationVariables>;
export const UpdateBoardTitleDocument = gql`
    mutation UpdateBoardTitle($boardId: Int!, $teamId: Int!, $title: String!) {
  updateBoardTitle(boardId: $boardId, teamId: $teamId, title: $title) {
    ...BoardLight
  }
}
    ${BoardLightFragmentDoc}`;
export type UpdateBoardTitleMutationFn = Apollo.MutationFunction<UpdateBoardTitleMutation, UpdateBoardTitleMutationVariables>;

/**
 * __useUpdateBoardTitleMutation__
 *
 * To run a mutation, you first call `useUpdateBoardTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardTitleMutation, { data, loading, error }] = useUpdateBoardTitleMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateBoardTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBoardTitleMutation, UpdateBoardTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBoardTitleMutation, UpdateBoardTitleMutationVariables>(UpdateBoardTitleDocument, options);
      }
export type UpdateBoardTitleMutationHookResult = ReturnType<typeof useUpdateBoardTitleMutation>;
export type UpdateBoardTitleMutationResult = Apollo.MutationResult<UpdateBoardTitleMutation>;
export type UpdateBoardTitleMutationOptions = Apollo.BaseMutationOptions<UpdateBoardTitleMutation, UpdateBoardTitleMutationVariables>;
export const UpdateCampaignTreatmentDocument = gql`
    mutation UpdateCampaignTreatment($campaignId: Int!, $status: campaign_status!) {
  updateCampaignTreatment(campaignId: $campaignId, status: $status) {
    ...Campaign
  }
}
    ${CampaignFragmentDoc}`;
export type UpdateCampaignTreatmentMutationFn = Apollo.MutationFunction<UpdateCampaignTreatmentMutation, UpdateCampaignTreatmentMutationVariables>;

/**
 * __useUpdateCampaignTreatmentMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignTreatmentMutation, { data, loading, error }] = useUpdateCampaignTreatmentMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCampaignTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignTreatmentMutation, UpdateCampaignTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignTreatmentMutation, UpdateCampaignTreatmentMutationVariables>(UpdateCampaignTreatmentDocument, options);
      }
export type UpdateCampaignTreatmentMutationHookResult = ReturnType<typeof useUpdateCampaignTreatmentMutation>;
export type UpdateCampaignTreatmentMutationResult = Apollo.MutationResult<UpdateCampaignTreatmentMutation>;
export type UpdateCampaignTreatmentMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignTreatmentMutation, UpdateCampaignTreatmentMutationVariables>;
export const UpdateDigestSeriesSendFrequencyDocument = gql`
    mutation UpdateDigestSeriesSendFrequency($digestSeriesId: Int!, $sendFrequency: DigestSendFrequency!) {
  updateDigestSeriesSendFrequency(
    id: $digestSeriesId
    sendFrequency: $sendFrequency
  ) {
    id
  }
}
    `;
export type UpdateDigestSeriesSendFrequencyMutationFn = Apollo.MutationFunction<UpdateDigestSeriesSendFrequencyMutation, UpdateDigestSeriesSendFrequencyMutationVariables>;

/**
 * __useUpdateDigestSeriesSendFrequencyMutation__
 *
 * To run a mutation, you first call `useUpdateDigestSeriesSendFrequencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigestSeriesSendFrequencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigestSeriesSendFrequencyMutation, { data, loading, error }] = useUpdateDigestSeriesSendFrequencyMutation({
 *   variables: {
 *      digestSeriesId: // value for 'digestSeriesId'
 *      sendFrequency: // value for 'sendFrequency'
 *   },
 * });
 */
export function useUpdateDigestSeriesSendFrequencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDigestSeriesSendFrequencyMutation, UpdateDigestSeriesSendFrequencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDigestSeriesSendFrequencyMutation, UpdateDigestSeriesSendFrequencyMutationVariables>(UpdateDigestSeriesSendFrequencyDocument, options);
      }
export type UpdateDigestSeriesSendFrequencyMutationHookResult = ReturnType<typeof useUpdateDigestSeriesSendFrequencyMutation>;
export type UpdateDigestSeriesSendFrequencyMutationResult = Apollo.MutationResult<UpdateDigestSeriesSendFrequencyMutation>;
export type UpdateDigestSeriesSendFrequencyMutationOptions = Apollo.BaseMutationOptions<UpdateDigestSeriesSendFrequencyMutation, UpdateDigestSeriesSendFrequencyMutationVariables>;
export const UpdateDomainDiscoveryDocument = gql`
    mutation UpdateDomainDiscovery($allowDiscovery: Boolean!, $orgDomainId: Int!, $orgId: Int!) {
  updateDomainDiscovery(
    allowDiscovery: $allowDiscovery
    orgDomainId: $orgDomainId
    orgId: $orgId
  ) {
    allowDiscovery
    domain
    id
  }
}
    `;
export type UpdateDomainDiscoveryMutationFn = Apollo.MutationFunction<UpdateDomainDiscoveryMutation, UpdateDomainDiscoveryMutationVariables>;

/**
 * __useUpdateDomainDiscoveryMutation__
 *
 * To run a mutation, you first call `useUpdateDomainDiscoveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainDiscoveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainDiscoveryMutation, { data, loading, error }] = useUpdateDomainDiscoveryMutation({
 *   variables: {
 *      allowDiscovery: // value for 'allowDiscovery'
 *      orgDomainId: // value for 'orgDomainId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUpdateDomainDiscoveryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDomainDiscoveryMutation, UpdateDomainDiscoveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainDiscoveryMutation, UpdateDomainDiscoveryMutationVariables>(UpdateDomainDiscoveryDocument, options);
      }
export type UpdateDomainDiscoveryMutationHookResult = ReturnType<typeof useUpdateDomainDiscoveryMutation>;
export type UpdateDomainDiscoveryMutationResult = Apollo.MutationResult<UpdateDomainDiscoveryMutation>;
export type UpdateDomainDiscoveryMutationOptions = Apollo.BaseMutationOptions<UpdateDomainDiscoveryMutation, UpdateDomainDiscoveryMutationVariables>;
export const UpdateGroupOwnerDocument = gql`
    mutation UpdateGroupOwner($groupId: BigInt!, $userId: Int!, $teamId: Int!, $orgId: Int!) {
  updateGroupOwner(
    groupId: $groupId
    userId: $userId
    teamId: $teamId
    orgId: $orgId
  ) {
    id
  }
}
    `;
export type UpdateGroupOwnerMutationFn = Apollo.MutationFunction<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>;

/**
 * __useUpdateGroupOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateGroupOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupOwnerMutation, { data, loading, error }] = useUpdateGroupOwnerMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      teamId: // value for 'teamId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUpdateGroupOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>(UpdateGroupOwnerDocument, options);
      }
export type UpdateGroupOwnerMutationHookResult = ReturnType<typeof useUpdateGroupOwnerMutation>;
export type UpdateGroupOwnerMutationResult = Apollo.MutationResult<UpdateGroupOwnerMutation>;
export type UpdateGroupOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>;
export const UpdateInsightDocument = gql`
    mutation UpdateInsight($entryIds: [BigInt!]!, $expirationDate: Date!, $feedbackStatus: digest_group_status!, $filterInput: FilterInput!, $insightId: Int!, $insightStatus: insight_status!, $text: String!, $title: String!, $chartBin: chart_bin_type!, $order: Int!, $excludeFromDigest: Boolean) {
  updateInsight(
    entryIds: $entryIds
    expirationDate: $expirationDate
    feedbackStatus: $feedbackStatus
    filterInput: $filterInput
    insightId: $insightId
    insightStatus: $insightStatus
    text: $text
    title: $title
    chartBin: $chartBin
    order: $order
    excludeFromDigest: $excludeFromDigest
  ) {
    ...InsightLight
  }
}
    ${InsightLightFragmentDoc}`;
export type UpdateInsightMutationFn = Apollo.MutationFunction<UpdateInsightMutation, UpdateInsightMutationVariables>;

/**
 * __useUpdateInsightMutation__
 *
 * To run a mutation, you first call `useUpdateInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightMutation, { data, loading, error }] = useUpdateInsightMutation({
 *   variables: {
 *      entryIds: // value for 'entryIds'
 *      expirationDate: // value for 'expirationDate'
 *      feedbackStatus: // value for 'feedbackStatus'
 *      filterInput: // value for 'filterInput'
 *      insightId: // value for 'insightId'
 *      insightStatus: // value for 'insightStatus'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      chartBin: // value for 'chartBin'
 *      order: // value for 'order'
 *      excludeFromDigest: // value for 'excludeFromDigest'
 *   },
 * });
 */
export function useUpdateInsightMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightMutation, UpdateInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightMutation, UpdateInsightMutationVariables>(UpdateInsightDocument, options);
      }
export type UpdateInsightMutationHookResult = ReturnType<typeof useUpdateInsightMutation>;
export type UpdateInsightMutationResult = Apollo.MutationResult<UpdateInsightMutation>;
export type UpdateInsightMutationOptions = Apollo.BaseMutationOptions<UpdateInsightMutation, UpdateInsightMutationVariables>;
export const UpdateOrganizationUserDocument = gql`
    mutation UpdateOrganizationUser($orgId: Int!, $userToUpdateEmail: String!, $assignedRoles: [AssignedRoles!]) {
  updateOrganizationUser(
    orgId: $orgId
    userToUpdateEmail: $userToUpdateEmail
    assignedRoles: $assignedRoles
  ) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      userToUpdateEmail: // value for 'userToUpdateEmail'
 *      assignedRoles: // value for 'assignedRoles'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>(UpdateOrganizationUserDocument, options);
      }
export type UpdateOrganizationUserMutationHookResult = ReturnType<typeof useUpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationResult = Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;
export const UpdateTeamDefaultsDocument = gql`
    mutation UpdateTeamDefaults($teamId: Int!, $exploreDefaultWindow: date_window, $startDate: Date, $endDate: Date, $customer_locked_out: Boolean, $lock_out_message: String) {
  updateTeamDefaults(
    teamId: $teamId
    exploreDefaultWindow: $exploreDefaultWindow
    startDate: $startDate
    endDate: $endDate
    customer_locked_out: $customer_locked_out
    lock_out_message: $lock_out_message
  ) {
    exploreDefaultWindow
    oldestFeedbackDate
    startDate
    endDate
    customer_locked_out
    lock_out_message
  }
}
    `;
export type UpdateTeamDefaultsMutationFn = Apollo.MutationFunction<UpdateTeamDefaultsMutation, UpdateTeamDefaultsMutationVariables>;

/**
 * __useUpdateTeamDefaultsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamDefaultsMutation, { data, loading, error }] = useUpdateTeamDefaultsMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      exploreDefaultWindow: // value for 'exploreDefaultWindow'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      customer_locked_out: // value for 'customer_locked_out'
 *      lock_out_message: // value for 'lock_out_message'
 *   },
 * });
 */
export function useUpdateTeamDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamDefaultsMutation, UpdateTeamDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamDefaultsMutation, UpdateTeamDefaultsMutationVariables>(UpdateTeamDefaultsDocument, options);
      }
export type UpdateTeamDefaultsMutationHookResult = ReturnType<typeof useUpdateTeamDefaultsMutation>;
export type UpdateTeamDefaultsMutationResult = Apollo.MutationResult<UpdateTeamDefaultsMutation>;
export type UpdateTeamDefaultsMutationOptions = Apollo.BaseMutationOptions<UpdateTeamDefaultsMutation, UpdateTeamDefaultsMutationVariables>;
export const UpdateAutoPopulateSgListDocument = gql`
    mutation UpdateAutoPopulateSGList($autoPopulateSgList: Boolean!, $updateAutoPopulateSgListId: Int!) {
  updateAutoPopulateSGList(
    autoPopulateSGList: $autoPopulateSgList
    id: $updateAutoPopulateSgListId
  ) {
    id
  }
}
    `;
export type UpdateAutoPopulateSgListMutationFn = Apollo.MutationFunction<UpdateAutoPopulateSgListMutation, UpdateAutoPopulateSgListMutationVariables>;

/**
 * __useUpdateAutoPopulateSgListMutation__
 *
 * To run a mutation, you first call `useUpdateAutoPopulateSgListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoPopulateSgListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoPopulateSgListMutation, { data, loading, error }] = useUpdateAutoPopulateSgListMutation({
 *   variables: {
 *      autoPopulateSgList: // value for 'autoPopulateSgList'
 *      updateAutoPopulateSgListId: // value for 'updateAutoPopulateSgListId'
 *   },
 * });
 */
export function useUpdateAutoPopulateSgListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutoPopulateSgListMutation, UpdateAutoPopulateSgListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutoPopulateSgListMutation, UpdateAutoPopulateSgListMutationVariables>(UpdateAutoPopulateSgListDocument, options);
      }
export type UpdateAutoPopulateSgListMutationHookResult = ReturnType<typeof useUpdateAutoPopulateSgListMutation>;
export type UpdateAutoPopulateSgListMutationResult = Apollo.MutationResult<UpdateAutoPopulateSgListMutation>;
export type UpdateAutoPopulateSgListMutationOptions = Apollo.BaseMutationOptions<UpdateAutoPopulateSgListMutation, UpdateAutoPopulateSgListMutationVariables>;
export const AddEmailToAlertDocument = gql`
    mutation AddEmailToAlert($alertId: Int!, $newEmail: String!, $teamId: Int!) {
  addEmailToAlert(alertId: $alertId, newEmail: $newEmail, teamId: $teamId) {
    alert_id
    id
    team_id
    to_email
  }
}
    `;
export type AddEmailToAlertMutationFn = Apollo.MutationFunction<AddEmailToAlertMutation, AddEmailToAlertMutationVariables>;

/**
 * __useAddEmailToAlertMutation__
 *
 * To run a mutation, you first call `useAddEmailToAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailToAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailToAlertMutation, { data, loading, error }] = useAddEmailToAlertMutation({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      newEmail: // value for 'newEmail'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useAddEmailToAlertMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailToAlertMutation, AddEmailToAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailToAlertMutation, AddEmailToAlertMutationVariables>(AddEmailToAlertDocument, options);
      }
export type AddEmailToAlertMutationHookResult = ReturnType<typeof useAddEmailToAlertMutation>;
export type AddEmailToAlertMutationResult = Apollo.MutationResult<AddEmailToAlertMutation>;
export type AddEmailToAlertMutationOptions = Apollo.BaseMutationOptions<AddEmailToAlertMutation, AddEmailToAlertMutationVariables>;
export const AmountOfEntriesDocument = gql`
    query AmountOfEntries($teamId: Int!, $teamUuid: String, $repliableOnly: Boolean, $filterStatement: FilterNode, $filterInput: FilterInput) {
  amountOfEntries(
    teamId: $teamId
    teamUuid: $teamUuid
    repliableOnly: $repliableOnly
    filterStatement: $filterStatement
    filterInput: $filterInput
  ) {
    amount
  }
}
    `;

/**
 * __useAmountOfEntriesQuery__
 *
 * To run a query within a React component, call `useAmountOfEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmountOfEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmountOfEntriesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      teamUuid: // value for 'teamUuid'
 *      repliableOnly: // value for 'repliableOnly'
 *      filterStatement: // value for 'filterStatement'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useAmountOfEntriesQuery(baseOptions: Apollo.QueryHookOptions<AmountOfEntriesQuery, AmountOfEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmountOfEntriesQuery, AmountOfEntriesQueryVariables>(AmountOfEntriesDocument, options);
      }
export function useAmountOfEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmountOfEntriesQuery, AmountOfEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmountOfEntriesQuery, AmountOfEntriesQueryVariables>(AmountOfEntriesDocument, options);
        }
export type AmountOfEntriesQueryHookResult = ReturnType<typeof useAmountOfEntriesQuery>;
export type AmountOfEntriesLazyQueryHookResult = ReturnType<typeof useAmountOfEntriesLazyQuery>;
export type AmountOfEntriesQueryResult = Apollo.QueryResult<AmountOfEntriesQuery, AmountOfEntriesQueryVariables>;
export const AmountOfGroupsDocument = gql`
    query AmountOfGroups($teamId: Int!, $status: group_status, $type: group_type, $filterInput: FilterInput, $filterStatement: FilterNode) {
  amountOfGroups(
    teamId: $teamId
    status: $status
    type: $type
    filterInput: $filterInput
    filterStatement: $filterStatement
  ) {
    amount
  }
}
    `;

/**
 * __useAmountOfGroupsQuery__
 *
 * To run a query within a React component, call `useAmountOfGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmountOfGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmountOfGroupsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      filterInput: // value for 'filterInput'
 *      filterStatement: // value for 'filterStatement'
 *   },
 * });
 */
export function useAmountOfGroupsQuery(baseOptions: Apollo.QueryHookOptions<AmountOfGroupsQuery, AmountOfGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmountOfGroupsQuery, AmountOfGroupsQueryVariables>(AmountOfGroupsDocument, options);
      }
export function useAmountOfGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmountOfGroupsQuery, AmountOfGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmountOfGroupsQuery, AmountOfGroupsQueryVariables>(AmountOfGroupsDocument, options);
        }
export type AmountOfGroupsQueryHookResult = ReturnType<typeof useAmountOfGroupsQuery>;
export type AmountOfGroupsLazyQueryHookResult = ReturnType<typeof useAmountOfGroupsLazyQuery>;
export type AmountOfGroupsQueryResult = Apollo.QueryResult<AmountOfGroupsQuery, AmountOfGroupsQueryVariables>;
export const GetAnnouncementEmailsDocument = gql`
    query GetAnnouncementEmails($teamId: Int!, $groupId: BigInt!) {
  getAnnouncementEmails(teamId: $teamId, groupId: $groupId) {
    ...Announcement
  }
}
    ${AnnouncementFragmentDoc}`;

/**
 * __useGetAnnouncementEmailsQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementEmailsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetAnnouncementEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementEmailsQuery, GetAnnouncementEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementEmailsQuery, GetAnnouncementEmailsQueryVariables>(GetAnnouncementEmailsDocument, options);
      }
export function useGetAnnouncementEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementEmailsQuery, GetAnnouncementEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementEmailsQuery, GetAnnouncementEmailsQueryVariables>(GetAnnouncementEmailsDocument, options);
        }
export type GetAnnouncementEmailsQueryHookResult = ReturnType<typeof useGetAnnouncementEmailsQuery>;
export type GetAnnouncementEmailsLazyQueryHookResult = ReturnType<typeof useGetAnnouncementEmailsLazyQuery>;
export type GetAnnouncementEmailsQueryResult = Apollo.QueryResult<GetAnnouncementEmailsQuery, GetAnnouncementEmailsQueryVariables>;
export const ConnectionsDocument = gql`
    query Connections($orgId: Int!) {
  connections {
    id
    title
    description
    logoUrl
    authUrl
    orgConnection(orgId: $orgId) {
      id
      connected_name
    }
  }
}
    `;

/**
 * __useConnectionsQuery__
 *
 * To run a query within a React component, call `useConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
      }
export function useConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export type ConnectionsQueryHookResult = ReturnType<typeof useConnectionsQuery>;
export type ConnectionsLazyQueryHookResult = ReturnType<typeof useConnectionsLazyQuery>;
export type ConnectionsQueryResult = Apollo.QueryResult<ConnectionsQuery, ConnectionsQueryVariables>;
export const DataForFiltersDocument = gql`
    query DataForFilters($teamId: Int!, $orgId: Int!) {
  segments(teamId: $teamId) {
    id
    displayName
    distinctValues
  }
  getAllGroups(teamId: $teamId) {
    id
    title
    status
    type
  }
  sources(teamId: $teamId)
  getTags(teamId: $teamId) {
    id
    name
  }
  getOrganizationUsers(orgId: $orgId) {
    email
    confirmed
    user {
      id
    }
  }
}
    `;

/**
 * __useDataForFiltersQuery__
 *
 * To run a query within a React component, call `useDataForFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataForFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataForFiltersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDataForFiltersQuery(baseOptions: Apollo.QueryHookOptions<DataForFiltersQuery, DataForFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataForFiltersQuery, DataForFiltersQueryVariables>(DataForFiltersDocument, options);
      }
export function useDataForFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataForFiltersQuery, DataForFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataForFiltersQuery, DataForFiltersQueryVariables>(DataForFiltersDocument, options);
        }
export type DataForFiltersQueryHookResult = ReturnType<typeof useDataForFiltersQuery>;
export type DataForFiltersLazyQueryHookResult = ReturnType<typeof useDataForFiltersLazyQuery>;
export type DataForFiltersQueryResult = Apollo.QueryResult<DataForFiltersQuery, DataForFiltersQueryVariables>;
export const DiscoverOrgsDocument = gql`
    query DiscoverOrgs {
  discoverOrgs {
    id
    name
  }
}
    `;

/**
 * __useDiscoverOrgsQuery__
 *
 * To run a query within a React component, call `useDiscoverOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscoverOrgsQuery(baseOptions?: Apollo.QueryHookOptions<DiscoverOrgsQuery, DiscoverOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverOrgsQuery, DiscoverOrgsQueryVariables>(DiscoverOrgsDocument, options);
      }
export function useDiscoverOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverOrgsQuery, DiscoverOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverOrgsQuery, DiscoverOrgsQueryVariables>(DiscoverOrgsDocument, options);
        }
export type DiscoverOrgsQueryHookResult = ReturnType<typeof useDiscoverOrgsQuery>;
export type DiscoverOrgsLazyQueryHookResult = ReturnType<typeof useDiscoverOrgsLazyQuery>;
export type DiscoverOrgsQueryResult = Apollo.QueryResult<DiscoverOrgsQuery, DiscoverOrgsQueryVariables>;
export const EmailExistsDocument = gql`
    query EmailExists($email: String!) {
  emailExists(email: $email)
}
    `;

/**
 * __useEmailExistsQuery__
 *
 * To run a query within a React component, call `useEmailExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailExistsQuery(baseOptions: Apollo.QueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailExistsQuery, EmailExistsQueryVariables>(EmailExistsDocument, options);
      }
export function useEmailExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailExistsQuery, EmailExistsQueryVariables>(EmailExistsDocument, options);
        }
export type EmailExistsQueryHookResult = ReturnType<typeof useEmailExistsQuery>;
export type EmailExistsLazyQueryHookResult = ReturnType<typeof useEmailExistsLazyQuery>;
export type EmailExistsQueryResult = Apollo.QueryResult<EmailExistsQuery, EmailExistsQueryVariables>;
export const FeedbackEntriesDocument = gql`
    query FeedbackEntries($teamId: Int!, $take: Int, $skip: Int, $filterInput: FilterInput, $repliableOnly: Boolean, $filterStatement: FilterNode) {
  entries(
    teamId: $teamId
    take: $take
    skip: $skip
    filterInput: $filterInput
    repliableOnly: $repliableOnly
    filterStatement: $filterStatement
  ) {
    ...Entry
  }
}
    ${EntryFragmentDoc}`;

/**
 * __useFeedbackEntriesQuery__
 *
 * To run a query within a React component, call `useFeedbackEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackEntriesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filterInput: // value for 'filterInput'
 *      repliableOnly: // value for 'repliableOnly'
 *      filterStatement: // value for 'filterStatement'
 *   },
 * });
 */
export function useFeedbackEntriesQuery(baseOptions: Apollo.QueryHookOptions<FeedbackEntriesQuery, FeedbackEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackEntriesQuery, FeedbackEntriesQueryVariables>(FeedbackEntriesDocument, options);
      }
export function useFeedbackEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackEntriesQuery, FeedbackEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackEntriesQuery, FeedbackEntriesQueryVariables>(FeedbackEntriesDocument, options);
        }
export type FeedbackEntriesQueryHookResult = ReturnType<typeof useFeedbackEntriesQuery>;
export type FeedbackEntriesLazyQueryHookResult = ReturnType<typeof useFeedbackEntriesLazyQuery>;
export type FeedbackEntriesQueryResult = Apollo.QueryResult<FeedbackEntriesQuery, FeedbackEntriesQueryVariables>;
export const FeedbackEntriesByTimeDocument = gql`
    query FeedbackEntriesByTime($teamId: Int!, $filterInput: FilterInput, $teamUuid: String) {
  feedbackEntriesByTime(
    teamId: $teamId
    filterInput: $filterInput
    teamUuid: $teamUuid
  ) {
    totalEntries
    entries {
      count
      date
    }
  }
}
    `;

/**
 * __useFeedbackEntriesByTimeQuery__
 *
 * To run a query within a React component, call `useFeedbackEntriesByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackEntriesByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackEntriesByTimeQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      teamUuid: // value for 'teamUuid'
 *   },
 * });
 */
export function useFeedbackEntriesByTimeQuery(baseOptions: Apollo.QueryHookOptions<FeedbackEntriesByTimeQuery, FeedbackEntriesByTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackEntriesByTimeQuery, FeedbackEntriesByTimeQueryVariables>(FeedbackEntriesByTimeDocument, options);
      }
export function useFeedbackEntriesByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackEntriesByTimeQuery, FeedbackEntriesByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackEntriesByTimeQuery, FeedbackEntriesByTimeQueryVariables>(FeedbackEntriesByTimeDocument, options);
        }
export type FeedbackEntriesByTimeQueryHookResult = ReturnType<typeof useFeedbackEntriesByTimeQuery>;
export type FeedbackEntriesByTimeLazyQueryHookResult = ReturnType<typeof useFeedbackEntriesByTimeLazyQuery>;
export type FeedbackEntriesByTimeQueryResult = Apollo.QueryResult<FeedbackEntriesByTimeQuery, FeedbackEntriesByTimeQueryVariables>;
export const GetFeedbackIntegrationsDocument = gql`
    query GetFeedbackIntegrations($teamId: Int!, $integrationTypeId: Int, $integrationId: Int) {
  feedbackIntegration(
    teamId: $teamId
    integrationTypeId: $integrationTypeId
    integrationId: $integrationId
  ) {
    ...FeedbackIntegration
  }
}
    ${FeedbackIntegrationFragmentDoc}`;

/**
 * __useGetFeedbackIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackIntegrationsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      integrationTypeId: // value for 'integrationTypeId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetFeedbackIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackIntegrationsQuery, GetFeedbackIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackIntegrationsQuery, GetFeedbackIntegrationsQueryVariables>(GetFeedbackIntegrationsDocument, options);
      }
export function useGetFeedbackIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackIntegrationsQuery, GetFeedbackIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackIntegrationsQuery, GetFeedbackIntegrationsQueryVariables>(GetFeedbackIntegrationsDocument, options);
        }
export type GetFeedbackIntegrationsQueryHookResult = ReturnType<typeof useGetFeedbackIntegrationsQuery>;
export type GetFeedbackIntegrationsLazyQueryHookResult = ReturnType<typeof useGetFeedbackIntegrationsLazyQuery>;
export type GetFeedbackIntegrationsQueryResult = Apollo.QueryResult<GetFeedbackIntegrationsQuery, GetFeedbackIntegrationsQueryVariables>;
export const FeedbackSentencesDocument = gql`
    query FeedbackSentences($teamId: Int!, $take: Int, $skip: Int, $sortByClusterId: BigInt, $unclusteredSentences: Boolean, $filterInput: FilterInput) {
  sentences(
    teamId: $teamId
    take: $take
    skip: $skip
    sortByClusterId: $sortByClusterId
    unclusteredSentences: $unclusteredSentences
    filterInput: $filterInput
  ) {
    ...SentenceEntry
  }
}
    ${SentenceEntryFragmentDoc}`;

/**
 * __useFeedbackSentencesQuery__
 *
 * To run a query within a React component, call `useFeedbackSentencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackSentencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackSentencesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      sortByClusterId: // value for 'sortByClusterId'
 *      unclusteredSentences: // value for 'unclusteredSentences'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useFeedbackSentencesQuery(baseOptions: Apollo.QueryHookOptions<FeedbackSentencesQuery, FeedbackSentencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackSentencesQuery, FeedbackSentencesQueryVariables>(FeedbackSentencesDocument, options);
      }
export function useFeedbackSentencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackSentencesQuery, FeedbackSentencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackSentencesQuery, FeedbackSentencesQueryVariables>(FeedbackSentencesDocument, options);
        }
export type FeedbackSentencesQueryHookResult = ReturnType<typeof useFeedbackSentencesQuery>;
export type FeedbackSentencesLazyQueryHookResult = ReturnType<typeof useFeedbackSentencesLazyQuery>;
export type FeedbackSentencesQueryResult = Apollo.QueryResult<FeedbackSentencesQuery, FeedbackSentencesQueryVariables>;
export const GenerateGptRepliesDocument = gql`
    query GenerateGptReplies($gptRepliesInput: [GptRepliesInput!]!, $teamId: Int!) {
  generateGptReplies(gptRepliesInput: $gptRepliesInput, teamId: $teamId) {
    entryId
    generatedText
    success
  }
}
    `;

/**
 * __useGenerateGptRepliesQuery__
 *
 * To run a query within a React component, call `useGenerateGptRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateGptRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateGptRepliesQuery({
 *   variables: {
 *      gptRepliesInput: // value for 'gptRepliesInput'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGenerateGptRepliesQuery(baseOptions: Apollo.QueryHookOptions<GenerateGptRepliesQuery, GenerateGptRepliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateGptRepliesQuery, GenerateGptRepliesQueryVariables>(GenerateGptRepliesDocument, options);
      }
export function useGenerateGptRepliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateGptRepliesQuery, GenerateGptRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateGptRepliesQuery, GenerateGptRepliesQueryVariables>(GenerateGptRepliesDocument, options);
        }
export type GenerateGptRepliesQueryHookResult = ReturnType<typeof useGenerateGptRepliesQuery>;
export type GenerateGptRepliesLazyQueryHookResult = ReturnType<typeof useGenerateGptRepliesLazyQuery>;
export type GenerateGptRepliesQueryResult = Apollo.QueryResult<GenerateGptRepliesQuery, GenerateGptRepliesQueryVariables>;
export const AccessControlListDocument = gql`
    query AccessControlList($domains: [DomainInput!]!) {
  accessControlList(domains: $domains) {
    actions
    resource
  }
}
    `;

/**
 * __useAccessControlListQuery__
 *
 * To run a query within a React component, call `useAccessControlListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessControlListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessControlListQuery({
 *   variables: {
 *      domains: // value for 'domains'
 *   },
 * });
 */
export function useAccessControlListQuery(baseOptions: Apollo.QueryHookOptions<AccessControlListQuery, AccessControlListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessControlListQuery, AccessControlListQueryVariables>(AccessControlListDocument, options);
      }
export function useAccessControlListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessControlListQuery, AccessControlListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessControlListQuery, AccessControlListQueryVariables>(AccessControlListDocument, options);
        }
export type AccessControlListQueryHookResult = ReturnType<typeof useAccessControlListQuery>;
export type AccessControlListLazyQueryHookResult = ReturnType<typeof useAccessControlListLazyQuery>;
export type AccessControlListQueryResult = Apollo.QueryResult<AccessControlListQuery, AccessControlListQueryVariables>;
export const GetActiveInsightsForTeamDocument = gql`
    query GetActiveInsightsForTeam($teamId: Int!) {
  getActiveInsightsForTeam(teamId: $teamId) {
    ...InsightNoSources
  }
}
    ${InsightNoSourcesFragmentDoc}`;

/**
 * __useGetActiveInsightsForTeamQuery__
 *
 * To run a query within a React component, call `useGetActiveInsightsForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveInsightsForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveInsightsForTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetActiveInsightsForTeamQuery(baseOptions: Apollo.QueryHookOptions<GetActiveInsightsForTeamQuery, GetActiveInsightsForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveInsightsForTeamQuery, GetActiveInsightsForTeamQueryVariables>(GetActiveInsightsForTeamDocument, options);
      }
export function useGetActiveInsightsForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveInsightsForTeamQuery, GetActiveInsightsForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveInsightsForTeamQuery, GetActiveInsightsForTeamQueryVariables>(GetActiveInsightsForTeamDocument, options);
        }
export type GetActiveInsightsForTeamQueryHookResult = ReturnType<typeof useGetActiveInsightsForTeamQuery>;
export type GetActiveInsightsForTeamLazyQueryHookResult = ReturnType<typeof useGetActiveInsightsForTeamLazyQuery>;
export type GetActiveInsightsForTeamQueryResult = Apollo.QueryResult<GetActiveInsightsForTeamQuery, GetActiveInsightsForTeamQueryVariables>;
export const GetAlertDocument = gql`
    query GetAlert($alertId: Int!, $teamId: Int!) {
  getAlert(alertId: $alertId, teamId: $teamId) {
    ...AlertData
  }
}
    ${AlertDataFragmentDoc}`;

/**
 * __useGetAlertQuery__
 *
 * To run a query within a React component, call `useGetAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetAlertQuery(baseOptions: Apollo.QueryHookOptions<GetAlertQuery, GetAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertQuery, GetAlertQueryVariables>(GetAlertDocument, options);
      }
export function useGetAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertQuery, GetAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertQuery, GetAlertQueryVariables>(GetAlertDocument, options);
        }
export type GetAlertQueryHookResult = ReturnType<typeof useGetAlertQuery>;
export type GetAlertLazyQueryHookResult = ReturnType<typeof useGetAlertLazyQuery>;
export type GetAlertQueryResult = Apollo.QueryResult<GetAlertQuery, GetAlertQueryVariables>;
export const GetAlertsDocument = gql`
    query GetAlerts($teamId: Int!, $type: AlertType) {
  getAlerts(teamId: $teamId, type: $type) {
    ...AlertData
  }
}
    ${AlertDataFragmentDoc}`;

/**
 * __useGetAlertsQuery__
 *
 * To run a query within a React component, call `useGetAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAlertsQuery(baseOptions: Apollo.QueryHookOptions<GetAlertsQuery, GetAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertsQuery, GetAlertsQueryVariables>(GetAlertsDocument, options);
      }
export function useGetAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertsQuery, GetAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertsQuery, GetAlertsQueryVariables>(GetAlertsDocument, options);
        }
export type GetAlertsQueryHookResult = ReturnType<typeof useGetAlertsQuery>;
export type GetAlertsLazyQueryHookResult = ReturnType<typeof useGetAlertsLazyQuery>;
export type GetAlertsQueryResult = Apollo.QueryResult<GetAlertsQuery, GetAlertsQueryVariables>;
export const GetAllOrganizationsDocument = gql`
    query GetAllOrganizations {
  allOrganizations {
    id
    name
  }
}
    `;

/**
 * __useGetAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(GetAllOrganizationsDocument, options);
      }
export function useGetAllOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(GetAllOrganizationsDocument, options);
        }
export type GetAllOrganizationsQueryHookResult = ReturnType<typeof useGetAllOrganizationsQuery>;
export type GetAllOrganizationsLazyQueryHookResult = ReturnType<typeof useGetAllOrganizationsLazyQuery>;
export type GetAllOrganizationsQueryResult = Apollo.QueryResult<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>;
export const GetAnnouncementTemplateDocument = gql`
    query GetAnnouncementTemplate($teamId: Int!) {
  getAnnouncementTemplate(teamId: $teamId)
}
    `;

/**
 * __useGetAnnouncementTemplateQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementTemplateQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetAnnouncementTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementTemplateQuery, GetAnnouncementTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementTemplateQuery, GetAnnouncementTemplateQueryVariables>(GetAnnouncementTemplateDocument, options);
      }
export function useGetAnnouncementTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementTemplateQuery, GetAnnouncementTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementTemplateQuery, GetAnnouncementTemplateQueryVariables>(GetAnnouncementTemplateDocument, options);
        }
export type GetAnnouncementTemplateQueryHookResult = ReturnType<typeof useGetAnnouncementTemplateQuery>;
export type GetAnnouncementTemplateLazyQueryHookResult = ReturnType<typeof useGetAnnouncementTemplateLazyQuery>;
export type GetAnnouncementTemplateQueryResult = Apollo.QueryResult<GetAnnouncementTemplateQuery, GetAnnouncementTemplateQueryVariables>;
export const GetAsanaProjectsDocument = gql`
    query GetAsanaProjects($orgId: Int!, $queryString: String!, $workspaceId: String!) {
  getAsanaProjects(
    orgId: $orgId
    queryString: $queryString
    workspaceId: $workspaceId
  ) {
    name
    providerUniqueId
  }
}
    `;

/**
 * __useGetAsanaProjectsQuery__
 *
 * To run a query within a React component, call `useGetAsanaProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsanaProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsanaProjectsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      queryString: // value for 'queryString'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAsanaProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetAsanaProjectsQuery, GetAsanaProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAsanaProjectsQuery, GetAsanaProjectsQueryVariables>(GetAsanaProjectsDocument, options);
      }
export function useGetAsanaProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAsanaProjectsQuery, GetAsanaProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAsanaProjectsQuery, GetAsanaProjectsQueryVariables>(GetAsanaProjectsDocument, options);
        }
export type GetAsanaProjectsQueryHookResult = ReturnType<typeof useGetAsanaProjectsQuery>;
export type GetAsanaProjectsLazyQueryHookResult = ReturnType<typeof useGetAsanaProjectsLazyQuery>;
export type GetAsanaProjectsQueryResult = Apollo.QueryResult<GetAsanaProjectsQuery, GetAsanaProjectsQueryVariables>;
export const GetAsanaTicketsDocument = gql`
    query GetAsanaTickets($orgId: Int!, $queryString: String!, $workspaceId: String!, $projectId: String!) {
  getAsanaTickets(
    orgId: $orgId
    queryString: $queryString
    workspaceId: $workspaceId
    projectId: $projectId
  ) {
    assignee
    dueDate
    name
    providerUniqueId
    sourcePermalink
    closedDate
    status
  }
}
    `;

/**
 * __useGetAsanaTicketsQuery__
 *
 * To run a query within a React component, call `useGetAsanaTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsanaTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsanaTicketsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      queryString: // value for 'queryString'
 *      workspaceId: // value for 'workspaceId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAsanaTicketsQuery(baseOptions: Apollo.QueryHookOptions<GetAsanaTicketsQuery, GetAsanaTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAsanaTicketsQuery, GetAsanaTicketsQueryVariables>(GetAsanaTicketsDocument, options);
      }
export function useGetAsanaTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAsanaTicketsQuery, GetAsanaTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAsanaTicketsQuery, GetAsanaTicketsQueryVariables>(GetAsanaTicketsDocument, options);
        }
export type GetAsanaTicketsQueryHookResult = ReturnType<typeof useGetAsanaTicketsQuery>;
export type GetAsanaTicketsLazyQueryHookResult = ReturnType<typeof useGetAsanaTicketsLazyQuery>;
export type GetAsanaTicketsQueryResult = Apollo.QueryResult<GetAsanaTicketsQuery, GetAsanaTicketsQueryVariables>;
export const GetAsanaWorkspacesDocument = gql`
    query GetAsanaWorkspaces($orgId: Int!, $queryString: String!) {
  getAsanaWorkspaces(orgId: $orgId, queryString: $queryString) {
    name
    providerUniqueId
  }
}
    `;

/**
 * __useGetAsanaWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetAsanaWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsanaWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsanaWorkspacesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useGetAsanaWorkspacesQuery(baseOptions: Apollo.QueryHookOptions<GetAsanaWorkspacesQuery, GetAsanaWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAsanaWorkspacesQuery, GetAsanaWorkspacesQueryVariables>(GetAsanaWorkspacesDocument, options);
      }
export function useGetAsanaWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAsanaWorkspacesQuery, GetAsanaWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAsanaWorkspacesQuery, GetAsanaWorkspacesQueryVariables>(GetAsanaWorkspacesDocument, options);
        }
export type GetAsanaWorkspacesQueryHookResult = ReturnType<typeof useGetAsanaWorkspacesQuery>;
export type GetAsanaWorkspacesLazyQueryHookResult = ReturnType<typeof useGetAsanaWorkspacesLazyQuery>;
export type GetAsanaWorkspacesQueryResult = Apollo.QueryResult<GetAsanaWorkspacesQuery, GetAsanaWorkspacesQueryVariables>;
export const GetBoardDocument = gql`
    query GetBoard($boardId: Int!, $teamId: Int!) {
  getBoard(boardId: $boardId, teamId: $teamId) {
    ...Board
  }
}
    ${BoardFragmentDoc}`;

/**
 * __useGetBoardQuery__
 *
 * To run a query within a React component, call `useGetBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetBoardQuery(baseOptions: Apollo.QueryHookOptions<GetBoardQuery, GetBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBoardQuery, GetBoardQueryVariables>(GetBoardDocument, options);
      }
export function useGetBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBoardQuery, GetBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBoardQuery, GetBoardQueryVariables>(GetBoardDocument, options);
        }
export type GetBoardQueryHookResult = ReturnType<typeof useGetBoardQuery>;
export type GetBoardLazyQueryHookResult = ReturnType<typeof useGetBoardLazyQuery>;
export type GetBoardQueryResult = Apollo.QueryResult<GetBoardQuery, GetBoardQueryVariables>;
export const GetBoardsDocument = gql`
    query GetBoards($teamId: Int!, $titleSubstring: String) {
  getBoards(teamId: $teamId, titleSubstring: $titleSubstring) {
    ...BoardLight
  }
}
    ${BoardLightFragmentDoc}`;

/**
 * __useGetBoardsQuery__
 *
 * To run a query within a React component, call `useGetBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      titleSubstring: // value for 'titleSubstring'
 *   },
 * });
 */
export function useGetBoardsQuery(baseOptions: Apollo.QueryHookOptions<GetBoardsQuery, GetBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBoardsQuery, GetBoardsQueryVariables>(GetBoardsDocument, options);
      }
export function useGetBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBoardsQuery, GetBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBoardsQuery, GetBoardsQueryVariables>(GetBoardsDocument, options);
        }
export type GetBoardsQueryHookResult = ReturnType<typeof useGetBoardsQuery>;
export type GetBoardsLazyQueryHookResult = ReturnType<typeof useGetBoardsLazyQuery>;
export type GetBoardsQueryResult = Apollo.QueryResult<GetBoardsQuery, GetBoardsQueryVariables>;
export const GetCampaignDocument = gql`
    query GetCampaign($pageName: String!) {
  getCampaign(pageName: $pageName) {
    ...Campaign
  }
}
    ${CampaignFragmentDoc}`;

/**
 * __useGetCampaignQuery__
 *
 * To run a query within a React component, call `useGetCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQuery({
 *   variables: {
 *      pageName: // value for 'pageName'
 *   },
 * });
 */
export function useGetCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
      }
export function useGetCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export type GetCampaignQueryHookResult = ReturnType<typeof useGetCampaignQuery>;
export type GetCampaignLazyQueryHookResult = ReturnType<typeof useGetCampaignLazyQuery>;
export type GetCampaignQueryResult = Apollo.QueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export const GetChangelogDataDocument = gql`
    query GetChangelogData($teamId: Int!) {
  getChangelogs(teamId: $teamId) {
    ...Changelog
  }
}
    ${ChangelogFragmentDoc}`;

/**
 * __useGetChangelogDataQuery__
 *
 * To run a query within a React component, call `useGetChangelogDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangelogDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangelogDataQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetChangelogDataQuery(baseOptions: Apollo.QueryHookOptions<GetChangelogDataQuery, GetChangelogDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChangelogDataQuery, GetChangelogDataQueryVariables>(GetChangelogDataDocument, options);
      }
export function useGetChangelogDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChangelogDataQuery, GetChangelogDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChangelogDataQuery, GetChangelogDataQueryVariables>(GetChangelogDataDocument, options);
        }
export type GetChangelogDataQueryHookResult = ReturnType<typeof useGetChangelogDataQuery>;
export type GetChangelogDataLazyQueryHookResult = ReturnType<typeof useGetChangelogDataLazyQuery>;
export type GetChangelogDataQueryResult = Apollo.QueryResult<GetChangelogDataQuery, GetChangelogDataQueryVariables>;
export const GetChart2DPreviewDocument = gql`
    query GetChart2DPreview($editChartInput: EditChartInput!, $teamId: Int!, $filterInput: FilterInput, $chartBinType: chart_bin_type) {
  getChart2DPreview(
    editChartInput: $editChartInput
    teamId: $teamId
    filterInput: $filterInput
    chartBinType: $chartBinType
  ) {
    ...Chart2D
  }
}
    ${Chart2DFragmentDoc}`;

/**
 * __useGetChart2DPreviewQuery__
 *
 * To run a query within a React component, call `useGetChart2DPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChart2DPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChart2DPreviewQuery({
 *   variables: {
 *      editChartInput: // value for 'editChartInput'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      chartBinType: // value for 'chartBinType'
 *   },
 * });
 */
export function useGetChart2DPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetChart2DPreviewQuery, GetChart2DPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChart2DPreviewQuery, GetChart2DPreviewQueryVariables>(GetChart2DPreviewDocument, options);
      }
export function useGetChart2DPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChart2DPreviewQuery, GetChart2DPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChart2DPreviewQuery, GetChart2DPreviewQueryVariables>(GetChart2DPreviewDocument, options);
        }
export type GetChart2DPreviewQueryHookResult = ReturnType<typeof useGetChart2DPreviewQuery>;
export type GetChart2DPreviewLazyQueryHookResult = ReturnType<typeof useGetChart2DPreviewLazyQuery>;
export type GetChart2DPreviewQueryResult = Apollo.QueryResult<GetChart2DPreviewQuery, GetChart2DPreviewQueryVariables>;
export const GetChartPreviewDocument = gql`
    query GetChartPreview($editChartInput: EditChartInput!, $teamId: Int!, $filterInput: FilterInput, $chartBinType: chart_bin_type) {
  getChartPreview(
    editChartInput: $editChartInput
    teamId: $teamId
    filterInput: $filterInput
    chartBinType: $chartBinType
  ) {
    ...Chart
  }
}
    ${ChartFragmentDoc}`;

/**
 * __useGetChartPreviewQuery__
 *
 * To run a query within a React component, call `useGetChartPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartPreviewQuery({
 *   variables: {
 *      editChartInput: // value for 'editChartInput'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      chartBinType: // value for 'chartBinType'
 *   },
 * });
 */
export function useGetChartPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetChartPreviewQuery, GetChartPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartPreviewQuery, GetChartPreviewQueryVariables>(GetChartPreviewDocument, options);
      }
export function useGetChartPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartPreviewQuery, GetChartPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartPreviewQuery, GetChartPreviewQueryVariables>(GetChartPreviewDocument, options);
        }
export type GetChartPreviewQueryHookResult = ReturnType<typeof useGetChartPreviewQuery>;
export type GetChartPreviewLazyQueryHookResult = ReturnType<typeof useGetChartPreviewLazyQuery>;
export type GetChartPreviewQueryResult = Apollo.QueryResult<GetChartPreviewQuery, GetChartPreviewQueryVariables>;
export const GetChildCandidatesDocument = gql`
    query GetChildCandidates($teamId: Int!, $parentGroupId: BigInt!, $groupTitleSearchString: String, $take: Int, $skip: Int) {
  getChildCandidates(
    teamId: $teamId
    parentGroupId: $parentGroupId
    groupTitleSearchString: $groupTitleSearchString
    take: $take
    skip: $skip
  ) {
    ...GroupTaxonomy
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useGetChildCandidatesQuery__
 *
 * To run a query within a React component, call `useGetChildCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildCandidatesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      parentGroupId: // value for 'parentGroupId'
 *      groupTitleSearchString: // value for 'groupTitleSearchString'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetChildCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GetChildCandidatesQuery, GetChildCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildCandidatesQuery, GetChildCandidatesQueryVariables>(GetChildCandidatesDocument, options);
      }
export function useGetChildCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildCandidatesQuery, GetChildCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildCandidatesQuery, GetChildCandidatesQueryVariables>(GetChildCandidatesDocument, options);
        }
export type GetChildCandidatesQueryHookResult = ReturnType<typeof useGetChildCandidatesQuery>;
export type GetChildCandidatesLazyQueryHookResult = ReturnType<typeof useGetChildCandidatesLazyQuery>;
export type GetChildCandidatesQueryResult = Apollo.QueryResult<GetChildCandidatesQuery, GetChildCandidatesQueryVariables>;
export const GetChildrenDocument = gql`
    query GetChildren($teamId: Int!, $filterInput: FilterInput!, $parentGroupId: BigInt!) {
  getChildren(
    teamId: $teamId
    filterInput: $filterInput
    parentGroupId: $parentGroupId
  ) {
    ...GroupTaxonomy
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useGetChildrenQuery__
 *
 * To run a query within a React component, call `useGetChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildrenQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      parentGroupId: // value for 'parentGroupId'
 *   },
 * });
 */
export function useGetChildrenQuery(baseOptions: Apollo.QueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, options);
      }
export function useGetChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, options);
        }
export type GetChildrenQueryHookResult = ReturnType<typeof useGetChildrenQuery>;
export type GetChildrenLazyQueryHookResult = ReturnType<typeof useGetChildrenLazyQuery>;
export type GetChildrenQueryResult = Apollo.QueryResult<GetChildrenQuery, GetChildrenQueryVariables>;
export const GetChildrenLightDocument = gql`
    query GetChildrenLight($parentGroupId: BigInt!, $teamId: Int!) {
  getChildrenLight(parentGroupId: $parentGroupId, teamId: $teamId) {
    id
    title
    teamId
    type
    status
  }
}
    `;

/**
 * __useGetChildrenLightQuery__
 *
 * To run a query within a React component, call `useGetChildrenLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildrenLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildrenLightQuery({
 *   variables: {
 *      parentGroupId: // value for 'parentGroupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetChildrenLightQuery(baseOptions: Apollo.QueryHookOptions<GetChildrenLightQuery, GetChildrenLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildrenLightQuery, GetChildrenLightQueryVariables>(GetChildrenLightDocument, options);
      }
export function useGetChildrenLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildrenLightQuery, GetChildrenLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildrenLightQuery, GetChildrenLightQueryVariables>(GetChildrenLightDocument, options);
        }
export type GetChildrenLightQueryHookResult = ReturnType<typeof useGetChildrenLightQuery>;
export type GetChildrenLightLazyQueryHookResult = ReturnType<typeof useGetChildrenLightLazyQuery>;
export type GetChildrenLightQueryResult = Apollo.QueryResult<GetChildrenLightQuery, GetChildrenLightQueryVariables>;
export const GetChildrenToAssignDocument = gql`
    query GetChildrenToAssign($groupId: BigInt!, $teamId: Int!, $filterInput: FilterInput) {
  getChildrenToAssign(
    groupId: $groupId
    teamId: $teamId
    filterInput: $filterInput
  ) {
    ...GroupTaxonomy
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useGetChildrenToAssignQuery__
 *
 * To run a query within a React component, call `useGetChildrenToAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildrenToAssignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildrenToAssignQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetChildrenToAssignQuery(baseOptions: Apollo.QueryHookOptions<GetChildrenToAssignQuery, GetChildrenToAssignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildrenToAssignQuery, GetChildrenToAssignQueryVariables>(GetChildrenToAssignDocument, options);
      }
export function useGetChildrenToAssignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildrenToAssignQuery, GetChildrenToAssignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildrenToAssignQuery, GetChildrenToAssignQueryVariables>(GetChildrenToAssignDocument, options);
        }
export type GetChildrenToAssignQueryHookResult = ReturnType<typeof useGetChildrenToAssignQuery>;
export type GetChildrenToAssignLazyQueryHookResult = ReturnType<typeof useGetChildrenToAssignLazyQuery>;
export type GetChildrenToAssignQueryResult = Apollo.QueryResult<GetChildrenToAssignQuery, GetChildrenToAssignQueryVariables>;
export const GetGroupEmailsDocument = gql`
    query GetGroupEmails($groupId: BigInt!, $teamId: Int!, $filterInput: FilterInput) {
  getGroupEmails(groupId: $groupId, teamId: $teamId, filterInput: $filterInput) {
    entryText
    userEmail
  }
}
    `;

/**
 * __useGetGroupEmailsQuery__
 *
 * To run a query within a React component, call `useGetGroupEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupEmailsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetGroupEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupEmailsQuery, GetGroupEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupEmailsQuery, GetGroupEmailsQueryVariables>(GetGroupEmailsDocument, options);
      }
export function useGetGroupEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupEmailsQuery, GetGroupEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupEmailsQuery, GetGroupEmailsQueryVariables>(GetGroupEmailsDocument, options);
        }
export type GetGroupEmailsQueryHookResult = ReturnType<typeof useGetGroupEmailsQuery>;
export type GetGroupEmailsLazyQueryHookResult = ReturnType<typeof useGetGroupEmailsLazyQuery>;
export type GetGroupEmailsQueryResult = Apollo.QueryResult<GetGroupEmailsQuery, GetGroupEmailsQueryVariables>;
export const GetCustomChartDocument = gql`
    query GetCustomChart($chartId: Int!, $teamId: Int!, $chartBinType: chart_bin_type, $filterInput: FilterInput) {
  getChart(
    chartId: $chartId
    teamId: $teamId
    chartBinType: $chartBinType
    filterInput: $filterInput
  ) {
    ...Chart
  }
}
    ${ChartFragmentDoc}`;

/**
 * __useGetCustomChartQuery__
 *
 * To run a query within a React component, call `useGetCustomChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomChartQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      teamId: // value for 'teamId'
 *      chartBinType: // value for 'chartBinType'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetCustomChartQuery(baseOptions: Apollo.QueryHookOptions<GetCustomChartQuery, GetCustomChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomChartQuery, GetCustomChartQueryVariables>(GetCustomChartDocument, options);
      }
export function useGetCustomChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomChartQuery, GetCustomChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomChartQuery, GetCustomChartQueryVariables>(GetCustomChartDocument, options);
        }
export type GetCustomChartQueryHookResult = ReturnType<typeof useGetCustomChartQuery>;
export type GetCustomChartLazyQueryHookResult = ReturnType<typeof useGetCustomChartLazyQuery>;
export type GetCustomChartQueryResult = Apollo.QueryResult<GetCustomChartQuery, GetCustomChartQueryVariables>;
export const GetCustomChart2DDocument = gql`
    query GetCustomChart2D($chartId: Int!, $teamId: Int!, $chartBinType: chart_bin_type, $filterInput: FilterInput) {
  getChart2D(
    chartId: $chartId
    teamId: $teamId
    chartBinType: $chartBinType
    filterInput: $filterInput
  ) {
    ...Chart2D
  }
}
    ${Chart2DFragmentDoc}`;

/**
 * __useGetCustomChart2DQuery__
 *
 * To run a query within a React component, call `useGetCustomChart2DQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomChart2DQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomChart2DQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      teamId: // value for 'teamId'
 *      chartBinType: // value for 'chartBinType'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetCustomChart2DQuery(baseOptions: Apollo.QueryHookOptions<GetCustomChart2DQuery, GetCustomChart2DQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomChart2DQuery, GetCustomChart2DQueryVariables>(GetCustomChart2DDocument, options);
      }
export function useGetCustomChart2DLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomChart2DQuery, GetCustomChart2DQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomChart2DQuery, GetCustomChart2DQueryVariables>(GetCustomChart2DDocument, options);
        }
export type GetCustomChart2DQueryHookResult = ReturnType<typeof useGetCustomChart2DQuery>;
export type GetCustomChart2DLazyQueryHookResult = ReturnType<typeof useGetCustomChart2DLazyQuery>;
export type GetCustomChart2DQueryResult = Apollo.QueryResult<GetCustomChart2DQuery, GetCustomChart2DQueryVariables>;
export const GetCustomChartsDocument = gql`
    query GetCustomCharts($teamId: Int!, $take: Int, $skip: Int, $filterInput: FilterInput, $chartBinType: chart_bin_type) {
  getCharts(
    teamId: $teamId
    take: $take
    skip: $skip
    filterInput: $filterInput
    chartBinType: $chartBinType
  ) {
    ...Chart
  }
}
    ${ChartFragmentDoc}`;

/**
 * __useGetCustomChartsQuery__
 *
 * To run a query within a React component, call `useGetCustomChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomChartsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filterInput: // value for 'filterInput'
 *      chartBinType: // value for 'chartBinType'
 *   },
 * });
 */
export function useGetCustomChartsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomChartsQuery, GetCustomChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomChartsQuery, GetCustomChartsQueryVariables>(GetCustomChartsDocument, options);
      }
export function useGetCustomChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomChartsQuery, GetCustomChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomChartsQuery, GetCustomChartsQueryVariables>(GetCustomChartsDocument, options);
        }
export type GetCustomChartsQueryHookResult = ReturnType<typeof useGetCustomChartsQuery>;
export type GetCustomChartsLazyQueryHookResult = ReturnType<typeof useGetCustomChartsLazyQuery>;
export type GetCustomChartsQueryResult = Apollo.QueryResult<GetCustomChartsQuery, GetCustomChartsQueryVariables>;
export const GetDashboardAlertsDocument = gql`
    query GetDashboardAlerts($teamId: Int!) {
  getDashboardAlerts(teamId: $teamId) {
    id
    message
  }
}
    `;

/**
 * __useGetDashboardAlertsQuery__
 *
 * To run a query within a React component, call `useGetDashboardAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardAlertsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetDashboardAlertsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardAlertsQuery, GetDashboardAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardAlertsQuery, GetDashboardAlertsQueryVariables>(GetDashboardAlertsDocument, options);
      }
export function useGetDashboardAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardAlertsQuery, GetDashboardAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardAlertsQuery, GetDashboardAlertsQueryVariables>(GetDashboardAlertsDocument, options);
        }
export type GetDashboardAlertsQueryHookResult = ReturnType<typeof useGetDashboardAlertsQuery>;
export type GetDashboardAlertsLazyQueryHookResult = ReturnType<typeof useGetDashboardAlertsLazyQuery>;
export type GetDashboardAlertsQueryResult = Apollo.QueryResult<GetDashboardAlertsQuery, GetDashboardAlertsQueryVariables>;
export const GetDigestSeriesDocument = gql`
    query GetDigestSeries {
  digestSeries {
    ...DigestSeriesData
  }
}
    ${DigestSeriesDataFragmentDoc}`;

/**
 * __useGetDigestSeriesQuery__
 *
 * To run a query within a React component, call `useGetDigestSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigestSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigestSeriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDigestSeriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDigestSeriesQuery, GetDigestSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigestSeriesQuery, GetDigestSeriesQueryVariables>(GetDigestSeriesDocument, options);
      }
export function useGetDigestSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigestSeriesQuery, GetDigestSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigestSeriesQuery, GetDigestSeriesQueryVariables>(GetDigestSeriesDocument, options);
        }
export type GetDigestSeriesQueryHookResult = ReturnType<typeof useGetDigestSeriesQuery>;
export type GetDigestSeriesLazyQueryHookResult = ReturnType<typeof useGetDigestSeriesLazyQuery>;
export type GetDigestSeriesQueryResult = Apollo.QueryResult<GetDigestSeriesQuery, GetDigestSeriesQueryVariables>;
export const GetDigestSeriesChannelsDocument = gql`
    query GetDigestSeriesChannels($seriesId: Int!) {
  digestSeriesChannels(seriesId: $seriesId) {
    id
    subChannelName
    subChannelType
  }
}
    `;

/**
 * __useGetDigestSeriesChannelsQuery__
 *
 * To run a query within a React component, call `useGetDigestSeriesChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigestSeriesChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigestSeriesChannelsQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useGetDigestSeriesChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetDigestSeriesChannelsQuery, GetDigestSeriesChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigestSeriesChannelsQuery, GetDigestSeriesChannelsQueryVariables>(GetDigestSeriesChannelsDocument, options);
      }
export function useGetDigestSeriesChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigestSeriesChannelsQuery, GetDigestSeriesChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigestSeriesChannelsQuery, GetDigestSeriesChannelsQueryVariables>(GetDigestSeriesChannelsDocument, options);
        }
export type GetDigestSeriesChannelsQueryHookResult = ReturnType<typeof useGetDigestSeriesChannelsQuery>;
export type GetDigestSeriesChannelsLazyQueryHookResult = ReturnType<typeof useGetDigestSeriesChannelsLazyQuery>;
export type GetDigestSeriesChannelsQueryResult = Apollo.QueryResult<GetDigestSeriesChannelsQuery, GetDigestSeriesChannelsQueryVariables>;
export const GetDigestSeriesTeamDocument = gql`
    query GetDigestSeriesTeam($seriesId: Int!) {
  digestSeriesTeam(seriesId: $seriesId) {
    id
    team_id
  }
}
    `;

/**
 * __useGetDigestSeriesTeamQuery__
 *
 * To run a query within a React component, call `useGetDigestSeriesTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigestSeriesTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigestSeriesTeamQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useGetDigestSeriesTeamQuery(baseOptions: Apollo.QueryHookOptions<GetDigestSeriesTeamQuery, GetDigestSeriesTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigestSeriesTeamQuery, GetDigestSeriesTeamQueryVariables>(GetDigestSeriesTeamDocument, options);
      }
export function useGetDigestSeriesTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigestSeriesTeamQuery, GetDigestSeriesTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigestSeriesTeamQuery, GetDigestSeriesTeamQueryVariables>(GetDigestSeriesTeamDocument, options);
        }
export type GetDigestSeriesTeamQueryHookResult = ReturnType<typeof useGetDigestSeriesTeamQuery>;
export type GetDigestSeriesTeamLazyQueryHookResult = ReturnType<typeof useGetDigestSeriesTeamLazyQuery>;
export type GetDigestSeriesTeamQueryResult = Apollo.QueryResult<GetDigestSeriesTeamQuery, GetDigestSeriesTeamQueryVariables>;
export const GetDigestsDocument = gql`
    query GetDigests {
  digests {
    ...DigestData
  }
}
    ${DigestDataFragmentDoc}`;

/**
 * __useGetDigestsQuery__
 *
 * To run a query within a React component, call `useGetDigestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDigestsQuery(baseOptions?: Apollo.QueryHookOptions<GetDigestsQuery, GetDigestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigestsQuery, GetDigestsQueryVariables>(GetDigestsDocument, options);
      }
export function useGetDigestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigestsQuery, GetDigestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigestsQuery, GetDigestsQueryVariables>(GetDigestsDocument, options);
        }
export type GetDigestsQueryHookResult = ReturnType<typeof useGetDigestsQuery>;
export type GetDigestsLazyQueryHookResult = ReturnType<typeof useGetDigestsLazyQuery>;
export type GetDigestsQueryResult = Apollo.QueryResult<GetDigestsQuery, GetDigestsQueryVariables>;
export const GetDigestsForActiveTeamDocument = gql`
    query GetDigestsForActiveTeam($teamId: Int!) {
  getActiveDigestsForTeam(teamId: $teamId) {
    ...DigestData
  }
}
    ${DigestDataFragmentDoc}`;

/**
 * __useGetDigestsForActiveTeamQuery__
 *
 * To run a query within a React component, call `useGetDigestsForActiveTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigestsForActiveTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigestsForActiveTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetDigestsForActiveTeamQuery(baseOptions: Apollo.QueryHookOptions<GetDigestsForActiveTeamQuery, GetDigestsForActiveTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigestsForActiveTeamQuery, GetDigestsForActiveTeamQueryVariables>(GetDigestsForActiveTeamDocument, options);
      }
export function useGetDigestsForActiveTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigestsForActiveTeamQuery, GetDigestsForActiveTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigestsForActiveTeamQuery, GetDigestsForActiveTeamQueryVariables>(GetDigestsForActiveTeamDocument, options);
        }
export type GetDigestsForActiveTeamQueryHookResult = ReturnType<typeof useGetDigestsForActiveTeamQuery>;
export type GetDigestsForActiveTeamLazyQueryHookResult = ReturnType<typeof useGetDigestsForActiveTeamLazyQuery>;
export type GetDigestsForActiveTeamQueryResult = Apollo.QueryResult<GetDigestsForActiveTeamQuery, GetDigestsForActiveTeamQueryVariables>;
export const GetEarliestFeedbackDateDocument = gql`
    query GetEarliestFeedbackDate($teamId: Int!) {
  earliestFeedbackDate(teamId: $teamId)
}
    `;

/**
 * __useGetEarliestFeedbackDateQuery__
 *
 * To run a query within a React component, call `useGetEarliestFeedbackDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestFeedbackDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestFeedbackDateQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetEarliestFeedbackDateQuery(baseOptions: Apollo.QueryHookOptions<GetEarliestFeedbackDateQuery, GetEarliestFeedbackDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEarliestFeedbackDateQuery, GetEarliestFeedbackDateQueryVariables>(GetEarliestFeedbackDateDocument, options);
      }
export function useGetEarliestFeedbackDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEarliestFeedbackDateQuery, GetEarliestFeedbackDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEarliestFeedbackDateQuery, GetEarliestFeedbackDateQueryVariables>(GetEarliestFeedbackDateDocument, options);
        }
export type GetEarliestFeedbackDateQueryHookResult = ReturnType<typeof useGetEarliestFeedbackDateQuery>;
export type GetEarliestFeedbackDateLazyQueryHookResult = ReturnType<typeof useGetEarliestFeedbackDateLazyQuery>;
export type GetEarliestFeedbackDateQueryResult = Apollo.QueryResult<GetEarliestFeedbackDateQuery, GetEarliestFeedbackDateQueryVariables>;
export const GetFilterFieldDisplayDocument = gql`
    query GetFilterFieldDisplay($fieldName: String!, $filterValue: String!, $teamId: Int!) {
  getFilterFieldDisplay(
    fieldName: $fieldName
    filterValue: $filterValue
    teamId: $teamId
  ) {
    displayName
    values {
      displayName
      filterValue
    }
  }
}
    `;

/**
 * __useGetFilterFieldDisplayQuery__
 *
 * To run a query within a React component, call `useGetFilterFieldDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterFieldDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterFieldDisplayQuery({
 *   variables: {
 *      fieldName: // value for 'fieldName'
 *      filterValue: // value for 'filterValue'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetFilterFieldDisplayQuery(baseOptions: Apollo.QueryHookOptions<GetFilterFieldDisplayQuery, GetFilterFieldDisplayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterFieldDisplayQuery, GetFilterFieldDisplayQueryVariables>(GetFilterFieldDisplayDocument, options);
      }
export function useGetFilterFieldDisplayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterFieldDisplayQuery, GetFilterFieldDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterFieldDisplayQuery, GetFilterFieldDisplayQueryVariables>(GetFilterFieldDisplayDocument, options);
        }
export type GetFilterFieldDisplayQueryHookResult = ReturnType<typeof useGetFilterFieldDisplayQuery>;
export type GetFilterFieldDisplayLazyQueryHookResult = ReturnType<typeof useGetFilterFieldDisplayLazyQuery>;
export type GetFilterFieldDisplayQueryResult = Apollo.QueryResult<GetFilterFieldDisplayQuery, GetFilterFieldDisplayQueryVariables>;
export const GetFilterFieldValuesDocument = gql`
    query GetFilterFieldValues($fieldName: String!, $skip: Int!, $take: Int!, $teamId: Int!, $fieldStatementFilters: FilterNode!) {
  getFilterFieldValues(
    fieldName: $fieldName
    skip: $skip
    take: $take
    teamId: $teamId
    fieldStatementFilters: $fieldStatementFilters
  ) {
    displayName
    filterValue
  }
}
    `;

/**
 * __useGetFilterFieldValuesQuery__
 *
 * To run a query within a React component, call `useGetFilterFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterFieldValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterFieldValuesQuery({
 *   variables: {
 *      fieldName: // value for 'fieldName'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      teamId: // value for 'teamId'
 *      fieldStatementFilters: // value for 'fieldStatementFilters'
 *   },
 * });
 */
export function useGetFilterFieldValuesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterFieldValuesQuery, GetFilterFieldValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterFieldValuesQuery, GetFilterFieldValuesQueryVariables>(GetFilterFieldValuesDocument, options);
      }
export function useGetFilterFieldValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterFieldValuesQuery, GetFilterFieldValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterFieldValuesQuery, GetFilterFieldValuesQueryVariables>(GetFilterFieldValuesDocument, options);
        }
export type GetFilterFieldValuesQueryHookResult = ReturnType<typeof useGetFilterFieldValuesQuery>;
export type GetFilterFieldValuesLazyQueryHookResult = ReturnType<typeof useGetFilterFieldValuesLazyQuery>;
export type GetFilterFieldValuesQueryResult = Apollo.QueryResult<GetFilterFieldValuesQuery, GetFilterFieldValuesQueryVariables>;
export const GetFilterFieldsDocument = gql`
    query GetFilterFields($teamId: Int!, $fieldStatementFilters: FilterNode!) {
  getFilterFields(teamId: $teamId, fieldStatementFilters: $fieldStatementFilters) {
    allowedOperators
    displayName
    fieldName
    hasValues
    hasOverLapWithExistingFilters
    additionalMetaData
  }
}
    `;

/**
 * __useGetFilterFieldsQuery__
 *
 * To run a query within a React component, call `useGetFilterFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterFieldsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      fieldStatementFilters: // value for 'fieldStatementFilters'
 *   },
 * });
 */
export function useGetFilterFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetFilterFieldsQuery, GetFilterFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterFieldsQuery, GetFilterFieldsQueryVariables>(GetFilterFieldsDocument, options);
      }
export function useGetFilterFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterFieldsQuery, GetFilterFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterFieldsQuery, GetFilterFieldsQueryVariables>(GetFilterFieldsDocument, options);
        }
export type GetFilterFieldsQueryHookResult = ReturnType<typeof useGetFilterFieldsQuery>;
export type GetFilterFieldsLazyQueryHookResult = ReturnType<typeof useGetFilterFieldsLazyQuery>;
export type GetFilterFieldsQueryResult = Apollo.QueryResult<GetFilterFieldsQuery, GetFilterFieldsQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($groupId: BigInt!, $teamId: Int!, $filterInput: FilterInput, $filterStatement: FilterNode, $belongs: Boolean, $teamUuid: String, $sentencesTake: Int, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  getGroup(
    groupId: $groupId
    teamId: $teamId
    filterInput: $filterInput
    filterStatement: $filterStatement
    belongs: $belongs
    teamUuid: $teamUuid
  ) {
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      filterStatement: // value for 'filterStatement'
 *      belongs: // value for 'belongs'
 *      teamUuid: // value for 'teamUuid'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const GetGroupForExportDocument = gql`
    query GetGroupForExport($groupId: BigInt!, $teamId: Int!, $filterInput: FilterInput!, $belongs: Boolean, $teamUuid: String, $sentencesTake: Int, $sentencesSkip: Int) {
  getGroup(
    groupId: $groupId
    teamId: $teamId
    filterInput: $filterInput
    belongs: $belongs
    teamUuid: $teamUuid
  ) {
    id
    title
    groupEntries(entriesTake: $sentencesTake, entriesSkip: $sentencesSkip) {
      ...GroupEntry
    }
    children {
      id
      title
      groupEntries(entriesTake: $sentencesTake, entriesSkip: $sentencesSkip) {
        ...GroupEntry
      }
      children {
        id
        title
        groupEntries(entriesTake: $sentencesTake, entriesSkip: $sentencesSkip) {
          ...GroupEntry
        }
        children {
          id
          title
          groupEntries(entriesTake: $sentencesTake, entriesSkip: $sentencesSkip) {
            ...GroupEntry
          }
        }
      }
    }
  }
}
    ${GroupEntryFragmentDoc}`;

/**
 * __useGetGroupForExportQuery__
 *
 * To run a query within a React component, call `useGetGroupForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupForExportQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      belongs: // value for 'belongs'
 *      teamUuid: // value for 'teamUuid'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *   },
 * });
 */
export function useGetGroupForExportQuery(baseOptions: Apollo.QueryHookOptions<GetGroupForExportQuery, GetGroupForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupForExportQuery, GetGroupForExportQueryVariables>(GetGroupForExportDocument, options);
      }
export function useGetGroupForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupForExportQuery, GetGroupForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupForExportQuery, GetGroupForExportQueryVariables>(GetGroupForExportDocument, options);
        }
export type GetGroupForExportQueryHookResult = ReturnType<typeof useGetGroupForExportQuery>;
export type GetGroupForExportLazyQueryHookResult = ReturnType<typeof useGetGroupForExportLazyQuery>;
export type GetGroupForExportQueryResult = Apollo.QueryResult<GetGroupForExportQuery, GetGroupForExportQueryVariables>;
export const GetGroupByIdDocument = gql`
    query GetGroupById($groupId: BigInt!, $teamId: Int!, $filterStatement: FilterNode) {
  getGroup(groupId: $groupId, teamId: $teamId, filterStatement: $filterStatement) {
    id
    title
    summary
    isPinnedByUser
    uniqueEntries
    tags {
      id
      name
    }
    createdAt
    creator {
      isUnwrapGenerated
      user {
        email
      }
    }
  }
}
    `;

/**
 * __useGetGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupByIdQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterStatement: // value for 'filterStatement'
 *   },
 * });
 */
export function useGetGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
      }
export function useGetGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
        }
export type GetGroupByIdQueryHookResult = ReturnType<typeof useGetGroupByIdQuery>;
export type GetGroupByIdLazyQueryHookResult = ReturnType<typeof useGetGroupByIdLazyQuery>;
export type GetGroupByIdQueryResult = Apollo.QueryResult<GetGroupByIdQuery, GetGroupByIdQueryVariables>;
export const GetGroupPlotDocument = gql`
    query GetGroupPlot($pageLevelFilterNode: FilterNode!, $plotConfigurationInput: PlotConfig!, $teamId: Int!, $denominatorFilterOverride: FilterNode) {
  getPlotPreview(
    pageLevelFilterNode: $pageLevelFilterNode
    plotConfigurationInput: $plotConfigurationInput
    teamId: $teamId
    denominatorFilterOverride: $denominatorFilterOverride
  ) {
    ...GroupPlot
  }
}
    ${GroupPlotFragmentDoc}`;

/**
 * __useGetGroupPlotQuery__
 *
 * To run a query within a React component, call `useGetGroupPlotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupPlotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupPlotQuery({
 *   variables: {
 *      pageLevelFilterNode: // value for 'pageLevelFilterNode'
 *      plotConfigurationInput: // value for 'plotConfigurationInput'
 *      teamId: // value for 'teamId'
 *      denominatorFilterOverride: // value for 'denominatorFilterOverride'
 *   },
 * });
 */
export function useGetGroupPlotQuery(baseOptions: Apollo.QueryHookOptions<GetGroupPlotQuery, GetGroupPlotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupPlotQuery, GetGroupPlotQueryVariables>(GetGroupPlotDocument, options);
      }
export function useGetGroupPlotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupPlotQuery, GetGroupPlotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupPlotQuery, GetGroupPlotQueryVariables>(GetGroupPlotDocument, options);
        }
export type GetGroupPlotQueryHookResult = ReturnType<typeof useGetGroupPlotQuery>;
export type GetGroupPlotLazyQueryHookResult = ReturnType<typeof useGetGroupPlotLazyQuery>;
export type GetGroupPlotQueryResult = Apollo.QueryResult<GetGroupPlotQuery, GetGroupPlotQueryVariables>;
export const GetGroupSentencesDocument = gql`
    query GetGroupSentences($groupId: BigInt!, $teamId: Int!, $filterInput: FilterInput, $belongs: Boolean, $teamUuid: String, $sentencesTake: Int, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  getGroup(
    groupId: $groupId
    teamId: $teamId
    filterInput: $filterInput
    belongs: $belongs
    teamUuid: $teamUuid
  ) {
    groupEntries(
      entriesTake: $sentencesTake
      entriesSkip: $sentencesSkip
      includeDescendantsOnMappings: $includeDescendantsOnMappings
    ) {
      ...GroupEntry
    }
  }
}
    ${GroupEntryFragmentDoc}`;

/**
 * __useGetGroupSentencesQuery__
 *
 * To run a query within a React component, call `useGetGroupSentencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupSentencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupSentencesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      belongs: // value for 'belongs'
 *      teamUuid: // value for 'teamUuid'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useGetGroupSentencesQuery(baseOptions: Apollo.QueryHookOptions<GetGroupSentencesQuery, GetGroupSentencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupSentencesQuery, GetGroupSentencesQueryVariables>(GetGroupSentencesDocument, options);
      }
export function useGetGroupSentencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupSentencesQuery, GetGroupSentencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupSentencesQuery, GetGroupSentencesQueryVariables>(GetGroupSentencesDocument, options);
        }
export type GetGroupSentencesQueryHookResult = ReturnType<typeof useGetGroupSentencesQuery>;
export type GetGroupSentencesLazyQueryHookResult = ReturnType<typeof useGetGroupSentencesLazyQuery>;
export type GetGroupSentencesQueryResult = Apollo.QueryResult<GetGroupSentencesQuery, GetGroupSentencesQueryVariables>;
export const GetGroupStatusDocument = gql`
    query GetGroupStatus($groupId: BigInt!, $teamId: Int!, $teamUuid: String) {
  getGroup(groupId: $groupId, teamId: $teamId, teamUuid: $teamUuid) {
    processing
    progress
  }
}
    `;

/**
 * __useGetGroupStatusQuery__
 *
 * To run a query within a React component, call `useGetGroupStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupStatusQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      teamUuid: // value for 'teamUuid'
 *   },
 * });
 */
export function useGetGroupStatusQuery(baseOptions: Apollo.QueryHookOptions<GetGroupStatusQuery, GetGroupStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupStatusQuery, GetGroupStatusQueryVariables>(GetGroupStatusDocument, options);
      }
export function useGetGroupStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupStatusQuery, GetGroupStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupStatusQuery, GetGroupStatusQueryVariables>(GetGroupStatusDocument, options);
        }
export type GetGroupStatusQueryHookResult = ReturnType<typeof useGetGroupStatusQuery>;
export type GetGroupStatusLazyQueryHookResult = ReturnType<typeof useGetGroupStatusLazyQuery>;
export type GetGroupStatusQueryResult = Apollo.QueryResult<GetGroupStatusQuery, GetGroupStatusQueryVariables>;
export const GetGroupsDocument = gql`
    query GetGroups($teamId: Int!, $belongs: Boolean, $filterInput: FilterInput!, $sentencesTake: Int, $status: group_status, $take: Int, $skip: Int, $teamUuid: String, $sortField: SortFieldType, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  getGroups(
    teamId: $teamId
    belongs: $belongs
    status: $status
    take: $take
    skip: $skip
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
  ) {
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      sentencesTake: // value for 'sentencesTake'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      teamUuid: // value for 'teamUuid'
 *      sortField: // value for 'sortField'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupsLightDocument = gql`
    query GetGroupsLight($teamId: Int!, $status: group_status, $type: group_type) {
  getAllGroups(teamId: $teamId, status: $status, type: $type) {
    ...GroupLight
  }
}
    ${GroupLightFragmentDoc}`;

/**
 * __useGetGroupsLightQuery__
 *
 * To run a query within a React component, call `useGetGroupsLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsLightQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetGroupsLightQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsLightQuery, GetGroupsLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsLightQuery, GetGroupsLightQueryVariables>(GetGroupsLightDocument, options);
      }
export function useGetGroupsLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsLightQuery, GetGroupsLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsLightQuery, GetGroupsLightQueryVariables>(GetGroupsLightDocument, options);
        }
export type GetGroupsLightQueryHookResult = ReturnType<typeof useGetGroupsLightQuery>;
export type GetGroupsLightLazyQueryHookResult = ReturnType<typeof useGetGroupsLightLazyQuery>;
export type GetGroupsLightQueryResult = Apollo.QueryResult<GetGroupsLightQuery, GetGroupsLightQueryVariables>;
export const GetGroupsLightTaxonomyDocument = gql`
    query GetGroupsLightTaxonomy($teamId: Int!, $status: group_status, $type: group_type) {
  getAllGroups(teamId: $teamId, status: $status, type: $type) {
    id
    title
    status
    type
    teamId
    totalDescendants
  }
}
    `;

/**
 * __useGetGroupsLightTaxonomyQuery__
 *
 * To run a query within a React component, call `useGetGroupsLightTaxonomyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsLightTaxonomyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsLightTaxonomyQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetGroupsLightTaxonomyQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsLightTaxonomyQuery, GetGroupsLightTaxonomyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsLightTaxonomyQuery, GetGroupsLightTaxonomyQueryVariables>(GetGroupsLightTaxonomyDocument, options);
      }
export function useGetGroupsLightTaxonomyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsLightTaxonomyQuery, GetGroupsLightTaxonomyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsLightTaxonomyQuery, GetGroupsLightTaxonomyQueryVariables>(GetGroupsLightTaxonomyDocument, options);
        }
export type GetGroupsLightTaxonomyQueryHookResult = ReturnType<typeof useGetGroupsLightTaxonomyQuery>;
export type GetGroupsLightTaxonomyLazyQueryHookResult = ReturnType<typeof useGetGroupsLightTaxonomyLazyQuery>;
export type GetGroupsLightTaxonomyQueryResult = Apollo.QueryResult<GetGroupsLightTaxonomyQuery, GetGroupsLightTaxonomyQueryVariables>;
export const GetInsightByCollectionDocument = gql`
    query GetInsightByCollection($collectionId: BigInt!, $collectionType: insight_collection_type!, $digestId: Int!) {
  getInsightByCollection(
    collectionId: $collectionId
    collectionType: $collectionType
    digestId: $digestId
  ) {
    ...InsightLight
  }
}
    ${InsightLightFragmentDoc}`;

/**
 * __useGetInsightByCollectionQuery__
 *
 * To run a query within a React component, call `useGetInsightByCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightByCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightByCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      collectionType: // value for 'collectionType'
 *      digestId: // value for 'digestId'
 *   },
 * });
 */
export function useGetInsightByCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetInsightByCollectionQuery, GetInsightByCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightByCollectionQuery, GetInsightByCollectionQueryVariables>(GetInsightByCollectionDocument, options);
      }
export function useGetInsightByCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightByCollectionQuery, GetInsightByCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightByCollectionQuery, GetInsightByCollectionQueryVariables>(GetInsightByCollectionDocument, options);
        }
export type GetInsightByCollectionQueryHookResult = ReturnType<typeof useGetInsightByCollectionQuery>;
export type GetInsightByCollectionLazyQueryHookResult = ReturnType<typeof useGetInsightByCollectionLazyQuery>;
export type GetInsightByCollectionQueryResult = Apollo.QueryResult<GetInsightByCollectionQuery, GetInsightByCollectionQueryVariables>;
export const GetInsightGroupsDocument = gql`
    query GetInsightGroups($teamId: Int!, $belongs: Boolean, $filterInput: FilterInput!, $sentencesTake: Int, $status: group_status, $take: Int, $teamUuid: String, $sortField: SortFieldType, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  getGroups(
    teamId: $teamId
    belongs: $belongs
    status: $status
    take: $take
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
    getInsights: true
  ) {
    isNew
    ...GroupData
    insight {
      ...GroupInsight
    }
  }
}
    ${GroupDataFragmentDoc}
${GroupInsightFragmentDoc}`;

/**
 * __useGetInsightGroupsQuery__
 *
 * To run a query within a React component, call `useGetInsightGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightGroupsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      sentencesTake: // value for 'sentencesTake'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      teamUuid: // value for 'teamUuid'
 *      sortField: // value for 'sortField'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useGetInsightGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetInsightGroupsQuery, GetInsightGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightGroupsQuery, GetInsightGroupsQueryVariables>(GetInsightGroupsDocument, options);
      }
export function useGetInsightGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightGroupsQuery, GetInsightGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightGroupsQuery, GetInsightGroupsQueryVariables>(GetInsightGroupsDocument, options);
        }
export type GetInsightGroupsQueryHookResult = ReturnType<typeof useGetInsightGroupsQuery>;
export type GetInsightGroupsLazyQueryHookResult = ReturnType<typeof useGetInsightGroupsLazyQuery>;
export type GetInsightGroupsQueryResult = Apollo.QueryResult<GetInsightGroupsQuery, GetInsightGroupsQueryVariables>;
export const GetInsightPreviewChartToDeleteDocument = gql`
    query getInsightPreviewChartToDelete($collectionId: BigInt!, $collectionType: insight_collection_type!, $filterInput: FilterInput!, $teamId: Int!, $chartBin: chart_bin_type) {
  getInsightPreviewChartToDelete(
    collectionId: $collectionId
    collectionType: $collectionType
    filterInput: $filterInput
    teamId: $teamId
    chartBin: $chartBin
  ) {
    ...SeriesData
  }
}
    ${SeriesDataFragmentDoc}`;

/**
 * __useGetInsightPreviewChartToDeleteQuery__
 *
 * To run a query within a React component, call `useGetInsightPreviewChartToDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightPreviewChartToDeleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightPreviewChartToDeleteQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      collectionType: // value for 'collectionType'
 *      filterInput: // value for 'filterInput'
 *      teamId: // value for 'teamId'
 *      chartBin: // value for 'chartBin'
 *   },
 * });
 */
export function useGetInsightPreviewChartToDeleteQuery(baseOptions: Apollo.QueryHookOptions<GetInsightPreviewChartToDeleteQuery, GetInsightPreviewChartToDeleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightPreviewChartToDeleteQuery, GetInsightPreviewChartToDeleteQueryVariables>(GetInsightPreviewChartToDeleteDocument, options);
      }
export function useGetInsightPreviewChartToDeleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightPreviewChartToDeleteQuery, GetInsightPreviewChartToDeleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightPreviewChartToDeleteQuery, GetInsightPreviewChartToDeleteQueryVariables>(GetInsightPreviewChartToDeleteDocument, options);
        }
export type GetInsightPreviewChartToDeleteQueryHookResult = ReturnType<typeof useGetInsightPreviewChartToDeleteQuery>;
export type GetInsightPreviewChartToDeleteLazyQueryHookResult = ReturnType<typeof useGetInsightPreviewChartToDeleteLazyQuery>;
export type GetInsightPreviewChartToDeleteQueryResult = Apollo.QueryResult<GetInsightPreviewChartToDeleteQuery, GetInsightPreviewChartToDeleteQueryVariables>;
export const GetInsightPreviewEntriesDocument = gql`
    query GetInsightPreviewEntries($collectionId: BigInt!, $collectionType: insight_collection_type!, $filterInput: FilterInput!, $teamId: Int!) {
  getInsightPreviewEntries(
    collectionId: $collectionId
    collectionType: $collectionType
    filterInput: $filterInput
    teamId: $teamId
  ) {
    ...Entry
  }
}
    ${EntryFragmentDoc}`;

/**
 * __useGetInsightPreviewEntriesQuery__
 *
 * To run a query within a React component, call `useGetInsightPreviewEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightPreviewEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightPreviewEntriesQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      collectionType: // value for 'collectionType'
 *      filterInput: // value for 'filterInput'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetInsightPreviewEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetInsightPreviewEntriesQuery, GetInsightPreviewEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightPreviewEntriesQuery, GetInsightPreviewEntriesQueryVariables>(GetInsightPreviewEntriesDocument, options);
      }
export function useGetInsightPreviewEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightPreviewEntriesQuery, GetInsightPreviewEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightPreviewEntriesQuery, GetInsightPreviewEntriesQueryVariables>(GetInsightPreviewEntriesDocument, options);
        }
export type GetInsightPreviewEntriesQueryHookResult = ReturnType<typeof useGetInsightPreviewEntriesQuery>;
export type GetInsightPreviewEntriesLazyQueryHookResult = ReturnType<typeof useGetInsightPreviewEntriesLazyQuery>;
export type GetInsightPreviewEntriesQueryResult = Apollo.QueryResult<GetInsightPreviewEntriesQuery, GetInsightPreviewEntriesQueryVariables>;
export const GetInsightSourcesDocument = gql`
    query GetInsightSources($teamId: Int!) {
  getInsightSources(teamId: $teamId)
}
    `;

/**
 * __useGetInsightSourcesQuery__
 *
 * To run a query within a React component, call `useGetInsightSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightSourcesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetInsightSourcesQuery(baseOptions: Apollo.QueryHookOptions<GetInsightSourcesQuery, GetInsightSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightSourcesQuery, GetInsightSourcesQueryVariables>(GetInsightSourcesDocument, options);
      }
export function useGetInsightSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightSourcesQuery, GetInsightSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightSourcesQuery, GetInsightSourcesQueryVariables>(GetInsightSourcesDocument, options);
        }
export type GetInsightSourcesQueryHookResult = ReturnType<typeof useGetInsightSourcesQuery>;
export type GetInsightSourcesLazyQueryHookResult = ReturnType<typeof useGetInsightSourcesLazyQuery>;
export type GetInsightSourcesQueryResult = Apollo.QueryResult<GetInsightSourcesQuery, GetInsightSourcesQueryVariables>;
export const GetInsightsDocument = gql`
    query GetInsights($digestId: Int!, $includeDenied: Boolean, $take: Int, $skip: Int) {
  getInsights(
    digestId: $digestId
    includeDenied: $includeDenied
    take: $take
    skip: $skip
  ) {
    ...InsightLight
  }
}
    ${InsightLightFragmentDoc}`;

/**
 * __useGetInsightsQuery__
 *
 * To run a query within a React component, call `useGetInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightsQuery({
 *   variables: {
 *      digestId: // value for 'digestId'
 *      includeDenied: // value for 'includeDenied'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetInsightsQuery, GetInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightsQuery, GetInsightsQueryVariables>(GetInsightsDocument, options);
      }
export function useGetInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightsQuery, GetInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightsQuery, GetInsightsQueryVariables>(GetInsightsDocument, options);
        }
export type GetInsightsQueryHookResult = ReturnType<typeof useGetInsightsQuery>;
export type GetInsightsLazyQueryHookResult = ReturnType<typeof useGetInsightsLazyQuery>;
export type GetInsightsQueryResult = Apollo.QueryResult<GetInsightsQuery, GetInsightsQueryVariables>;
export const GetIntegrationDataSourceFieldsDocument = gql`
    query GetIntegrationDataSourceFields($input: MutateFeedbackIntegration!) {
  describeSourceFields(integrationType: $input) {
    describeSourceFieldsUuid
  }
}
    `;

/**
 * __useGetIntegrationDataSourceFieldsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationDataSourceFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationDataSourceFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationDataSourceFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntegrationDataSourceFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationDataSourceFieldsQuery, GetIntegrationDataSourceFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationDataSourceFieldsQuery, GetIntegrationDataSourceFieldsQueryVariables>(GetIntegrationDataSourceFieldsDocument, options);
      }
export function useGetIntegrationDataSourceFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationDataSourceFieldsQuery, GetIntegrationDataSourceFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationDataSourceFieldsQuery, GetIntegrationDataSourceFieldsQueryVariables>(GetIntegrationDataSourceFieldsDocument, options);
        }
export type GetIntegrationDataSourceFieldsQueryHookResult = ReturnType<typeof useGetIntegrationDataSourceFieldsQuery>;
export type GetIntegrationDataSourceFieldsLazyQueryHookResult = ReturnType<typeof useGetIntegrationDataSourceFieldsLazyQuery>;
export type GetIntegrationDataSourceFieldsQueryResult = Apollo.QueryResult<GetIntegrationDataSourceFieldsQuery, GetIntegrationDataSourceFieldsQueryVariables>;
export const GetInviteLinkStatusDocument = gql`
    query GetInviteLinkStatus($inviteLinkHash: String!) {
  getInviteLinkStatus(inviteLinkHash: $inviteLinkHash)
}
    `;

/**
 * __useGetInviteLinkStatusQuery__
 *
 * To run a query within a React component, call `useGetInviteLinkStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteLinkStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteLinkStatusQuery({
 *   variables: {
 *      inviteLinkHash: // value for 'inviteLinkHash'
 *   },
 * });
 */
export function useGetInviteLinkStatusQuery(baseOptions: Apollo.QueryHookOptions<GetInviteLinkStatusQuery, GetInviteLinkStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteLinkStatusQuery, GetInviteLinkStatusQueryVariables>(GetInviteLinkStatusDocument, options);
      }
export function useGetInviteLinkStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteLinkStatusQuery, GetInviteLinkStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteLinkStatusQuery, GetInviteLinkStatusQueryVariables>(GetInviteLinkStatusDocument, options);
        }
export type GetInviteLinkStatusQueryHookResult = ReturnType<typeof useGetInviteLinkStatusQuery>;
export type GetInviteLinkStatusLazyQueryHookResult = ReturnType<typeof useGetInviteLinkStatusLazyQuery>;
export type GetInviteLinkStatusQueryResult = Apollo.QueryResult<GetInviteLinkStatusQuery, GetInviteLinkStatusQueryVariables>;
export const GetJiraProjectsDocument = gql`
    query GetJiraProjects($orgId: Int!, $queryString: String!) {
  getJiraProjects(orgId: $orgId, queryString: $queryString) {
    providerUniqueId
    name
    key
  }
}
    `;

/**
 * __useGetJiraProjectsQuery__
 *
 * To run a query within a React component, call `useGetJiraProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJiraProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJiraProjectsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useGetJiraProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetJiraProjectsQuery, GetJiraProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJiraProjectsQuery, GetJiraProjectsQueryVariables>(GetJiraProjectsDocument, options);
      }
export function useGetJiraProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJiraProjectsQuery, GetJiraProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJiraProjectsQuery, GetJiraProjectsQueryVariables>(GetJiraProjectsDocument, options);
        }
export type GetJiraProjectsQueryHookResult = ReturnType<typeof useGetJiraProjectsQuery>;
export type GetJiraProjectsLazyQueryHookResult = ReturnType<typeof useGetJiraProjectsLazyQuery>;
export type GetJiraProjectsQueryResult = Apollo.QueryResult<GetJiraProjectsQuery, GetJiraProjectsQueryVariables>;
export const GetJiraTicketsDocument = gql`
    query GetJiraTickets($orgId: Int!, $queryString: String!, $projectId: String!) {
  getJiraTickets(orgId: $orgId, queryString: $queryString, projectId: $projectId) {
    assignee
    dueDate
    name
    providerUniqueId
    sourcePermalink
    closedDate
    status
  }
}
    `;

/**
 * __useGetJiraTicketsQuery__
 *
 * To run a query within a React component, call `useGetJiraTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJiraTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJiraTicketsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      queryString: // value for 'queryString'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetJiraTicketsQuery(baseOptions: Apollo.QueryHookOptions<GetJiraTicketsQuery, GetJiraTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJiraTicketsQuery, GetJiraTicketsQueryVariables>(GetJiraTicketsDocument, options);
      }
export function useGetJiraTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJiraTicketsQuery, GetJiraTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJiraTicketsQuery, GetJiraTicketsQueryVariables>(GetJiraTicketsDocument, options);
        }
export type GetJiraTicketsQueryHookResult = ReturnType<typeof useGetJiraTicketsQuery>;
export type GetJiraTicketsLazyQueryHookResult = ReturnType<typeof useGetJiraTicketsLazyQuery>;
export type GetJiraTicketsQueryResult = Apollo.QueryResult<GetJiraTicketsQuery, GetJiraTicketsQueryVariables>;
export const GetLinearTeamsDocument = gql`
    query GetLinearTeams($orgId: Int!, $queryString: String!) {
  getLinearTeams(orgId: $orgId, queryString: $queryString) {
    key
    name
    providerUniqueId
  }
}
    `;

/**
 * __useGetLinearTeamsQuery__
 *
 * To run a query within a React component, call `useGetLinearTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinearTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinearTeamsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useGetLinearTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetLinearTeamsQuery, GetLinearTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinearTeamsQuery, GetLinearTeamsQueryVariables>(GetLinearTeamsDocument, options);
      }
export function useGetLinearTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinearTeamsQuery, GetLinearTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinearTeamsQuery, GetLinearTeamsQueryVariables>(GetLinearTeamsDocument, options);
        }
export type GetLinearTeamsQueryHookResult = ReturnType<typeof useGetLinearTeamsQuery>;
export type GetLinearTeamsLazyQueryHookResult = ReturnType<typeof useGetLinearTeamsLazyQuery>;
export type GetLinearTeamsQueryResult = Apollo.QueryResult<GetLinearTeamsQuery, GetLinearTeamsQueryVariables>;
export const GetLinearTicketsDocument = gql`
    query GetLinearTickets($orgId: Int!, $queryString: String!, $linearTeamId: String) {
  getLinearTickets(
    orgId: $orgId
    queryString: $queryString
    linearTeamId: $linearTeamId
  ) {
    assignee
    closedDate
    dueDate
    name
    providerUniqueId
    sourcePermalink
    status
  }
}
    `;

/**
 * __useGetLinearTicketsQuery__
 *
 * To run a query within a React component, call `useGetLinearTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinearTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinearTicketsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      queryString: // value for 'queryString'
 *      linearTeamId: // value for 'linearTeamId'
 *   },
 * });
 */
export function useGetLinearTicketsQuery(baseOptions: Apollo.QueryHookOptions<GetLinearTicketsQuery, GetLinearTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinearTicketsQuery, GetLinearTicketsQueryVariables>(GetLinearTicketsDocument, options);
      }
export function useGetLinearTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinearTicketsQuery, GetLinearTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinearTicketsQuery, GetLinearTicketsQueryVariables>(GetLinearTicketsDocument, options);
        }
export type GetLinearTicketsQueryHookResult = ReturnType<typeof useGetLinearTicketsQuery>;
export type GetLinearTicketsLazyQueryHookResult = ReturnType<typeof useGetLinearTicketsLazyQuery>;
export type GetLinearTicketsQueryResult = Apollo.QueryResult<GetLinearTicketsQuery, GetLinearTicketsQueryVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization($orgId: Int!) {
  getOrganization(orgId: $orgId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationUserTeamsDocument = gql`
    query GetOrganizationUserTeams($orgId: Int!) {
  currentOrgUser(orgId: $orgId) {
    ...OrgUserTeams
  }
}
    ${OrgUserTeamsFragmentDoc}`;

/**
 * __useGetOrganizationUserTeamsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserTeamsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrganizationUserTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUserTeamsQuery, GetOrganizationUserTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUserTeamsQuery, GetOrganizationUserTeamsQueryVariables>(GetOrganizationUserTeamsDocument, options);
      }
export function useGetOrganizationUserTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUserTeamsQuery, GetOrganizationUserTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUserTeamsQuery, GetOrganizationUserTeamsQueryVariables>(GetOrganizationUserTeamsDocument, options);
        }
export type GetOrganizationUserTeamsQueryHookResult = ReturnType<typeof useGetOrganizationUserTeamsQuery>;
export type GetOrganizationUserTeamsLazyQueryHookResult = ReturnType<typeof useGetOrganizationUserTeamsLazyQuery>;
export type GetOrganizationUserTeamsQueryResult = Apollo.QueryResult<GetOrganizationUserTeamsQuery, GetOrganizationUserTeamsQueryVariables>;
export const GetOrganizationUsersDocument = gql`
    query GetOrganizationUsers($orgId: Int!) {
  getOrganizationUsers(orgId: $orgId) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersQueryResult = Apollo.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const GetOrganizationsLightDocument = gql`
    query GetOrganizationsLight {
  getOrganizations {
    ...OrganizationsLight
  }
}
    ${OrganizationsLightFragmentDoc}`;

/**
 * __useGetOrganizationsLightQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsLightQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsLightQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsLightQuery, GetOrganizationsLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsLightQuery, GetOrganizationsLightQueryVariables>(GetOrganizationsLightDocument, options);
      }
export function useGetOrganizationsLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsLightQuery, GetOrganizationsLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsLightQuery, GetOrganizationsLightQueryVariables>(GetOrganizationsLightDocument, options);
        }
export type GetOrganizationsLightQueryHookResult = ReturnType<typeof useGetOrganizationsLightQuery>;
export type GetOrganizationsLightLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLightLazyQuery>;
export type GetOrganizationsLightQueryResult = Apollo.QueryResult<GetOrganizationsLightQuery, GetOrganizationsLightQueryVariables>;
export const GetOrphansDocument = gql`
    query GetOrphans($teamId: Int!, $belongs: Boolean, $filterInput: FilterInput!, $status: group_status, $take: Int, $skip: Int, $teamUuid: String, $sortField: SortFieldType) {
  getGroups(
    teamId: $teamId
    belongs: $belongs
    status: $status
    take: $take
    skip: $skip
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
    onlyIncludeOrphans: true
  ) {
    ...GroupTaxonomy
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useGetOrphansQuery__
 *
 * To run a query within a React component, call `useGetOrphansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrphansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrphansQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      teamUuid: // value for 'teamUuid'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useGetOrphansQuery(baseOptions: Apollo.QueryHookOptions<GetOrphansQuery, GetOrphansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrphansQuery, GetOrphansQueryVariables>(GetOrphansDocument, options);
      }
export function useGetOrphansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrphansQuery, GetOrphansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrphansQuery, GetOrphansQueryVariables>(GetOrphansDocument, options);
        }
export type GetOrphansQueryHookResult = ReturnType<typeof useGetOrphansQuery>;
export type GetOrphansLazyQueryHookResult = ReturnType<typeof useGetOrphansLazyQuery>;
export type GetOrphansQueryResult = Apollo.QueryResult<GetOrphansQuery, GetOrphansQueryVariables>;
export const GetPartialEntriesDocument = gql`
    query GetPartialEntries($teamId: Int!, $filterInput: FilterInput, $filterStatement: FilterNode, $skip: Int, $sortBy: SortByType, $take: Int) {
  entries(
    teamId: $teamId
    filterInput: $filterInput
    filterStatement: $filterStatement
    skip: $skip
    sortBy: $sortBy
    take: $take
  ) {
    ...PartialEntry
  }
}
    ${PartialEntryFragmentDoc}`;

/**
 * __useGetPartialEntriesQuery__
 *
 * To run a query within a React component, call `useGetPartialEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartialEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartialEntriesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      filterStatement: // value for 'filterStatement'
 *      skip: // value for 'skip'
 *      sortBy: // value for 'sortBy'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPartialEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetPartialEntriesQuery, GetPartialEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartialEntriesQuery, GetPartialEntriesQueryVariables>(GetPartialEntriesDocument, options);
      }
export function useGetPartialEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartialEntriesQuery, GetPartialEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartialEntriesQuery, GetPartialEntriesQueryVariables>(GetPartialEntriesDocument, options);
        }
export type GetPartialEntriesQueryHookResult = ReturnType<typeof useGetPartialEntriesQuery>;
export type GetPartialEntriesLazyQueryHookResult = ReturnType<typeof useGetPartialEntriesLazyQuery>;
export type GetPartialEntriesQueryResult = Apollo.QueryResult<GetPartialEntriesQuery, GetPartialEntriesQueryVariables>;
export const GetPinnedGroupsDocument = gql`
    query GetPinnedGroups($teamId: Int!, $belongs: Boolean, $filterInput: FilterInput!, $sentencesTake: Int, $status: group_status, $take: Int, $skip: Int, $teamUuid: String, $sortField: SortFieldType, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  getGroups(
    teamId: $teamId
    belongs: $belongs
    status: $status
    take: $take
    skip: $skip
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
    pinnedByUser: true
  ) {
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useGetPinnedGroupsQuery__
 *
 * To run a query within a React component, call `useGetPinnedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedGroupsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      sentencesTake: // value for 'sentencesTake'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      teamUuid: // value for 'teamUuid'
 *      sortField: // value for 'sortField'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useGetPinnedGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetPinnedGroupsQuery, GetPinnedGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPinnedGroupsQuery, GetPinnedGroupsQueryVariables>(GetPinnedGroupsDocument, options);
      }
export function useGetPinnedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPinnedGroupsQuery, GetPinnedGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPinnedGroupsQuery, GetPinnedGroupsQueryVariables>(GetPinnedGroupsDocument, options);
        }
export type GetPinnedGroupsQueryHookResult = ReturnType<typeof useGetPinnedGroupsQuery>;
export type GetPinnedGroupsLazyQueryHookResult = ReturnType<typeof useGetPinnedGroupsLazyQuery>;
export type GetPinnedGroupsQueryResult = Apollo.QueryResult<GetPinnedGroupsQuery, GetPinnedGroupsQueryVariables>;
export const GetPlotDocument = gql`
    query GetPlot($chartId: Int!, $pageLevelFilterNode: FilterNode!, $teamId: Int!, $chartBinType: chart_bin_type) {
  getPlot(
    chartId: $chartId
    pageLevelFilterNode: $pageLevelFilterNode
    teamId: $teamId
    chartBinType: $chartBinType
  ) {
    ...Plot
  }
}
    ${PlotFragmentDoc}`;

/**
 * __useGetPlotQuery__
 *
 * To run a query within a React component, call `useGetPlotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlotQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      pageLevelFilterNode: // value for 'pageLevelFilterNode'
 *      teamId: // value for 'teamId'
 *      chartBinType: // value for 'chartBinType'
 *   },
 * });
 */
export function useGetPlotQuery(baseOptions: Apollo.QueryHookOptions<GetPlotQuery, GetPlotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlotQuery, GetPlotQueryVariables>(GetPlotDocument, options);
      }
export function useGetPlotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlotQuery, GetPlotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlotQuery, GetPlotQueryVariables>(GetPlotDocument, options);
        }
export type GetPlotQueryHookResult = ReturnType<typeof useGetPlotQuery>;
export type GetPlotLazyQueryHookResult = ReturnType<typeof useGetPlotLazyQuery>;
export type GetPlotQueryResult = Apollo.QueryResult<GetPlotQuery, GetPlotQueryVariables>;
export const GetPlotPreviewDocument = gql`
    query GetPlotPreview($pageLevelFilterNode: FilterNode!, $plotConfigurationInput: PlotConfig!, $teamId: Int!) {
  getPlotPreview(
    pageLevelFilterNode: $pageLevelFilterNode
    plotConfigurationInput: $plotConfigurationInput
    teamId: $teamId
  ) {
    ...Plot
  }
}
    ${PlotFragmentDoc}`;

/**
 * __useGetPlotPreviewQuery__
 *
 * To run a query within a React component, call `useGetPlotPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlotPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlotPreviewQuery({
 *   variables: {
 *      pageLevelFilterNode: // value for 'pageLevelFilterNode'
 *      plotConfigurationInput: // value for 'plotConfigurationInput'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetPlotPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetPlotPreviewQuery, GetPlotPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlotPreviewQuery, GetPlotPreviewQueryVariables>(GetPlotPreviewDocument, options);
      }
export function useGetPlotPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlotPreviewQuery, GetPlotPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlotPreviewQuery, GetPlotPreviewQueryVariables>(GetPlotPreviewDocument, options);
        }
export type GetPlotPreviewQueryHookResult = ReturnType<typeof useGetPlotPreviewQuery>;
export type GetPlotPreviewLazyQueryHookResult = ReturnType<typeof useGetPlotPreviewLazyQuery>;
export type GetPlotPreviewQueryResult = Apollo.QueryResult<GetPlotPreviewQuery, GetPlotPreviewQueryVariables>;
export const GetPreviewPageGroupsDocument = gql`
    query GetPreviewPageGroups($email: String!, $teamId: Int!, $teamUuid: String!, $belongs: Boolean, $take: Int, $skip: Int, $filterInput: FilterInput!, $sentencesTake: Int, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  getPreviewPageGroups(
    email: $email
    teamId: $teamId
    teamUuid: $teamUuid
    belongs: $belongs
    take: $take
    skip: $skip
    filterInput: $filterInput
  ) {
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useGetPreviewPageGroupsQuery__
 *
 * To run a query within a React component, call `useGetPreviewPageGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewPageGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewPageGroupsQuery({
 *   variables: {
 *      email: // value for 'email'
 *      teamId: // value for 'teamId'
 *      teamUuid: // value for 'teamUuid'
 *      belongs: // value for 'belongs'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filterInput: // value for 'filterInput'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useGetPreviewPageGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewPageGroupsQuery, GetPreviewPageGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewPageGroupsQuery, GetPreviewPageGroupsQueryVariables>(GetPreviewPageGroupsDocument, options);
      }
export function useGetPreviewPageGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewPageGroupsQuery, GetPreviewPageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewPageGroupsQuery, GetPreviewPageGroupsQueryVariables>(GetPreviewPageGroupsDocument, options);
        }
export type GetPreviewPageGroupsQueryHookResult = ReturnType<typeof useGetPreviewPageGroupsQuery>;
export type GetPreviewPageGroupsLazyQueryHookResult = ReturnType<typeof useGetPreviewPageGroupsLazyQuery>;
export type GetPreviewPageGroupsQueryResult = Apollo.QueryResult<GetPreviewPageGroupsQuery, GetPreviewPageGroupsQueryVariables>;
export const GetPublicGroupDocument = gql`
    query GetPublicGroup($groupId: BigInt!, $filterInput: FilterInput!, $belongs: Boolean, $teamUuid: String!, $sentencesTake: Int, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  getPublicGroup(
    groupId: $groupId
    filterInput: $filterInput
    belongs: $belongs
    teamUuid: $teamUuid
  ) {
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useGetPublicGroupQuery__
 *
 * To run a query within a React component, call `useGetPublicGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      filterInput: // value for 'filterInput'
 *      belongs: // value for 'belongs'
 *      teamUuid: // value for 'teamUuid'
 *      sentencesTake: // value for 'sentencesTake'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useGetPublicGroupQuery(baseOptions: Apollo.QueryHookOptions<GetPublicGroupQuery, GetPublicGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicGroupQuery, GetPublicGroupQueryVariables>(GetPublicGroupDocument, options);
      }
export function useGetPublicGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicGroupQuery, GetPublicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicGroupQuery, GetPublicGroupQueryVariables>(GetPublicGroupDocument, options);
        }
export type GetPublicGroupQueryHookResult = ReturnType<typeof useGetPublicGroupQuery>;
export type GetPublicGroupLazyQueryHookResult = ReturnType<typeof useGetPublicGroupLazyQuery>;
export type GetPublicGroupQueryResult = Apollo.QueryResult<GetPublicGroupQuery, GetPublicGroupQueryVariables>;
export const GetSlackChannelIdDocument = gql`
    query GetSlackChannelId($channelName: String!, $orgId: Int!) {
  getChannelId(channelName: $channelName, orgId: $orgId)
}
    `;

/**
 * __useGetSlackChannelIdQuery__
 *
 * To run a query within a React component, call `useGetSlackChannelIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackChannelIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackChannelIdQuery({
 *   variables: {
 *      channelName: // value for 'channelName'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetSlackChannelIdQuery(baseOptions: Apollo.QueryHookOptions<GetSlackChannelIdQuery, GetSlackChannelIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlackChannelIdQuery, GetSlackChannelIdQueryVariables>(GetSlackChannelIdDocument, options);
      }
export function useGetSlackChannelIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlackChannelIdQuery, GetSlackChannelIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlackChannelIdQuery, GetSlackChannelIdQueryVariables>(GetSlackChannelIdDocument, options);
        }
export type GetSlackChannelIdQueryHookResult = ReturnType<typeof useGetSlackChannelIdQuery>;
export type GetSlackChannelIdLazyQueryHookResult = ReturnType<typeof useGetSlackChannelIdLazyQuery>;
export type GetSlackChannelIdQueryResult = Apollo.QueryResult<GetSlackChannelIdQuery, GetSlackChannelIdQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags($teamId: Int!) {
  getTags(teamId: $teamId) {
    id
    name
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const TaxonomyDocument = gql`
    query Taxonomy($teamId: Int!, $filterInput: FilterInput) {
  getTaxonomy(teamId: $teamId, filterInput: $filterInput) {
    groupId
    node {
      ...GroupTaxonomy
    }
    childrenIds
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useTaxonomyQuery__
 *
 * To run a query within a React component, call `useTaxonomyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useTaxonomyQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyQuery, TaxonomyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyQuery, TaxonomyQueryVariables>(TaxonomyDocument, options);
      }
export function useTaxonomyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyQuery, TaxonomyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyQuery, TaxonomyQueryVariables>(TaxonomyDocument, options);
        }
export type TaxonomyQueryHookResult = ReturnType<typeof useTaxonomyQuery>;
export type TaxonomyLazyQueryHookResult = ReturnType<typeof useTaxonomyLazyQuery>;
export type TaxonomyQueryResult = Apollo.QueryResult<TaxonomyQuery, TaxonomyQueryVariables>;
export const GetTaxonomyGroupDocument = gql`
    query GetTaxonomyGroup($groupId: BigInt!, $teamId: Int!, $filterInput: FilterInput!, $belongs: Boolean, $teamUuid: String) {
  getGroup(
    groupId: $groupId
    teamId: $teamId
    filterInput: $filterInput
    belongs: $belongs
    teamUuid: $teamUuid
  ) {
    ...GroupTaxonomy
    parent(teamId: $teamId, FilterInput: $filterInput) {
      id
    }
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useGetTaxonomyGroupQuery__
 *
 * To run a query within a React component, call `useGetTaxonomyGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxonomyGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxonomyGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      belongs: // value for 'belongs'
 *      teamUuid: // value for 'teamUuid'
 *   },
 * });
 */
export function useGetTaxonomyGroupQuery(baseOptions: Apollo.QueryHookOptions<GetTaxonomyGroupQuery, GetTaxonomyGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxonomyGroupQuery, GetTaxonomyGroupQueryVariables>(GetTaxonomyGroupDocument, options);
      }
export function useGetTaxonomyGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxonomyGroupQuery, GetTaxonomyGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxonomyGroupQuery, GetTaxonomyGroupQueryVariables>(GetTaxonomyGroupDocument, options);
        }
export type GetTaxonomyGroupQueryHookResult = ReturnType<typeof useGetTaxonomyGroupQuery>;
export type GetTaxonomyGroupLazyQueryHookResult = ReturnType<typeof useGetTaxonomyGroupLazyQuery>;
export type GetTaxonomyGroupQueryResult = Apollo.QueryResult<GetTaxonomyGroupQuery, GetTaxonomyGroupQueryVariables>;
export const TeamDefaultConfigsDocument = gql`
    query TeamDefaultConfigs {
  teamDefaultConfigs {
    endDate
    startDate
    exploreDefaultWindow
    teamId
  }
}
    `;

/**
 * __useTeamDefaultConfigsQuery__
 *
 * To run a query within a React component, call `useTeamDefaultConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamDefaultConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamDefaultConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamDefaultConfigsQuery(baseOptions?: Apollo.QueryHookOptions<TeamDefaultConfigsQuery, TeamDefaultConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamDefaultConfigsQuery, TeamDefaultConfigsQueryVariables>(TeamDefaultConfigsDocument, options);
      }
export function useTeamDefaultConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamDefaultConfigsQuery, TeamDefaultConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamDefaultConfigsQuery, TeamDefaultConfigsQueryVariables>(TeamDefaultConfigsDocument, options);
        }
export type TeamDefaultConfigsQueryHookResult = ReturnType<typeof useTeamDefaultConfigsQuery>;
export type TeamDefaultConfigsLazyQueryHookResult = ReturnType<typeof useTeamDefaultConfigsLazyQuery>;
export type TeamDefaultConfigsQueryResult = Apollo.QueryResult<TeamDefaultConfigsQuery, TeamDefaultConfigsQueryVariables>;
export const GetTeamPotentialWidgetsDocument = gql`
    query GetTeamPotentialWidgets($teamId: Int!, $titleSubstring: String) {
  getTeamPotentialWidgets(teamId: $teamId, titleSubstring: $titleSubstring) {
    ...PotentialWidget
  }
}
    ${PotentialWidgetFragmentDoc}`;

/**
 * __useGetTeamPotentialWidgetsQuery__
 *
 * To run a query within a React component, call `useGetTeamPotentialWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamPotentialWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamPotentialWidgetsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      titleSubstring: // value for 'titleSubstring'
 *   },
 * });
 */
export function useGetTeamPotentialWidgetsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamPotentialWidgetsQuery, GetTeamPotentialWidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamPotentialWidgetsQuery, GetTeamPotentialWidgetsQueryVariables>(GetTeamPotentialWidgetsDocument, options);
      }
export function useGetTeamPotentialWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamPotentialWidgetsQuery, GetTeamPotentialWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamPotentialWidgetsQuery, GetTeamPotentialWidgetsQueryVariables>(GetTeamPotentialWidgetsDocument, options);
        }
export type GetTeamPotentialWidgetsQueryHookResult = ReturnType<typeof useGetTeamPotentialWidgetsQuery>;
export type GetTeamPotentialWidgetsLazyQueryHookResult = ReturnType<typeof useGetTeamPotentialWidgetsLazyQuery>;
export type GetTeamPotentialWidgetsQueryResult = Apollo.QueryResult<GetTeamPotentialWidgetsQuery, GetTeamPotentialWidgetsQueryVariables>;
export const GetUserAttrOrgsDocument = gql`
    query GetUserAttrOrgs {
  getUserAttributes {
    id
    lastName
    firstName
    email
    dateCreated
    orgs {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserAttrOrgsQuery__
 *
 * To run a query within a React component, call `useGetUserAttrOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAttrOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAttrOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAttrOrgsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAttrOrgsQuery, GetUserAttrOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAttrOrgsQuery, GetUserAttrOrgsQueryVariables>(GetUserAttrOrgsDocument, options);
      }
export function useGetUserAttrOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAttrOrgsQuery, GetUserAttrOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAttrOrgsQuery, GetUserAttrOrgsQueryVariables>(GetUserAttrOrgsDocument, options);
        }
export type GetUserAttrOrgsQueryHookResult = ReturnType<typeof useGetUserAttrOrgsQuery>;
export type GetUserAttrOrgsLazyQueryHookResult = ReturnType<typeof useGetUserAttrOrgsLazyQuery>;
export type GetUserAttrOrgsQueryResult = Apollo.QueryResult<GetUserAttrOrgsQuery, GetUserAttrOrgsQueryVariables>;
export const GetUserAttributesDocument = gql`
    query GetUserAttributes {
  getUserAttributes {
    id
    lastName
    firstName
    email
    dateCreated
  }
}
    `;

/**
 * __useGetUserAttributesQuery__
 *
 * To run a query within a React component, call `useGetUserAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAttributesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
      }
export function useGetUserAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
        }
export type GetUserAttributesQueryHookResult = ReturnType<typeof useGetUserAttributesQuery>;
export type GetUserAttributesLazyQueryHookResult = ReturnType<typeof useGetUserAttributesLazyQuery>;
export type GetUserAttributesQueryResult = Apollo.QueryResult<GetUserAttributesQuery, GetUserAttributesQueryVariables>;
export const GroupSearchDocument = gql`
    query GroupSearch($searchString: String!, $teamId: Int!, $filterInput: FilterInput, $filterStatement: FilterNode) {
  groupSearch(
    searchString: $searchString
    teamId: $teamId
    filterInput: $filterInput
    filterStatement: $filterStatement
  ) {
    groupId
    node {
      ...GroupTaxonomy
    }
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useGroupSearchQuery__
 *
 * To run a query within a React component, call `useGroupSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      filterStatement: // value for 'filterStatement'
 *   },
 * });
 */
export function useGroupSearchQuery(baseOptions: Apollo.QueryHookOptions<GroupSearchQuery, GroupSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupSearchQuery, GroupSearchQueryVariables>(GroupSearchDocument, options);
      }
export function useGroupSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupSearchQuery, GroupSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupSearchQuery, GroupSearchQueryVariables>(GroupSearchDocument, options);
        }
export type GroupSearchQueryHookResult = ReturnType<typeof useGroupSearchQuery>;
export type GroupSearchLazyQueryHookResult = ReturnType<typeof useGroupSearchLazyQuery>;
export type GroupSearchQueryResult = Apollo.QueryResult<GroupSearchQuery, GroupSearchQueryVariables>;
export const IntegrationConnectedDocument = gql`
    query IntegrationConnected($input: MutateFeedbackIntegration!) {
  testIntegrationConnected(integrationType: $input) {
    success
    appName
    response
  }
}
    `;

/**
 * __useIntegrationConnectedQuery__
 *
 * To run a query within a React component, call `useIntegrationConnectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConnectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConnectedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationConnectedQuery(baseOptions: Apollo.QueryHookOptions<IntegrationConnectedQuery, IntegrationConnectedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationConnectedQuery, IntegrationConnectedQueryVariables>(IntegrationConnectedDocument, options);
      }
export function useIntegrationConnectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConnectedQuery, IntegrationConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationConnectedQuery, IntegrationConnectedQueryVariables>(IntegrationConnectedDocument, options);
        }
export type IntegrationConnectedQueryHookResult = ReturnType<typeof useIntegrationConnectedQuery>;
export type IntegrationConnectedLazyQueryHookResult = ReturnType<typeof useIntegrationConnectedLazyQuery>;
export type IntegrationConnectedQueryResult = Apollo.QueryResult<IntegrationConnectedQuery, IntegrationConnectedQueryVariables>;
export const IntegrationsDocument = gql`
    query Integrations($teamId: Int!, $orgId: Int!, $feedbackIntegrationType: feedback_integration_type) {
  integrations(feedbackIntegrationType: $feedbackIntegrationType) {
    ...IntegrationType
  }
}
    ${IntegrationTypeFragmentDoc}`;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      orgId: // value for 'orgId'
 *      feedbackIntegrationType: // value for 'feedbackIntegrationType'
 *   },
 * });
 */
export function useIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
      }
export function useIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
export type IntegrationsQueryHookResult = ReturnType<typeof useIntegrationsQuery>;
export type IntegrationsLazyQueryHookResult = ReturnType<typeof useIntegrationsLazyQuery>;
export type IntegrationsQueryResult = Apollo.QueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export const IntegrationsLightDocument = gql`
    query IntegrationsLight {
  integrations {
    id
    itemName
    logoUrl
    sourceKey
    title
  }
}
    `;

/**
 * __useIntegrationsLightQuery__
 *
 * To run a query within a React component, call `useIntegrationsLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsLightQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationsLightQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsLightQuery, IntegrationsLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsLightQuery, IntegrationsLightQueryVariables>(IntegrationsLightDocument, options);
      }
export function useIntegrationsLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsLightQuery, IntegrationsLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsLightQuery, IntegrationsLightQueryVariables>(IntegrationsLightDocument, options);
        }
export type IntegrationsLightQueryHookResult = ReturnType<typeof useIntegrationsLightQuery>;
export type IntegrationsLightLazyQueryHookResult = ReturnType<typeof useIntegrationsLightLazyQuery>;
export type IntegrationsLightQueryResult = Apollo.QueryResult<IntegrationsLightQuery, IntegrationsLightQueryVariables>;
export const InternalPermissionsDocument = gql`
    mutation InternalPermissions($orgId: Int!, $teamId: Int!, $userId: Int!, $role: role!) {
  internalPermissions(
    orgId: $orgId
    teamId: $teamId
    userId: $userId
    role: $role
  )
}
    `;
export type InternalPermissionsMutationFn = Apollo.MutationFunction<InternalPermissionsMutation, InternalPermissionsMutationVariables>;

/**
 * __useInternalPermissionsMutation__
 *
 * To run a mutation, you first call `useInternalPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalPermissionsMutation, { data, loading, error }] = useInternalPermissionsMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useInternalPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<InternalPermissionsMutation, InternalPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InternalPermissionsMutation, InternalPermissionsMutationVariables>(InternalPermissionsDocument, options);
      }
export type InternalPermissionsMutationHookResult = ReturnType<typeof useInternalPermissionsMutation>;
export type InternalPermissionsMutationResult = Apollo.MutationResult<InternalPermissionsMutation>;
export type InternalPermissionsMutationOptions = Apollo.BaseMutationOptions<InternalPermissionsMutation, InternalPermissionsMutationVariables>;
export const InternalUsersDocument = gql`
    query InternalUsers {
  internalUsers {
    id
    email
    name
  }
}
    `;

/**
 * __useInternalUsersQuery__
 *
 * To run a query within a React component, call `useInternalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalUsersQuery(baseOptions?: Apollo.QueryHookOptions<InternalUsersQuery, InternalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalUsersQuery, InternalUsersQueryVariables>(InternalUsersDocument, options);
      }
export function useInternalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalUsersQuery, InternalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalUsersQuery, InternalUsersQueryVariables>(InternalUsersDocument, options);
        }
export type InternalUsersQueryHookResult = ReturnType<typeof useInternalUsersQuery>;
export type InternalUsersLazyQueryHookResult = ReturnType<typeof useInternalUsersLazyQuery>;
export type InternalUsersQueryResult = Apollo.QueryResult<InternalUsersQuery, InternalUsersQueryVariables>;
export const ListExternalTicketsDocument = gql`
    query ListExternalTickets($groupId: BigInt!, $teamId: Int!) {
  listExternalTickets(groupId: $groupId, teamId: $teamId) {
    ...ExternalTicket
  }
}
    ${ExternalTicketFragmentDoc}`;

/**
 * __useListExternalTicketsQuery__
 *
 * To run a query within a React component, call `useListExternalTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExternalTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExternalTicketsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useListExternalTicketsQuery(baseOptions: Apollo.QueryHookOptions<ListExternalTicketsQuery, ListExternalTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListExternalTicketsQuery, ListExternalTicketsQueryVariables>(ListExternalTicketsDocument, options);
      }
export function useListExternalTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListExternalTicketsQuery, ListExternalTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListExternalTicketsQuery, ListExternalTicketsQueryVariables>(ListExternalTicketsDocument, options);
        }
export type ListExternalTicketsQueryHookResult = ReturnType<typeof useListExternalTicketsQuery>;
export type ListExternalTicketsLazyQueryHookResult = ReturnType<typeof useListExternalTicketsLazyQuery>;
export type ListExternalTicketsQueryResult = Apollo.QueryResult<ListExternalTicketsQuery, ListExternalTicketsQueryVariables>;
export const OldestFeedbackDateDocument = gql`
    query OldestFeedbackDate($teamId: Int!, $teamUuid: String) {
  oldestFeedbackDate(teamId: $teamId, teamUuid: $teamUuid)
}
    `;

/**
 * __useOldestFeedbackDateQuery__
 *
 * To run a query within a React component, call `useOldestFeedbackDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldestFeedbackDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldestFeedbackDateQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      teamUuid: // value for 'teamUuid'
 *   },
 * });
 */
export function useOldestFeedbackDateQuery(baseOptions: Apollo.QueryHookOptions<OldestFeedbackDateQuery, OldestFeedbackDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldestFeedbackDateQuery, OldestFeedbackDateQueryVariables>(OldestFeedbackDateDocument, options);
      }
export function useOldestFeedbackDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldestFeedbackDateQuery, OldestFeedbackDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldestFeedbackDateQuery, OldestFeedbackDateQueryVariables>(OldestFeedbackDateDocument, options);
        }
export type OldestFeedbackDateQueryHookResult = ReturnType<typeof useOldestFeedbackDateQuery>;
export type OldestFeedbackDateLazyQueryHookResult = ReturnType<typeof useOldestFeedbackDateLazyQuery>;
export type OldestFeedbackDateQueryResult = Apollo.QueryResult<OldestFeedbackDateQuery, OldestFeedbackDateQueryVariables>;
export const OldestFeedbackEntryDocument = gql`
    query OldestFeedbackEntry($teamId: Int!, $sortBy: SortByType, $teamUuid: String) {
  entries(teamId: $teamId, take: 1, sortBy: $sortBy, teamUuid: $teamUuid) {
    date
  }
}
    `;

/**
 * __useOldestFeedbackEntryQuery__
 *
 * To run a query within a React component, call `useOldestFeedbackEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldestFeedbackEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldestFeedbackEntryQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      sortBy: // value for 'sortBy'
 *      teamUuid: // value for 'teamUuid'
 *   },
 * });
 */
export function useOldestFeedbackEntryQuery(baseOptions: Apollo.QueryHookOptions<OldestFeedbackEntryQuery, OldestFeedbackEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldestFeedbackEntryQuery, OldestFeedbackEntryQueryVariables>(OldestFeedbackEntryDocument, options);
      }
export function useOldestFeedbackEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldestFeedbackEntryQuery, OldestFeedbackEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldestFeedbackEntryQuery, OldestFeedbackEntryQueryVariables>(OldestFeedbackEntryDocument, options);
        }
export type OldestFeedbackEntryQueryHookResult = ReturnType<typeof useOldestFeedbackEntryQuery>;
export type OldestFeedbackEntryLazyQueryHookResult = ReturnType<typeof useOldestFeedbackEntryLazyQuery>;
export type OldestFeedbackEntryQueryResult = Apollo.QueryResult<OldestFeedbackEntryQuery, OldestFeedbackEntryQueryVariables>;
export const OrgManagedByOktaDocument = gql`
    query OrgManagedByOkta($teamId: Int!) {
  isOrganizationManagedByOkta(teamId: $teamId)
}
    `;

/**
 * __useOrgManagedByOktaQuery__
 *
 * To run a query within a React component, call `useOrgManagedByOktaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgManagedByOktaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgManagedByOktaQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useOrgManagedByOktaQuery(baseOptions: Apollo.QueryHookOptions<OrgManagedByOktaQuery, OrgManagedByOktaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgManagedByOktaQuery, OrgManagedByOktaQueryVariables>(OrgManagedByOktaDocument, options);
      }
export function useOrgManagedByOktaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgManagedByOktaQuery, OrgManagedByOktaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgManagedByOktaQuery, OrgManagedByOktaQueryVariables>(OrgManagedByOktaDocument, options);
        }
export type OrgManagedByOktaQueryHookResult = ReturnType<typeof useOrgManagedByOktaQuery>;
export type OrgManagedByOktaLazyQueryHookResult = ReturnType<typeof useOrgManagedByOktaLazyQuery>;
export type OrgManagedByOktaQueryResult = Apollo.QueryResult<OrgManagedByOktaQuery, OrgManagedByOktaQueryVariables>;
export const PollExecutionDocument = gql`
    query PollExecution($executionUuid: String!, $teamId: Int!, $orgId: Int) {
  pollExecution(executionUuid: $executionUuid, teamId: $teamId, orgId: $orgId) {
    status
    executionUuid
    responsePayload
  }
}
    `;

/**
 * __usePollExecutionQuery__
 *
 * To run a query within a React component, call `usePollExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollExecutionQuery({
 *   variables: {
 *      executionUuid: // value for 'executionUuid'
 *      teamId: // value for 'teamId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function usePollExecutionQuery(baseOptions: Apollo.QueryHookOptions<PollExecutionQuery, PollExecutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollExecutionQuery, PollExecutionQueryVariables>(PollExecutionDocument, options);
      }
export function usePollExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollExecutionQuery, PollExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollExecutionQuery, PollExecutionQueryVariables>(PollExecutionDocument, options);
        }
export type PollExecutionQueryHookResult = ReturnType<typeof usePollExecutionQuery>;
export type PollExecutionLazyQueryHookResult = ReturnType<typeof usePollExecutionLazyQuery>;
export type PollExecutionQueryResult = Apollo.QueryResult<PollExecutionQuery, PollExecutionQueryVariables>;
export const PublicTeamDefaultsDocument = gql`
    query PublicTeamDefaults($teamUuid: String!) {
  publicTeamDefaults(teamUuid: $teamUuid) {
    endDate
    exploreDefaultWindow
    oldestFeedbackDate
    startDate
    customer_locked_out
    lock_out_message
  }
}
    `;

/**
 * __usePublicTeamDefaultsQuery__
 *
 * To run a query within a React component, call `usePublicTeamDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicTeamDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicTeamDefaultsQuery({
 *   variables: {
 *      teamUuid: // value for 'teamUuid'
 *   },
 * });
 */
export function usePublicTeamDefaultsQuery(baseOptions: Apollo.QueryHookOptions<PublicTeamDefaultsQuery, PublicTeamDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicTeamDefaultsQuery, PublicTeamDefaultsQueryVariables>(PublicTeamDefaultsDocument, options);
      }
export function usePublicTeamDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicTeamDefaultsQuery, PublicTeamDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicTeamDefaultsQuery, PublicTeamDefaultsQueryVariables>(PublicTeamDefaultsDocument, options);
        }
export type PublicTeamDefaultsQueryHookResult = ReturnType<typeof usePublicTeamDefaultsQuery>;
export type PublicTeamDefaultsLazyQueryHookResult = ReturnType<typeof usePublicTeamDefaultsLazyQuery>;
export type PublicTeamDefaultsQueryResult = Apollo.QueryResult<PublicTeamDefaultsQuery, PublicTeamDefaultsQueryVariables>;
export const PublicTeamGroupsListDocument = gql`
    query PublicTeamGroupsList($teamUuid: String!, $belongs: Boolean, $filterInput: FilterInput!, $sentencesTake: Int, $status: group_status, $take: Int, $skip: Int, $sortField: SortFieldType, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  publicTeamGroups(
    belongs: $belongs
    status: $status
    take: $take
    skip: $skip
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
  ) {
    amountOfGroups {
      amount
    }
    groups {
      ...GroupData
    }
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __usePublicTeamGroupsListQuery__
 *
 * To run a query within a React component, call `usePublicTeamGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicTeamGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicTeamGroupsListQuery({
 *   variables: {
 *      teamUuid: // value for 'teamUuid'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      sentencesTake: // value for 'sentencesTake'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      sortField: // value for 'sortField'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function usePublicTeamGroupsListQuery(baseOptions: Apollo.QueryHookOptions<PublicTeamGroupsListQuery, PublicTeamGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicTeamGroupsListQuery, PublicTeamGroupsListQueryVariables>(PublicTeamGroupsListDocument, options);
      }
export function usePublicTeamGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicTeamGroupsListQuery, PublicTeamGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicTeamGroupsListQuery, PublicTeamGroupsListQueryVariables>(PublicTeamGroupsListDocument, options);
        }
export type PublicTeamGroupsListQueryHookResult = ReturnType<typeof usePublicTeamGroupsListQuery>;
export type PublicTeamGroupsListLazyQueryHookResult = ReturnType<typeof usePublicTeamGroupsListLazyQuery>;
export type PublicTeamGroupsListQueryResult = Apollo.QueryResult<PublicTeamGroupsListQuery, PublicTeamGroupsListQueryVariables>;
export const PublicTeamsDocument = gql`
    query PublicTeams($uuid: String!) {
  publicTeams(uuid: $uuid) {
    id
    name
  }
}
    `;

/**
 * __usePublicTeamsQuery__
 *
 * To run a query within a React component, call `usePublicTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicTeamsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function usePublicTeamsQuery(baseOptions: Apollo.QueryHookOptions<PublicTeamsQuery, PublicTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicTeamsQuery, PublicTeamsQueryVariables>(PublicTeamsDocument, options);
      }
export function usePublicTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicTeamsQuery, PublicTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicTeamsQuery, PublicTeamsQueryVariables>(PublicTeamsDocument, options);
        }
export type PublicTeamsQueryHookResult = ReturnType<typeof usePublicTeamsQuery>;
export type PublicTeamsLazyQueryHookResult = ReturnType<typeof usePublicTeamsLazyQuery>;
export type PublicTeamsQueryResult = Apollo.QueryResult<PublicTeamsQuery, PublicTeamsQueryVariables>;
export const RemoveEmailFromAlertDocument = gql`
    mutation RemoveEmailFromAlert($alertId: Int!, $teamId: Int!, $alertEmailId: Int!) {
  removeEmailFromAlert(
    alertId: $alertId
    teamId: $teamId
    alertEmailId: $alertEmailId
  ) {
    alert_id
    id
    team_id
    to_email
  }
}
    `;
export type RemoveEmailFromAlertMutationFn = Apollo.MutationFunction<RemoveEmailFromAlertMutation, RemoveEmailFromAlertMutationVariables>;

/**
 * __useRemoveEmailFromAlertMutation__
 *
 * To run a mutation, you first call `useRemoveEmailFromAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmailFromAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmailFromAlertMutation, { data, loading, error }] = useRemoveEmailFromAlertMutation({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      teamId: // value for 'teamId'
 *      alertEmailId: // value for 'alertEmailId'
 *   },
 * });
 */
export function useRemoveEmailFromAlertMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmailFromAlertMutation, RemoveEmailFromAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmailFromAlertMutation, RemoveEmailFromAlertMutationVariables>(RemoveEmailFromAlertDocument, options);
      }
export type RemoveEmailFromAlertMutationHookResult = ReturnType<typeof useRemoveEmailFromAlertMutation>;
export type RemoveEmailFromAlertMutationResult = Apollo.MutationResult<RemoveEmailFromAlertMutation>;
export type RemoveEmailFromAlertMutationOptions = Apollo.BaseMutationOptions<RemoveEmailFromAlertMutation, RemoveEmailFromAlertMutationVariables>;
export const SearchDigestSeriesDocument = gql`
    query SearchDigestSeries($query: String!) {
  searchDigestSeries(query: $query) {
    ...DigestSeriesData
  }
}
    ${DigestSeriesDataFragmentDoc}`;

/**
 * __useSearchDigestSeriesQuery__
 *
 * To run a query within a React component, call `useSearchDigestSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDigestSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDigestSeriesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchDigestSeriesQuery(baseOptions: Apollo.QueryHookOptions<SearchDigestSeriesQuery, SearchDigestSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDigestSeriesQuery, SearchDigestSeriesQueryVariables>(SearchDigestSeriesDocument, options);
      }
export function useSearchDigestSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDigestSeriesQuery, SearchDigestSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDigestSeriesQuery, SearchDigestSeriesQueryVariables>(SearchDigestSeriesDocument, options);
        }
export type SearchDigestSeriesQueryHookResult = ReturnType<typeof useSearchDigestSeriesQuery>;
export type SearchDigestSeriesLazyQueryHookResult = ReturnType<typeof useSearchDigestSeriesLazyQuery>;
export type SearchDigestSeriesQueryResult = Apollo.QueryResult<SearchDigestSeriesQuery, SearchDigestSeriesQueryVariables>;
export const SearchDigestsDocument = gql`
    query SearchDigests($query: String!) {
  searchDigests(query: $query) {
    ...DigestData
  }
}
    ${DigestDataFragmentDoc}`;

/**
 * __useSearchDigestsQuery__
 *
 * To run a query within a React component, call `useSearchDigestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDigestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDigestsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchDigestsQuery(baseOptions: Apollo.QueryHookOptions<SearchDigestsQuery, SearchDigestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDigestsQuery, SearchDigestsQueryVariables>(SearchDigestsDocument, options);
      }
export function useSearchDigestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDigestsQuery, SearchDigestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDigestsQuery, SearchDigestsQueryVariables>(SearchDigestsDocument, options);
        }
export type SearchDigestsQueryHookResult = ReturnType<typeof useSearchDigestsQuery>;
export type SearchDigestsLazyQueryHookResult = ReturnType<typeof useSearchDigestsLazyQuery>;
export type SearchDigestsQueryResult = Apollo.QueryResult<SearchDigestsQuery, SearchDigestsQueryVariables>;
export const SegmentGroupDocument = gql`
    query SegmentGroup($teamId: Int!, $aiGenerated: Boolean) {
  segments(teamId: $teamId, aiGenerated: $aiGenerated) {
    displayName
    id
    aiGenerated
  }
}
    `;

/**
 * __useSegmentGroupQuery__
 *
 * To run a query within a React component, call `useSegmentGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentGroupQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      aiGenerated: // value for 'aiGenerated'
 *   },
 * });
 */
export function useSegmentGroupQuery(baseOptions: Apollo.QueryHookOptions<SegmentGroupQuery, SegmentGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentGroupQuery, SegmentGroupQueryVariables>(SegmentGroupDocument, options);
      }
export function useSegmentGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentGroupQuery, SegmentGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentGroupQuery, SegmentGroupQueryVariables>(SegmentGroupDocument, options);
        }
export type SegmentGroupQueryHookResult = ReturnType<typeof useSegmentGroupQuery>;
export type SegmentGroupLazyQueryHookResult = ReturnType<typeof useSegmentGroupLazyQuery>;
export type SegmentGroupQueryResult = Apollo.QueryResult<SegmentGroupQuery, SegmentGroupQueryVariables>;
export const SimilarSentencesDocument = gql`
    query SimilarSentences($queryString: String!, $teamId: Int!, $filterInput: FilterInput, $groupId: BigInt, $take: Int, $skip: Int) {
  similarSentences(
    queryString: $queryString
    teamId: $teamId
    filterInput: $filterInput
    groupId: $groupId
    take: $take
    skip: $skip
  ) {
    id
    text
    is_title
    is_distillate
    entry {
      ...Entry
    }
  }
}
    ${EntryFragmentDoc}`;

/**
 * __useSimilarSentencesQuery__
 *
 * To run a query within a React component, call `useSimilarSentencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarSentencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarSentencesQuery({
 *   variables: {
 *      queryString: // value for 'queryString'
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *      groupId: // value for 'groupId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSimilarSentencesQuery(baseOptions: Apollo.QueryHookOptions<SimilarSentencesQuery, SimilarSentencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarSentencesQuery, SimilarSentencesQueryVariables>(SimilarSentencesDocument, options);
      }
export function useSimilarSentencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarSentencesQuery, SimilarSentencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarSentencesQuery, SimilarSentencesQueryVariables>(SimilarSentencesDocument, options);
        }
export type SimilarSentencesQueryHookResult = ReturnType<typeof useSimilarSentencesQuery>;
export type SimilarSentencesLazyQueryHookResult = ReturnType<typeof useSimilarSentencesLazyQuery>;
export type SimilarSentencesQueryResult = Apollo.QueryResult<SimilarSentencesQuery, SimilarSentencesQueryVariables>;
export const SourcesDocument = gql`
    query Sources($teamId: Int!) {
  sources(teamId: $teamId)
}
    `;

/**
 * __useSourcesQuery__
 *
 * To run a query within a React component, call `useSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useSourcesQuery(baseOptions: Apollo.QueryHookOptions<SourcesQuery, SourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourcesQuery, SourcesQueryVariables>(SourcesDocument, options);
      }
export function useSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourcesQuery, SourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourcesQuery, SourcesQueryVariables>(SourcesDocument, options);
        }
export type SourcesQueryHookResult = ReturnType<typeof useSourcesQuery>;
export type SourcesLazyQueryHookResult = ReturnType<typeof useSourcesLazyQuery>;
export type SourcesQueryResult = Apollo.QueryResult<SourcesQuery, SourcesQueryVariables>;
export const TeamsDocument = gql`
    query Teams($teamsId: Int!, $uuid: String) {
  teams(id: $teamsId, uuid: $uuid) {
    ...TeamData
  }
}
    ${TeamDataFragmentDoc}`;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      teamsId: // value for 'teamsId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const TeamChartsDocument = gql`
    query TeamCharts($teamId: Int!, $filterInput: FilterInput) {
  teamCharts(teamId: $teamId, filterInput: $filterInput) {
    charts {
      chartId
      chartName
      savedFilterInput {
        startDate
        endDate
      }
    }
    amountOfCharts
  }
}
    `;

/**
 * __useTeamChartsQuery__
 *
 * To run a query within a React component, call `useTeamChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamChartsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useTeamChartsQuery(baseOptions: Apollo.QueryHookOptions<TeamChartsQuery, TeamChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamChartsQuery, TeamChartsQueryVariables>(TeamChartsDocument, options);
      }
export function useTeamChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamChartsQuery, TeamChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamChartsQuery, TeamChartsQueryVariables>(TeamChartsDocument, options);
        }
export type TeamChartsQueryHookResult = ReturnType<typeof useTeamChartsQuery>;
export type TeamChartsLazyQueryHookResult = ReturnType<typeof useTeamChartsLazyQuery>;
export type TeamChartsQueryResult = Apollo.QueryResult<TeamChartsQuery, TeamChartsQueryVariables>;
export const TeamDefaultsDocument = gql`
    query TeamDefaults($teamId: Int!, $teamUuid: String) {
  teamDefaults(teamId: $teamId, teamUuid: $teamUuid) {
    endDate
    exploreDefaultWindow
    oldestFeedbackDate
    startDate
    customer_locked_out
    lock_out_message
  }
}
    `;

/**
 * __useTeamDefaultsQuery__
 *
 * To run a query within a React component, call `useTeamDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamDefaultsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      teamUuid: // value for 'teamUuid'
 *   },
 * });
 */
export function useTeamDefaultsQuery(baseOptions: Apollo.QueryHookOptions<TeamDefaultsQuery, TeamDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamDefaultsQuery, TeamDefaultsQueryVariables>(TeamDefaultsDocument, options);
      }
export function useTeamDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamDefaultsQuery, TeamDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamDefaultsQuery, TeamDefaultsQueryVariables>(TeamDefaultsDocument, options);
        }
export type TeamDefaultsQueryHookResult = ReturnType<typeof useTeamDefaultsQuery>;
export type TeamDefaultsLazyQueryHookResult = ReturnType<typeof useTeamDefaultsLazyQuery>;
export type TeamDefaultsQueryResult = Apollo.QueryResult<TeamDefaultsQuery, TeamDefaultsQueryVariables>;
export const TeamFlagsDocument = gql`
    query TeamFlags($teamId: Int!) {
  teamFlags(teamId: $teamId) {
    categorizing_last_run
    clustering_last_run
    currently_categorizing_themes
    currently_clustering
    currently_tokenizing
    id
    tokenizing_last_run
  }
}
    `;

/**
 * __useTeamFlagsQuery__
 *
 * To run a query within a React component, call `useTeamFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamFlagsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTeamFlagsQuery(baseOptions: Apollo.QueryHookOptions<TeamFlagsQuery, TeamFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamFlagsQuery, TeamFlagsQueryVariables>(TeamFlagsDocument, options);
      }
export function useTeamFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamFlagsQuery, TeamFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamFlagsQuery, TeamFlagsQueryVariables>(TeamFlagsDocument, options);
        }
export type TeamFlagsQueryHookResult = ReturnType<typeof useTeamFlagsQuery>;
export type TeamFlagsLazyQueryHookResult = ReturnType<typeof useTeamFlagsLazyQuery>;
export type TeamFlagsQueryResult = Apollo.QueryResult<TeamFlagsQuery, TeamFlagsQueryVariables>;
export const TeamGroupsListDocument = gql`
    query TeamGroupsList($teamId: Int!, $belongs: Boolean, $filterInput: FilterInput, $filterStatement: FilterNode, $sentencesTake: Int, $status: group_status, $take: Int, $skip: Int, $teamUuid: String, $sortField: SortFieldType, $sentencesSkip: Int, $includeDescendantsOnMappings: Boolean) {
  teamGroups(
    teamId: $teamId
    belongs: $belongs
    status: $status
    take: $take
    skip: $skip
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
    filterStatement: $filterStatement
  ) {
    amountOfGroups {
      amount
    }
    groups {
      ...GroupData
    }
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useTeamGroupsListQuery__
 *
 * To run a query within a React component, call `useTeamGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamGroupsListQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      filterStatement: // value for 'filterStatement'
 *      sentencesTake: // value for 'sentencesTake'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      teamUuid: // value for 'teamUuid'
 *      sortField: // value for 'sortField'
 *      sentencesSkip: // value for 'sentencesSkip'
 *      includeDescendantsOnMappings: // value for 'includeDescendantsOnMappings'
 *   },
 * });
 */
export function useTeamGroupsListQuery(baseOptions: Apollo.QueryHookOptions<TeamGroupsListQuery, TeamGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamGroupsListQuery, TeamGroupsListQueryVariables>(TeamGroupsListDocument, options);
      }
export function useTeamGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamGroupsListQuery, TeamGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamGroupsListQuery, TeamGroupsListQueryVariables>(TeamGroupsListDocument, options);
        }
export type TeamGroupsListQueryHookResult = ReturnType<typeof useTeamGroupsListQuery>;
export type TeamGroupsListLazyQueryHookResult = ReturnType<typeof useTeamGroupsListLazyQuery>;
export type TeamGroupsListQueryResult = Apollo.QueryResult<TeamGroupsListQuery, TeamGroupsListQueryVariables>;
export const TeamGroupsTaxonomyFlatDocument = gql`
    query TeamGroupsTaxonomyFlat($teamId: Int!, $belongs: Boolean, $filterInput: FilterInput, $status: group_status, $take: Int, $skip: Int, $teamUuid: String, $sortField: SortFieldType, $filterStatement: FilterNode) {
  teamGroups(
    teamId: $teamId
    belongs: $belongs
    status: $status
    take: $take
    skip: $skip
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
    filterStatement: $filterStatement
  ) {
    amountOfGroups {
      amount
    }
    taxonomyFlat {
      groupId
      node {
        ...GroupTaxonomy
        __typename
      }
    }
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useTeamGroupsTaxonomyFlatQuery__
 *
 * To run a query within a React component, call `useTeamGroupsTaxonomyFlatQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamGroupsTaxonomyFlatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamGroupsTaxonomyFlatQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      teamUuid: // value for 'teamUuid'
 *      sortField: // value for 'sortField'
 *      filterStatement: // value for 'filterStatement'
 *   },
 * });
 */
export function useTeamGroupsTaxonomyFlatQuery(baseOptions: Apollo.QueryHookOptions<TeamGroupsTaxonomyFlatQuery, TeamGroupsTaxonomyFlatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamGroupsTaxonomyFlatQuery, TeamGroupsTaxonomyFlatQueryVariables>(TeamGroupsTaxonomyFlatDocument, options);
      }
export function useTeamGroupsTaxonomyFlatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamGroupsTaxonomyFlatQuery, TeamGroupsTaxonomyFlatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamGroupsTaxonomyFlatQuery, TeamGroupsTaxonomyFlatQueryVariables>(TeamGroupsTaxonomyFlatDocument, options);
        }
export type TeamGroupsTaxonomyFlatQueryHookResult = ReturnType<typeof useTeamGroupsTaxonomyFlatQuery>;
export type TeamGroupsTaxonomyFlatLazyQueryHookResult = ReturnType<typeof useTeamGroupsTaxonomyFlatLazyQuery>;
export type TeamGroupsTaxonomyFlatQueryResult = Apollo.QueryResult<TeamGroupsTaxonomyFlatQuery, TeamGroupsTaxonomyFlatQueryVariables>;
export const TeamGroupsTaxonomyTreeDocument = gql`
    query TeamGroupsTaxonomyTree($teamId: Int!, $belongs: Boolean, $filterInput: FilterInput, $status: group_status, $take: Int, $skip: Int, $teamUuid: String, $sortField: SortFieldType, $filterStatement: FilterNode) {
  teamGroups(
    teamId: $teamId
    belongs: $belongs
    status: $status
    take: $take
    skip: $skip
    filterInput: $filterInput
    teamUuid: $teamUuid
    sortField: $sortField
    filterStatement: $filterStatement
  ) {
    amountOfGroups {
      amount
    }
    taxonomyTrees {
      groupId
      node {
        ...GroupTaxonomy
      }
      children {
        groupId
        node {
          ...GroupTaxonomy
        }
        children {
          groupId
          node {
            ...GroupTaxonomy
          }
          children {
            groupId
            node {
              ...GroupTaxonomy
            }
            children {
              groupId
              node {
                ...GroupTaxonomy
              }
              children {
                groupId
                node {
                  ...GroupTaxonomy
                }
                children {
                  groupId
                  node {
                    ...GroupTaxonomy
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${GroupTaxonomyFragmentDoc}`;

/**
 * __useTeamGroupsTaxonomyTreeQuery__
 *
 * To run a query within a React component, call `useTeamGroupsTaxonomyTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamGroupsTaxonomyTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamGroupsTaxonomyTreeQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      belongs: // value for 'belongs'
 *      filterInput: // value for 'filterInput'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      teamUuid: // value for 'teamUuid'
 *      sortField: // value for 'sortField'
 *      filterStatement: // value for 'filterStatement'
 *   },
 * });
 */
export function useTeamGroupsTaxonomyTreeQuery(baseOptions: Apollo.QueryHookOptions<TeamGroupsTaxonomyTreeQuery, TeamGroupsTaxonomyTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamGroupsTaxonomyTreeQuery, TeamGroupsTaxonomyTreeQueryVariables>(TeamGroupsTaxonomyTreeDocument, options);
      }
export function useTeamGroupsTaxonomyTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamGroupsTaxonomyTreeQuery, TeamGroupsTaxonomyTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamGroupsTaxonomyTreeQuery, TeamGroupsTaxonomyTreeQueryVariables>(TeamGroupsTaxonomyTreeDocument, options);
        }
export type TeamGroupsTaxonomyTreeQueryHookResult = ReturnType<typeof useTeamGroupsTaxonomyTreeQuery>;
export type TeamGroupsTaxonomyTreeLazyQueryHookResult = ReturnType<typeof useTeamGroupsTaxonomyTreeLazyQuery>;
export type TeamGroupsTaxonomyTreeQueryResult = Apollo.QueryResult<TeamGroupsTaxonomyTreeQuery, TeamGroupsTaxonomyTreeQueryVariables>;
export const TestExternalTicketsIntegrationDocument = gql`
    query TestExternalTicketsIntegration($integrationType: MutateFeedbackIntegration!, $orgId: Int!) {
  testExternalTicketsIntegration(integrationType: $integrationType, orgId: $orgId)
}
    `;

/**
 * __useTestExternalTicketsIntegrationQuery__
 *
 * To run a query within a React component, call `useTestExternalTicketsIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestExternalTicketsIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestExternalTicketsIntegrationQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useTestExternalTicketsIntegrationQuery(baseOptions: Apollo.QueryHookOptions<TestExternalTicketsIntegrationQuery, TestExternalTicketsIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestExternalTicketsIntegrationQuery, TestExternalTicketsIntegrationQueryVariables>(TestExternalTicketsIntegrationDocument, options);
      }
export function useTestExternalTicketsIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestExternalTicketsIntegrationQuery, TestExternalTicketsIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestExternalTicketsIntegrationQuery, TestExternalTicketsIntegrationQueryVariables>(TestExternalTicketsIntegrationDocument, options);
        }
export type TestExternalTicketsIntegrationQueryHookResult = ReturnType<typeof useTestExternalTicketsIntegrationQuery>;
export type TestExternalTicketsIntegrationLazyQueryHookResult = ReturnType<typeof useTestExternalTicketsIntegrationLazyQuery>;
export type TestExternalTicketsIntegrationQueryResult = Apollo.QueryResult<TestExternalTicketsIntegrationQuery, TestExternalTicketsIntegrationQueryVariables>;
export const EditDigestSeriesTeamDocument = gql`
    mutation EditDigestSeriesTeam($editDigestSeriesTeamId: Int!, $teamIds: [Int!]!) {
  editDigestSeriesTeam(id: $editDigestSeriesTeamId, teamIds: $teamIds) {
    ...DigestSeriesData
  }
}
    ${DigestSeriesDataFragmentDoc}`;
export type EditDigestSeriesTeamMutationFn = Apollo.MutationFunction<EditDigestSeriesTeamMutation, EditDigestSeriesTeamMutationVariables>;

/**
 * __useEditDigestSeriesTeamMutation__
 *
 * To run a mutation, you first call `useEditDigestSeriesTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDigestSeriesTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDigestSeriesTeamMutation, { data, loading, error }] = useEditDigestSeriesTeamMutation({
 *   variables: {
 *      editDigestSeriesTeamId: // value for 'editDigestSeriesTeamId'
 *      teamIds: // value for 'teamIds'
 *   },
 * });
 */
export function useEditDigestSeriesTeamMutation(baseOptions?: Apollo.MutationHookOptions<EditDigestSeriesTeamMutation, EditDigestSeriesTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDigestSeriesTeamMutation, EditDigestSeriesTeamMutationVariables>(EditDigestSeriesTeamDocument, options);
      }
export type EditDigestSeriesTeamMutationHookResult = ReturnType<typeof useEditDigestSeriesTeamMutation>;
export type EditDigestSeriesTeamMutationResult = Apollo.MutationResult<EditDigestSeriesTeamMutation>;
export type EditDigestSeriesTeamMutationOptions = Apollo.BaseMutationOptions<EditDigestSeriesTeamMutation, EditDigestSeriesTeamMutationVariables>;
export const ValidateIntegrationConfigDocument = gql`
    query ValidateIntegrationConfig($input: MutateFeedbackIntegration!) {
  validateIntegrationConfig(integration: $input) {
    validationUuid
  }
}
    `;

/**
 * __useValidateIntegrationConfigQuery__
 *
 * To run a query within a React component, call `useValidateIntegrationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateIntegrationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateIntegrationConfigQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateIntegrationConfigQuery(baseOptions: Apollo.QueryHookOptions<ValidateIntegrationConfigQuery, ValidateIntegrationConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateIntegrationConfigQuery, ValidateIntegrationConfigQueryVariables>(ValidateIntegrationConfigDocument, options);
      }
export function useValidateIntegrationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateIntegrationConfigQuery, ValidateIntegrationConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateIntegrationConfigQuery, ValidateIntegrationConfigQueryVariables>(ValidateIntegrationConfigDocument, options);
        }
export type ValidateIntegrationConfigQueryHookResult = ReturnType<typeof useValidateIntegrationConfigQuery>;
export type ValidateIntegrationConfigLazyQueryHookResult = ReturnType<typeof useValidateIntegrationConfigLazyQuery>;
export type ValidateIntegrationConfigQueryResult = Apollo.QueryResult<ValidateIntegrationConfigQuery, ValidateIntegrationConfigQueryVariables>;
export const GetPreviewPageLeadDocument = gql`
    query getPreviewPageLead($email: String) {
  getPreviewPageLead(email: $email)
}
    `;

/**
 * __useGetPreviewPageLeadQuery__
 *
 * To run a query within a React component, call `useGetPreviewPageLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewPageLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewPageLeadQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetPreviewPageLeadQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviewPageLeadQuery, GetPreviewPageLeadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewPageLeadQuery, GetPreviewPageLeadQueryVariables>(GetPreviewPageLeadDocument, options);
      }
export function useGetPreviewPageLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewPageLeadQuery, GetPreviewPageLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewPageLeadQuery, GetPreviewPageLeadQueryVariables>(GetPreviewPageLeadDocument, options);
        }
export type GetPreviewPageLeadQueryHookResult = ReturnType<typeof useGetPreviewPageLeadQuery>;
export type GetPreviewPageLeadLazyQueryHookResult = ReturnType<typeof useGetPreviewPageLeadLazyQuery>;
export type GetPreviewPageLeadQueryResult = Apollo.QueryResult<GetPreviewPageLeadQuery, GetPreviewPageLeadQueryVariables>;